// version 20211115
const area = [
    {
        code: '110000',
        name: '北京',
        simple_name: '北京',
        hidden: 0,
        cities: [
            {
                code: '110100',
                name: '北京市',
                simple_name: '北京',
                hidden: 0,
                districts: [
                    {
                        code: '110101',
                        name: '东城区',
                        simple_name: '东城',
                        hidden: 0,
                    },
                    {
                        code: '110102',
                        name: '西城区',
                        simple_name: '西城',
                        hidden: 0,
                    },
                    {
                        code: '110105',
                        name: '朝阳区',
                        simple_name: '朝阳',
                        hidden: 0,
                    },
                    {
                        code: '110106',
                        name: '丰台区',
                        simple_name: '丰台',
                        hidden: 0,
                    },
                    {
                        code: '110107',
                        name: '石景山区',
                        simple_name: '石景山',
                        hidden: 0,
                    },
                    {
                        code: '110108',
                        name: '海淀区',
                        simple_name: '海淀',
                        hidden: 0,
                    },
                    {
                        code: '110109',
                        name: '门头沟区',
                        simple_name: '门头沟',
                        hidden: 0,
                    },
                    {
                        code: '110111',
                        name: '房山区',
                        simple_name: '房山',
                        hidden: 0,
                    },
                    {
                        code: '110112',
                        name: '通州区',
                        simple_name: '通州',
                        hidden: 0,
                    },
                    {
                        code: '110113',
                        name: '顺义区',
                        simple_name: '顺义',
                        hidden: 0,
                    },
                    {
                        code: '110114',
                        name: '昌平区',
                        simple_name: '昌平',
                        hidden: 0,
                    },
                    {
                        code: '110115',
                        name: '大兴区',
                        simple_name: '大兴',
                        hidden: 0,
                    },
                    {
                        code: '110116',
                        name: '怀柔区',
                        simple_name: '怀柔',
                        hidden: 0,
                    },
                    {
                        code: '110117',
                        name: '平谷区',
                        simple_name: '平谷',
                        hidden: 0,
                    },
                    {
                        code: '110228',
                        name: '密云县',
                        simple_name: '密云',
                        hidden: 0,
                    },
                    {
                        code: '110229',
                        name: '延庆县',
                        simple_name: '延庆',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '120000',
        name: '天津',
        simple_name: '天津',
        hidden: 0,
        cities: [
            {
                code: '120100',
                name: '天津市',
                simple_name: '天津',
                hidden: 0,
                districts: [
                    {
                        code: '120101',
                        name: '和平区',
                        simple_name: '和平',
                        hidden: 0,
                    },
                    {
                        code: '120102',
                        name: '河东区',
                        simple_name: '河东',
                        hidden: 0,
                    },
                    {
                        code: '120103',
                        name: '河西区',
                        simple_name: '河西',
                        hidden: 0,
                    },
                    {
                        code: '120104',
                        name: '南开区',
                        simple_name: '南开',
                        hidden: 0,
                    },
                    {
                        code: '120105',
                        name: '河北区',
                        simple_name: '河北',
                        hidden: 0,
                    },
                    {
                        code: '120106',
                        name: '红桥区',
                        simple_name: '红桥',
                        hidden: 0,
                    },
                    {
                        code: '120110',
                        name: '东丽区',
                        simple_name: '东丽',
                        hidden: 0,
                    },
                    {
                        code: '120111',
                        name: '西青区',
                        simple_name: '西青',
                        hidden: 0,
                    },
                    {
                        code: '120112',
                        name: '津南区',
                        simple_name: '津南',
                        hidden: 0,
                    },
                    {
                        code: '120113',
                        name: '北辰区',
                        simple_name: '北辰',
                        hidden: 0,
                    },
                    {
                        code: '120114',
                        name: '武清区',
                        simple_name: '武清',
                        hidden: 0,
                    },
                    {
                        code: '120115',
                        name: '宝坻区',
                        simple_name: '宝坻',
                        hidden: 0,
                    },
                    {
                        code: '120116',
                        name: '滨海新区',
                        simple_name: '滨海新区',
                        hidden: 0,
                    },
                    {
                        code: '120221',
                        name: '宁河县',
                        simple_name: '宁河',
                        hidden: 0,
                    },
                    {
                        code: '120223',
                        name: '静海县',
                        simple_name: '静海',
                        hidden: 0,
                    },
                    {
                        code: '120225',
                        name: '蓟县',
                        simple_name: '蓟县',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '130000',
        name: '河北省',
        simple_name: '河北',
        hidden: 0,
        cities: [
            {
                code: '130100',
                name: '石家庄市',
                simple_name: '石家庄',
                hidden: 0,
                districts: [
                    {
                        code: '130102',
                        name: '长安区',
                        simple_name: '长安',
                        hidden: 0,
                    },
                    {
                        code: '130104',
                        name: '桥西区',
                        simple_name: '桥西',
                        hidden: 0,
                    },
                    {
                        code: '130105',
                        name: '新华区',
                        simple_name: '新华',
                        hidden: 0,
                    },
                    {
                        code: '130107',
                        name: '井陉矿区',
                        simple_name: '井陉矿区',
                        hidden: 0,
                    },
                    {
                        code: '130108',
                        name: '裕华区',
                        simple_name: '裕华',
                        hidden: 0,
                    },
                    {
                        code: '130109',
                        name: '藁城区',
                        simple_name: '藁城',
                        hidden: 0,
                    },
                    {
                        code: '130110',
                        name: '鹿泉区',
                        simple_name: '鹿泉',
                        hidden: 0,
                    },
                    {
                        code: '130111',
                        name: '栾城区',
                        simple_name: '栾城',
                        hidden: 0,
                    },
                    {
                        code: '130121',
                        name: '井陉县',
                        simple_name: '井陉',
                        hidden: 0,
                    },
                    {
                        code: '130123',
                        name: '正定县',
                        simple_name: '正定',
                        hidden: 0,
                    },
                    {
                        code: '130125',
                        name: '行唐县',
                        simple_name: '行唐',
                        hidden: 0,
                    },
                    {
                        code: '130126',
                        name: '灵寿县',
                        simple_name: '灵寿',
                        hidden: 0,
                    },
                    {
                        code: '130127',
                        name: '高邑县',
                        simple_name: '高邑',
                        hidden: 0,
                    },
                    {
                        code: '130128',
                        name: '深泽县',
                        simple_name: '深泽',
                        hidden: 0,
                    },
                    {
                        code: '130129',
                        name: '赞皇县',
                        simple_name: '赞皇',
                        hidden: 0,
                    },
                    {
                        code: '130130',
                        name: '无极县',
                        simple_name: '无极',
                        hidden: 0,
                    },
                    {
                        code: '130131',
                        name: '平山县',
                        simple_name: '平山',
                        hidden: 0,
                    },
                    {
                        code: '130132',
                        name: '元氏县',
                        simple_name: '元氏',
                        hidden: 0,
                    },
                    {
                        code: '130133',
                        name: '赵县',
                        simple_name: '赵县',
                        hidden: 0,
                    },
                    {
                        code: '130181',
                        name: '辛集市',
                        simple_name: '辛集',
                        hidden: 0,
                    },
                    {
                        code: '130183',
                        name: '晋州市',
                        simple_name: '晋州',
                        hidden: 0,
                    },
                    {
                        code: '130184',
                        name: '新乐市',
                        simple_name: '新乐',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130200',
                name: '唐山市',
                simple_name: '唐山',
                hidden: 0,
                districts: [
                    {
                        code: '130202',
                        name: '路南区',
                        simple_name: '路南',
                        hidden: 0,
                    },
                    {
                        code: '130203',
                        name: '路北区',
                        simple_name: '路北',
                        hidden: 0,
                    },
                    {
                        code: '130204',
                        name: '古冶区',
                        simple_name: '古冶',
                        hidden: 0,
                    },
                    {
                        code: '130205',
                        name: '开平区',
                        simple_name: '开平',
                        hidden: 0,
                    },
                    {
                        code: '130207',
                        name: '丰南区',
                        simple_name: '丰南',
                        hidden: 0,
                    },
                    {
                        code: '130208',
                        name: '丰润区',
                        simple_name: '丰润',
                        hidden: 0,
                    },
                    {
                        code: '130209',
                        name: '曹妃甸区',
                        simple_name: '曹妃甸',
                        hidden: 0,
                    },
                    {
                        code: '130223',
                        name: '滦县',
                        simple_name: '滦县',
                        hidden: 0,
                    },
                    {
                        code: '130224',
                        name: '滦南县',
                        simple_name: '滦南',
                        hidden: 0,
                    },
                    {
                        code: '130225',
                        name: '乐亭县',
                        simple_name: '乐亭',
                        hidden: 0,
                    },
                    {
                        code: '130227',
                        name: '迁西县',
                        simple_name: '迁西',
                        hidden: 0,
                    },
                    {
                        code: '130229',
                        name: '玉田县',
                        simple_name: '玉田',
                        hidden: 0,
                    },
                    {
                        code: '130281',
                        name: '遵化市',
                        simple_name: '遵化',
                        hidden: 0,
                    },
                    {
                        code: '130283',
                        name: '迁安市',
                        simple_name: '迁安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130300',
                name: '秦皇岛市',
                simple_name: '秦皇岛',
                hidden: 0,
                districts: [
                    {
                        code: '130302',
                        name: '海港区',
                        simple_name: '海港',
                        hidden: 0,
                    },
                    {
                        code: '130303',
                        name: '山海关区',
                        simple_name: '山海关',
                        hidden: 0,
                    },
                    {
                        code: '130304',
                        name: '北戴河区',
                        simple_name: '北戴河',
                        hidden: 0,
                    },
                    {
                        code: '130321',
                        name: '青龙满族自治县',
                        simple_name: '青龙',
                        hidden: 0,
                    },
                    {
                        code: '130322',
                        name: '昌黎县',
                        simple_name: '昌黎',
                        hidden: 0,
                    },
                    {
                        code: '130323',
                        name: '抚宁县',
                        simple_name: '抚宁',
                        hidden: 0,
                    },
                    {
                        code: '130324',
                        name: '卢龙县',
                        simple_name: '卢龙',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130400',
                name: '邯郸市',
                simple_name: '邯郸',
                hidden: 0,
                districts: [
                    {
                        code: '130402',
                        name: '邯山区',
                        simple_name: '邯山',
                        hidden: 0,
                    },
                    {
                        code: '130403',
                        name: '丛台区',
                        simple_name: '丛台',
                        hidden: 0,
                    },
                    {
                        code: '130404',
                        name: '复兴区',
                        simple_name: '复兴',
                        hidden: 0,
                    },
                    {
                        code: '130406',
                        name: '峰峰矿区',
                        simple_name: '峰峰矿区',
                        hidden: 0,
                    },
                    {
                        code: '130421',
                        name: '邯郸县',
                        simple_name: '邯郸',
                        hidden: 0,
                    },
                    {
                        code: '130423',
                        name: '临漳县',
                        simple_name: '临漳',
                        hidden: 0,
                    },
                    {
                        code: '130424',
                        name: '成安县',
                        simple_name: '成安',
                        hidden: 0,
                    },
                    {
                        code: '130425',
                        name: '大名县',
                        simple_name: '大名',
                        hidden: 0,
                    },
                    {
                        code: '130426',
                        name: '涉县',
                        simple_name: '涉县',
                        hidden: 0,
                    },
                    {
                        code: '130427',
                        name: '磁县',
                        simple_name: '磁县',
                        hidden: 0,
                    },
                    {
                        code: '130428',
                        name: '肥乡县',
                        simple_name: '肥乡',
                        hidden: 0,
                    },
                    {
                        code: '130429',
                        name: '永年县',
                        simple_name: '永年',
                        hidden: 0,
                    },
                    {
                        code: '130430',
                        name: '邱县',
                        simple_name: '邱县',
                        hidden: 0,
                    },
                    {
                        code: '130431',
                        name: '鸡泽县',
                        simple_name: '鸡泽',
                        hidden: 0,
                    },
                    {
                        code: '130432',
                        name: '广平县',
                        simple_name: '广平',
                        hidden: 0,
                    },
                    {
                        code: '130433',
                        name: '馆陶县',
                        simple_name: '馆陶',
                        hidden: 0,
                    },
                    {
                        code: '130434',
                        name: '魏县',
                        simple_name: '魏县',
                        hidden: 0,
                    },
                    {
                        code: '130435',
                        name: '曲周县',
                        simple_name: '曲周',
                        hidden: 0,
                    },
                    {
                        code: '130481',
                        name: '武安市',
                        simple_name: '武安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130500',
                name: '邢台市',
                simple_name: '邢台',
                hidden: 0,
                districts: [
                    {
                        code: '130502',
                        name: '桥东区',
                        simple_name: '桥东',
                        hidden: 0,
                    },
                    {
                        code: '130503',
                        name: '桥西区',
                        simple_name: '桥西',
                        hidden: 0,
                    },
                    {
                        code: '130521',
                        name: '邢台县',
                        simple_name: '邢台',
                        hidden: 0,
                    },
                    {
                        code: '130522',
                        name: '临城县',
                        simple_name: '临城',
                        hidden: 0,
                    },
                    {
                        code: '130523',
                        name: '内丘县',
                        simple_name: '内丘',
                        hidden: 0,
                    },
                    {
                        code: '130524',
                        name: '柏乡县',
                        simple_name: '柏乡',
                        hidden: 0,
                    },
                    {
                        code: '130525',
                        name: '隆尧县',
                        simple_name: '隆尧',
                        hidden: 0,
                    },
                    {
                        code: '130526',
                        name: '任县',
                        simple_name: '任县',
                        hidden: 0,
                    },
                    {
                        code: '130527',
                        name: '南和县',
                        simple_name: '南和',
                        hidden: 0,
                    },
                    {
                        code: '130528',
                        name: '宁晋县',
                        simple_name: '宁晋',
                        hidden: 0,
                    },
                    {
                        code: '130529',
                        name: '巨鹿县',
                        simple_name: '巨鹿',
                        hidden: 0,
                    },
                    {
                        code: '130530',
                        name: '新河县',
                        simple_name: '新河',
                        hidden: 0,
                    },
                    {
                        code: '130531',
                        name: '广宗县',
                        simple_name: '广宗',
                        hidden: 0,
                    },
                    {
                        code: '130532',
                        name: '平乡县',
                        simple_name: '平乡',
                        hidden: 0,
                    },
                    {
                        code: '130533',
                        name: '威县',
                        simple_name: '威县',
                        hidden: 0,
                    },
                    {
                        code: '130534',
                        name: '清河县',
                        simple_name: '清河',
                        hidden: 0,
                    },
                    {
                        code: '130535',
                        name: '临西县',
                        simple_name: '临西',
                        hidden: 0,
                    },
                    {
                        code: '130581',
                        name: '南宫市',
                        simple_name: '南宫',
                        hidden: 0,
                    },
                    {
                        code: '130582',
                        name: '沙河市',
                        simple_name: '沙河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130600',
                name: '保定市',
                simple_name: '保定',
                hidden: 0,
                districts: [
                    {
                        code: '130602',
                        name: '新市区',
                        simple_name: '新市',
                        hidden: 0,
                    },
                    {
                        code: '130603',
                        name: '北市区',
                        simple_name: '北市',
                        hidden: 0,
                    },
                    {
                        code: '130604',
                        name: '南市区',
                        simple_name: '南市',
                        hidden: 0,
                    },
                    {
                        code: '130621',
                        name: '满城县',
                        simple_name: '满城',
                        hidden: 0,
                    },
                    {
                        code: '130622',
                        name: '清苑县',
                        simple_name: '清苑',
                        hidden: 0,
                    },
                    {
                        code: '130623',
                        name: '涞水县',
                        simple_name: '涞水',
                        hidden: 0,
                    },
                    {
                        code: '130624',
                        name: '阜平县',
                        simple_name: '阜平',
                        hidden: 0,
                    },
                    {
                        code: '130625',
                        name: '徐水县',
                        simple_name: '徐水',
                        hidden: 0,
                    },
                    {
                        code: '130626',
                        name: '定兴县',
                        simple_name: '定兴',
                        hidden: 0,
                    },
                    {
                        code: '130627',
                        name: '唐县',
                        simple_name: '唐县',
                        hidden: 0,
                    },
                    {
                        code: '130628',
                        name: '高阳县',
                        simple_name: '高阳',
                        hidden: 0,
                    },
                    {
                        code: '130629',
                        name: '容城县',
                        simple_name: '容城',
                        hidden: 0,
                    },
                    {
                        code: '130630',
                        name: '涞源县',
                        simple_name: '涞源',
                        hidden: 0,
                    },
                    {
                        code: '130631',
                        name: '望都县',
                        simple_name: '望都',
                        hidden: 0,
                    },
                    {
                        code: '130632',
                        name: '安新县',
                        simple_name: '安新',
                        hidden: 0,
                    },
                    {
                        code: '130633',
                        name: '易县',
                        simple_name: '易县',
                        hidden: 0,
                    },
                    {
                        code: '130634',
                        name: '曲阳县',
                        simple_name: '曲阳',
                        hidden: 0,
                    },
                    {
                        code: '130635',
                        name: '蠡县',
                        simple_name: '蠡县',
                        hidden: 0,
                    },
                    {
                        code: '130636',
                        name: '顺平县',
                        simple_name: '顺平',
                        hidden: 0,
                    },
                    {
                        code: '130637',
                        name: '博野县',
                        simple_name: '博野',
                        hidden: 0,
                    },
                    {
                        code: '130638',
                        name: '雄县',
                        simple_name: '雄县',
                        hidden: 0,
                    },
                    {
                        code: '130681',
                        name: '涿州市',
                        simple_name: '涿州',
                        hidden: 0,
                    },
                    {
                        code: '130682',
                        name: '定州市',
                        simple_name: '定州',
                        hidden: 0,
                    },
                    {
                        code: '130683',
                        name: '安国市',
                        simple_name: '安国',
                        hidden: 0,
                    },
                    {
                        code: '130684',
                        name: '高碑店市',
                        simple_name: '高碑店',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130700',
                name: '张家口市',
                simple_name: '张家口',
                hidden: 0,
                districts: [
                    {
                        code: '130702',
                        name: '桥东区',
                        simple_name: '桥东',
                        hidden: 0,
                    },
                    {
                        code: '130703',
                        name: '桥西区',
                        simple_name: '桥西',
                        hidden: 0,
                    },
                    {
                        code: '130705',
                        name: '宣化区',
                        simple_name: '宣化',
                        hidden: 0,
                    },
                    {
                        code: '130706',
                        name: '下花园区',
                        simple_name: '下花园',
                        hidden: 0,
                    },
                    {
                        code: '130721',
                        name: '宣化县',
                        simple_name: '宣化',
                        hidden: 0,
                    },
                    {
                        code: '130722',
                        name: '张北县',
                        simple_name: '张北',
                        hidden: 0,
                    },
                    {
                        code: '130723',
                        name: '康保县',
                        simple_name: '康保',
                        hidden: 0,
                    },
                    {
                        code: '130724',
                        name: '沽源县',
                        simple_name: '沽源',
                        hidden: 0,
                    },
                    {
                        code: '130725',
                        name: '尚义县',
                        simple_name: '尚义',
                        hidden: 0,
                    },
                    {
                        code: '130726',
                        name: '蔚县',
                        simple_name: '蔚县',
                        hidden: 0,
                    },
                    {
                        code: '130727',
                        name: '阳原县',
                        simple_name: '阳原',
                        hidden: 0,
                    },
                    {
                        code: '130728',
                        name: '怀安县',
                        simple_name: '怀安',
                        hidden: 0,
                    },
                    {
                        code: '130729',
                        name: '万全县',
                        simple_name: '万全',
                        hidden: 0,
                    },
                    {
                        code: '130730',
                        name: '怀来县',
                        simple_name: '怀来',
                        hidden: 0,
                    },
                    {
                        code: '130731',
                        name: '涿鹿县',
                        simple_name: '涿鹿',
                        hidden: 0,
                    },
                    {
                        code: '130732',
                        name: '赤城县',
                        simple_name: '赤城',
                        hidden: 0,
                    },
                    {
                        code: '130733',
                        name: '崇礼县',
                        simple_name: '崇礼',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130800',
                name: '承德市',
                simple_name: '承德',
                hidden: 0,
                districts: [
                    {
                        code: '130802',
                        name: '双桥区',
                        simple_name: '双桥',
                        hidden: 0,
                    },
                    {
                        code: '130803',
                        name: '双滦区',
                        simple_name: '双滦',
                        hidden: 0,
                    },
                    {
                        code: '130804',
                        name: '鹰手营子矿区',
                        simple_name: '鹰手营子矿区',
                        hidden: 0,
                    },
                    {
                        code: '130821',
                        name: '承德县',
                        simple_name: '承德',
                        hidden: 0,
                    },
                    {
                        code: '130822',
                        name: '兴隆县',
                        simple_name: '兴隆',
                        hidden: 0,
                    },
                    {
                        code: '130823',
                        name: '平泉县',
                        simple_name: '平泉',
                        hidden: 0,
                    },
                    {
                        code: '130824',
                        name: '滦平县',
                        simple_name: '滦平',
                        hidden: 0,
                    },
                    {
                        code: '130825',
                        name: '隆化县',
                        simple_name: '隆化',
                        hidden: 0,
                    },
                    {
                        code: '130826',
                        name: '丰宁满族自治县',
                        simple_name: '丰宁',
                        hidden: 0,
                    },
                    {
                        code: '130827',
                        name: '宽城满族自治县',
                        simple_name: '宽城',
                        hidden: 0,
                    },
                    {
                        code: '130828',
                        name: '围场满族蒙古族自治县',
                        simple_name: '围场',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '130900',
                name: '沧州市',
                simple_name: '沧州',
                hidden: 0,
                districts: [
                    {
                        code: '130902',
                        name: '新华区',
                        simple_name: '新华',
                        hidden: 0,
                    },
                    {
                        code: '130903',
                        name: '运河区',
                        simple_name: '运河',
                        hidden: 0,
                    },
                    {
                        code: '130921',
                        name: '沧县',
                        simple_name: '沧县',
                        hidden: 0,
                    },
                    {
                        code: '130922',
                        name: '青县',
                        simple_name: '青县',
                        hidden: 0,
                    },
                    {
                        code: '130923',
                        name: '东光县',
                        simple_name: '东光',
                        hidden: 0,
                    },
                    {
                        code: '130924',
                        name: '海兴县',
                        simple_name: '海兴',
                        hidden: 0,
                    },
                    {
                        code: '130925',
                        name: '盐山县',
                        simple_name: '盐山',
                        hidden: 0,
                    },
                    {
                        code: '130926',
                        name: '肃宁县',
                        simple_name: '肃宁',
                        hidden: 0,
                    },
                    {
                        code: '130927',
                        name: '南皮县',
                        simple_name: '南皮',
                        hidden: 0,
                    },
                    {
                        code: '130928',
                        name: '吴桥县',
                        simple_name: '吴桥',
                        hidden: 0,
                    },
                    {
                        code: '130929',
                        name: '献县',
                        simple_name: '献县',
                        hidden: 0,
                    },
                    {
                        code: '130930',
                        name: '孟村回族自治县',
                        simple_name: '孟村',
                        hidden: 0,
                    },
                    {
                        code: '130981',
                        name: '泊头市',
                        simple_name: '泊头',
                        hidden: 0,
                    },
                    {
                        code: '130982',
                        name: '任丘市',
                        simple_name: '任丘',
                        hidden: 0,
                    },
                    {
                        code: '130983',
                        name: '黄骅市',
                        simple_name: '黄骅',
                        hidden: 0,
                    },
                    {
                        code: '130984',
                        name: '河间市',
                        simple_name: '河间',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '131000',
                name: '廊坊市',
                simple_name: '廊坊',
                hidden: 0,
                districts: [
                    {
                        code: '131002',
                        name: '安次区',
                        simple_name: '安次',
                        hidden: 0,
                    },
                    {
                        code: '131003',
                        name: '广阳区',
                        simple_name: '广阳',
                        hidden: 0,
                    },
                    {
                        code: '131022',
                        name: '固安县',
                        simple_name: '固安',
                        hidden: 0,
                    },
                    {
                        code: '131023',
                        name: '永清县',
                        simple_name: '永清',
                        hidden: 0,
                    },
                    {
                        code: '131024',
                        name: '香河县',
                        simple_name: '香河',
                        hidden: 0,
                    },
                    {
                        code: '131025',
                        name: '大城县',
                        simple_name: '大城',
                        hidden: 0,
                    },
                    {
                        code: '131026',
                        name: '文安县',
                        simple_name: '文安',
                        hidden: 0,
                    },
                    {
                        code: '131028',
                        name: '大厂回族自治县',
                        simple_name: '大厂',
                        hidden: 0,
                    },
                    {
                        code: '131081',
                        name: '霸州市',
                        simple_name: '霸州',
                        hidden: 0,
                    },
                    {
                        code: '131082',
                        name: '三河市',
                        simple_name: '三河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '131100',
                name: '衡水市',
                simple_name: '衡水',
                hidden: 0,
                districts: [
                    {
                        code: '131102',
                        name: '桃城区',
                        simple_name: '桃城',
                        hidden: 0,
                    },
                    {
                        code: '131121',
                        name: '枣强县',
                        simple_name: '枣强',
                        hidden: 0,
                    },
                    {
                        code: '131122',
                        name: '武邑县',
                        simple_name: '武邑',
                        hidden: 0,
                    },
                    {
                        code: '131123',
                        name: '武强县',
                        simple_name: '武强',
                        hidden: 0,
                    },
                    {
                        code: '131124',
                        name: '饶阳县',
                        simple_name: '饶阳',
                        hidden: 0,
                    },
                    {
                        code: '131125',
                        name: '安平县',
                        simple_name: '安平',
                        hidden: 0,
                    },
                    {
                        code: '131126',
                        name: '故城县',
                        simple_name: '故城',
                        hidden: 0,
                    },
                    {
                        code: '131127',
                        name: '景县',
                        simple_name: '景县',
                        hidden: 0,
                    },
                    {
                        code: '131128',
                        name: '阜城县',
                        simple_name: '阜城',
                        hidden: 0,
                    },
                    {
                        code: '131181',
                        name: '冀州市',
                        simple_name: '冀州',
                        hidden: 0,
                    },
                    {
                        code: '131182',
                        name: '深州市',
                        simple_name: '深州',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '140000',
        name: '山西省',
        simple_name: '山西',
        hidden: 0,
        cities: [
            {
                code: '140100',
                name: '太原市',
                simple_name: '太原',
                hidden: 0,
                districts: [
                    {
                        code: '140105',
                        name: '小店区',
                        simple_name: '小店',
                        hidden: 0,
                    },
                    {
                        code: '140106',
                        name: '迎泽区',
                        simple_name: '迎泽',
                        hidden: 0,
                    },
                    {
                        code: '140107',
                        name: '杏花岭区',
                        simple_name: '杏花岭',
                        hidden: 0,
                    },
                    {
                        code: '140108',
                        name: '尖草坪区',
                        simple_name: '尖草坪',
                        hidden: 0,
                    },
                    {
                        code: '140109',
                        name: '万柏林区',
                        simple_name: '万柏林',
                        hidden: 0,
                    },
                    {
                        code: '140110',
                        name: '晋源区',
                        simple_name: '晋源',
                        hidden: 0,
                    },
                    {
                        code: '140121',
                        name: '清徐县',
                        simple_name: '清徐',
                        hidden: 0,
                    },
                    {
                        code: '140122',
                        name: '阳曲县',
                        simple_name: '阳曲',
                        hidden: 0,
                    },
                    {
                        code: '140123',
                        name: '娄烦县',
                        simple_name: '娄烦',
                        hidden: 0,
                    },
                    {
                        code: '140181',
                        name: '古交市',
                        simple_name: '古交',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140200',
                name: '大同市',
                simple_name: '大同',
                hidden: 0,
                districts: [
                    {
                        code: '140202',
                        name: '城区',
                        simple_name: '城区',
                        hidden: 0,
                    },
                    {
                        code: '140203',
                        name: '矿区',
                        simple_name: '矿区',
                        hidden: 0,
                    },
                    {
                        code: '140211',
                        name: '南郊区',
                        simple_name: '南郊',
                        hidden: 0,
                    },
                    {
                        code: '140212',
                        name: '新荣区',
                        simple_name: '新荣',
                        hidden: 0,
                    },
                    {
                        code: '140221',
                        name: '阳高县',
                        simple_name: '阳高',
                        hidden: 0,
                    },
                    {
                        code: '140222',
                        name: '天镇县',
                        simple_name: '天镇',
                        hidden: 0,
                    },
                    {
                        code: '140223',
                        name: '广灵县',
                        simple_name: '广灵',
                        hidden: 0,
                    },
                    {
                        code: '140224',
                        name: '灵丘县',
                        simple_name: '灵丘',
                        hidden: 0,
                    },
                    {
                        code: '140225',
                        name: '浑源县',
                        simple_name: '浑源',
                        hidden: 0,
                    },
                    {
                        code: '140226',
                        name: '左云县',
                        simple_name: '左云',
                        hidden: 0,
                    },
                    {
                        code: '140227',
                        name: '大同县',
                        simple_name: '大同',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140300',
                name: '阳泉市',
                simple_name: '阳泉',
                hidden: 0,
                districts: [
                    {
                        code: '140302',
                        name: '城区',
                        simple_name: '城区',
                        hidden: 0,
                    },
                    {
                        code: '140303',
                        name: '矿区',
                        simple_name: '矿区',
                        hidden: 0,
                    },
                    {
                        code: '140311',
                        name: '郊区',
                        simple_name: '郊区',
                        hidden: 0,
                    },
                    {
                        code: '140321',
                        name: '平定县',
                        simple_name: '平定',
                        hidden: 0,
                    },
                    {
                        code: '140322',
                        name: '盂县',
                        simple_name: '盂县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140400',
                name: '长治市',
                simple_name: '长治',
                hidden: 0,
                districts: [
                    {
                        code: '140402',
                        name: '城区',
                        simple_name: '城区',
                        hidden: 0,
                    },
                    {
                        code: '140411',
                        name: '郊区',
                        simple_name: '郊区',
                        hidden: 0,
                    },
                    {
                        code: '140421',
                        name: '长治县',
                        simple_name: '长治',
                        hidden: 0,
                    },
                    {
                        code: '140423',
                        name: '襄垣县',
                        simple_name: '襄垣',
                        hidden: 0,
                    },
                    {
                        code: '140424',
                        name: '屯留县',
                        simple_name: '屯留',
                        hidden: 0,
                    },
                    {
                        code: '140425',
                        name: '平顺县',
                        simple_name: '平顺',
                        hidden: 0,
                    },
                    {
                        code: '140426',
                        name: '黎城县',
                        simple_name: '黎城',
                        hidden: 0,
                    },
                    {
                        code: '140427',
                        name: '壶关县',
                        simple_name: '壶关',
                        hidden: 0,
                    },
                    {
                        code: '140428',
                        name: '长子县',
                        simple_name: '长子',
                        hidden: 0,
                    },
                    {
                        code: '140429',
                        name: '武乡县',
                        simple_name: '武乡',
                        hidden: 0,
                    },
                    {
                        code: '140430',
                        name: '沁县',
                        simple_name: '沁县',
                        hidden: 0,
                    },
                    {
                        code: '140431',
                        name: '沁源县',
                        simple_name: '沁源',
                        hidden: 0,
                    },
                    {
                        code: '140481',
                        name: '潞城市',
                        simple_name: '潞城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140500',
                name: '晋城市',
                simple_name: '晋城',
                hidden: 0,
                districts: [
                    {
                        code: '140502',
                        name: '城区',
                        simple_name: '城区',
                        hidden: 0,
                    },
                    {
                        code: '140521',
                        name: '沁水县',
                        simple_name: '沁水',
                        hidden: 0,
                    },
                    {
                        code: '140522',
                        name: '阳城县',
                        simple_name: '阳城',
                        hidden: 0,
                    },
                    {
                        code: '140524',
                        name: '陵川县',
                        simple_name: '陵川',
                        hidden: 0,
                    },
                    {
                        code: '140525',
                        name: '泽州县',
                        simple_name: '泽州',
                        hidden: 0,
                    },
                    {
                        code: '140581',
                        name: '高平市',
                        simple_name: '高平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140600',
                name: '朔州市',
                simple_name: '朔州',
                hidden: 0,
                districts: [
                    {
                        code: '140602',
                        name: '朔城区',
                        simple_name: '朔城',
                        hidden: 0,
                    },
                    {
                        code: '140603',
                        name: '平鲁区',
                        simple_name: '平鲁',
                        hidden: 0,
                    },
                    {
                        code: '140621',
                        name: '山阴县',
                        simple_name: '山阴',
                        hidden: 0,
                    },
                    {
                        code: '140622',
                        name: '应县',
                        simple_name: '应县',
                        hidden: 0,
                    },
                    {
                        code: '140623',
                        name: '右玉县',
                        simple_name: '右玉',
                        hidden: 0,
                    },
                    {
                        code: '140624',
                        name: '怀仁县',
                        simple_name: '怀仁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140700',
                name: '晋中市',
                simple_name: '晋中',
                hidden: 0,
                districts: [
                    {
                        code: '140702',
                        name: '榆次区',
                        simple_name: '榆次',
                        hidden: 0,
                    },
                    {
                        code: '140721',
                        name: '榆社县',
                        simple_name: '榆社',
                        hidden: 0,
                    },
                    {
                        code: '140722',
                        name: '左权县',
                        simple_name: '左权',
                        hidden: 0,
                    },
                    {
                        code: '140723',
                        name: '和顺县',
                        simple_name: '和顺',
                        hidden: 0,
                    },
                    {
                        code: '140724',
                        name: '昔阳县',
                        simple_name: '昔阳',
                        hidden: 0,
                    },
                    {
                        code: '140725',
                        name: '寿阳县',
                        simple_name: '寿阳',
                        hidden: 0,
                    },
                    {
                        code: '140726',
                        name: '太谷县',
                        simple_name: '太谷',
                        hidden: 0,
                    },
                    {
                        code: '140727',
                        name: '祁县',
                        simple_name: '祁县',
                        hidden: 0,
                    },
                    {
                        code: '140728',
                        name: '平遥县',
                        simple_name: '平遥',
                        hidden: 0,
                    },
                    {
                        code: '140729',
                        name: '灵石县',
                        simple_name: '灵石',
                        hidden: 0,
                    },
                    {
                        code: '140781',
                        name: '介休市',
                        simple_name: '介休',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140800',
                name: '运城市',
                simple_name: '运城',
                hidden: 0,
                districts: [
                    {
                        code: '140802',
                        name: '盐湖区',
                        simple_name: '盐湖',
                        hidden: 0,
                    },
                    {
                        code: '140821',
                        name: '临猗县',
                        simple_name: '临猗',
                        hidden: 0,
                    },
                    {
                        code: '140822',
                        name: '万荣县',
                        simple_name: '万荣',
                        hidden: 0,
                    },
                    {
                        code: '140823',
                        name: '闻喜县',
                        simple_name: '闻喜',
                        hidden: 0,
                    },
                    {
                        code: '140824',
                        name: '稷山县',
                        simple_name: '稷山',
                        hidden: 0,
                    },
                    {
                        code: '140825',
                        name: '新绛县',
                        simple_name: '新绛',
                        hidden: 0,
                    },
                    {
                        code: '140826',
                        name: '绛县',
                        simple_name: '绛县',
                        hidden: 0,
                    },
                    {
                        code: '140827',
                        name: '垣曲县',
                        simple_name: '垣曲',
                        hidden: 0,
                    },
                    {
                        code: '140828',
                        name: '夏县',
                        simple_name: '夏县',
                        hidden: 0,
                    },
                    {
                        code: '140829',
                        name: '平陆县',
                        simple_name: '平陆',
                        hidden: 0,
                    },
                    {
                        code: '140830',
                        name: '芮城县',
                        simple_name: '芮城',
                        hidden: 0,
                    },
                    {
                        code: '140881',
                        name: '永济市',
                        simple_name: '永济',
                        hidden: 0,
                    },
                    {
                        code: '140882',
                        name: '河津市',
                        simple_name: '河津',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '140900',
                name: '忻州市',
                simple_name: '忻州',
                hidden: 0,
                districts: [
                    {
                        code: '140902',
                        name: '忻府区',
                        simple_name: '忻府',
                        hidden: 0,
                    },
                    {
                        code: '140921',
                        name: '定襄县',
                        simple_name: '定襄',
                        hidden: 0,
                    },
                    {
                        code: '140922',
                        name: '五台县',
                        simple_name: '五台',
                        hidden: 0,
                    },
                    {
                        code: '140923',
                        name: '代县',
                        simple_name: '代县',
                        hidden: 0,
                    },
                    {
                        code: '140924',
                        name: '繁峙县',
                        simple_name: '繁峙',
                        hidden: 0,
                    },
                    {
                        code: '140925',
                        name: '宁武县',
                        simple_name: '宁武',
                        hidden: 0,
                    },
                    {
                        code: '140926',
                        name: '静乐县',
                        simple_name: '静乐',
                        hidden: 0,
                    },
                    {
                        code: '140927',
                        name: '神池县',
                        simple_name: '神池',
                        hidden: 0,
                    },
                    {
                        code: '140928',
                        name: '五寨县',
                        simple_name: '五寨',
                        hidden: 0,
                    },
                    {
                        code: '140929',
                        name: '岢岚县',
                        simple_name: '岢岚',
                        hidden: 0,
                    },
                    {
                        code: '140930',
                        name: '河曲县',
                        simple_name: '河曲',
                        hidden: 0,
                    },
                    {
                        code: '140931',
                        name: '保德县',
                        simple_name: '保德',
                        hidden: 0,
                    },
                    {
                        code: '140932',
                        name: '偏关县',
                        simple_name: '偏关',
                        hidden: 0,
                    },
                    {
                        code: '140981',
                        name: '原平市',
                        simple_name: '原平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '141000',
                name: '临汾市',
                simple_name: '临汾',
                hidden: 0,
                districts: [
                    {
                        code: '141002',
                        name: '尧都区',
                        simple_name: '尧都',
                        hidden: 0,
                    },
                    {
                        code: '141021',
                        name: '曲沃县',
                        simple_name: '曲沃',
                        hidden: 0,
                    },
                    {
                        code: '141022',
                        name: '翼城县',
                        simple_name: '翼城',
                        hidden: 0,
                    },
                    {
                        code: '141023',
                        name: '襄汾县',
                        simple_name: '襄汾',
                        hidden: 0,
                    },
                    {
                        code: '141024',
                        name: '洪洞县',
                        simple_name: '洪洞',
                        hidden: 0,
                    },
                    {
                        code: '141025',
                        name: '古县',
                        simple_name: '古县',
                        hidden: 0,
                    },
                    {
                        code: '141026',
                        name: '安泽县',
                        simple_name: '安泽',
                        hidden: 0,
                    },
                    {
                        code: '141027',
                        name: '浮山县',
                        simple_name: '浮山',
                        hidden: 0,
                    },
                    {
                        code: '141028',
                        name: '吉县',
                        simple_name: '吉县',
                        hidden: 0,
                    },
                    {
                        code: '141029',
                        name: '乡宁县',
                        simple_name: '乡宁',
                        hidden: 0,
                    },
                    {
                        code: '141030',
                        name: '大宁县',
                        simple_name: '大宁',
                        hidden: 0,
                    },
                    {
                        code: '141031',
                        name: '隰县',
                        simple_name: '隰县',
                        hidden: 0,
                    },
                    {
                        code: '141032',
                        name: '永和县',
                        simple_name: '永和',
                        hidden: 0,
                    },
                    {
                        code: '141033',
                        name: '蒲县',
                        simple_name: '蒲县',
                        hidden: 0,
                    },
                    {
                        code: '141034',
                        name: '汾西县',
                        simple_name: '汾西',
                        hidden: 0,
                    },
                    {
                        code: '141081',
                        name: '侯马市',
                        simple_name: '侯马',
                        hidden: 0,
                    },
                    {
                        code: '141082',
                        name: '霍州市',
                        simple_name: '霍州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '141100',
                name: '吕梁市',
                simple_name: '吕梁',
                hidden: 0,
                districts: [
                    {
                        code: '141102',
                        name: '离石区',
                        simple_name: '离石',
                        hidden: 0,
                    },
                    {
                        code: '141121',
                        name: '文水县',
                        simple_name: '文水',
                        hidden: 0,
                    },
                    {
                        code: '141122',
                        name: '交城县',
                        simple_name: '交城',
                        hidden: 0,
                    },
                    {
                        code: '141123',
                        name: '兴县',
                        simple_name: '兴县',
                        hidden: 0,
                    },
                    {
                        code: '141124',
                        name: '临县',
                        simple_name: '临县',
                        hidden: 0,
                    },
                    {
                        code: '141125',
                        name: '柳林县',
                        simple_name: '柳林',
                        hidden: 0,
                    },
                    {
                        code: '141126',
                        name: '石楼县',
                        simple_name: '石楼',
                        hidden: 0,
                    },
                    {
                        code: '141127',
                        name: '岚县',
                        simple_name: '岚县',
                        hidden: 0,
                    },
                    {
                        code: '141128',
                        name: '方山县',
                        simple_name: '方山',
                        hidden: 0,
                    },
                    {
                        code: '141129',
                        name: '中阳县',
                        simple_name: '中阳',
                        hidden: 0,
                    },
                    {
                        code: '141130',
                        name: '交口县',
                        simple_name: '交口',
                        hidden: 0,
                    },
                    {
                        code: '141181',
                        name: '孝义市',
                        simple_name: '孝义',
                        hidden: 0,
                    },
                    {
                        code: '141182',
                        name: '汾阳市',
                        simple_name: '汾阳',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '150000',
        name: '内蒙古自治区',
        simple_name: '内蒙古',
        hidden: 0,
        cities: [
            {
                code: '150100',
                name: '呼和浩特市',
                simple_name: '呼和浩特',
                hidden: 0,
                districts: [
                    {
                        code: '150102',
                        name: '新城区',
                        simple_name: '新城',
                        hidden: 0,
                    },
                    {
                        code: '150103',
                        name: '回民区',
                        simple_name: '回民',
                        hidden: 0,
                    },
                    {
                        code: '150104',
                        name: '玉泉区',
                        simple_name: '玉泉',
                        hidden: 0,
                    },
                    {
                        code: '150105',
                        name: '赛罕区',
                        simple_name: '赛罕',
                        hidden: 0,
                    },
                    {
                        code: '150121',
                        name: '土默特左旗',
                        simple_name: '土默特左旗',
                        hidden: 0,
                    },
                    {
                        code: '150122',
                        name: '托克托县',
                        simple_name: '托克托',
                        hidden: 0,
                    },
                    {
                        code: '150123',
                        name: '和林格尔县',
                        simple_name: '和林格尔',
                        hidden: 0,
                    },
                    {
                        code: '150124',
                        name: '清水河县',
                        simple_name: '清水河',
                        hidden: 0,
                    },
                    {
                        code: '150125',
                        name: '武川县',
                        simple_name: '武川',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150200',
                name: '包头市',
                simple_name: '包头',
                hidden: 0,
                districts: [
                    {
                        code: '150202',
                        name: '东河区',
                        simple_name: '东河',
                        hidden: 0,
                    },
                    {
                        code: '150203',
                        name: '昆都仑区',
                        simple_name: '昆都仑',
                        hidden: 0,
                    },
                    {
                        code: '150204',
                        name: '青山区',
                        simple_name: '青山',
                        hidden: 0,
                    },
                    {
                        code: '150205',
                        name: '石拐区',
                        simple_name: '石拐',
                        hidden: 0,
                    },
                    {
                        code: '150206',
                        name: '白云鄂博矿区',
                        simple_name: '白云鄂博矿区',
                        hidden: 0,
                    },
                    {
                        code: '150207',
                        name: '九原区',
                        simple_name: '九原',
                        hidden: 0,
                    },
                    {
                        code: '150221',
                        name: '土默特右旗',
                        simple_name: '土默特右旗',
                        hidden: 0,
                    },
                    {
                        code: '150222',
                        name: '固阳县',
                        simple_name: '固阳',
                        hidden: 0,
                    },
                    {
                        code: '150223',
                        name: '达尔罕茂明安联合旗',
                        simple_name: '达茂旗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150300',
                name: '乌海市',
                simple_name: '乌海',
                hidden: 0,
                districts: [
                    {
                        code: '150302',
                        name: '海勃湾区',
                        simple_name: '海勃湾',
                        hidden: 0,
                    },
                    {
                        code: '150303',
                        name: '海南区',
                        simple_name: '海南',
                        hidden: 0,
                    },
                    {
                        code: '150304',
                        name: '乌达区',
                        simple_name: '乌达',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150400',
                name: '赤峰市',
                simple_name: '赤峰',
                hidden: 0,
                districts: [
                    {
                        code: '150402',
                        name: '红山区',
                        simple_name: '红山',
                        hidden: 0,
                    },
                    {
                        code: '150403',
                        name: '元宝山区',
                        simple_name: '元宝山',
                        hidden: 0,
                    },
                    {
                        code: '150404',
                        name: '松山区',
                        simple_name: '松山',
                        hidden: 0,
                    },
                    {
                        code: '150421',
                        name: '阿鲁科尔沁旗',
                        simple_name: '阿鲁科尔沁旗',
                        hidden: 0,
                    },
                    {
                        code: '150422',
                        name: '巴林左旗',
                        simple_name: '巴林左旗',
                        hidden: 0,
                    },
                    {
                        code: '150423',
                        name: '巴林右旗',
                        simple_name: '巴林右旗',
                        hidden: 0,
                    },
                    {
                        code: '150424',
                        name: '林西县',
                        simple_name: '林西',
                        hidden: 0,
                    },
                    {
                        code: '150425',
                        name: '克什克腾旗',
                        simple_name: '克什克腾旗',
                        hidden: 0,
                    },
                    {
                        code: '150426',
                        name: '翁牛特旗',
                        simple_name: '翁牛特旗',
                        hidden: 0,
                    },
                    {
                        code: '150428',
                        name: '喀喇沁旗',
                        simple_name: '喀喇沁旗',
                        hidden: 0,
                    },
                    {
                        code: '150429',
                        name: '宁城县',
                        simple_name: '宁城',
                        hidden: 0,
                    },
                    {
                        code: '150430',
                        name: '敖汉旗',
                        simple_name: '敖汉旗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150500',
                name: '通辽市',
                simple_name: '通辽',
                hidden: 0,
                districts: [
                    {
                        code: '150502',
                        name: '科尔沁区',
                        simple_name: '科尔沁',
                        hidden: 0,
                    },
                    {
                        code: '150521',
                        name: '科尔沁左翼中旗',
                        simple_name: '科尔沁左翼中旗',
                        hidden: 0,
                    },
                    {
                        code: '150522',
                        name: '科尔沁左翼后旗',
                        simple_name: '科尔沁左翼后旗',
                        hidden: 0,
                    },
                    {
                        code: '150523',
                        name: '开鲁县',
                        simple_name: '开鲁',
                        hidden: 0,
                    },
                    {
                        code: '150524',
                        name: '库伦旗',
                        simple_name: '库伦旗',
                        hidden: 0,
                    },
                    {
                        code: '150525',
                        name: '奈曼旗',
                        simple_name: '奈曼旗',
                        hidden: 0,
                    },
                    {
                        code: '150526',
                        name: '扎鲁特旗',
                        simple_name: '扎鲁特旗',
                        hidden: 0,
                    },
                    {
                        code: '150581',
                        name: '霍林郭勒市',
                        simple_name: '霍林郭勒',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150600',
                name: '鄂尔多斯市',
                simple_name: '鄂尔多斯',
                hidden: 0,
                districts: [
                    {
                        code: '150602',
                        name: '东胜区',
                        simple_name: '东胜',
                        hidden: 0,
                    },
                    {
                        code: '150621',
                        name: '达拉特旗',
                        simple_name: '达拉特旗',
                        hidden: 0,
                    },
                    {
                        code: '150622',
                        name: '准格尔旗',
                        simple_name: '准格尔旗',
                        hidden: 0,
                    },
                    {
                        code: '150623',
                        name: '鄂托克前旗',
                        simple_name: '鄂托克前旗',
                        hidden: 0,
                    },
                    {
                        code: '150624',
                        name: '鄂托克旗',
                        simple_name: '鄂托克旗',
                        hidden: 0,
                    },
                    {
                        code: '150625',
                        name: '杭锦旗',
                        simple_name: '杭锦旗',
                        hidden: 0,
                    },
                    {
                        code: '150626',
                        name: '乌审旗',
                        simple_name: '乌审旗',
                        hidden: 0,
                    },
                    {
                        code: '150627',
                        name: '伊金霍洛旗',
                        simple_name: '伊金霍洛旗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150700',
                name: '呼伦贝尔市',
                simple_name: '呼伦贝尔',
                hidden: 0,
                districts: [
                    {
                        code: '150702',
                        name: '海拉尔区',
                        simple_name: '海拉尔',
                        hidden: 0,
                    },
                    {
                        code: '150703',
                        name: '扎赉诺尔区',
                        simple_name: '扎赉诺尔',
                        hidden: 0,
                    },
                    {
                        code: '150721',
                        name: '阿荣旗',
                        simple_name: '阿荣旗',
                        hidden: 0,
                    },
                    {
                        code: '150722',
                        name: '莫力达瓦达斡尔族自治旗',
                        simple_name: '莫旗',
                        hidden: 0,
                    },
                    {
                        code: '150723',
                        name: '鄂伦春自治旗',
                        simple_name: '鄂伦春',
                        hidden: 0,
                    },
                    {
                        code: '150724',
                        name: '鄂温克族自治旗',
                        simple_name: '鄂温',
                        hidden: 0,
                    },
                    {
                        code: '150725',
                        name: '陈巴尔虎旗',
                        simple_name: '陈巴尔虎旗',
                        hidden: 0,
                    },
                    {
                        code: '150726',
                        name: '新巴尔虎左旗',
                        simple_name: '新巴尔虎左旗',
                        hidden: 0,
                    },
                    {
                        code: '150727',
                        name: '新巴尔虎右旗',
                        simple_name: '新巴尔虎右旗',
                        hidden: 0,
                    },
                    {
                        code: '150781',
                        name: '满洲里市',
                        simple_name: '满洲里',
                        hidden: 0,
                    },
                    {
                        code: '150782',
                        name: '牙克石市',
                        simple_name: '牙克石',
                        hidden: 0,
                    },
                    {
                        code: '150783',
                        name: '扎兰屯市',
                        simple_name: '扎兰屯',
                        hidden: 0,
                    },
                    {
                        code: '150784',
                        name: '额尔古纳市',
                        simple_name: '额尔古纳',
                        hidden: 0,
                    },
                    {
                        code: '150785',
                        name: '根河市',
                        simple_name: '根河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150800',
                name: '巴彦淖尔市',
                simple_name: '巴彦淖尔',
                hidden: 0,
                districts: [
                    {
                        code: '150802',
                        name: '临河区',
                        simple_name: '临河',
                        hidden: 0,
                    },
                    {
                        code: '150821',
                        name: '五原县',
                        simple_name: '五原',
                        hidden: 0,
                    },
                    {
                        code: '150822',
                        name: '磴口县',
                        simple_name: '磴口',
                        hidden: 0,
                    },
                    {
                        code: '150823',
                        name: '乌拉特前旗',
                        simple_name: '乌拉特前旗',
                        hidden: 0,
                    },
                    {
                        code: '150824',
                        name: '乌拉特中旗',
                        simple_name: '乌拉特中旗',
                        hidden: 0,
                    },
                    {
                        code: '150825',
                        name: '乌拉特后旗',
                        simple_name: '乌拉特后旗',
                        hidden: 0,
                    },
                    {
                        code: '150826',
                        name: '杭锦后旗',
                        simple_name: '杭锦后旗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '150900',
                name: '乌兰察布市',
                simple_name: '乌兰察布',
                hidden: 0,
                districts: [
                    {
                        code: '150902',
                        name: '集宁区',
                        simple_name: '集宁',
                        hidden: 0,
                    },
                    {
                        code: '150921',
                        name: '卓资县',
                        simple_name: '卓资',
                        hidden: 0,
                    },
                    {
                        code: '150922',
                        name: '化德县',
                        simple_name: '化德',
                        hidden: 0,
                    },
                    {
                        code: '150923',
                        name: '商都县',
                        simple_name: '商都',
                        hidden: 0,
                    },
                    {
                        code: '150924',
                        name: '兴和县',
                        simple_name: '兴和',
                        hidden: 0,
                    },
                    {
                        code: '150925',
                        name: '凉城县',
                        simple_name: '凉城',
                        hidden: 0,
                    },
                    {
                        code: '150926',
                        name: '察哈尔右翼前旗',
                        simple_name: '察右前旗',
                        hidden: 0,
                    },
                    {
                        code: '150927',
                        name: '察哈尔右翼中旗',
                        simple_name: '察右中旗',
                        hidden: 0,
                    },
                    {
                        code: '150928',
                        name: '察哈尔右翼后旗',
                        simple_name: '察右后旗',
                        hidden: 0,
                    },
                    {
                        code: '150929',
                        name: '四子王旗',
                        simple_name: '四子王旗',
                        hidden: 0,
                    },
                    {
                        code: '150981',
                        name: '丰镇市',
                        simple_name: '丰镇',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '152200',
                name: '兴安盟',
                simple_name: '兴安盟',
                hidden: 0,
                districts: [
                    {
                        code: '152201',
                        name: '乌兰浩特市',
                        simple_name: '乌兰浩特',
                        hidden: 0,
                    },
                    {
                        code: '152202',
                        name: '阿尔山市',
                        simple_name: '阿尔山',
                        hidden: 0,
                    },
                    {
                        code: '152221',
                        name: '科尔沁右翼前旗',
                        simple_name: '科右前旗',
                        hidden: 0,
                    },
                    {
                        code: '152222',
                        name: '科尔沁右翼中旗',
                        simple_name: '科右中旗',
                        hidden: 0,
                    },
                    {
                        code: '152223',
                        name: '扎赉特旗',
                        simple_name: '扎赉特旗',
                        hidden: 0,
                    },
                    {
                        code: '152224',
                        name: '突泉县',
                        simple_name: '突泉',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '152500',
                name: '锡林郭勒盟',
                simple_name: '锡林郭勒盟',
                hidden: 0,
                districts: [
                    {
                        code: '152501',
                        name: '二连浩特市',
                        simple_name: '二连浩特',
                        hidden: 0,
                    },
                    {
                        code: '152502',
                        name: '锡林浩特市',
                        simple_name: '锡林浩特',
                        hidden: 0,
                    },
                    {
                        code: '152522',
                        name: '阿巴嘎旗',
                        simple_name: '阿巴嘎旗',
                        hidden: 0,
                    },
                    {
                        code: '152523',
                        name: '苏尼特左旗',
                        simple_name: '苏尼特左旗',
                        hidden: 0,
                    },
                    {
                        code: '152524',
                        name: '苏尼特右旗',
                        simple_name: '苏尼特右旗',
                        hidden: 0,
                    },
                    {
                        code: '152525',
                        name: '东乌珠穆沁旗',
                        simple_name: '东乌旗',
                        hidden: 0,
                    },
                    {
                        code: '152526',
                        name: '西乌珠穆沁旗',
                        simple_name: '西乌旗',
                        hidden: 0,
                    },
                    {
                        code: '152527',
                        name: '太仆寺旗',
                        simple_name: '太仆寺旗',
                        hidden: 0,
                    },
                    {
                        code: '152528',
                        name: '镶黄旗',
                        simple_name: '镶黄旗',
                        hidden: 0,
                    },
                    {
                        code: '152529',
                        name: '正镶白旗',
                        simple_name: '正镶白旗',
                        hidden: 0,
                    },
                    {
                        code: '152530',
                        name: '正蓝旗',
                        simple_name: '正蓝旗',
                        hidden: 0,
                    },
                    {
                        code: '152531',
                        name: '多伦县',
                        simple_name: '多伦',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '152900',
                name: '阿拉善盟',
                simple_name: '阿拉善盟',
                hidden: 0,
                districts: [
                    {
                        code: '152921',
                        name: '阿拉善左旗',
                        simple_name: '阿拉善左旗',
                        hidden: 0,
                    },
                    {
                        code: '152922',
                        name: '阿拉善右旗',
                        simple_name: '阿拉善右旗',
                        hidden: 0,
                    },
                    {
                        code: '152923',
                        name: '额济纳旗',
                        simple_name: '额济纳旗',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '210000',
        name: '辽宁省',
        simple_name: '辽宁',
        hidden: 0,
        cities: [
            {
                code: '210100',
                name: '沈阳市',
                simple_name: '沈阳',
                hidden: 0,
                districts: [
                    {
                        code: '210102',
                        name: '和平区',
                        simple_name: '和平',
                        hidden: 0,
                    },
                    {
                        code: '210103',
                        name: '沈河区',
                        simple_name: '沈河',
                        hidden: 0,
                    },
                    {
                        code: '210104',
                        name: '大东区',
                        simple_name: '大东',
                        hidden: 0,
                    },
                    {
                        code: '210105',
                        name: '皇姑区',
                        simple_name: '皇姑',
                        hidden: 0,
                    },
                    {
                        code: '210106',
                        name: '铁西区',
                        simple_name: '铁西',
                        hidden: 0,
                    },
                    {
                        code: '210111',
                        name: '苏家屯区',
                        simple_name: '苏家屯',
                        hidden: 0,
                    },
                    {
                        code: '210112',
                        name: '浑南区',
                        simple_name: '浑南',
                        hidden: 0,
                    },
                    {
                        code: '210113',
                        name: '沈北新区',
                        simple_name: '沈北新区',
                        hidden: 0,
                    },
                    {
                        code: '210114',
                        name: '于洪区',
                        simple_name: '于洪',
                        hidden: 0,
                    },
                    {
                        code: '210122',
                        name: '辽中县',
                        simple_name: '辽中',
                        hidden: 0,
                    },
                    {
                        code: '210123',
                        name: '康平县',
                        simple_name: '康平',
                        hidden: 0,
                    },
                    {
                        code: '210124',
                        name: '法库县',
                        simple_name: '法库',
                        hidden: 0,
                    },
                    {
                        code: '210181',
                        name: '新民市',
                        simple_name: '新民',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210200',
                name: '大连市',
                simple_name: '大连',
                hidden: 0,
                districts: [
                    {
                        code: '210202',
                        name: '中山区',
                        simple_name: '中山',
                        hidden: 0,
                    },
                    {
                        code: '210203',
                        name: '西岗区',
                        simple_name: '西岗',
                        hidden: 0,
                    },
                    {
                        code: '210204',
                        name: '沙河口区',
                        simple_name: '沙河口',
                        hidden: 0,
                    },
                    {
                        code: '210211',
                        name: '甘井子区',
                        simple_name: '甘井子',
                        hidden: 0,
                    },
                    {
                        code: '210212',
                        name: '旅顺口区',
                        simple_name: '旅顺口',
                        hidden: 0,
                    },
                    {
                        code: '210213',
                        name: '金州区',
                        simple_name: '金州',
                        hidden: 0,
                    },
                    {
                        code: '210224',
                        name: '长海县',
                        simple_name: '长海',
                        hidden: 0,
                    },
                    {
                        code: '210281',
                        name: '瓦房店市',
                        simple_name: '瓦房店',
                        hidden: 0,
                    },
                    {
                        code: '210282',
                        name: '普兰店市',
                        simple_name: '普兰店',
                        hidden: 0,
                    },
                    {
                        code: '210283',
                        name: '庄河市',
                        simple_name: '庄河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210300',
                name: '鞍山市',
                simple_name: '鞍山',
                hidden: 0,
                districts: [
                    {
                        code: '210302',
                        name: '铁东区',
                        simple_name: '铁东',
                        hidden: 0,
                    },
                    {
                        code: '210303',
                        name: '铁西区',
                        simple_name: '铁西',
                        hidden: 0,
                    },
                    {
                        code: '210304',
                        name: '立山区',
                        simple_name: '立山',
                        hidden: 0,
                    },
                    {
                        code: '210311',
                        name: '千山区',
                        simple_name: '千山',
                        hidden: 0,
                    },
                    {
                        code: '210321',
                        name: '台安县',
                        simple_name: '台安',
                        hidden: 0,
                    },
                    {
                        code: '210323',
                        name: '岫岩满族自治县',
                        simple_name: '岫岩',
                        hidden: 0,
                    },
                    {
                        code: '210381',
                        name: '海城市',
                        simple_name: '海城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210400',
                name: '抚顺市',
                simple_name: '抚顺',
                hidden: 0,
                districts: [
                    {
                        code: '210402',
                        name: '新抚区',
                        simple_name: '新抚',
                        hidden: 0,
                    },
                    {
                        code: '210403',
                        name: '东洲区',
                        simple_name: '东洲',
                        hidden: 0,
                    },
                    {
                        code: '210404',
                        name: '望花区',
                        simple_name: '望花',
                        hidden: 0,
                    },
                    {
                        code: '210411',
                        name: '顺城区',
                        simple_name: '顺城',
                        hidden: 0,
                    },
                    {
                        code: '210421',
                        name: '抚顺县',
                        simple_name: '抚顺',
                        hidden: 0,
                    },
                    {
                        code: '210422',
                        name: '新宾满族自治县',
                        simple_name: '新宾',
                        hidden: 0,
                    },
                    {
                        code: '210423',
                        name: '清原满族自治县',
                        simple_name: '清原',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210500',
                name: '本溪市',
                simple_name: '本溪',
                hidden: 0,
                districts: [
                    {
                        code: '210502',
                        name: '平山区',
                        simple_name: '平山',
                        hidden: 0,
                    },
                    {
                        code: '210503',
                        name: '溪湖区',
                        simple_name: '溪湖',
                        hidden: 0,
                    },
                    {
                        code: '210504',
                        name: '明山区',
                        simple_name: '明山',
                        hidden: 0,
                    },
                    {
                        code: '210505',
                        name: '南芬区',
                        simple_name: '南芬',
                        hidden: 0,
                    },
                    {
                        code: '210521',
                        name: '本溪满族自治县',
                        simple_name: '本溪',
                        hidden: 0,
                    },
                    {
                        code: '210522',
                        name: '桓仁满族自治县',
                        simple_name: '桓仁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210600',
                name: '丹东市',
                simple_name: '丹东',
                hidden: 0,
                districts: [
                    {
                        code: '210602',
                        name: '元宝区',
                        simple_name: '元宝',
                        hidden: 0,
                    },
                    {
                        code: '210603',
                        name: '振兴区',
                        simple_name: '振兴',
                        hidden: 0,
                    },
                    {
                        code: '210604',
                        name: '振安区',
                        simple_name: '振安',
                        hidden: 0,
                    },
                    {
                        code: '210624',
                        name: '宽甸满族自治县',
                        simple_name: '宽甸',
                        hidden: 0,
                    },
                    {
                        code: '210681',
                        name: '东港市',
                        simple_name: '东港',
                        hidden: 0,
                    },
                    {
                        code: '210682',
                        name: '凤城市',
                        simple_name: '凤城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210700',
                name: '锦州市',
                simple_name: '锦州',
                hidden: 0,
                districts: [
                    {
                        code: '210702',
                        name: '古塔区',
                        simple_name: '古塔',
                        hidden: 0,
                    },
                    {
                        code: '210703',
                        name: '凌河区',
                        simple_name: '凌河',
                        hidden: 0,
                    },
                    {
                        code: '210711',
                        name: '太和区',
                        simple_name: '太和',
                        hidden: 0,
                    },
                    {
                        code: '210726',
                        name: '黑山县',
                        simple_name: '黑山',
                        hidden: 0,
                    },
                    {
                        code: '210727',
                        name: '义县',
                        simple_name: '义县',
                        hidden: 0,
                    },
                    {
                        code: '210781',
                        name: '凌海市',
                        simple_name: '凌海',
                        hidden: 0,
                    },
                    {
                        code: '210782',
                        name: '北镇市',
                        simple_name: '北镇',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210800',
                name: '营口市',
                simple_name: '营口',
                hidden: 0,
                districts: [
                    {
                        code: '210802',
                        name: '站前区',
                        simple_name: '站前',
                        hidden: 0,
                    },
                    {
                        code: '210803',
                        name: '西市区',
                        simple_name: '西市',
                        hidden: 0,
                    },
                    {
                        code: '210804',
                        name: '鲅鱼圈区',
                        simple_name: '鲅鱼圈',
                        hidden: 0,
                    },
                    {
                        code: '210811',
                        name: '老边区',
                        simple_name: '老边',
                        hidden: 0,
                    },
                    {
                        code: '210881',
                        name: '盖州市',
                        simple_name: '盖州',
                        hidden: 0,
                    },
                    {
                        code: '210882',
                        name: '大石桥市',
                        simple_name: '大石桥',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '210900',
                name: '阜新市',
                simple_name: '阜新',
                hidden: 0,
                districts: [
                    {
                        code: '210902',
                        name: '海州区',
                        simple_name: '海州',
                        hidden: 0,
                    },
                    {
                        code: '210903',
                        name: '新邱区',
                        simple_name: '新邱',
                        hidden: 0,
                    },
                    {
                        code: '210904',
                        name: '太平区',
                        simple_name: '太平',
                        hidden: 0,
                    },
                    {
                        code: '210905',
                        name: '清河门区',
                        simple_name: '清河门',
                        hidden: 0,
                    },
                    {
                        code: '210911',
                        name: '细河区',
                        simple_name: '细河',
                        hidden: 0,
                    },
                    {
                        code: '210921',
                        name: '阜新蒙古族自治县',
                        simple_name: '阜新',
                        hidden: 0,
                    },
                    {
                        code: '210922',
                        name: '彰武县',
                        simple_name: '彰武',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '211000',
                name: '辽阳市',
                simple_name: '辽阳',
                hidden: 0,
                districts: [
                    {
                        code: '211002',
                        name: '白塔区',
                        simple_name: '白塔',
                        hidden: 0,
                    },
                    {
                        code: '211003',
                        name: '文圣区',
                        simple_name: '文圣',
                        hidden: 0,
                    },
                    {
                        code: '211004',
                        name: '宏伟区',
                        simple_name: '宏伟',
                        hidden: 0,
                    },
                    {
                        code: '211005',
                        name: '弓长岭区',
                        simple_name: '弓长岭',
                        hidden: 0,
                    },
                    {
                        code: '211011',
                        name: '太子河区',
                        simple_name: '太子河',
                        hidden: 0,
                    },
                    {
                        code: '211021',
                        name: '辽阳县',
                        simple_name: '辽阳',
                        hidden: 0,
                    },
                    {
                        code: '211081',
                        name: '灯塔市',
                        simple_name: '灯塔',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '211100',
                name: '盘锦市',
                simple_name: '盘锦',
                hidden: 0,
                districts: [
                    {
                        code: '211102',
                        name: '双台子区',
                        simple_name: '双台子',
                        hidden: 0,
                    },
                    {
                        code: '211103',
                        name: '兴隆台区',
                        simple_name: '兴隆台',
                        hidden: 0,
                    },
                    {
                        code: '211121',
                        name: '大洼县',
                        simple_name: '大洼',
                        hidden: 0,
                    },
                    {
                        code: '211122',
                        name: '盘山县',
                        simple_name: '盘山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '211200',
                name: '铁岭市',
                simple_name: '铁岭',
                hidden: 0,
                districts: [
                    {
                        code: '211202',
                        name: '银州区',
                        simple_name: '银州',
                        hidden: 0,
                    },
                    {
                        code: '211204',
                        name: '清河区',
                        simple_name: '清河',
                        hidden: 0,
                    },
                    {
                        code: '211221',
                        name: '铁岭县',
                        simple_name: '铁岭',
                        hidden: 0,
                    },
                    {
                        code: '211223',
                        name: '西丰县',
                        simple_name: '西丰',
                        hidden: 0,
                    },
                    {
                        code: '211224',
                        name: '昌图县',
                        simple_name: '昌图',
                        hidden: 0,
                    },
                    {
                        code: '211281',
                        name: '调兵山市',
                        simple_name: '调兵山',
                        hidden: 0,
                    },
                    {
                        code: '211282',
                        name: '开原市',
                        simple_name: '开原',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '211300',
                name: '朝阳市',
                simple_name: '朝阳',
                hidden: 0,
                districts: [
                    {
                        code: '211302',
                        name: '双塔区',
                        simple_name: '双塔',
                        hidden: 0,
                    },
                    {
                        code: '211303',
                        name: '龙城区',
                        simple_name: '龙城',
                        hidden: 0,
                    },
                    {
                        code: '211321',
                        name: '朝阳县',
                        simple_name: '朝阳',
                        hidden: 0,
                    },
                    {
                        code: '211322',
                        name: '建平县',
                        simple_name: '建平',
                        hidden: 0,
                    },
                    {
                        code: '211324',
                        name: '喀喇沁左翼蒙古族自治县',
                        simple_name: '喀喇沁左翼',
                        hidden: 0,
                    },
                    {
                        code: '211381',
                        name: '北票市',
                        simple_name: '北票',
                        hidden: 0,
                    },
                    {
                        code: '211382',
                        name: '凌源市',
                        simple_name: '凌源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '211400',
                name: '葫芦岛市',
                simple_name: '葫芦岛',
                hidden: 0,
                districts: [
                    {
                        code: '211402',
                        name: '连山区',
                        simple_name: '连山',
                        hidden: 0,
                    },
                    {
                        code: '211403',
                        name: '龙港区',
                        simple_name: '龙港',
                        hidden: 0,
                    },
                    {
                        code: '211404',
                        name: '南票区',
                        simple_name: '南票',
                        hidden: 0,
                    },
                    {
                        code: '211421',
                        name: '绥中县',
                        simple_name: '绥中',
                        hidden: 0,
                    },
                    {
                        code: '211422',
                        name: '建昌县',
                        simple_name: '建昌',
                        hidden: 0,
                    },
                    {
                        code: '211481',
                        name: '兴城市',
                        simple_name: '兴城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '211500',
                name: '金普新区',
                simple_name: '金普新区',
                hidden: 0,
                districts: [
                    {
                        code: '211501',
                        name: '金州新区',
                        simple_name: '金州新区',
                        hidden: 0,
                    },
                    {
                        code: '211502',
                        name: '普湾新区',
                        simple_name: '普湾新区',
                        hidden: 0,
                    },
                    {
                        code: '211503',
                        name: '保税区',
                        simple_name: '保税区',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '220000',
        name: '吉林省',
        simple_name: '吉林',
        hidden: 0,
        cities: [
            {
                code: '220100',
                name: '长春市',
                simple_name: '长春',
                hidden: 0,
                districts: [
                    {
                        code: '220102',
                        name: '南关区',
                        simple_name: '南关',
                        hidden: 0,
                    },
                    {
                        code: '220103',
                        name: '宽城区',
                        simple_name: '宽城',
                        hidden: 0,
                    },
                    {
                        code: '220104',
                        name: '朝阳区',
                        simple_name: '朝阳',
                        hidden: 0,
                    },
                    {
                        code: '220105',
                        name: '二道区',
                        simple_name: '二道',
                        hidden: 0,
                    },
                    {
                        code: '220106',
                        name: '绿园区',
                        simple_name: '绿园',
                        hidden: 0,
                    },
                    {
                        code: '220112',
                        name: '双阳区',
                        simple_name: '双阳',
                        hidden: 0,
                    },
                    {
                        code: '220113',
                        name: '九台区',
                        simple_name: '九台',
                        hidden: 0,
                    },
                    {
                        code: '220122',
                        name: '农安县',
                        simple_name: '农安',
                        hidden: 0,
                    },
                    {
                        code: '220182',
                        name: '榆树市',
                        simple_name: '榆树',
                        hidden: 0,
                    },
                    {
                        code: '220183',
                        name: '德惠市',
                        simple_name: '德惠',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220200',
                name: '吉林市',
                simple_name: '吉林',
                hidden: 0,
                districts: [
                    {
                        code: '220202',
                        name: '昌邑区',
                        simple_name: '昌邑',
                        hidden: 0,
                    },
                    {
                        code: '220203',
                        name: '龙潭区',
                        simple_name: '龙潭',
                        hidden: 0,
                    },
                    {
                        code: '220204',
                        name: '船营区',
                        simple_name: '船营',
                        hidden: 0,
                    },
                    {
                        code: '220211',
                        name: '丰满区',
                        simple_name: '丰满',
                        hidden: 0,
                    },
                    {
                        code: '220221',
                        name: '永吉县',
                        simple_name: '永吉',
                        hidden: 0,
                    },
                    {
                        code: '220281',
                        name: '蛟河市',
                        simple_name: '蛟河',
                        hidden: 0,
                    },
                    {
                        code: '220282',
                        name: '桦甸市',
                        simple_name: '桦甸',
                        hidden: 0,
                    },
                    {
                        code: '220283',
                        name: '舒兰市',
                        simple_name: '舒兰',
                        hidden: 0,
                    },
                    {
                        code: '220284',
                        name: '磐石市',
                        simple_name: '磐石',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220300',
                name: '四平市',
                simple_name: '四平',
                hidden: 0,
                districts: [
                    {
                        code: '220302',
                        name: '铁西区',
                        simple_name: '铁西',
                        hidden: 0,
                    },
                    {
                        code: '220303',
                        name: '铁东区',
                        simple_name: '铁东',
                        hidden: 0,
                    },
                    {
                        code: '220322',
                        name: '梨树县',
                        simple_name: '梨树',
                        hidden: 0,
                    },
                    {
                        code: '220323',
                        name: '伊通满族自治县',
                        simple_name: '伊通',
                        hidden: 0,
                    },
                    {
                        code: '220381',
                        name: '公主岭市',
                        simple_name: '公主岭',
                        hidden: 0,
                    },
                    {
                        code: '220382',
                        name: '双辽市',
                        simple_name: '双辽',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220400',
                name: '辽源市',
                simple_name: '辽源',
                hidden: 0,
                districts: [
                    {
                        code: '220402',
                        name: '龙山区',
                        simple_name: '龙山',
                        hidden: 0,
                    },
                    {
                        code: '220403',
                        name: '西安区',
                        simple_name: '西安',
                        hidden: 0,
                    },
                    {
                        code: '220421',
                        name: '东丰县',
                        simple_name: '东丰',
                        hidden: 0,
                    },
                    {
                        code: '220422',
                        name: '东辽县',
                        simple_name: '东辽',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220500',
                name: '通化市',
                simple_name: '通化',
                hidden: 0,
                districts: [
                    {
                        code: '220502',
                        name: '东昌区',
                        simple_name: '东昌',
                        hidden: 0,
                    },
                    {
                        code: '220503',
                        name: '二道江区',
                        simple_name: '二道江',
                        hidden: 0,
                    },
                    {
                        code: '220521',
                        name: '通化县',
                        simple_name: '通化',
                        hidden: 0,
                    },
                    {
                        code: '220523',
                        name: '辉南县',
                        simple_name: '辉南',
                        hidden: 0,
                    },
                    {
                        code: '220524',
                        name: '柳河县',
                        simple_name: '柳河',
                        hidden: 0,
                    },
                    {
                        code: '220581',
                        name: '梅河口市',
                        simple_name: '梅河口',
                        hidden: 0,
                    },
                    {
                        code: '220582',
                        name: '集安市',
                        simple_name: '集安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220600',
                name: '白山市',
                simple_name: '白山',
                hidden: 0,
                districts: [
                    {
                        code: '220602',
                        name: '浑江区',
                        simple_name: '浑江',
                        hidden: 0,
                    },
                    {
                        code: '220605',
                        name: '江源区',
                        simple_name: '江源',
                        hidden: 0,
                    },
                    {
                        code: '220621',
                        name: '抚松县',
                        simple_name: '抚松',
                        hidden: 0,
                    },
                    {
                        code: '220622',
                        name: '靖宇县',
                        simple_name: '靖宇',
                        hidden: 0,
                    },
                    {
                        code: '220623',
                        name: '长白朝鲜族自治县',
                        simple_name: '长白',
                        hidden: 0,
                    },
                    {
                        code: '220681',
                        name: '临江市',
                        simple_name: '临江',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220700',
                name: '松原市',
                simple_name: '松原',
                hidden: 0,
                districts: [
                    {
                        code: '220702',
                        name: '宁江区',
                        simple_name: '宁江',
                        hidden: 0,
                    },
                    {
                        code: '220721',
                        name: '前郭尔罗斯蒙古族自治县',
                        simple_name: '前郭尔罗斯',
                        hidden: 0,
                    },
                    {
                        code: '220722',
                        name: '长岭县',
                        simple_name: '长岭',
                        hidden: 0,
                    },
                    {
                        code: '220723',
                        name: '乾安县',
                        simple_name: '乾安',
                        hidden: 0,
                    },
                    {
                        code: '220781',
                        name: '扶余市',
                        simple_name: '扶余',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '220800',
                name: '白城市',
                simple_name: '白城',
                hidden: 0,
                districts: [
                    {
                        code: '220802',
                        name: '洮北区',
                        simple_name: '洮北',
                        hidden: 0,
                    },
                    {
                        code: '220821',
                        name: '镇赉县',
                        simple_name: '镇赉',
                        hidden: 0,
                    },
                    {
                        code: '220822',
                        name: '通榆县',
                        simple_name: '通榆',
                        hidden: 0,
                    },
                    {
                        code: '220881',
                        name: '洮南市',
                        simple_name: '洮南',
                        hidden: 0,
                    },
                    {
                        code: '220882',
                        name: '大安市',
                        simple_name: '大安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '222400',
                name: '延边朝鲜族自治州',
                simple_name: '延边',
                hidden: 0,
                districts: [
                    {
                        code: '222401',
                        name: '延吉市',
                        simple_name: '延吉',
                        hidden: 0,
                    },
                    {
                        code: '222402',
                        name: '图们市',
                        simple_name: '图们',
                        hidden: 0,
                    },
                    {
                        code: '222403',
                        name: '敦化市',
                        simple_name: '敦化',
                        hidden: 0,
                    },
                    {
                        code: '222404',
                        name: '珲春市',
                        simple_name: '珲春',
                        hidden: 0,
                    },
                    {
                        code: '222405',
                        name: '龙井市',
                        simple_name: '龙井',
                        hidden: 0,
                    },
                    {
                        code: '222406',
                        name: '和龙市',
                        simple_name: '和龙',
                        hidden: 0,
                    },
                    {
                        code: '222424',
                        name: '汪清县',
                        simple_name: '汪清',
                        hidden: 0,
                    },
                    {
                        code: '222426',
                        name: '安图县',
                        simple_name: '安图',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '230000',
        name: '黑龙江省',
        simple_name: '黑龙江',
        hidden: 0,
        cities: [
            {
                code: '230100',
                name: '哈尔滨市',
                simple_name: '哈尔滨',
                hidden: 0,
                districts: [
                    {
                        code: '230102',
                        name: '道里区',
                        simple_name: '道里',
                        hidden: 0,
                    },
                    {
                        code: '230103',
                        name: '南岗区',
                        simple_name: '南岗',
                        hidden: 0,
                    },
                    {
                        code: '230104',
                        name: '道外区',
                        simple_name: '道外',
                        hidden: 0,
                    },
                    {
                        code: '230108',
                        name: '平房区',
                        simple_name: '平房',
                        hidden: 0,
                    },
                    {
                        code: '230109',
                        name: '松北区',
                        simple_name: '松北',
                        hidden: 0,
                    },
                    {
                        code: '230110',
                        name: '香坊区',
                        simple_name: '香坊',
                        hidden: 0,
                    },
                    {
                        code: '230111',
                        name: '呼兰区',
                        simple_name: '呼兰',
                        hidden: 0,
                    },
                    {
                        code: '230112',
                        name: '阿城区',
                        simple_name: '阿城',
                        hidden: 0,
                    },
                    {
                        code: '230113',
                        name: '双城区',
                        simple_name: '双城',
                        hidden: 0,
                    },
                    {
                        code: '230123',
                        name: '依兰县',
                        simple_name: '依兰',
                        hidden: 0,
                    },
                    {
                        code: '230124',
                        name: '方正县',
                        simple_name: '方正',
                        hidden: 0,
                    },
                    {
                        code: '230125',
                        name: '宾县',
                        simple_name: '宾县',
                        hidden: 0,
                    },
                    {
                        code: '230126',
                        name: '巴彦县',
                        simple_name: '巴彦',
                        hidden: 0,
                    },
                    {
                        code: '230127',
                        name: '木兰县',
                        simple_name: '木兰',
                        hidden: 0,
                    },
                    {
                        code: '230128',
                        name: '通河县',
                        simple_name: '通河',
                        hidden: 0,
                    },
                    {
                        code: '230129',
                        name: '延寿县',
                        simple_name: '延寿',
                        hidden: 0,
                    },
                    {
                        code: '230183',
                        name: '尚志市',
                        simple_name: '尚志',
                        hidden: 0,
                    },
                    {
                        code: '230184',
                        name: '五常市',
                        simple_name: '五常',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230200',
                name: '齐齐哈尔市',
                simple_name: '齐齐哈尔',
                hidden: 0,
                districts: [
                    {
                        code: '230202',
                        name: '龙沙区',
                        simple_name: '龙沙',
                        hidden: 0,
                    },
                    {
                        code: '230203',
                        name: '建华区',
                        simple_name: '建华',
                        hidden: 0,
                    },
                    {
                        code: '230204',
                        name: '铁锋区',
                        simple_name: '铁锋',
                        hidden: 0,
                    },
                    {
                        code: '230205',
                        name: '昂昂溪区',
                        simple_name: '昂昂溪',
                        hidden: 0,
                    },
                    {
                        code: '230206',
                        name: '富拉尔基区',
                        simple_name: '富拉尔基',
                        hidden: 0,
                    },
                    {
                        code: '230207',
                        name: '碾子山区',
                        simple_name: '碾子山',
                        hidden: 0,
                    },
                    {
                        code: '230208',
                        name: '梅里斯达斡尔族区',
                        simple_name: '梅里斯',
                        hidden: 0,
                    },
                    {
                        code: '230221',
                        name: '龙江县',
                        simple_name: '龙江',
                        hidden: 0,
                    },
                    {
                        code: '230223',
                        name: '依安县',
                        simple_name: '依安',
                        hidden: 0,
                    },
                    {
                        code: '230224',
                        name: '泰来县',
                        simple_name: '泰来',
                        hidden: 0,
                    },
                    {
                        code: '230225',
                        name: '甘南县',
                        simple_name: '甘南',
                        hidden: 0,
                    },
                    {
                        code: '230227',
                        name: '富裕县',
                        simple_name: '富裕',
                        hidden: 0,
                    },
                    {
                        code: '230229',
                        name: '克山县',
                        simple_name: '克山',
                        hidden: 0,
                    },
                    {
                        code: '230230',
                        name: '克东县',
                        simple_name: '克东',
                        hidden: 0,
                    },
                    {
                        code: '230231',
                        name: '拜泉县',
                        simple_name: '拜泉',
                        hidden: 0,
                    },
                    {
                        code: '230281',
                        name: '讷河市',
                        simple_name: '讷河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230300',
                name: '鸡西市',
                simple_name: '鸡西',
                hidden: 0,
                districts: [
                    {
                        code: '230302',
                        name: '鸡冠区',
                        simple_name: '鸡冠',
                        hidden: 0,
                    },
                    {
                        code: '230303',
                        name: '恒山区',
                        simple_name: '恒山',
                        hidden: 0,
                    },
                    {
                        code: '230304',
                        name: '滴道区',
                        simple_name: '滴道',
                        hidden: 0,
                    },
                    {
                        code: '230305',
                        name: '梨树区',
                        simple_name: '梨树',
                        hidden: 0,
                    },
                    {
                        code: '230306',
                        name: '城子河区',
                        simple_name: '城子河',
                        hidden: 0,
                    },
                    {
                        code: '230307',
                        name: '麻山区',
                        simple_name: '麻山',
                        hidden: 0,
                    },
                    {
                        code: '230321',
                        name: '鸡东县',
                        simple_name: '鸡东',
                        hidden: 0,
                    },
                    {
                        code: '230381',
                        name: '虎林市',
                        simple_name: '虎林',
                        hidden: 0,
                    },
                    {
                        code: '230382',
                        name: '密山市',
                        simple_name: '密山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230400',
                name: '鹤岗市',
                simple_name: '鹤岗',
                hidden: 0,
                districts: [
                    {
                        code: '230402',
                        name: '向阳区',
                        simple_name: '向阳',
                        hidden: 0,
                    },
                    {
                        code: '230403',
                        name: '工农区',
                        simple_name: '工农',
                        hidden: 0,
                    },
                    {
                        code: '230404',
                        name: '南山区',
                        simple_name: '南山',
                        hidden: 0,
                    },
                    {
                        code: '230405',
                        name: '兴安区',
                        simple_name: '兴安',
                        hidden: 0,
                    },
                    {
                        code: '230406',
                        name: '东山区',
                        simple_name: '东山',
                        hidden: 0,
                    },
                    {
                        code: '230407',
                        name: '兴山区',
                        simple_name: '兴山',
                        hidden: 0,
                    },
                    {
                        code: '230421',
                        name: '萝北县',
                        simple_name: '萝北',
                        hidden: 0,
                    },
                    {
                        code: '230422',
                        name: '绥滨县',
                        simple_name: '绥滨',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230500',
                name: '双鸭山市',
                simple_name: '双鸭山',
                hidden: 0,
                districts: [
                    {
                        code: '230502',
                        name: '尖山区',
                        simple_name: '尖山',
                        hidden: 0,
                    },
                    {
                        code: '230503',
                        name: '岭东区',
                        simple_name: '岭东',
                        hidden: 0,
                    },
                    {
                        code: '230505',
                        name: '四方台区',
                        simple_name: '四方台',
                        hidden: 0,
                    },
                    {
                        code: '230506',
                        name: '宝山区',
                        simple_name: '宝山',
                        hidden: 0,
                    },
                    {
                        code: '230521',
                        name: '集贤县',
                        simple_name: '集贤',
                        hidden: 0,
                    },
                    {
                        code: '230522',
                        name: '友谊县',
                        simple_name: '友谊',
                        hidden: 0,
                    },
                    {
                        code: '230523',
                        name: '宝清县',
                        simple_name: '宝清',
                        hidden: 0,
                    },
                    {
                        code: '230524',
                        name: '饶河县',
                        simple_name: '饶河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230600',
                name: '大庆市',
                simple_name: '大庆',
                hidden: 0,
                districts: [
                    {
                        code: '230602',
                        name: '萨尔图区',
                        simple_name: '萨尔图',
                        hidden: 0,
                    },
                    {
                        code: '230603',
                        name: '龙凤区',
                        simple_name: '龙凤',
                        hidden: 0,
                    },
                    {
                        code: '230604',
                        name: '让胡路区',
                        simple_name: '让胡路',
                        hidden: 0,
                    },
                    {
                        code: '230605',
                        name: '红岗区',
                        simple_name: '红岗',
                        hidden: 0,
                    },
                    {
                        code: '230606',
                        name: '大同区',
                        simple_name: '大同',
                        hidden: 0,
                    },
                    {
                        code: '230621',
                        name: '肇州县',
                        simple_name: '肇州',
                        hidden: 0,
                    },
                    {
                        code: '230622',
                        name: '肇源县',
                        simple_name: '肇源',
                        hidden: 0,
                    },
                    {
                        code: '230623',
                        name: '林甸县',
                        simple_name: '林甸',
                        hidden: 0,
                    },
                    {
                        code: '230624',
                        name: '杜尔伯特蒙古族自治县',
                        simple_name: '杜尔伯特',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230700',
                name: '伊春市',
                simple_name: '伊春',
                hidden: 0,
                districts: [
                    {
                        code: '230702',
                        name: '伊春区',
                        simple_name: '伊春',
                        hidden: 0,
                    },
                    {
                        code: '230703',
                        name: '南岔区',
                        simple_name: '南岔',
                        hidden: 0,
                    },
                    {
                        code: '230704',
                        name: '友好区',
                        simple_name: '友好',
                        hidden: 0,
                    },
                    {
                        code: '230705',
                        name: '西林区',
                        simple_name: '西林',
                        hidden: 0,
                    },
                    {
                        code: '230706',
                        name: '翠峦区',
                        simple_name: '翠峦',
                        hidden: 0,
                    },
                    {
                        code: '230707',
                        name: '新青区',
                        simple_name: '新青',
                        hidden: 0,
                    },
                    {
                        code: '230708',
                        name: '美溪区',
                        simple_name: '美溪',
                        hidden: 0,
                    },
                    {
                        code: '230709',
                        name: '金山屯区',
                        simple_name: '金山屯',
                        hidden: 0,
                    },
                    {
                        code: '230710',
                        name: '五营区',
                        simple_name: '五营',
                        hidden: 0,
                    },
                    {
                        code: '230711',
                        name: '乌马河区',
                        simple_name: '乌马河',
                        hidden: 0,
                    },
                    {
                        code: '230712',
                        name: '汤旺河区',
                        simple_name: '汤旺河',
                        hidden: 0,
                    },
                    {
                        code: '230713',
                        name: '带岭区',
                        simple_name: '带岭',
                        hidden: 0,
                    },
                    {
                        code: '230714',
                        name: '乌伊岭区',
                        simple_name: '乌伊岭',
                        hidden: 0,
                    },
                    {
                        code: '230715',
                        name: '红星区',
                        simple_name: '红星',
                        hidden: 0,
                    },
                    {
                        code: '230716',
                        name: '上甘岭区',
                        simple_name: '上甘岭',
                        hidden: 0,
                    },
                    {
                        code: '230722',
                        name: '嘉荫县',
                        simple_name: '嘉荫',
                        hidden: 0,
                    },
                    {
                        code: '230781',
                        name: '铁力市',
                        simple_name: '铁力',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230800',
                name: '佳木斯市',
                simple_name: '佳木斯',
                hidden: 0,
                districts: [
                    {
                        code: '230803',
                        name: '向阳区',
                        simple_name: '向阳',
                        hidden: 0,
                    },
                    {
                        code: '230804',
                        name: '前进区',
                        simple_name: '前进',
                        hidden: 0,
                    },
                    {
                        code: '230805',
                        name: '东风区',
                        simple_name: '东风',
                        hidden: 0,
                    },
                    {
                        code: '230811',
                        name: '郊区',
                        simple_name: '郊区',
                        hidden: 0,
                    },
                    {
                        code: '230822',
                        name: '桦南县',
                        simple_name: '桦南',
                        hidden: 0,
                    },
                    {
                        code: '230826',
                        name: '桦川县',
                        simple_name: '桦川',
                        hidden: 0,
                    },
                    {
                        code: '230828',
                        name: '汤原县',
                        simple_name: '汤原',
                        hidden: 0,
                    },
                    {
                        code: '230833',
                        name: '抚远县',
                        simple_name: '抚远',
                        hidden: 0,
                    },
                    {
                        code: '230881',
                        name: '同江市',
                        simple_name: '同江',
                        hidden: 0,
                    },
                    {
                        code: '230882',
                        name: '富锦市',
                        simple_name: '富锦',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '230900',
                name: '七台河市',
                simple_name: '七台河',
                hidden: 0,
                districts: [
                    {
                        code: '230902',
                        name: '新兴区',
                        simple_name: '新兴',
                        hidden: 0,
                    },
                    {
                        code: '230903',
                        name: '桃山区',
                        simple_name: '桃山',
                        hidden: 0,
                    },
                    {
                        code: '230904',
                        name: '茄子河区',
                        simple_name: '茄子河',
                        hidden: 0,
                    },
                    {
                        code: '230921',
                        name: '勃利县',
                        simple_name: '勃利',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '231000',
                name: '牡丹江市',
                simple_name: '牡丹江',
                hidden: 0,
                districts: [
                    {
                        code: '231002',
                        name: '东安区',
                        simple_name: '东安',
                        hidden: 0,
                    },
                    {
                        code: '231003',
                        name: '阳明区',
                        simple_name: '阳明',
                        hidden: 0,
                    },
                    {
                        code: '231004',
                        name: '爱民区',
                        simple_name: '爱民',
                        hidden: 0,
                    },
                    {
                        code: '231005',
                        name: '西安区',
                        simple_name: '西安',
                        hidden: 0,
                    },
                    {
                        code: '231024',
                        name: '东宁县',
                        simple_name: '东宁',
                        hidden: 0,
                    },
                    {
                        code: '231025',
                        name: '林口县',
                        simple_name: '林口',
                        hidden: 0,
                    },
                    {
                        code: '231081',
                        name: '绥芬河市',
                        simple_name: '绥芬河',
                        hidden: 0,
                    },
                    {
                        code: '231083',
                        name: '海林市',
                        simple_name: '海林',
                        hidden: 0,
                    },
                    {
                        code: '231084',
                        name: '宁安市',
                        simple_name: '宁安',
                        hidden: 0,
                    },
                    {
                        code: '231085',
                        name: '穆棱市',
                        simple_name: '穆棱',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '231100',
                name: '黑河市',
                simple_name: '黑河',
                hidden: 0,
                districts: [
                    {
                        code: '231102',
                        name: '爱辉区',
                        simple_name: '爱辉',
                        hidden: 0,
                    },
                    {
                        code: '231121',
                        name: '嫩江县',
                        simple_name: '嫩江',
                        hidden: 0,
                    },
                    {
                        code: '231123',
                        name: '逊克县',
                        simple_name: '逊克',
                        hidden: 0,
                    },
                    {
                        code: '231124',
                        name: '孙吴县',
                        simple_name: '孙吴',
                        hidden: 0,
                    },
                    {
                        code: '231181',
                        name: '北安市',
                        simple_name: '北安',
                        hidden: 0,
                    },
                    {
                        code: '231182',
                        name: '五大连池市',
                        simple_name: '五大连池',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '231200',
                name: '绥化市',
                simple_name: '绥化',
                hidden: 0,
                districts: [
                    {
                        code: '231202',
                        name: '北林区',
                        simple_name: '北林',
                        hidden: 0,
                    },
                    {
                        code: '231221',
                        name: '望奎县',
                        simple_name: '望奎',
                        hidden: 0,
                    },
                    {
                        code: '231222',
                        name: '兰西县',
                        simple_name: '兰西',
                        hidden: 0,
                    },
                    {
                        code: '231223',
                        name: '青冈县',
                        simple_name: '青冈',
                        hidden: 0,
                    },
                    {
                        code: '231224',
                        name: '庆安县',
                        simple_name: '庆安',
                        hidden: 0,
                    },
                    {
                        code: '231225',
                        name: '明水县',
                        simple_name: '明水',
                        hidden: 0,
                    },
                    {
                        code: '231226',
                        name: '绥棱县',
                        simple_name: '绥棱',
                        hidden: 0,
                    },
                    {
                        code: '231281',
                        name: '安达市',
                        simple_name: '安达',
                        hidden: 0,
                    },
                    {
                        code: '231282',
                        name: '肇东市',
                        simple_name: '肇东',
                        hidden: 0,
                    },
                    {
                        code: '231283',
                        name: '海伦市',
                        simple_name: '海伦',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '232700',
                name: '大兴安岭地区',
                simple_name: '大兴安岭',
                hidden: 0,
                districts: [
                    {
                        code: '232701',
                        name: '加格达奇区',
                        simple_name: '加格达奇',
                        hidden: 0,
                    },
                    {
                        code: '232702',
                        name: '新林区',
                        simple_name: '新林',
                        hidden: 0,
                    },
                    {
                        code: '232703',
                        name: '松岭区',
                        simple_name: '松岭',
                        hidden: 0,
                    },
                    {
                        code: '232704',
                        name: '呼中区',
                        simple_name: '呼中',
                        hidden: 0,
                    },
                    {
                        code: '232721',
                        name: '呼玛县',
                        simple_name: '呼玛',
                        hidden: 0,
                    },
                    {
                        code: '232722',
                        name: '塔河县',
                        simple_name: '塔河',
                        hidden: 0,
                    },
                    {
                        code: '232723',
                        name: '漠河县',
                        simple_name: '漠河',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '310000',
        name: '上海',
        simple_name: '上海',
        hidden: 0,
        cities: [
            {
                code: '310100',
                name: '上海市',
                simple_name: '上海',
                hidden: 0,
                districts: [
                    {
                        code: '310101',
                        name: '黄浦区',
                        simple_name: '黄浦',
                        hidden: 0,
                    },
                    {
                        code: '310104',
                        name: '徐汇区',
                        simple_name: '徐汇',
                        hidden: 0,
                    },
                    {
                        code: '310105',
                        name: '长宁区',
                        simple_name: '长宁',
                        hidden: 0,
                    },
                    {
                        code: '310106',
                        name: '静安区',
                        simple_name: '静安',
                        hidden: 0,
                    },
                    {
                        code: '310107',
                        name: '普陀区',
                        simple_name: '普陀',
                        hidden: 0,
                    },
                    {
                        code: '310108',
                        name: '闸北区',
                        simple_name: '闸北',
                        hidden: 0,
                    },
                    {
                        code: '310109',
                        name: '虹口区',
                        simple_name: '虹口',
                        hidden: 0,
                    },
                    {
                        code: '310110',
                        name: '杨浦区',
                        simple_name: '杨浦',
                        hidden: 0,
                    },
                    {
                        code: '310112',
                        name: '闵行区',
                        simple_name: '闵行',
                        hidden: 0,
                    },
                    {
                        code: '310113',
                        name: '宝山区',
                        simple_name: '宝山',
                        hidden: 0,
                    },
                    {
                        code: '310114',
                        name: '嘉定区',
                        simple_name: '嘉定',
                        hidden: 0,
                    },
                    {
                        code: '310115',
                        name: '浦东新区',
                        simple_name: '浦东',
                        hidden: 0,
                    },
                    {
                        code: '310116',
                        name: '金山区',
                        simple_name: '金山',
                        hidden: 0,
                    },
                    {
                        code: '310117',
                        name: '松江区',
                        simple_name: '松江',
                        hidden: 0,
                    },
                    {
                        code: '310118',
                        name: '青浦区',
                        simple_name: '青浦',
                        hidden: 0,
                    },
                    {
                        code: '310120',
                        name: '奉贤区',
                        simple_name: '奉贤',
                        hidden: 0,
                    },
                    {
                        code: '310230',
                        name: '崇明县',
                        simple_name: '崇明',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '320000',
        name: '江苏省',
        simple_name: '江苏',
        hidden: 0,
        cities: [
            {
                code: '320100',
                name: '南京市',
                simple_name: '南京',
                hidden: 0,
                districts: [
                    {
                        code: '320102',
                        name: '玄武区',
                        simple_name: '玄武',
                        hidden: 0,
                    },
                    {
                        code: '320104',
                        name: '秦淮区',
                        simple_name: '秦淮',
                        hidden: 0,
                    },
                    {
                        code: '320105',
                        name: '建邺区',
                        simple_name: '建邺',
                        hidden: 0,
                    },
                    {
                        code: '320106',
                        name: '鼓楼区',
                        simple_name: '鼓楼',
                        hidden: 0,
                    },
                    {
                        code: '320111',
                        name: '浦口区',
                        simple_name: '浦口',
                        hidden: 0,
                    },
                    {
                        code: '320113',
                        name: '栖霞区',
                        simple_name: '栖霞',
                        hidden: 0,
                    },
                    {
                        code: '320114',
                        name: '雨花台区',
                        simple_name: '雨花台',
                        hidden: 0,
                    },
                    {
                        code: '320115',
                        name: '江宁区',
                        simple_name: '江宁',
                        hidden: 0,
                    },
                    {
                        code: '320116',
                        name: '六合区',
                        simple_name: '六合',
                        hidden: 0,
                    },
                    {
                        code: '320117',
                        name: '溧水区',
                        simple_name: '溧水',
                        hidden: 0,
                    },
                    {
                        code: '320118',
                        name: '高淳区',
                        simple_name: '高淳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320200',
                name: '无锡市',
                simple_name: '无锡',
                hidden: 0,
                districts: [
                    {
                        code: '320202',
                        name: '崇安区',
                        simple_name: '崇安',
                        hidden: 0,
                    },
                    {
                        code: '320203',
                        name: '南长区',
                        simple_name: '南长',
                        hidden: 0,
                    },
                    {
                        code: '320204',
                        name: '北塘区',
                        simple_name: '北塘',
                        hidden: 0,
                    },
                    {
                        code: '320205',
                        name: '锡山区',
                        simple_name: '锡山',
                        hidden: 0,
                    },
                    {
                        code: '320206',
                        name: '惠山区',
                        simple_name: '惠山',
                        hidden: 0,
                    },
                    {
                        code: '320211',
                        name: '滨湖区',
                        simple_name: '滨湖',
                        hidden: 0,
                    },
                    {
                        code: '320281',
                        name: '江阴市',
                        simple_name: '江阴',
                        hidden: 0,
                    },
                    {
                        code: '320282',
                        name: '宜兴市',
                        simple_name: '宜兴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320300',
                name: '徐州市',
                simple_name: '徐州',
                hidden: 0,
                districts: [
                    {
                        code: '320302',
                        name: '鼓楼区',
                        simple_name: '鼓楼',
                        hidden: 0,
                    },
                    {
                        code: '320303',
                        name: '云龙区',
                        simple_name: '云龙',
                        hidden: 0,
                    },
                    {
                        code: '320305',
                        name: '贾汪区',
                        simple_name: '贾汪',
                        hidden: 0,
                    },
                    {
                        code: '320311',
                        name: '泉山区',
                        simple_name: '泉山',
                        hidden: 0,
                    },
                    {
                        code: '320312',
                        name: '铜山区',
                        simple_name: '铜山',
                        hidden: 0,
                    },
                    {
                        code: '320321',
                        name: '丰县',
                        simple_name: '丰县',
                        hidden: 0,
                    },
                    {
                        code: '320322',
                        name: '沛县',
                        simple_name: '沛县',
                        hidden: 0,
                    },
                    {
                        code: '320324',
                        name: '睢宁县',
                        simple_name: '睢宁',
                        hidden: 0,
                    },
                    {
                        code: '320381',
                        name: '新沂市',
                        simple_name: '新沂',
                        hidden: 0,
                    },
                    {
                        code: '320382',
                        name: '邳州市',
                        simple_name: '邳州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320400',
                name: '常州市',
                simple_name: '常州',
                hidden: 0,
                districts: [
                    {
                        code: '320402',
                        name: '天宁区',
                        simple_name: '天宁',
                        hidden: 0,
                    },
                    {
                        code: '320404',
                        name: '钟楼区',
                        simple_name: '钟楼',
                        hidden: 0,
                    },
                    {
                        code: '320405',
                        name: '戚墅堰区',
                        simple_name: '戚墅堰',
                        hidden: 0,
                    },
                    {
                        code: '320411',
                        name: '新北区',
                        simple_name: '新北',
                        hidden: 0,
                    },
                    {
                        code: '320412',
                        name: '武进区',
                        simple_name: '武进',
                        hidden: 0,
                    },
                    {
                        code: '320481',
                        name: '溧阳市',
                        simple_name: '溧阳',
                        hidden: 0,
                    },
                    {
                        code: '320482',
                        name: '金坛市',
                        simple_name: '金坛',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320500',
                name: '苏州市',
                simple_name: '苏州',
                hidden: 0,
                districts: [
                    {
                        code: '320505',
                        name: '虎丘区',
                        simple_name: '虎丘',
                        hidden: 0,
                    },
                    {
                        code: '320506',
                        name: '吴中区',
                        simple_name: '吴中',
                        hidden: 0,
                    },
                    {
                        code: '320507',
                        name: '相城区',
                        simple_name: '相城',
                        hidden: 0,
                    },
                    {
                        code: '320508',
                        name: '姑苏区',
                        simple_name: '姑苏',
                        hidden: 0,
                    },
                    {
                        code: '320509',
                        name: '吴江区',
                        simple_name: '吴江',
                        hidden: 0,
                    },
                    {
                        code: '320581',
                        name: '常熟市',
                        simple_name: '常熟',
                        hidden: 0,
                    },
                    {
                        code: '320582',
                        name: '张家港市',
                        simple_name: '张家港',
                        hidden: 0,
                    },
                    {
                        code: '320583',
                        name: '昆山市',
                        simple_name: '昆山',
                        hidden: 0,
                    },
                    {
                        code: '320585',
                        name: '太仓市',
                        simple_name: '太仓',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320600',
                name: '南通市',
                simple_name: '南通',
                hidden: 0,
                districts: [
                    {
                        code: '320602',
                        name: '崇川区',
                        simple_name: '崇川',
                        hidden: 0,
                    },
                    {
                        code: '320611',
                        name: '港闸区',
                        simple_name: '港闸',
                        hidden: 0,
                    },
                    {
                        code: '320612',
                        name: '通州区',
                        simple_name: '通州',
                        hidden: 0,
                    },
                    {
                        code: '320621',
                        name: '海安县',
                        simple_name: '海安',
                        hidden: 0,
                    },
                    {
                        code: '320623',
                        name: '如东县',
                        simple_name: '如东',
                        hidden: 0,
                    },
                    {
                        code: '320681',
                        name: '启东市',
                        simple_name: '启东',
                        hidden: 0,
                    },
                    {
                        code: '320682',
                        name: '如皋市',
                        simple_name: '如皋',
                        hidden: 0,
                    },
                    {
                        code: '320684',
                        name: '海门市',
                        simple_name: '海门',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320700',
                name: '连云港市',
                simple_name: '连云港',
                hidden: 0,
                districts: [
                    {
                        code: '320703',
                        name: '连云区',
                        simple_name: '连云',
                        hidden: 0,
                    },
                    {
                        code: '320706',
                        name: '海州区',
                        simple_name: '海州',
                        hidden: 0,
                    },
                    {
                        code: '320707',
                        name: '赣榆区',
                        simple_name: '赣榆',
                        hidden: 0,
                    },
                    {
                        code: '320722',
                        name: '东海县',
                        simple_name: '东海',
                        hidden: 0,
                    },
                    {
                        code: '320723',
                        name: '灌云县',
                        simple_name: '灌云',
                        hidden: 0,
                    },
                    {
                        code: '320724',
                        name: '灌南县',
                        simple_name: '灌南',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320800',
                name: '淮安市',
                simple_name: '淮安',
                hidden: 0,
                districts: [
                    {
                        code: '320802',
                        name: '清河区',
                        simple_name: '清河',
                        hidden: 0,
                    },
                    {
                        code: '320803',
                        name: '淮安区',
                        simple_name: '淮安',
                        hidden: 0,
                    },
                    {
                        code: '320804',
                        name: '淮阴区',
                        simple_name: '淮阴',
                        hidden: 0,
                    },
                    {
                        code: '320811',
                        name: '清浦区',
                        simple_name: '清浦',
                        hidden: 0,
                    },
                    {
                        code: '320826',
                        name: '涟水县',
                        simple_name: '涟水',
                        hidden: 0,
                    },
                    {
                        code: '320829',
                        name: '洪泽县',
                        simple_name: '洪泽',
                        hidden: 0,
                    },
                    {
                        code: '320830',
                        name: '盱眙县',
                        simple_name: '盱眙',
                        hidden: 0,
                    },
                    {
                        code: '320831',
                        name: '金湖县',
                        simple_name: '金湖',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '320900',
                name: '盐城市',
                simple_name: '盐城',
                hidden: 0,
                districts: [
                    {
                        code: '320902',
                        name: '亭湖区',
                        simple_name: '亭湖',
                        hidden: 0,
                    },
                    {
                        code: '320903',
                        name: '盐都区',
                        simple_name: '盐都',
                        hidden: 0,
                    },
                    {
                        code: '320921',
                        name: '响水县',
                        simple_name: '响水',
                        hidden: 0,
                    },
                    {
                        code: '320922',
                        name: '滨海县',
                        simple_name: '滨海',
                        hidden: 0,
                    },
                    {
                        code: '320923',
                        name: '阜宁县',
                        simple_name: '阜宁',
                        hidden: 0,
                    },
                    {
                        code: '320924',
                        name: '射阳县',
                        simple_name: '射阳',
                        hidden: 0,
                    },
                    {
                        code: '320925',
                        name: '建湖县',
                        simple_name: '建湖',
                        hidden: 0,
                    },
                    {
                        code: '320981',
                        name: '东台市',
                        simple_name: '东台',
                        hidden: 0,
                    },
                    {
                        code: '320982',
                        name: '大丰市',
                        simple_name: '大丰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '321000',
                name: '扬州市',
                simple_name: '扬州',
                hidden: 0,
                districts: [
                    {
                        code: '321002',
                        name: '广陵区',
                        simple_name: '广陵',
                        hidden: 0,
                    },
                    {
                        code: '321003',
                        name: '邗江区',
                        simple_name: '邗江',
                        hidden: 0,
                    },
                    {
                        code: '321012',
                        name: '江都区',
                        simple_name: '江都',
                        hidden: 0,
                    },
                    {
                        code: '321023',
                        name: '宝应县',
                        simple_name: '宝应',
                        hidden: 0,
                    },
                    {
                        code: '321081',
                        name: '仪征市',
                        simple_name: '仪征',
                        hidden: 0,
                    },
                    {
                        code: '321084',
                        name: '高邮市',
                        simple_name: '高邮',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '321100',
                name: '镇江市',
                simple_name: '镇江',
                hidden: 0,
                districts: [
                    {
                        code: '321102',
                        name: '京口区',
                        simple_name: '京口',
                        hidden: 0,
                    },
                    {
                        code: '321111',
                        name: '润州区',
                        simple_name: '润州',
                        hidden: 0,
                    },
                    {
                        code: '321112',
                        name: '丹徒区',
                        simple_name: '丹徒',
                        hidden: 0,
                    },
                    {
                        code: '321181',
                        name: '丹阳市',
                        simple_name: '丹阳',
                        hidden: 0,
                    },
                    {
                        code: '321182',
                        name: '扬中市',
                        simple_name: '扬中',
                        hidden: 0,
                    },
                    {
                        code: '321183',
                        name: '句容市',
                        simple_name: '句容',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '321200',
                name: '泰州市',
                simple_name: '泰州',
                hidden: 0,
                districts: [
                    {
                        code: '321202',
                        name: '海陵区',
                        simple_name: '海陵',
                        hidden: 0,
                    },
                    {
                        code: '321203',
                        name: '高港区',
                        simple_name: '高港',
                        hidden: 0,
                    },
                    {
                        code: '321204',
                        name: '姜堰区',
                        simple_name: '姜堰',
                        hidden: 0,
                    },
                    {
                        code: '321281',
                        name: '兴化市',
                        simple_name: '兴化',
                        hidden: 0,
                    },
                    {
                        code: '321282',
                        name: '靖江市',
                        simple_name: '靖江',
                        hidden: 0,
                    },
                    {
                        code: '321283',
                        name: '泰兴市',
                        simple_name: '泰兴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '321300',
                name: '宿迁市',
                simple_name: '宿迁',
                hidden: 0,
                districts: [
                    {
                        code: '321302',
                        name: '宿城区',
                        simple_name: '宿城',
                        hidden: 0,
                    },
                    {
                        code: '321311',
                        name: '宿豫区',
                        simple_name: '宿豫',
                        hidden: 0,
                    },
                    {
                        code: '321322',
                        name: '沭阳县',
                        simple_name: '沭阳',
                        hidden: 0,
                    },
                    {
                        code: '321323',
                        name: '泗阳县',
                        simple_name: '泗阳',
                        hidden: 0,
                    },
                    {
                        code: '321324',
                        name: '泗洪县',
                        simple_name: '泗洪',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '330000',
        name: '浙江省',
        simple_name: '浙江',
        hidden: 0,
        cities: [
            {
                code: '330100',
                name: '杭州市',
                simple_name: '杭州',
                hidden: 0,
                districts: [
                    {
                        code: '330102',
                        name: '上城区',
                        simple_name: '上城',
                        hidden: 0,
                    },
                    {
                        code: '330103',
                        name: '下城区',
                        simple_name: '下城',
                        hidden: 0,
                    },
                    {
                        code: '330104',
                        name: '江干区',
                        simple_name: '江干',
                        hidden: 0,
                    },
                    {
                        code: '330105',
                        name: '拱墅区',
                        simple_name: '拱墅',
                        hidden: 0,
                    },
                    {
                        code: '330106',
                        name: '西湖区',
                        simple_name: '西湖',
                        hidden: 0,
                    },
                    {
                        code: '330108',
                        name: '滨江区',
                        simple_name: '滨江',
                        hidden: 0,
                    },
                    {
                        code: '330109',
                        name: '萧山区',
                        simple_name: '萧山',
                        hidden: 0,
                    },
                    {
                        code: '330110',
                        name: '余杭区',
                        simple_name: '余杭',
                        hidden: 0,
                    },
                    {
                        code: '330122',
                        name: '桐庐县',
                        simple_name: '桐庐',
                        hidden: 0,
                    },
                    {
                        code: '330127',
                        name: '淳安县',
                        simple_name: '淳安',
                        hidden: 0,
                    },
                    {
                        code: '330182',
                        name: '建德市',
                        simple_name: '建德',
                        hidden: 0,
                    },
                    {
                        code: '330183',
                        name: '富阳区',
                        simple_name: '富阳',
                        hidden: 0,
                    },
                    {
                        code: '330185',
                        name: '临安区',
                        simple_name: '临安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330200',
                name: '宁波市',
                simple_name: '宁波',
                hidden: 0,
                districts: [
                    {
                        code: '330203',
                        name: '海曙区',
                        simple_name: '海曙',
                        hidden: 0,
                    },
                    {
                        code: '330204',
                        name: '江东区',
                        simple_name: '江东',
                        hidden: 0,
                    },
                    {
                        code: '330205',
                        name: '江北区',
                        simple_name: '江北',
                        hidden: 0,
                    },
                    {
                        code: '330206',
                        name: '北仑区',
                        simple_name: '北仑',
                        hidden: 0,
                    },
                    {
                        code: '330211',
                        name: '镇海区',
                        simple_name: '镇海',
                        hidden: 0,
                    },
                    {
                        code: '330212',
                        name: '鄞州区',
                        simple_name: '鄞州',
                        hidden: 0,
                    },
                    {
                        code: '330225',
                        name: '象山县',
                        simple_name: '象山',
                        hidden: 0,
                    },
                    {
                        code: '330226',
                        name: '宁海县',
                        simple_name: '宁海',
                        hidden: 0,
                    },
                    {
                        code: '330281',
                        name: '余姚市',
                        simple_name: '余姚',
                        hidden: 0,
                    },
                    {
                        code: '330282',
                        name: '慈溪市',
                        simple_name: '慈溪',
                        hidden: 0,
                    },
                    {
                        code: '330283',
                        name: '奉化市',
                        simple_name: '奉化',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330300',
                name: '温州市',
                simple_name: '温州',
                hidden: 0,
                districts: [
                    {
                        code: '330302',
                        name: '鹿城区',
                        simple_name: '鹿城',
                        hidden: 0,
                    },
                    {
                        code: '330303',
                        name: '龙湾区',
                        simple_name: '龙湾',
                        hidden: 0,
                    },
                    {
                        code: '330304',
                        name: '瓯海区',
                        simple_name: '瓯海',
                        hidden: 0,
                    },
                    {
                        code: '330322',
                        name: '洞头县',
                        simple_name: '洞头',
                        hidden: 0,
                    },
                    {
                        code: '330324',
                        name: '永嘉县',
                        simple_name: '永嘉',
                        hidden: 0,
                    },
                    {
                        code: '330326',
                        name: '平阳县',
                        simple_name: '平阳',
                        hidden: 0,
                    },
                    {
                        code: '330327',
                        name: '苍南县',
                        simple_name: '苍南',
                        hidden: 0,
                    },
                    {
                        code: '330328',
                        name: '文成县',
                        simple_name: '文成',
                        hidden: 0,
                    },
                    {
                        code: '330329',
                        name: '泰顺县',
                        simple_name: '泰顺',
                        hidden: 0,
                    },
                    {
                        code: '330381',
                        name: '瑞安市',
                        simple_name: '瑞安',
                        hidden: 0,
                    },
                    {
                        code: '330382',
                        name: '乐清市',
                        simple_name: '乐清',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330400',
                name: '嘉兴市',
                simple_name: '嘉兴',
                hidden: 0,
                districts: [
                    {
                        code: '330402',
                        name: '南湖区',
                        simple_name: '南湖',
                        hidden: 0,
                    },
                    {
                        code: '330411',
                        name: '秀洲区',
                        simple_name: '秀洲',
                        hidden: 0,
                    },
                    {
                        code: '330421',
                        name: '嘉善县',
                        simple_name: '嘉善',
                        hidden: 0,
                    },
                    {
                        code: '330424',
                        name: '海盐县',
                        simple_name: '海盐',
                        hidden: 0,
                    },
                    {
                        code: '330481',
                        name: '海宁市',
                        simple_name: '海宁',
                        hidden: 0,
                    },
                    {
                        code: '330482',
                        name: '平湖市',
                        simple_name: '平湖',
                        hidden: 0,
                    },
                    {
                        code: '330483',
                        name: '桐乡市',
                        simple_name: '桐乡',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330500',
                name: '湖州市',
                simple_name: '湖州',
                hidden: 0,
                districts: [
                    {
                        code: '330502',
                        name: '吴兴区',
                        simple_name: '吴兴',
                        hidden: 0,
                    },
                    {
                        code: '330503',
                        name: '南浔区',
                        simple_name: '南浔',
                        hidden: 0,
                    },
                    {
                        code: '330521',
                        name: '德清县',
                        simple_name: '德清',
                        hidden: 0,
                    },
                    {
                        code: '330522',
                        name: '长兴县',
                        simple_name: '长兴',
                        hidden: 0,
                    },
                    {
                        code: '330523',
                        name: '安吉县',
                        simple_name: '安吉',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330600',
                name: '绍兴市',
                simple_name: '绍兴',
                hidden: 0,
                districts: [
                    {
                        code: '330602',
                        name: '越城区',
                        simple_name: '越城',
                        hidden: 0,
                    },
                    {
                        code: '330603',
                        name: '柯桥区',
                        simple_name: '柯桥',
                        hidden: 0,
                    },
                    {
                        code: '330604',
                        name: '上虞区',
                        simple_name: '上虞',
                        hidden: 0,
                    },
                    {
                        code: '330624',
                        name: '新昌县',
                        simple_name: '新昌',
                        hidden: 0,
                    },
                    {
                        code: '330681',
                        name: '诸暨市',
                        simple_name: '诸暨',
                        hidden: 0,
                    },
                    {
                        code: '330683',
                        name: '嵊州市',
                        simple_name: '嵊州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330700',
                name: '金华市',
                simple_name: '金华',
                hidden: 0,
                districts: [
                    {
                        code: '330702',
                        name: '婺城区',
                        simple_name: '婺城',
                        hidden: 0,
                    },
                    {
                        code: '330703',
                        name: '金东区',
                        simple_name: '金东',
                        hidden: 0,
                    },
                    {
                        code: '330723',
                        name: '武义县',
                        simple_name: '武义',
                        hidden: 0,
                    },
                    {
                        code: '330726',
                        name: '浦江县',
                        simple_name: '浦江',
                        hidden: 0,
                    },
                    {
                        code: '330727',
                        name: '磐安县',
                        simple_name: '磐安',
                        hidden: 0,
                    },
                    {
                        code: '330781',
                        name: '兰溪市',
                        simple_name: '兰溪',
                        hidden: 0,
                    },
                    {
                        code: '330782',
                        name: '义乌市',
                        simple_name: '义乌',
                        hidden: 0,
                    },
                    {
                        code: '330783',
                        name: '东阳市',
                        simple_name: '东阳',
                        hidden: 0,
                    },
                    {
                        code: '330784',
                        name: '永康市',
                        simple_name: '永康',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330800',
                name: '衢州市',
                simple_name: '衢州',
                hidden: 0,
                districts: [
                    {
                        code: '330802',
                        name: '柯城区',
                        simple_name: '柯城',
                        hidden: 0,
                    },
                    {
                        code: '330803',
                        name: '衢江区',
                        simple_name: '衢江',
                        hidden: 0,
                    },
                    {
                        code: '330822',
                        name: '常山县',
                        simple_name: '常山',
                        hidden: 0,
                    },
                    {
                        code: '330824',
                        name: '开化县',
                        simple_name: '开化',
                        hidden: 0,
                    },
                    {
                        code: '330825',
                        name: '龙游县',
                        simple_name: '龙游',
                        hidden: 0,
                    },
                    {
                        code: '330881',
                        name: '江山市',
                        simple_name: '江山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '330900',
                name: '舟山市',
                simple_name: '舟山',
                hidden: 0,
                districts: [
                    {
                        code: '330902',
                        name: '定海区',
                        simple_name: '定海',
                        hidden: 0,
                    },
                    {
                        code: '330903',
                        name: '普陀区',
                        simple_name: '普陀',
                        hidden: 0,
                    },
                    {
                        code: '330921',
                        name: '岱山县',
                        simple_name: '岱山',
                        hidden: 0,
                    },
                    {
                        code: '330922',
                        name: '嵊泗县',
                        simple_name: '嵊泗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '331000',
                name: '台州市',
                simple_name: '台州',
                hidden: 0,
                districts: [
                    {
                        code: '331002',
                        name: '椒江区',
                        simple_name: '椒江',
                        hidden: 0,
                    },
                    {
                        code: '331003',
                        name: '黄岩区',
                        simple_name: '黄岩',
                        hidden: 0,
                    },
                    {
                        code: '331004',
                        name: '路桥区',
                        simple_name: '路桥',
                        hidden: 0,
                    },
                    {
                        code: '331021',
                        name: '玉环县',
                        simple_name: '玉环',
                        hidden: 0,
                    },
                    {
                        code: '331022',
                        name: '三门县',
                        simple_name: '三门',
                        hidden: 0,
                    },
                    {
                        code: '331023',
                        name: '天台县',
                        simple_name: '天台',
                        hidden: 0,
                    },
                    {
                        code: '331024',
                        name: '仙居县',
                        simple_name: '仙居',
                        hidden: 0,
                    },
                    {
                        code: '331081',
                        name: '温岭市',
                        simple_name: '温岭',
                        hidden: 0,
                    },
                    {
                        code: '331082',
                        name: '临海市',
                        simple_name: '临海',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '331100',
                name: '丽水市',
                simple_name: '丽水',
                hidden: 0,
                districts: [
                    {
                        code: '331102',
                        name: '莲都区',
                        simple_name: '莲都',
                        hidden: 0,
                    },
                    {
                        code: '331121',
                        name: '青田县',
                        simple_name: '青田',
                        hidden: 0,
                    },
                    {
                        code: '331122',
                        name: '缙云县',
                        simple_name: '缙云',
                        hidden: 0,
                    },
                    {
                        code: '331123',
                        name: '遂昌县',
                        simple_name: '遂昌',
                        hidden: 0,
                    },
                    {
                        code: '331124',
                        name: '松阳县',
                        simple_name: '松阳',
                        hidden: 0,
                    },
                    {
                        code: '331125',
                        name: '云和县',
                        simple_name: '云和',
                        hidden: 0,
                    },
                    {
                        code: '331126',
                        name: '庆元县',
                        simple_name: '庆元',
                        hidden: 0,
                    },
                    {
                        code: '331127',
                        name: '景宁畲族自治县',
                        simple_name: '景宁',
                        hidden: 0,
                    },
                    {
                        code: '331181',
                        name: '龙泉市',
                        simple_name: '龙泉',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '331200',
                name: '舟山群岛新区',
                simple_name: '舟山新区',
                hidden: 0,
                districts: [
                    {
                        code: '331201',
                        name: '金塘岛',
                        simple_name: '金塘',
                        hidden: 0,
                    },
                    {
                        code: '331202',
                        name: '六横岛',
                        simple_name: '六横',
                        hidden: 0,
                    },
                    {
                        code: '331203',
                        name: '衢山岛',
                        simple_name: '衢山',
                        hidden: 0,
                    },
                    {
                        code: '331204',
                        name: '舟山本岛西北部',
                        simple_name: '舟山',
                        hidden: 0,
                    },
                    {
                        code: '331205',
                        name: '岱山岛西南部',
                        simple_name: '岱山',
                        hidden: 0,
                    },
                    {
                        code: '331206',
                        name: '泗礁岛',
                        simple_name: '泗礁',
                        hidden: 0,
                    },
                    {
                        code: '331207',
                        name: '朱家尖岛',
                        simple_name: '朱家尖',
                        hidden: 0,
                    },
                    {
                        code: '331208',
                        name: '洋山岛',
                        simple_name: '洋山',
                        hidden: 0,
                    },
                    {
                        code: '331209',
                        name: '长涂岛',
                        simple_name: '长涂',
                        hidden: 0,
                    },
                    {
                        code: '331210',
                        name: '虾峙岛',
                        simple_name: '虾峙',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '340000',
        name: '安徽省',
        simple_name: '安徽',
        hidden: 0,
        cities: [
            {
                code: '340100',
                name: '合肥市',
                simple_name: '合肥',
                hidden: 0,
                districts: [
                    {
                        code: '340102',
                        name: '瑶海区',
                        simple_name: '瑶海',
                        hidden: 0,
                    },
                    {
                        code: '340103',
                        name: '庐阳区',
                        simple_name: '庐阳',
                        hidden: 0,
                    },
                    {
                        code: '340104',
                        name: '蜀山区',
                        simple_name: '蜀山',
                        hidden: 0,
                    },
                    {
                        code: '340111',
                        name: '包河区',
                        simple_name: '包河',
                        hidden: 0,
                    },
                    {
                        code: '340121',
                        name: '长丰县',
                        simple_name: '长丰',
                        hidden: 0,
                    },
                    {
                        code: '340122',
                        name: '肥东县',
                        simple_name: '肥东',
                        hidden: 0,
                    },
                    {
                        code: '340123',
                        name: '肥西县',
                        simple_name: '肥西',
                        hidden: 0,
                    },
                    {
                        code: '340124',
                        name: '庐江县',
                        simple_name: '庐江',
                        hidden: 0,
                    },
                    {
                        code: '340181',
                        name: '巢湖市',
                        simple_name: '巢湖',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340200',
                name: '芜湖市',
                simple_name: '芜湖',
                hidden: 0,
                districts: [
                    {
                        code: '340202',
                        name: '镜湖区',
                        simple_name: '镜湖',
                        hidden: 0,
                    },
                    {
                        code: '340203',
                        name: '弋江区',
                        simple_name: '弋江',
                        hidden: 0,
                    },
                    {
                        code: '340207',
                        name: '鸠江区',
                        simple_name: '鸠江',
                        hidden: 0,
                    },
                    {
                        code: '340208',
                        name: '三山区',
                        simple_name: '三山',
                        hidden: 0,
                    },
                    {
                        code: '340221',
                        name: '芜湖县',
                        simple_name: '芜湖',
                        hidden: 0,
                    },
                    {
                        code: '340222',
                        name: '繁昌县',
                        simple_name: '繁昌',
                        hidden: 0,
                    },
                    {
                        code: '340223',
                        name: '南陵县',
                        simple_name: '南陵',
                        hidden: 0,
                    },
                    {
                        code: '340225',
                        name: '无为县',
                        simple_name: '无为',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340300',
                name: '蚌埠市',
                simple_name: '蚌埠',
                hidden: 0,
                districts: [
                    {
                        code: '340302',
                        name: '龙子湖区',
                        simple_name: '龙子湖',
                        hidden: 0,
                    },
                    {
                        code: '340303',
                        name: '蚌山区',
                        simple_name: '蚌山',
                        hidden: 0,
                    },
                    {
                        code: '340304',
                        name: '禹会区',
                        simple_name: '禹会',
                        hidden: 0,
                    },
                    {
                        code: '340311',
                        name: '淮上区',
                        simple_name: '淮上',
                        hidden: 0,
                    },
                    {
                        code: '340321',
                        name: '怀远县',
                        simple_name: '怀远',
                        hidden: 0,
                    },
                    {
                        code: '340322',
                        name: '五河县',
                        simple_name: '五河',
                        hidden: 0,
                    },
                    {
                        code: '340323',
                        name: '固镇县',
                        simple_name: '固镇',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340400',
                name: '淮南市',
                simple_name: '淮南',
                hidden: 0,
                districts: [
                    {
                        code: '340402',
                        name: '大通区',
                        simple_name: '大通',
                        hidden: 0,
                    },
                    {
                        code: '340403',
                        name: '田家庵区',
                        simple_name: '田家庵',
                        hidden: 0,
                    },
                    {
                        code: '340404',
                        name: '谢家集区',
                        simple_name: '谢家集',
                        hidden: 0,
                    },
                    {
                        code: '340405',
                        name: '八公山区',
                        simple_name: '八公山',
                        hidden: 0,
                    },
                    {
                        code: '340406',
                        name: '潘集区',
                        simple_name: '潘集',
                        hidden: 0,
                    },
                    {
                        code: '340421',
                        name: '凤台县',
                        simple_name: '凤台',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340500',
                name: '马鞍山市',
                simple_name: '马鞍山',
                hidden: 0,
                districts: [
                    {
                        code: '340503',
                        name: '花山区',
                        simple_name: '花山',
                        hidden: 0,
                    },
                    {
                        code: '340504',
                        name: '雨山区',
                        simple_name: '雨山',
                        hidden: 0,
                    },
                    {
                        code: '340506',
                        name: '博望区',
                        simple_name: '博望',
                        hidden: 0,
                    },
                    {
                        code: '340521',
                        name: '当涂县',
                        simple_name: '当涂',
                        hidden: 0,
                    },
                    {
                        code: '340522',
                        name: '含山县',
                        simple_name: '含山',
                        hidden: 0,
                    },
                    {
                        code: '340523',
                        name: '和县',
                        simple_name: '和县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340600',
                name: '淮北市',
                simple_name: '淮北',
                hidden: 0,
                districts: [
                    {
                        code: '340602',
                        name: '杜集区',
                        simple_name: '杜集',
                        hidden: 0,
                    },
                    {
                        code: '340603',
                        name: '相山区',
                        simple_name: '相山',
                        hidden: 0,
                    },
                    {
                        code: '340604',
                        name: '烈山区',
                        simple_name: '烈山',
                        hidden: 0,
                    },
                    {
                        code: '340621',
                        name: '濉溪县',
                        simple_name: '濉溪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340700',
                name: '铜陵市',
                simple_name: '铜陵',
                hidden: 0,
                districts: [
                    {
                        code: '340702',
                        name: '铜官山区',
                        simple_name: '铜官山',
                        hidden: 0,
                    },
                    {
                        code: '340703',
                        name: '狮子山区',
                        simple_name: '狮子山',
                        hidden: 0,
                    },
                    {
                        code: '340711',
                        name: '郊区',
                        simple_name: '郊区',
                        hidden: 0,
                    },
                    {
                        code: '340721',
                        name: '铜陵县',
                        simple_name: '铜陵',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '340800',
                name: '安庆市',
                simple_name: '安庆',
                hidden: 0,
                districts: [
                    {
                        code: '340802',
                        name: '迎江区',
                        simple_name: '迎江',
                        hidden: 0,
                    },
                    {
                        code: '340803',
                        name: '大观区',
                        simple_name: '大观',
                        hidden: 0,
                    },
                    {
                        code: '340811',
                        name: '宜秀区',
                        simple_name: '宜秀',
                        hidden: 0,
                    },
                    {
                        code: '340822',
                        name: '怀宁县',
                        simple_name: '怀宁',
                        hidden: 0,
                    },
                    {
                        code: '340823',
                        name: '枞阳县',
                        simple_name: '枞阳',
                        hidden: 0,
                    },
                    {
                        code: '340824',
                        name: '潜山县',
                        simple_name: '潜山',
                        hidden: 0,
                    },
                    {
                        code: '340825',
                        name: '太湖县',
                        simple_name: '太湖',
                        hidden: 0,
                    },
                    {
                        code: '340826',
                        name: '宿松县',
                        simple_name: '宿松',
                        hidden: 0,
                    },
                    {
                        code: '340827',
                        name: '望江县',
                        simple_name: '望江',
                        hidden: 0,
                    },
                    {
                        code: '340828',
                        name: '岳西县',
                        simple_name: '岳西',
                        hidden: 0,
                    },
                    {
                        code: '340881',
                        name: '桐城市',
                        simple_name: '桐城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341000',
                name: '黄山市',
                simple_name: '黄山',
                hidden: 0,
                districts: [
                    {
                        code: '341002',
                        name: '屯溪区',
                        simple_name: '屯溪',
                        hidden: 0,
                    },
                    {
                        code: '341003',
                        name: '黄山区',
                        simple_name: '黄山',
                        hidden: 0,
                    },
                    {
                        code: '341004',
                        name: '徽州区',
                        simple_name: '徽州',
                        hidden: 0,
                    },
                    {
                        code: '341021',
                        name: '歙县',
                        simple_name: '歙县',
                        hidden: 0,
                    },
                    {
                        code: '341022',
                        name: '休宁县',
                        simple_name: '休宁',
                        hidden: 0,
                    },
                    {
                        code: '341023',
                        name: '黟县',
                        simple_name: '黟县',
                        hidden: 0,
                    },
                    {
                        code: '341024',
                        name: '祁门县',
                        simple_name: '祁门',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341100',
                name: '滁州市',
                simple_name: '滁州',
                hidden: 0,
                districts: [
                    {
                        code: '341102',
                        name: '琅琊区',
                        simple_name: '琅琊',
                        hidden: 0,
                    },
                    {
                        code: '341103',
                        name: '南谯区',
                        simple_name: '南谯',
                        hidden: 0,
                    },
                    {
                        code: '341122',
                        name: '来安县',
                        simple_name: '来安',
                        hidden: 0,
                    },
                    {
                        code: '341124',
                        name: '全椒县',
                        simple_name: '全椒',
                        hidden: 0,
                    },
                    {
                        code: '341125',
                        name: '定远县',
                        simple_name: '定远',
                        hidden: 0,
                    },
                    {
                        code: '341126',
                        name: '凤阳县',
                        simple_name: '凤阳',
                        hidden: 0,
                    },
                    {
                        code: '341181',
                        name: '天长市',
                        simple_name: '天长',
                        hidden: 0,
                    },
                    {
                        code: '341182',
                        name: '明光市',
                        simple_name: '明光',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341200',
                name: '阜阳市',
                simple_name: '阜阳',
                hidden: 0,
                districts: [
                    {
                        code: '341202',
                        name: '颍州区',
                        simple_name: '颍州',
                        hidden: 0,
                    },
                    {
                        code: '341203',
                        name: '颍东区',
                        simple_name: '颍东',
                        hidden: 0,
                    },
                    {
                        code: '341204',
                        name: '颍泉区',
                        simple_name: '颍泉',
                        hidden: 0,
                    },
                    {
                        code: '341221',
                        name: '临泉县',
                        simple_name: '临泉',
                        hidden: 0,
                    },
                    {
                        code: '341222',
                        name: '太和县',
                        simple_name: '太和',
                        hidden: 0,
                    },
                    {
                        code: '341225',
                        name: '阜南县',
                        simple_name: '阜南',
                        hidden: 0,
                    },
                    {
                        code: '341226',
                        name: '颍上县',
                        simple_name: '颍上',
                        hidden: 0,
                    },
                    {
                        code: '341282',
                        name: '界首市',
                        simple_name: '界首',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341300',
                name: '宿州市',
                simple_name: '宿州',
                hidden: 0,
                districts: [
                    {
                        code: '341302',
                        name: '埇桥区',
                        simple_name: '埇桥',
                        hidden: 0,
                    },
                    {
                        code: '341321',
                        name: '砀山县',
                        simple_name: '砀山',
                        hidden: 0,
                    },
                    {
                        code: '341322',
                        name: '萧县',
                        simple_name: '萧县',
                        hidden: 0,
                    },
                    {
                        code: '341323',
                        name: '灵璧县',
                        simple_name: '灵璧',
                        hidden: 0,
                    },
                    {
                        code: '341324',
                        name: '泗县',
                        simple_name: '泗县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341500',
                name: '六安市',
                simple_name: '六安',
                hidden: 0,
                districts: [
                    {
                        code: '341502',
                        name: '金安区',
                        simple_name: '金安',
                        hidden: 0,
                    },
                    {
                        code: '341503',
                        name: '裕安区',
                        simple_name: '裕安',
                        hidden: 0,
                    },
                    {
                        code: '341521',
                        name: '寿县',
                        simple_name: '寿县',
                        hidden: 0,
                    },
                    {
                        code: '341522',
                        name: '霍邱县',
                        simple_name: '霍邱',
                        hidden: 0,
                    },
                    {
                        code: '341523',
                        name: '舒城县',
                        simple_name: '舒城',
                        hidden: 0,
                    },
                    {
                        code: '341524',
                        name: '金寨县',
                        simple_name: '金寨',
                        hidden: 0,
                    },
                    {
                        code: '341525',
                        name: '霍山县',
                        simple_name: '霍山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341600',
                name: '亳州市',
                simple_name: '亳州',
                hidden: 0,
                districts: [
                    {
                        code: '341602',
                        name: '谯城区',
                        simple_name: '谯城',
                        hidden: 0,
                    },
                    {
                        code: '341621',
                        name: '涡阳县',
                        simple_name: '涡阳',
                        hidden: 0,
                    },
                    {
                        code: '341622',
                        name: '蒙城县',
                        simple_name: '蒙城',
                        hidden: 0,
                    },
                    {
                        code: '341623',
                        name: '利辛县',
                        simple_name: '利辛',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341700',
                name: '池州市',
                simple_name: '池州',
                hidden: 0,
                districts: [
                    {
                        code: '341702',
                        name: '贵池区',
                        simple_name: '贵池',
                        hidden: 0,
                    },
                    {
                        code: '341721',
                        name: '东至县',
                        simple_name: '东至',
                        hidden: 0,
                    },
                    {
                        code: '341722',
                        name: '石台县',
                        simple_name: '石台',
                        hidden: 0,
                    },
                    {
                        code: '341723',
                        name: '青阳县',
                        simple_name: '青阳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '341800',
                name: '宣城市',
                simple_name: '宣城',
                hidden: 0,
                districts: [
                    {
                        code: '341802',
                        name: '宣州区',
                        simple_name: '宣州',
                        hidden: 0,
                    },
                    {
                        code: '341821',
                        name: '郎溪县',
                        simple_name: '郎溪',
                        hidden: 0,
                    },
                    {
                        code: '341822',
                        name: '广德县',
                        simple_name: '广德',
                        hidden: 0,
                    },
                    {
                        code: '341823',
                        name: '泾县',
                        simple_name: '泾县',
                        hidden: 0,
                    },
                    {
                        code: '341824',
                        name: '绩溪县',
                        simple_name: '绩溪',
                        hidden: 0,
                    },
                    {
                        code: '341825',
                        name: '旌德县',
                        simple_name: '旌德',
                        hidden: 0,
                    },
                    {
                        code: '341881',
                        name: '宁国市',
                        simple_name: '宁国',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '350000',
        name: '福建省',
        simple_name: '福建',
        hidden: 0,
        cities: [
            {
                code: '350100',
                name: '福州市',
                simple_name: '福州',
                hidden: 0,
                districts: [
                    {
                        code: '350102',
                        name: '鼓楼区',
                        simple_name: '鼓楼',
                        hidden: 0,
                    },
                    {
                        code: '350103',
                        name: '台江区',
                        simple_name: '台江',
                        hidden: 0,
                    },
                    {
                        code: '350104',
                        name: '仓山区',
                        simple_name: '仓山',
                        hidden: 0,
                    },
                    {
                        code: '350105',
                        name: '马尾区',
                        simple_name: '马尾',
                        hidden: 0,
                    },
                    {
                        code: '350111',
                        name: '晋安区',
                        simple_name: '晋安',
                        hidden: 0,
                    },
                    {
                        code: '350121',
                        name: '闽侯县',
                        simple_name: '闽侯',
                        hidden: 0,
                    },
                    {
                        code: '350122',
                        name: '连江县',
                        simple_name: '连江',
                        hidden: 0,
                    },
                    {
                        code: '350123',
                        name: '罗源县',
                        simple_name: '罗源',
                        hidden: 0,
                    },
                    {
                        code: '350124',
                        name: '闽清县',
                        simple_name: '闽清',
                        hidden: 0,
                    },
                    {
                        code: '350125',
                        name: '永泰县',
                        simple_name: '永泰',
                        hidden: 0,
                    },
                    {
                        code: '350128',
                        name: '平潭县',
                        simple_name: '平潭',
                        hidden: 0,
                    },
                    {
                        code: '350181',
                        name: '福清市',
                        simple_name: '福清',
                        hidden: 0,
                    },
                    {
                        code: '350182',
                        name: '长乐市',
                        simple_name: '长乐',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350200',
                name: '厦门市',
                simple_name: '厦门',
                hidden: 0,
                districts: [
                    {
                        code: '350203',
                        name: '思明区',
                        simple_name: '思明',
                        hidden: 0,
                    },
                    {
                        code: '350205',
                        name: '海沧区',
                        simple_name: '海沧',
                        hidden: 0,
                    },
                    {
                        code: '350206',
                        name: '湖里区',
                        simple_name: '湖里',
                        hidden: 0,
                    },
                    {
                        code: '350211',
                        name: '集美区',
                        simple_name: '集美',
                        hidden: 0,
                    },
                    {
                        code: '350212',
                        name: '同安区',
                        simple_name: '同安',
                        hidden: 0,
                    },
                    {
                        code: '350213',
                        name: '翔安区',
                        simple_name: '翔安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350300',
                name: '莆田市',
                simple_name: '莆田',
                hidden: 0,
                districts: [
                    {
                        code: '350302',
                        name: '城厢区',
                        simple_name: '城厢',
                        hidden: 0,
                    },
                    {
                        code: '350303',
                        name: '涵江区',
                        simple_name: '涵江',
                        hidden: 0,
                    },
                    {
                        code: '350304',
                        name: '荔城区',
                        simple_name: '荔城',
                        hidden: 0,
                    },
                    {
                        code: '350305',
                        name: '秀屿区',
                        simple_name: '秀屿',
                        hidden: 0,
                    },
                    {
                        code: '350322',
                        name: '仙游县',
                        simple_name: '仙游',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350400',
                name: '三明市',
                simple_name: '三明',
                hidden: 0,
                districts: [
                    {
                        code: '350402',
                        name: '梅列区',
                        simple_name: '梅列',
                        hidden: 0,
                    },
                    {
                        code: '350403',
                        name: '三元区',
                        simple_name: '三元',
                        hidden: 0,
                    },
                    {
                        code: '350421',
                        name: '明溪县',
                        simple_name: '明溪',
                        hidden: 0,
                    },
                    {
                        code: '350423',
                        name: '清流县',
                        simple_name: '清流',
                        hidden: 0,
                    },
                    {
                        code: '350424',
                        name: '宁化县',
                        simple_name: '宁化',
                        hidden: 0,
                    },
                    {
                        code: '350425',
                        name: '大田县',
                        simple_name: '大田',
                        hidden: 0,
                    },
                    {
                        code: '350426',
                        name: '尤溪县',
                        simple_name: '尤溪',
                        hidden: 0,
                    },
                    {
                        code: '350427',
                        name: '沙县',
                        simple_name: '沙县',
                        hidden: 0,
                    },
                    {
                        code: '350428',
                        name: '将乐县',
                        simple_name: '将乐',
                        hidden: 0,
                    },
                    {
                        code: '350429',
                        name: '泰宁县',
                        simple_name: '泰宁',
                        hidden: 0,
                    },
                    {
                        code: '350430',
                        name: '建宁县',
                        simple_name: '建宁',
                        hidden: 0,
                    },
                    {
                        code: '350481',
                        name: '永安市',
                        simple_name: '永安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350500',
                name: '泉州市',
                simple_name: '泉州',
                hidden: 0,
                districts: [
                    {
                        code: '350502',
                        name: '鲤城区',
                        simple_name: '鲤城',
                        hidden: 0,
                    },
                    {
                        code: '350503',
                        name: '丰泽区',
                        simple_name: '丰泽',
                        hidden: 0,
                    },
                    {
                        code: '350504',
                        name: '洛江区',
                        simple_name: '洛江',
                        hidden: 0,
                    },
                    {
                        code: '350505',
                        name: '泉港区',
                        simple_name: '泉港',
                        hidden: 0,
                    },
                    {
                        code: '350521',
                        name: '惠安县',
                        simple_name: '惠安',
                        hidden: 0,
                    },
                    {
                        code: '350524',
                        name: '安溪县',
                        simple_name: '安溪',
                        hidden: 0,
                    },
                    {
                        code: '350525',
                        name: '永春县',
                        simple_name: '永春',
                        hidden: 0,
                    },
                    {
                        code: '350526',
                        name: '德化县',
                        simple_name: '德化',
                        hidden: 0,
                    },
                    {
                        code: '350527',
                        name: '金门县',
                        simple_name: '金门',
                        hidden: 0,
                    },
                    {
                        code: '350581',
                        name: '石狮市',
                        simple_name: '石狮',
                        hidden: 0,
                    },
                    {
                        code: '350582',
                        name: '晋江市',
                        simple_name: '晋江',
                        hidden: 0,
                    },
                    {
                        code: '350583',
                        name: '南安市',
                        simple_name: '南安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350600',
                name: '漳州市',
                simple_name: '漳州',
                hidden: 0,
                districts: [
                    {
                        code: '350602',
                        name: '芗城区',
                        simple_name: '芗城',
                        hidden: 0,
                    },
                    {
                        code: '350603',
                        name: '龙文区',
                        simple_name: '龙文',
                        hidden: 0,
                    },
                    {
                        code: '350622',
                        name: '云霄县',
                        simple_name: '云霄',
                        hidden: 0,
                    },
                    {
                        code: '350623',
                        name: '漳浦县',
                        simple_name: '漳浦',
                        hidden: 0,
                    },
                    {
                        code: '350624',
                        name: '诏安县',
                        simple_name: '诏安',
                        hidden: 0,
                    },
                    {
                        code: '350625',
                        name: '长泰县',
                        simple_name: '长泰',
                        hidden: 0,
                    },
                    {
                        code: '350626',
                        name: '东山县',
                        simple_name: '东山',
                        hidden: 0,
                    },
                    {
                        code: '350627',
                        name: '南靖县',
                        simple_name: '南靖',
                        hidden: 0,
                    },
                    {
                        code: '350628',
                        name: '平和县',
                        simple_name: '平和',
                        hidden: 0,
                    },
                    {
                        code: '350629',
                        name: '华安县',
                        simple_name: '华安',
                        hidden: 0,
                    },
                    {
                        code: '350681',
                        name: '龙海市',
                        simple_name: '龙海',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350700',
                name: '南平市',
                simple_name: '南平',
                hidden: 0,
                districts: [
                    {
                        code: '350702',
                        name: '延平区',
                        simple_name: '延平',
                        hidden: 0,
                    },
                    {
                        code: '350703',
                        name: '建阳区',
                        simple_name: '建阳',
                        hidden: 0,
                    },
                    {
                        code: '350721',
                        name: '顺昌县',
                        simple_name: '顺昌',
                        hidden: 0,
                    },
                    {
                        code: '350722',
                        name: '浦城县',
                        simple_name: '浦城',
                        hidden: 0,
                    },
                    {
                        code: '350723',
                        name: '光泽县',
                        simple_name: '光泽',
                        hidden: 0,
                    },
                    {
                        code: '350724',
                        name: '松溪县',
                        simple_name: '松溪',
                        hidden: 0,
                    },
                    {
                        code: '350725',
                        name: '政和县',
                        simple_name: '政和',
                        hidden: 0,
                    },
                    {
                        code: '350781',
                        name: '邵武市',
                        simple_name: '邵武',
                        hidden: 0,
                    },
                    {
                        code: '350782',
                        name: '武夷山市',
                        simple_name: '武夷山',
                        hidden: 0,
                    },
                    {
                        code: '350783',
                        name: '建瓯市',
                        simple_name: '建瓯',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350800',
                name: '龙岩市',
                simple_name: '龙岩',
                hidden: 0,
                districts: [
                    {
                        code: '350802',
                        name: '新罗区',
                        simple_name: '新罗',
                        hidden: 0,
                    },
                    {
                        code: '350821',
                        name: '长汀县',
                        simple_name: '长汀',
                        hidden: 0,
                    },
                    {
                        code: '350822',
                        name: '永定区',
                        simple_name: '永定',
                        hidden: 0,
                    },
                    {
                        code: '350823',
                        name: '上杭县',
                        simple_name: '上杭',
                        hidden: 0,
                    },
                    {
                        code: '350824',
                        name: '武平县',
                        simple_name: '武平',
                        hidden: 0,
                    },
                    {
                        code: '350825',
                        name: '连城县',
                        simple_name: '连城',
                        hidden: 0,
                    },
                    {
                        code: '350881',
                        name: '漳平市',
                        simple_name: '漳平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '350900',
                name: '宁德市',
                simple_name: '宁德',
                hidden: 0,
                districts: [
                    {
                        code: '350902',
                        name: '蕉城区',
                        simple_name: '蕉城',
                        hidden: 0,
                    },
                    {
                        code: '350921',
                        name: '霞浦县',
                        simple_name: '霞浦',
                        hidden: 0,
                    },
                    {
                        code: '350922',
                        name: '古田县',
                        simple_name: '古田',
                        hidden: 0,
                    },
                    {
                        code: '350923',
                        name: '屏南县',
                        simple_name: '屏南',
                        hidden: 0,
                    },
                    {
                        code: '350924',
                        name: '寿宁县',
                        simple_name: '寿宁',
                        hidden: 0,
                    },
                    {
                        code: '350925',
                        name: '周宁县',
                        simple_name: '周宁',
                        hidden: 0,
                    },
                    {
                        code: '350926',
                        name: '柘荣县',
                        simple_name: '柘荣',
                        hidden: 0,
                    },
                    {
                        code: '350981',
                        name: '福安市',
                        simple_name: '福安',
                        hidden: 0,
                    },
                    {
                        code: '350982',
                        name: '福鼎市',
                        simple_name: '福鼎',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '360000',
        name: '江西省',
        simple_name: '江西',
        hidden: 0,
        cities: [
            {
                code: '360100',
                name: '南昌市',
                simple_name: '南昌',
                hidden: 0,
                districts: [
                    {
                        code: '360102',
                        name: '东湖区',
                        simple_name: '东湖',
                        hidden: 0,
                    },
                    {
                        code: '360103',
                        name: '西湖区',
                        simple_name: '西湖',
                        hidden: 0,
                    },
                    {
                        code: '360104',
                        name: '青云谱区',
                        simple_name: '青云谱',
                        hidden: 0,
                    },
                    {
                        code: '360105',
                        name: '湾里区',
                        simple_name: '湾里',
                        hidden: 0,
                    },
                    {
                        code: '360111',
                        name: '青山湖区',
                        simple_name: '青山湖',
                        hidden: 0,
                    },
                    {
                        code: '360121',
                        name: '南昌县',
                        simple_name: '南昌',
                        hidden: 0,
                    },
                    {
                        code: '360122',
                        name: '新建县',
                        simple_name: '新建',
                        hidden: 0,
                    },
                    {
                        code: '360123',
                        name: '安义县',
                        simple_name: '安义',
                        hidden: 0,
                    },
                    {
                        code: '360124',
                        name: '进贤县',
                        simple_name: '进贤',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360200',
                name: '景德镇市',
                simple_name: '景德镇',
                hidden: 0,
                districts: [
                    {
                        code: '360202',
                        name: '昌江区',
                        simple_name: '昌江',
                        hidden: 0,
                    },
                    {
                        code: '360203',
                        name: '珠山区',
                        simple_name: '珠山',
                        hidden: 0,
                    },
                    {
                        code: '360222',
                        name: '浮梁县',
                        simple_name: '浮梁',
                        hidden: 0,
                    },
                    {
                        code: '360281',
                        name: '乐平市',
                        simple_name: '乐平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360300',
                name: '萍乡市',
                simple_name: '萍乡',
                hidden: 0,
                districts: [
                    {
                        code: '360302',
                        name: '安源区',
                        simple_name: '安源',
                        hidden: 0,
                    },
                    {
                        code: '360313',
                        name: '湘东区',
                        simple_name: '湘东',
                        hidden: 0,
                    },
                    {
                        code: '360321',
                        name: '莲花县',
                        simple_name: '莲花',
                        hidden: 0,
                    },
                    {
                        code: '360322',
                        name: '上栗县',
                        simple_name: '上栗',
                        hidden: 0,
                    },
                    {
                        code: '360323',
                        name: '芦溪县',
                        simple_name: '芦溪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360400',
                name: '九江市',
                simple_name: '九江',
                hidden: 0,
                districts: [
                    {
                        code: '360402',
                        name: '庐山区',
                        simple_name: '庐山',
                        hidden: 0,
                    },
                    {
                        code: '360403',
                        name: '浔阳区',
                        simple_name: '浔阳',
                        hidden: 0,
                    },
                    {
                        code: '360421',
                        name: '九江县',
                        simple_name: '九江',
                        hidden: 0,
                    },
                    {
                        code: '360423',
                        name: '武宁县',
                        simple_name: '武宁',
                        hidden: 0,
                    },
                    {
                        code: '360424',
                        name: '修水县',
                        simple_name: '修水',
                        hidden: 0,
                    },
                    {
                        code: '360425',
                        name: '永修县',
                        simple_name: '永修',
                        hidden: 0,
                    },
                    {
                        code: '360426',
                        name: '德安县',
                        simple_name: '德安',
                        hidden: 0,
                    },
                    {
                        code: '360427',
                        name: '星子县',
                        simple_name: '星子',
                        hidden: 0,
                    },
                    {
                        code: '360428',
                        name: '都昌县',
                        simple_name: '都昌',
                        hidden: 0,
                    },
                    {
                        code: '360429',
                        name: '湖口县',
                        simple_name: '湖口',
                        hidden: 0,
                    },
                    {
                        code: '360430',
                        name: '彭泽县',
                        simple_name: '彭泽',
                        hidden: 0,
                    },
                    {
                        code: '360481',
                        name: '瑞昌市',
                        simple_name: '瑞昌',
                        hidden: 0,
                    },
                    {
                        code: '360482',
                        name: '共青城市',
                        simple_name: '共青城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360500',
                name: '新余市',
                simple_name: '新余',
                hidden: 0,
                districts: [
                    {
                        code: '360502',
                        name: '渝水区',
                        simple_name: '渝水',
                        hidden: 0,
                    },
                    {
                        code: '360521',
                        name: '分宜县',
                        simple_name: '分宜',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360600',
                name: '鹰潭市',
                simple_name: '鹰潭',
                hidden: 0,
                districts: [
                    {
                        code: '360602',
                        name: '月湖区',
                        simple_name: '月湖',
                        hidden: 0,
                    },
                    {
                        code: '360622',
                        name: '余江县',
                        simple_name: '余江',
                        hidden: 0,
                    },
                    {
                        code: '360681',
                        name: '贵溪市',
                        simple_name: '贵溪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360700',
                name: '赣州市',
                simple_name: '赣州',
                hidden: 0,
                districts: [
                    {
                        code: '360702',
                        name: '章贡区',
                        simple_name: '章贡',
                        hidden: 0,
                    },
                    {
                        code: '360703',
                        name: '南康区',
                        simple_name: '南康',
                        hidden: 0,
                    },
                    {
                        code: '360721',
                        name: '赣县',
                        simple_name: '赣县',
                        hidden: 0,
                    },
                    {
                        code: '360722',
                        name: '信丰县',
                        simple_name: '信丰',
                        hidden: 0,
                    },
                    {
                        code: '360723',
                        name: '大余县',
                        simple_name: '大余',
                        hidden: 0,
                    },
                    {
                        code: '360724',
                        name: '上犹县',
                        simple_name: '上犹',
                        hidden: 0,
                    },
                    {
                        code: '360725',
                        name: '崇义县',
                        simple_name: '崇义',
                        hidden: 0,
                    },
                    {
                        code: '360726',
                        name: '安远县',
                        simple_name: '安远',
                        hidden: 0,
                    },
                    {
                        code: '360727',
                        name: '龙南县',
                        simple_name: '龙南',
                        hidden: 0,
                    },
                    {
                        code: '360728',
                        name: '定南县',
                        simple_name: '定南',
                        hidden: 0,
                    },
                    {
                        code: '360729',
                        name: '全南县',
                        simple_name: '全南',
                        hidden: 0,
                    },
                    {
                        code: '360730',
                        name: '宁都县',
                        simple_name: '宁都',
                        hidden: 0,
                    },
                    {
                        code: '360731',
                        name: '于都县',
                        simple_name: '于都',
                        hidden: 0,
                    },
                    {
                        code: '360732',
                        name: '兴国县',
                        simple_name: '兴国',
                        hidden: 0,
                    },
                    {
                        code: '360733',
                        name: '会昌县',
                        simple_name: '会昌',
                        hidden: 0,
                    },
                    {
                        code: '360734',
                        name: '寻乌县',
                        simple_name: '寻乌',
                        hidden: 0,
                    },
                    {
                        code: '360735',
                        name: '石城县',
                        simple_name: '石城',
                        hidden: 0,
                    },
                    {
                        code: '360781',
                        name: '瑞金市',
                        simple_name: '瑞金',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360800',
                name: '吉安市',
                simple_name: '吉安',
                hidden: 0,
                districts: [
                    {
                        code: '360802',
                        name: '吉州区',
                        simple_name: '吉州',
                        hidden: 0,
                    },
                    {
                        code: '360803',
                        name: '青原区',
                        simple_name: '青原',
                        hidden: 0,
                    },
                    {
                        code: '360821',
                        name: '吉安县',
                        simple_name: '吉安',
                        hidden: 0,
                    },
                    {
                        code: '360822',
                        name: '吉水县',
                        simple_name: '吉水',
                        hidden: 0,
                    },
                    {
                        code: '360823',
                        name: '峡江县',
                        simple_name: '峡江',
                        hidden: 0,
                    },
                    {
                        code: '360824',
                        name: '新干县',
                        simple_name: '新干',
                        hidden: 0,
                    },
                    {
                        code: '360825',
                        name: '永丰县',
                        simple_name: '永丰',
                        hidden: 0,
                    },
                    {
                        code: '360826',
                        name: '泰和县',
                        simple_name: '泰和',
                        hidden: 0,
                    },
                    {
                        code: '360827',
                        name: '遂川县',
                        simple_name: '遂川',
                        hidden: 0,
                    },
                    {
                        code: '360828',
                        name: '万安县',
                        simple_name: '万安',
                        hidden: 0,
                    },
                    {
                        code: '360829',
                        name: '安福县',
                        simple_name: '安福',
                        hidden: 0,
                    },
                    {
                        code: '360830',
                        name: '永新县',
                        simple_name: '永新',
                        hidden: 0,
                    },
                    {
                        code: '360881',
                        name: '井冈山市',
                        simple_name: '井冈山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '360900',
                name: '宜春市',
                simple_name: '宜春',
                hidden: 0,
                districts: [
                    {
                        code: '360902',
                        name: '袁州区',
                        simple_name: '袁州',
                        hidden: 0,
                    },
                    {
                        code: '360921',
                        name: '奉新县',
                        simple_name: '奉新',
                        hidden: 0,
                    },
                    {
                        code: '360922',
                        name: '万载县',
                        simple_name: '万载',
                        hidden: 0,
                    },
                    {
                        code: '360923',
                        name: '上高县',
                        simple_name: '上高',
                        hidden: 0,
                    },
                    {
                        code: '360924',
                        name: '宜丰县',
                        simple_name: '宜丰',
                        hidden: 0,
                    },
                    {
                        code: '360925',
                        name: '靖安县',
                        simple_name: '靖安',
                        hidden: 0,
                    },
                    {
                        code: '360926',
                        name: '铜鼓县',
                        simple_name: '铜鼓',
                        hidden: 0,
                    },
                    {
                        code: '360981',
                        name: '丰城市',
                        simple_name: '丰城',
                        hidden: 0,
                    },
                    {
                        code: '360982',
                        name: '樟树市',
                        simple_name: '樟树',
                        hidden: 0,
                    },
                    {
                        code: '360983',
                        name: '高安市',
                        simple_name: '高安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '361000',
                name: '抚州市',
                simple_name: '抚州',
                hidden: 0,
                districts: [
                    {
                        code: '361002',
                        name: '临川区',
                        simple_name: '临川',
                        hidden: 0,
                    },
                    {
                        code: '361021',
                        name: '南城县',
                        simple_name: '南城',
                        hidden: 0,
                    },
                    {
                        code: '361022',
                        name: '黎川县',
                        simple_name: '黎川',
                        hidden: 0,
                    },
                    {
                        code: '361023',
                        name: '南丰县',
                        simple_name: '南丰',
                        hidden: 0,
                    },
                    {
                        code: '361024',
                        name: '崇仁县',
                        simple_name: '崇仁',
                        hidden: 0,
                    },
                    {
                        code: '361025',
                        name: '乐安县',
                        simple_name: '乐安',
                        hidden: 0,
                    },
                    {
                        code: '361026',
                        name: '宜黄县',
                        simple_name: '宜黄',
                        hidden: 0,
                    },
                    {
                        code: '361027',
                        name: '金溪县',
                        simple_name: '金溪',
                        hidden: 0,
                    },
                    {
                        code: '361028',
                        name: '资溪县',
                        simple_name: '资溪',
                        hidden: 0,
                    },
                    {
                        code: '361029',
                        name: '东乡县',
                        simple_name: '东乡',
                        hidden: 0,
                    },
                    {
                        code: '361030',
                        name: '广昌县',
                        simple_name: '广昌',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '361100',
                name: '上饶市',
                simple_name: '上饶',
                hidden: 0,
                districts: [
                    {
                        code: '361102',
                        name: '信州区',
                        simple_name: '信州',
                        hidden: 0,
                    },
                    {
                        code: '361121',
                        name: '上饶县',
                        simple_name: '上饶',
                        hidden: 0,
                    },
                    {
                        code: '361122',
                        name: '广丰县',
                        simple_name: '广丰',
                        hidden: 0,
                    },
                    {
                        code: '361123',
                        name: '玉山县',
                        simple_name: '玉山',
                        hidden: 0,
                    },
                    {
                        code: '361124',
                        name: '铅山县',
                        simple_name: '铅山',
                        hidden: 0,
                    },
                    {
                        code: '361125',
                        name: '横峰县',
                        simple_name: '横峰',
                        hidden: 0,
                    },
                    {
                        code: '361126',
                        name: '弋阳县',
                        simple_name: '弋阳',
                        hidden: 0,
                    },
                    {
                        code: '361127',
                        name: '余干县',
                        simple_name: '余干',
                        hidden: 0,
                    },
                    {
                        code: '361128',
                        name: '鄱阳县',
                        simple_name: '鄱阳',
                        hidden: 0,
                    },
                    {
                        code: '361129',
                        name: '万年县',
                        simple_name: '万年',
                        hidden: 0,
                    },
                    {
                        code: '361130',
                        name: '婺源县',
                        simple_name: '婺源',
                        hidden: 0,
                    },
                    {
                        code: '361181',
                        name: '德兴市',
                        simple_name: '德兴',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '370000',
        name: '山东省',
        simple_name: '山东',
        hidden: 0,
        cities: [
            {
                code: '370100',
                name: '济南市',
                simple_name: '济南',
                hidden: 0,
                districts: [
                    {
                        code: '370102',
                        name: '历下区',
                        simple_name: '历下',
                        hidden: 0,
                    },
                    {
                        code: '370103',
                        name: '市中区',
                        simple_name: '市中区',
                        hidden: 0,
                    },
                    {
                        code: '370104',
                        name: '槐荫区',
                        simple_name: '槐荫',
                        hidden: 0,
                    },
                    {
                        code: '370105',
                        name: '天桥区',
                        simple_name: '天桥',
                        hidden: 0,
                    },
                    {
                        code: '370112',
                        name: '历城区',
                        simple_name: '历城',
                        hidden: 0,
                    },
                    {
                        code: '370113',
                        name: '长清区',
                        simple_name: '长清',
                        hidden: 0,
                    },
                    {
                        code: '370124',
                        name: '平阴县',
                        simple_name: '平阴',
                        hidden: 0,
                    },
                    {
                        code: '370125',
                        name: '济阳县',
                        simple_name: '济阳',
                        hidden: 0,
                    },
                    {
                        code: '370126',
                        name: '商河县',
                        simple_name: '商河',
                        hidden: 0,
                    },
                    {
                        code: '370181',
                        name: '章丘市',
                        simple_name: '章丘',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370200',
                name: '青岛市',
                simple_name: '青岛',
                hidden: 0,
                districts: [
                    {
                        code: '370202',
                        name: '市南区',
                        simple_name: '市南',
                        hidden: 0,
                    },
                    {
                        code: '370203',
                        name: '市北区',
                        simple_name: '市北',
                        hidden: 0,
                    },
                    {
                        code: '370211',
                        name: '黄岛区',
                        simple_name: '黄岛',
                        hidden: 0,
                    },
                    {
                        code: '370212',
                        name: '崂山区',
                        simple_name: '崂山',
                        hidden: 0,
                    },
                    {
                        code: '370213',
                        name: '李沧区',
                        simple_name: '李沧',
                        hidden: 0,
                    },
                    {
                        code: '370214',
                        name: '城阳区',
                        simple_name: '城阳',
                        hidden: 0,
                    },
                    {
                        code: '370281',
                        name: '胶州市',
                        simple_name: '胶州',
                        hidden: 0,
                    },
                    {
                        code: '370282',
                        name: '即墨市',
                        simple_name: '即墨',
                        hidden: 0,
                    },
                    {
                        code: '370283',
                        name: '平度市',
                        simple_name: '平度',
                        hidden: 0,
                    },
                    {
                        code: '370285',
                        name: '莱西市',
                        simple_name: '莱西',
                        hidden: 0,
                    },
                    {
                        code: '370286',
                        name: '西海岸新区',
                        simple_name: '西海岸',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370300',
                name: '淄博市',
                simple_name: '淄博',
                hidden: 0,
                districts: [
                    {
                        code: '370302',
                        name: '淄川区',
                        simple_name: '淄川',
                        hidden: 0,
                    },
                    {
                        code: '370303',
                        name: '张店区',
                        simple_name: '张店',
                        hidden: 0,
                    },
                    {
                        code: '370304',
                        name: '博山区',
                        simple_name: '博山',
                        hidden: 0,
                    },
                    {
                        code: '370305',
                        name: '临淄区',
                        simple_name: '临淄',
                        hidden: 0,
                    },
                    {
                        code: '370306',
                        name: '周村区',
                        simple_name: '周村',
                        hidden: 0,
                    },
                    {
                        code: '370321',
                        name: '桓台县',
                        simple_name: '桓台',
                        hidden: 0,
                    },
                    {
                        code: '370322',
                        name: '高青县',
                        simple_name: '高青',
                        hidden: 0,
                    },
                    {
                        code: '370323',
                        name: '沂源县',
                        simple_name: '沂源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370400',
                name: '枣庄市',
                simple_name: '枣庄',
                hidden: 0,
                districts: [
                    {
                        code: '370402',
                        name: '市中区',
                        simple_name: '市中区',
                        hidden: 0,
                    },
                    {
                        code: '370403',
                        name: '薛城区',
                        simple_name: '薛城',
                        hidden: 0,
                    },
                    {
                        code: '370404',
                        name: '峄城区',
                        simple_name: '峄城',
                        hidden: 0,
                    },
                    {
                        code: '370405',
                        name: '台儿庄区',
                        simple_name: '台儿庄',
                        hidden: 0,
                    },
                    {
                        code: '370406',
                        name: '山亭区',
                        simple_name: '山亭',
                        hidden: 0,
                    },
                    {
                        code: '370481',
                        name: '滕州市',
                        simple_name: '滕州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370500',
                name: '东营市',
                simple_name: '东营',
                hidden: 0,
                districts: [
                    {
                        code: '370502',
                        name: '东营区',
                        simple_name: '东营',
                        hidden: 0,
                    },
                    {
                        code: '370503',
                        name: '河口区',
                        simple_name: '河口',
                        hidden: 0,
                    },
                    {
                        code: '370521',
                        name: '垦利县',
                        simple_name: '垦利',
                        hidden: 0,
                    },
                    {
                        code: '370522',
                        name: '利津县',
                        simple_name: '利津',
                        hidden: 0,
                    },
                    {
                        code: '370523',
                        name: '广饶县',
                        simple_name: '广饶',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370600',
                name: '烟台市',
                simple_name: '烟台',
                hidden: 0,
                districts: [
                    {
                        code: '370602',
                        name: '芝罘区',
                        simple_name: '芝罘',
                        hidden: 0,
                    },
                    {
                        code: '370611',
                        name: '福山区',
                        simple_name: '福山',
                        hidden: 0,
                    },
                    {
                        code: '370612',
                        name: '牟平区',
                        simple_name: '牟平',
                        hidden: 0,
                    },
                    {
                        code: '370613',
                        name: '莱山区',
                        simple_name: '莱山',
                        hidden: 0,
                    },
                    {
                        code: '370634',
                        name: '长岛县',
                        simple_name: '长岛',
                        hidden: 0,
                    },
                    {
                        code: '370681',
                        name: '龙口市',
                        simple_name: '龙口',
                        hidden: 0,
                    },
                    {
                        code: '370682',
                        name: '莱阳市',
                        simple_name: '莱阳',
                        hidden: 0,
                    },
                    {
                        code: '370683',
                        name: '莱州市',
                        simple_name: '莱州',
                        hidden: 0,
                    },
                    {
                        code: '370684',
                        name: '蓬莱市',
                        simple_name: '蓬莱',
                        hidden: 0,
                    },
                    {
                        code: '370685',
                        name: '招远市',
                        simple_name: '招远',
                        hidden: 0,
                    },
                    {
                        code: '370686',
                        name: '栖霞市',
                        simple_name: '栖霞',
                        hidden: 0,
                    },
                    {
                        code: '370687',
                        name: '海阳市',
                        simple_name: '海阳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370700',
                name: '潍坊市',
                simple_name: '潍坊',
                hidden: 0,
                districts: [
                    {
                        code: '370702',
                        name: '潍城区',
                        simple_name: '潍城',
                        hidden: 0,
                    },
                    {
                        code: '370703',
                        name: '寒亭区',
                        simple_name: '寒亭',
                        hidden: 0,
                    },
                    {
                        code: '370704',
                        name: '坊子区',
                        simple_name: '坊子',
                        hidden: 0,
                    },
                    {
                        code: '370705',
                        name: '奎文区',
                        simple_name: '奎文',
                        hidden: 0,
                    },
                    {
                        code: '370724',
                        name: '临朐县',
                        simple_name: '临朐',
                        hidden: 0,
                    },
                    {
                        code: '370725',
                        name: '昌乐县',
                        simple_name: '昌乐',
                        hidden: 0,
                    },
                    {
                        code: '370781',
                        name: '青州市',
                        simple_name: '青州',
                        hidden: 0,
                    },
                    {
                        code: '370782',
                        name: '诸城市',
                        simple_name: '诸城',
                        hidden: 0,
                    },
                    {
                        code: '370783',
                        name: '寿光市',
                        simple_name: '寿光',
                        hidden: 0,
                    },
                    {
                        code: '370784',
                        name: '安丘市',
                        simple_name: '安丘',
                        hidden: 0,
                    },
                    {
                        code: '370785',
                        name: '高密市',
                        simple_name: '高密',
                        hidden: 0,
                    },
                    {
                        code: '370786',
                        name: '昌邑市',
                        simple_name: '昌邑',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370800',
                name: '济宁市',
                simple_name: '济宁',
                hidden: 0,
                districts: [
                    {
                        code: '370811',
                        name: '任城区',
                        simple_name: '任城',
                        hidden: 0,
                    },
                    {
                        code: '370812',
                        name: '兖州区',
                        simple_name: '兖州',
                        hidden: 0,
                    },
                    {
                        code: '370826',
                        name: '微山县',
                        simple_name: '微山',
                        hidden: 0,
                    },
                    {
                        code: '370827',
                        name: '鱼台县',
                        simple_name: '鱼台',
                        hidden: 0,
                    },
                    {
                        code: '370828',
                        name: '金乡县',
                        simple_name: '金乡',
                        hidden: 0,
                    },
                    {
                        code: '370829',
                        name: '嘉祥县',
                        simple_name: '嘉祥',
                        hidden: 0,
                    },
                    {
                        code: '370830',
                        name: '汶上县',
                        simple_name: '汶上',
                        hidden: 0,
                    },
                    {
                        code: '370831',
                        name: '泗水县',
                        simple_name: '泗水',
                        hidden: 0,
                    },
                    {
                        code: '370832',
                        name: '梁山县',
                        simple_name: '梁山',
                        hidden: 0,
                    },
                    {
                        code: '370881',
                        name: '曲阜市',
                        simple_name: '曲阜',
                        hidden: 0,
                    },
                    {
                        code: '370883',
                        name: '邹城市',
                        simple_name: '邹城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '370900',
                name: '泰安市',
                simple_name: '泰安',
                hidden: 0,
                districts: [
                    {
                        code: '370902',
                        name: '泰山区',
                        simple_name: '泰山',
                        hidden: 0,
                    },
                    {
                        code: '370911',
                        name: '岱岳区',
                        simple_name: '岱岳',
                        hidden: 0,
                    },
                    {
                        code: '370921',
                        name: '宁阳县',
                        simple_name: '宁阳',
                        hidden: 0,
                    },
                    {
                        code: '370923',
                        name: '东平县',
                        simple_name: '东平',
                        hidden: 0,
                    },
                    {
                        code: '370982',
                        name: '新泰市',
                        simple_name: '新泰',
                        hidden: 0,
                    },
                    {
                        code: '370983',
                        name: '肥城市',
                        simple_name: '肥城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371000',
                name: '威海市',
                simple_name: '威海',
                hidden: 0,
                districts: [
                    {
                        code: '371002',
                        name: '环翠区',
                        simple_name: '环翠',
                        hidden: 0,
                    },
                    {
                        code: '371003',
                        name: '文登区',
                        simple_name: '文登',
                        hidden: 0,
                    },
                    {
                        code: '371082',
                        name: '荣成市',
                        simple_name: '荣成',
                        hidden: 0,
                    },
                    {
                        code: '371083',
                        name: '乳山市',
                        simple_name: '乳山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371100',
                name: '日照市',
                simple_name: '日照',
                hidden: 0,
                districts: [
                    {
                        code: '371102',
                        name: '东港区',
                        simple_name: '东港',
                        hidden: 0,
                    },
                    {
                        code: '371103',
                        name: '岚山区',
                        simple_name: '岚山',
                        hidden: 0,
                    },
                    {
                        code: '371121',
                        name: '五莲县',
                        simple_name: '五莲',
                        hidden: 0,
                    },
                    {
                        code: '371122',
                        name: '莒县',
                        simple_name: '莒县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371200',
                name: '莱芜市',
                simple_name: '莱芜',
                hidden: 0,
                districts: [
                    {
                        code: '371202',
                        name: '莱城区',
                        simple_name: '莱城',
                        hidden: 0,
                    },
                    {
                        code: '371203',
                        name: '钢城区',
                        simple_name: '钢城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371300',
                name: '临沂市',
                simple_name: '临沂',
                hidden: 0,
                districts: [
                    {
                        code: '371302',
                        name: '兰山区',
                        simple_name: '兰山',
                        hidden: 0,
                    },
                    {
                        code: '371311',
                        name: '罗庄区',
                        simple_name: '罗庄',
                        hidden: 0,
                    },
                    {
                        code: '371312',
                        name: '河东区',
                        simple_name: '河东',
                        hidden: 0,
                    },
                    {
                        code: '371321',
                        name: '沂南县',
                        simple_name: '沂南',
                        hidden: 0,
                    },
                    {
                        code: '371322',
                        name: '郯城县',
                        simple_name: '郯城',
                        hidden: 0,
                    },
                    {
                        code: '371323',
                        name: '沂水县',
                        simple_name: '沂水',
                        hidden: 0,
                    },
                    {
                        code: '371324',
                        name: '兰陵县',
                        simple_name: '兰陵',
                        hidden: 0,
                    },
                    {
                        code: '371325',
                        name: '费县',
                        simple_name: '费县',
                        hidden: 0,
                    },
                    {
                        code: '371326',
                        name: '平邑县',
                        simple_name: '平邑',
                        hidden: 0,
                    },
                    {
                        code: '371327',
                        name: '莒南县',
                        simple_name: '莒南',
                        hidden: 0,
                    },
                    {
                        code: '371328',
                        name: '蒙阴县',
                        simple_name: '蒙阴',
                        hidden: 0,
                    },
                    {
                        code: '371329',
                        name: '临沭县',
                        simple_name: '临沭',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371400',
                name: '德州市',
                simple_name: '德州',
                hidden: 0,
                districts: [
                    {
                        code: '371402',
                        name: '德城区',
                        simple_name: '德城',
                        hidden: 0,
                    },
                    {
                        code: '371403',
                        name: '陵城区',
                        simple_name: '陵城',
                        hidden: 0,
                    },
                    {
                        code: '371422',
                        name: '宁津县',
                        simple_name: '宁津',
                        hidden: 0,
                    },
                    {
                        code: '371423',
                        name: '庆云县',
                        simple_name: '庆云',
                        hidden: 0,
                    },
                    {
                        code: '371424',
                        name: '临邑县',
                        simple_name: '临邑',
                        hidden: 0,
                    },
                    {
                        code: '371425',
                        name: '齐河县',
                        simple_name: '齐河',
                        hidden: 0,
                    },
                    {
                        code: '371426',
                        name: '平原县',
                        simple_name: '平原',
                        hidden: 0,
                    },
                    {
                        code: '371427',
                        name: '夏津县',
                        simple_name: '夏津',
                        hidden: 0,
                    },
                    {
                        code: '371428',
                        name: '武城县',
                        simple_name: '武城',
                        hidden: 0,
                    },
                    {
                        code: '371481',
                        name: '乐陵市',
                        simple_name: '乐陵',
                        hidden: 0,
                    },
                    {
                        code: '371482',
                        name: '禹城市',
                        simple_name: '禹城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371500',
                name: '聊城市',
                simple_name: '聊城',
                hidden: 0,
                districts: [
                    {
                        code: '371502',
                        name: '东昌府区',
                        simple_name: '东昌府',
                        hidden: 0,
                    },
                    {
                        code: '371521',
                        name: '阳谷县',
                        simple_name: '阳谷',
                        hidden: 0,
                    },
                    {
                        code: '371522',
                        name: '莘县',
                        simple_name: '莘县',
                        hidden: 0,
                    },
                    {
                        code: '371523',
                        name: '茌平县',
                        simple_name: '茌平',
                        hidden: 0,
                    },
                    {
                        code: '371524',
                        name: '东阿县',
                        simple_name: '东阿',
                        hidden: 0,
                    },
                    {
                        code: '371525',
                        name: '冠县',
                        simple_name: '冠县',
                        hidden: 0,
                    },
                    {
                        code: '371526',
                        name: '高唐县',
                        simple_name: '高唐',
                        hidden: 0,
                    },
                    {
                        code: '371581',
                        name: '临清市',
                        simple_name: '临清',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371600',
                name: '滨州市',
                simple_name: '滨州',
                hidden: 0,
                districts: [
                    {
                        code: '371602',
                        name: '滨城区',
                        simple_name: '滨城',
                        hidden: 0,
                    },
                    {
                        code: '371603',
                        name: '沾化区',
                        simple_name: '沾化',
                        hidden: 0,
                    },
                    {
                        code: '371621',
                        name: '惠民县',
                        simple_name: '惠民',
                        hidden: 0,
                    },
                    {
                        code: '371622',
                        name: '阳信县',
                        simple_name: '阳信',
                        hidden: 0,
                    },
                    {
                        code: '371623',
                        name: '无棣县',
                        simple_name: '无棣',
                        hidden: 0,
                    },
                    {
                        code: '371625',
                        name: '博兴县',
                        simple_name: '博兴',
                        hidden: 0,
                    },
                    {
                        code: '371626',
                        name: '邹平县',
                        simple_name: '邹平',
                        hidden: 0,
                    },
                    {
                        code: '371627',
                        name: '北海新区',
                        simple_name: '北海新区',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '371700',
                name: '菏泽市',
                simple_name: '菏泽',
                hidden: 0,
                districts: [
                    {
                        code: '371702',
                        name: '牡丹区',
                        simple_name: '牡丹',
                        hidden: 0,
                    },
                    {
                        code: '371721',
                        name: '曹县',
                        simple_name: '曹县',
                        hidden: 0,
                    },
                    {
                        code: '371722',
                        name: '单县',
                        simple_name: '单县',
                        hidden: 0,
                    },
                    {
                        code: '371723',
                        name: '成武县',
                        simple_name: '成武',
                        hidden: 0,
                    },
                    {
                        code: '371724',
                        name: '巨野县',
                        simple_name: '巨野',
                        hidden: 0,
                    },
                    {
                        code: '371725',
                        name: '郓城县',
                        simple_name: '郓城',
                        hidden: 0,
                    },
                    {
                        code: '371726',
                        name: '鄄城县',
                        simple_name: '鄄城',
                        hidden: 0,
                    },
                    {
                        code: '371727',
                        name: '定陶县',
                        simple_name: '定陶',
                        hidden: 0,
                    },
                    {
                        code: '371728',
                        name: '东明县',
                        simple_name: '东明',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '410000',
        name: '河南省',
        simple_name: '河南',
        hidden: 0,
        cities: [
            {
                code: '410100',
                name: '郑州市',
                simple_name: '郑州',
                hidden: 0,
                districts: [
                    {
                        code: '410102',
                        name: '中原区',
                        simple_name: '中原',
                        hidden: 0,
                    },
                    {
                        code: '410103',
                        name: '二七区',
                        simple_name: '二七',
                        hidden: 0,
                    },
                    {
                        code: '410104',
                        name: '管城回族区',
                        simple_name: '管城',
                        hidden: 0,
                    },
                    {
                        code: '410105',
                        name: '金水区',
                        simple_name: '金水',
                        hidden: 0,
                    },
                    {
                        code: '410106',
                        name: '上街区',
                        simple_name: '上街',
                        hidden: 0,
                    },
                    {
                        code: '410108',
                        name: '惠济区',
                        simple_name: '惠济',
                        hidden: 0,
                    },
                    {
                        code: '410122',
                        name: '中牟县',
                        simple_name: '中牟',
                        hidden: 0,
                    },
                    {
                        code: '410181',
                        name: '巩义市',
                        simple_name: '巩义',
                        hidden: 0,
                    },
                    {
                        code: '410182',
                        name: '荥阳市',
                        simple_name: '荥阳',
                        hidden: 0,
                    },
                    {
                        code: '410183',
                        name: '新密市',
                        simple_name: '新密',
                        hidden: 0,
                    },
                    {
                        code: '410184',
                        name: '新郑市',
                        simple_name: '新郑',
                        hidden: 0,
                    },
                    {
                        code: '410185',
                        name: '登封市',
                        simple_name: '登封',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410200',
                name: '开封市',
                simple_name: '开封',
                hidden: 0,
                districts: [
                    {
                        code: '410202',
                        name: '龙亭区',
                        simple_name: '龙亭',
                        hidden: 0,
                    },
                    {
                        code: '410203',
                        name: '顺河回族区',
                        simple_name: '顺河',
                        hidden: 0,
                    },
                    {
                        code: '410204',
                        name: '鼓楼区',
                        simple_name: '鼓楼',
                        hidden: 0,
                    },
                    {
                        code: '410205',
                        name: '禹王台区',
                        simple_name: '禹王台',
                        hidden: 0,
                    },
                    {
                        code: '410212',
                        name: '祥符区',
                        simple_name: '祥符',
                        hidden: 0,
                    },
                    {
                        code: '410221',
                        name: '杞县',
                        simple_name: '杞县',
                        hidden: 0,
                    },
                    {
                        code: '410222',
                        name: '通许县',
                        simple_name: '通许',
                        hidden: 0,
                    },
                    {
                        code: '410223',
                        name: '尉氏县',
                        simple_name: '尉氏',
                        hidden: 0,
                    },
                    {
                        code: '410225',
                        name: '兰考县',
                        simple_name: '兰考',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410300',
                name: '洛阳市',
                simple_name: '洛阳',
                hidden: 0,
                districts: [
                    {
                        code: '410302',
                        name: '老城区',
                        simple_name: '老城',
                        hidden: 0,
                    },
                    {
                        code: '410303',
                        name: '西工区',
                        simple_name: '西工',
                        hidden: 0,
                    },
                    {
                        code: '410304',
                        name: '瀍河回族区',
                        simple_name: '瀍河',
                        hidden: 0,
                    },
                    {
                        code: '410305',
                        name: '涧西区',
                        simple_name: '涧西',
                        hidden: 0,
                    },
                    {
                        code: '410306',
                        name: '吉利区',
                        simple_name: '吉利',
                        hidden: 0,
                    },
                    {
                        code: '410311',
                        name: '洛龙区',
                        simple_name: '洛龙',
                        hidden: 0,
                    },
                    {
                        code: '410322',
                        name: '孟津县',
                        simple_name: '孟津',
                        hidden: 0,
                    },
                    {
                        code: '410323',
                        name: '新安县',
                        simple_name: '新安',
                        hidden: 0,
                    },
                    {
                        code: '410324',
                        name: '栾川县',
                        simple_name: '栾川',
                        hidden: 0,
                    },
                    {
                        code: '410325',
                        name: '嵩县',
                        simple_name: '嵩县',
                        hidden: 0,
                    },
                    {
                        code: '410326',
                        name: '汝阳县',
                        simple_name: '汝阳',
                        hidden: 0,
                    },
                    {
                        code: '410327',
                        name: '宜阳县',
                        simple_name: '宜阳',
                        hidden: 0,
                    },
                    {
                        code: '410328',
                        name: '洛宁县',
                        simple_name: '洛宁',
                        hidden: 0,
                    },
                    {
                        code: '410329',
                        name: '伊川县',
                        simple_name: '伊川',
                        hidden: 0,
                    },
                    {
                        code: '410381',
                        name: '偃师市',
                        simple_name: '偃师',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410400',
                name: '平顶山市',
                simple_name: '平顶山',
                hidden: 0,
                districts: [
                    {
                        code: '410402',
                        name: '新华区',
                        simple_name: '新华',
                        hidden: 0,
                    },
                    {
                        code: '410403',
                        name: '卫东区',
                        simple_name: '卫东',
                        hidden: 0,
                    },
                    {
                        code: '410404',
                        name: '石龙区',
                        simple_name: '石龙',
                        hidden: 0,
                    },
                    {
                        code: '410411',
                        name: '湛河区',
                        simple_name: '湛河',
                        hidden: 0,
                    },
                    {
                        code: '410421',
                        name: '宝丰县',
                        simple_name: '宝丰',
                        hidden: 0,
                    },
                    {
                        code: '410422',
                        name: '叶县',
                        simple_name: '叶县',
                        hidden: 0,
                    },
                    {
                        code: '410423',
                        name: '鲁山县',
                        simple_name: '鲁山',
                        hidden: 0,
                    },
                    {
                        code: '410425',
                        name: '郏县',
                        simple_name: '郏县',
                        hidden: 0,
                    },
                    {
                        code: '410481',
                        name: '舞钢市',
                        simple_name: '舞钢',
                        hidden: 0,
                    },
                    {
                        code: '410482',
                        name: '汝州市',
                        simple_name: '汝州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410500',
                name: '安阳市',
                simple_name: '安阳',
                hidden: 0,
                districts: [
                    {
                        code: '410502',
                        name: '文峰区',
                        simple_name: '文峰',
                        hidden: 0,
                    },
                    {
                        code: '410503',
                        name: '北关区',
                        simple_name: '北关',
                        hidden: 0,
                    },
                    {
                        code: '410505',
                        name: '殷都区',
                        simple_name: '殷都',
                        hidden: 0,
                    },
                    {
                        code: '410506',
                        name: '龙安区',
                        simple_name: '龙安',
                        hidden: 0,
                    },
                    {
                        code: '410522',
                        name: '安阳县',
                        simple_name: '安阳',
                        hidden: 0,
                    },
                    {
                        code: '410523',
                        name: '汤阴县',
                        simple_name: '汤阴',
                        hidden: 0,
                    },
                    {
                        code: '410526',
                        name: '滑县',
                        simple_name: '滑县',
                        hidden: 0,
                    },
                    {
                        code: '410527',
                        name: '内黄县',
                        simple_name: '内黄',
                        hidden: 0,
                    },
                    {
                        code: '410581',
                        name: '林州市',
                        simple_name: '林州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410600',
                name: '鹤壁市',
                simple_name: '鹤壁',
                hidden: 0,
                districts: [
                    {
                        code: '410602',
                        name: '鹤山区',
                        simple_name: '鹤山',
                        hidden: 0,
                    },
                    {
                        code: '410603',
                        name: '山城区',
                        simple_name: '山城',
                        hidden: 0,
                    },
                    {
                        code: '410611',
                        name: '淇滨区',
                        simple_name: '淇滨',
                        hidden: 0,
                    },
                    {
                        code: '410621',
                        name: '浚县',
                        simple_name: '浚县',
                        hidden: 0,
                    },
                    {
                        code: '410622',
                        name: '淇县',
                        simple_name: '淇县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410700',
                name: '新乡市',
                simple_name: '新乡',
                hidden: 0,
                districts: [
                    {
                        code: '410702',
                        name: '红旗区',
                        simple_name: '红旗',
                        hidden: 0,
                    },
                    {
                        code: '410703',
                        name: '卫滨区',
                        simple_name: '卫滨',
                        hidden: 0,
                    },
                    {
                        code: '410704',
                        name: '凤泉区',
                        simple_name: '凤泉',
                        hidden: 0,
                    },
                    {
                        code: '410711',
                        name: '牧野区',
                        simple_name: '牧野',
                        hidden: 0,
                    },
                    {
                        code: '410721',
                        name: '新乡县',
                        simple_name: '新乡',
                        hidden: 0,
                    },
                    {
                        code: '410724',
                        name: '获嘉县',
                        simple_name: '获嘉',
                        hidden: 0,
                    },
                    {
                        code: '410725',
                        name: '原阳县',
                        simple_name: '原阳',
                        hidden: 0,
                    },
                    {
                        code: '410726',
                        name: '延津县',
                        simple_name: '延津',
                        hidden: 0,
                    },
                    {
                        code: '410727',
                        name: '封丘县',
                        simple_name: '封丘',
                        hidden: 0,
                    },
                    {
                        code: '410728',
                        name: '长垣县',
                        simple_name: '长垣',
                        hidden: 0,
                    },
                    {
                        code: '410781',
                        name: '卫辉市',
                        simple_name: '卫辉',
                        hidden: 0,
                    },
                    {
                        code: '410782',
                        name: '辉县市',
                        simple_name: '辉县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410800',
                name: '焦作市',
                simple_name: '焦作',
                hidden: 0,
                districts: [
                    {
                        code: '410802',
                        name: '解放区',
                        simple_name: '解放',
                        hidden: 0,
                    },
                    {
                        code: '410803',
                        name: '中站区',
                        simple_name: '中站',
                        hidden: 0,
                    },
                    {
                        code: '410804',
                        name: '马村区',
                        simple_name: '马村',
                        hidden: 0,
                    },
                    {
                        code: '410811',
                        name: '山阳区',
                        simple_name: '山阳',
                        hidden: 0,
                    },
                    {
                        code: '410821',
                        name: '修武县',
                        simple_name: '修武',
                        hidden: 0,
                    },
                    {
                        code: '410822',
                        name: '博爱县',
                        simple_name: '博爱',
                        hidden: 0,
                    },
                    {
                        code: '410823',
                        name: '武陟县',
                        simple_name: '武陟',
                        hidden: 0,
                    },
                    {
                        code: '410825',
                        name: '温县',
                        simple_name: '温县',
                        hidden: 0,
                    },
                    {
                        code: '410882',
                        name: '沁阳市',
                        simple_name: '沁阳',
                        hidden: 0,
                    },
                    {
                        code: '410883',
                        name: '孟州市',
                        simple_name: '孟州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '410900',
                name: '濮阳市',
                simple_name: '濮阳',
                hidden: 0,
                districts: [
                    {
                        code: '410902',
                        name: '华龙区',
                        simple_name: '华龙',
                        hidden: 0,
                    },
                    {
                        code: '410922',
                        name: '清丰县',
                        simple_name: '清丰',
                        hidden: 0,
                    },
                    {
                        code: '410923',
                        name: '南乐县',
                        simple_name: '南乐',
                        hidden: 0,
                    },
                    {
                        code: '410926',
                        name: '范县',
                        simple_name: '范县',
                        hidden: 0,
                    },
                    {
                        code: '410927',
                        name: '台前县',
                        simple_name: '台前',
                        hidden: 0,
                    },
                    {
                        code: '410928',
                        name: '濮阳县',
                        simple_name: '濮阳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411000',
                name: '许昌市',
                simple_name: '许昌',
                hidden: 0,
                districts: [
                    {
                        code: '411002',
                        name: '魏都区',
                        simple_name: '魏都',
                        hidden: 0,
                    },
                    {
                        code: '411023',
                        name: '许昌县',
                        simple_name: '许昌',
                        hidden: 0,
                    },
                    {
                        code: '411024',
                        name: '鄢陵县',
                        simple_name: '鄢陵',
                        hidden: 0,
                    },
                    {
                        code: '411025',
                        name: '襄城县',
                        simple_name: '襄城',
                        hidden: 0,
                    },
                    {
                        code: '411081',
                        name: '禹州市',
                        simple_name: '禹州',
                        hidden: 0,
                    },
                    {
                        code: '411082',
                        name: '长葛市',
                        simple_name: '长葛',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411100',
                name: '漯河市',
                simple_name: '漯河',
                hidden: 0,
                districts: [
                    {
                        code: '411102',
                        name: '源汇区',
                        simple_name: '源汇',
                        hidden: 0,
                    },
                    {
                        code: '411103',
                        name: '郾城区',
                        simple_name: '郾城',
                        hidden: 0,
                    },
                    {
                        code: '411104',
                        name: '召陵区',
                        simple_name: '召陵',
                        hidden: 0,
                    },
                    {
                        code: '411121',
                        name: '舞阳县',
                        simple_name: '舞阳',
                        hidden: 0,
                    },
                    {
                        code: '411122',
                        name: '临颍县',
                        simple_name: '临颍',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411200',
                name: '三门峡市',
                simple_name: '三门峡',
                hidden: 0,
                districts: [
                    {
                        code: '411202',
                        name: '湖滨区',
                        simple_name: '湖滨',
                        hidden: 0,
                    },
                    {
                        code: '411221',
                        name: '渑池县',
                        simple_name: '渑池',
                        hidden: 0,
                    },
                    {
                        code: '411222',
                        name: '陕县',
                        simple_name: '陕县',
                        hidden: 0,
                    },
                    {
                        code: '411224',
                        name: '卢氏县',
                        simple_name: '卢氏',
                        hidden: 0,
                    },
                    {
                        code: '411281',
                        name: '义马市',
                        simple_name: '义马',
                        hidden: 0,
                    },
                    {
                        code: '411282',
                        name: '灵宝市',
                        simple_name: '灵宝',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411300',
                name: '南阳市',
                simple_name: '南阳',
                hidden: 0,
                districts: [
                    {
                        code: '411302',
                        name: '宛城区',
                        simple_name: '宛城',
                        hidden: 0,
                    },
                    {
                        code: '411303',
                        name: '卧龙区',
                        simple_name: '卧龙',
                        hidden: 0,
                    },
                    {
                        code: '411321',
                        name: '南召县',
                        simple_name: '南召',
                        hidden: 0,
                    },
                    {
                        code: '411322',
                        name: '方城县',
                        simple_name: '方城',
                        hidden: 0,
                    },
                    {
                        code: '411323',
                        name: '西峡县',
                        simple_name: '西峡',
                        hidden: 0,
                    },
                    {
                        code: '411324',
                        name: '镇平县',
                        simple_name: '镇平',
                        hidden: 0,
                    },
                    {
                        code: '411325',
                        name: '内乡县',
                        simple_name: '内乡',
                        hidden: 0,
                    },
                    {
                        code: '411326',
                        name: '淅川县',
                        simple_name: '淅川',
                        hidden: 0,
                    },
                    {
                        code: '411327',
                        name: '社旗县',
                        simple_name: '社旗',
                        hidden: 0,
                    },
                    {
                        code: '411328',
                        name: '唐河县',
                        simple_name: '唐河',
                        hidden: 0,
                    },
                    {
                        code: '411329',
                        name: '新野县',
                        simple_name: '新野',
                        hidden: 0,
                    },
                    {
                        code: '411330',
                        name: '桐柏县',
                        simple_name: '桐柏',
                        hidden: 0,
                    },
                    {
                        code: '411381',
                        name: '邓州市',
                        simple_name: '邓州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411400',
                name: '商丘市',
                simple_name: '商丘',
                hidden: 0,
                districts: [
                    {
                        code: '411402',
                        name: '梁园区',
                        simple_name: '梁园',
                        hidden: 0,
                    },
                    {
                        code: '411403',
                        name: '睢阳区',
                        simple_name: '睢阳',
                        hidden: 0,
                    },
                    {
                        code: '411421',
                        name: '民权县',
                        simple_name: '民权',
                        hidden: 0,
                    },
                    {
                        code: '411422',
                        name: '睢县',
                        simple_name: '睢县',
                        hidden: 0,
                    },
                    {
                        code: '411423',
                        name: '宁陵县',
                        simple_name: '宁陵',
                        hidden: 0,
                    },
                    {
                        code: '411424',
                        name: '柘城县',
                        simple_name: '柘城',
                        hidden: 0,
                    },
                    {
                        code: '411425',
                        name: '虞城县',
                        simple_name: '虞城',
                        hidden: 0,
                    },
                    {
                        code: '411426',
                        name: '夏邑县',
                        simple_name: '夏邑',
                        hidden: 0,
                    },
                    {
                        code: '411481',
                        name: '永城市',
                        simple_name: '永城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411500',
                name: '信阳市',
                simple_name: '信阳',
                hidden: 0,
                districts: [
                    {
                        code: '411502',
                        name: '浉河区',
                        simple_name: '浉河',
                        hidden: 0,
                    },
                    {
                        code: '411503',
                        name: '平桥区',
                        simple_name: '平桥',
                        hidden: 0,
                    },
                    {
                        code: '411521',
                        name: '罗山县',
                        simple_name: '罗山',
                        hidden: 0,
                    },
                    {
                        code: '411522',
                        name: '光山县',
                        simple_name: '光山',
                        hidden: 0,
                    },
                    {
                        code: '411523',
                        name: '新县',
                        simple_name: '新县',
                        hidden: 0,
                    },
                    {
                        code: '411524',
                        name: '商城县',
                        simple_name: '商城',
                        hidden: 0,
                    },
                    {
                        code: '411525',
                        name: '固始县',
                        simple_name: '固始',
                        hidden: 0,
                    },
                    {
                        code: '411526',
                        name: '潢川县',
                        simple_name: '潢川',
                        hidden: 0,
                    },
                    {
                        code: '411527',
                        name: '淮滨县',
                        simple_name: '淮滨',
                        hidden: 0,
                    },
                    {
                        code: '411528',
                        name: '息县',
                        simple_name: '息县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411600',
                name: '周口市',
                simple_name: '周口',
                hidden: 0,
                districts: [
                    {
                        code: '411602',
                        name: '川汇区',
                        simple_name: '川汇',
                        hidden: 0,
                    },
                    {
                        code: '411621',
                        name: '扶沟县',
                        simple_name: '扶沟',
                        hidden: 0,
                    },
                    {
                        code: '411622',
                        name: '西华县',
                        simple_name: '西华',
                        hidden: 0,
                    },
                    {
                        code: '411623',
                        name: '商水县',
                        simple_name: '商水',
                        hidden: 0,
                    },
                    {
                        code: '411624',
                        name: '沈丘县',
                        simple_name: '沈丘',
                        hidden: 0,
                    },
                    {
                        code: '411625',
                        name: '郸城县',
                        simple_name: '郸城',
                        hidden: 0,
                    },
                    {
                        code: '411626',
                        name: '淮阳县',
                        simple_name: '淮阳',
                        hidden: 0,
                    },
                    {
                        code: '411627',
                        name: '太康县',
                        simple_name: '太康',
                        hidden: 0,
                    },
                    {
                        code: '411628',
                        name: '鹿邑县',
                        simple_name: '鹿邑',
                        hidden: 0,
                    },
                    {
                        code: '411681',
                        name: '项城市',
                        simple_name: '项城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '411700',
                name: '驻马店市',
                simple_name: '驻马店',
                hidden: 0,
                districts: [
                    {
                        code: '411702',
                        name: '驿城区',
                        simple_name: '驿城',
                        hidden: 0,
                    },
                    {
                        code: '411721',
                        name: '西平县',
                        simple_name: '西平',
                        hidden: 0,
                    },
                    {
                        code: '411722',
                        name: '上蔡县',
                        simple_name: '上蔡',
                        hidden: 0,
                    },
                    {
                        code: '411723',
                        name: '平舆县',
                        simple_name: '平舆',
                        hidden: 0,
                    },
                    {
                        code: '411724',
                        name: '正阳县',
                        simple_name: '正阳',
                        hidden: 0,
                    },
                    {
                        code: '411725',
                        name: '确山县',
                        simple_name: '确山',
                        hidden: 0,
                    },
                    {
                        code: '411726',
                        name: '泌阳县',
                        simple_name: '泌阳',
                        hidden: 0,
                    },
                    {
                        code: '411727',
                        name: '汝南县',
                        simple_name: '汝南',
                        hidden: 0,
                    },
                    {
                        code: '411728',
                        name: '遂平县',
                        simple_name: '遂平',
                        hidden: 0,
                    },
                    {
                        code: '411729',
                        name: '新蔡县',
                        simple_name: '新蔡',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '419000',
                name: '直辖县级',
                simple_name: ' ',
                hidden: 0,
                districts: [
                    {
                        code: '419001',
                        name: '济源市',
                        simple_name: '济源',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '420000',
        name: '湖北省',
        simple_name: '湖北',
        hidden: 0,
        cities: [
            {
                code: '420100',
                name: '武汉市',
                simple_name: '武汉',
                hidden: 0,
                districts: [
                    {
                        code: '420102',
                        name: '江岸区',
                        simple_name: '江岸',
                        hidden: 0,
                    },
                    {
                        code: '420103',
                        name: '江汉区',
                        simple_name: '江汉',
                        hidden: 0,
                    },
                    {
                        code: '420104',
                        name: '硚口区',
                        simple_name: '硚口',
                        hidden: 0,
                    },
                    {
                        code: '420105',
                        name: '汉阳区',
                        simple_name: '汉阳',
                        hidden: 0,
                    },
                    {
                        code: '420106',
                        name: '武昌区',
                        simple_name: '武昌',
                        hidden: 0,
                    },
                    {
                        code: '420107',
                        name: '青山区',
                        simple_name: '青山',
                        hidden: 0,
                    },
                    {
                        code: '420111',
                        name: '洪山区',
                        simple_name: '洪山',
                        hidden: 0,
                    },
                    {
                        code: '420112',
                        name: '东西湖区',
                        simple_name: '东西湖',
                        hidden: 0,
                    },
                    {
                        code: '420113',
                        name: '汉南区',
                        simple_name: '汉南',
                        hidden: 0,
                    },
                    {
                        code: '420114',
                        name: '蔡甸区',
                        simple_name: '蔡甸',
                        hidden: 0,
                    },
                    {
                        code: '420115',
                        name: '江夏区',
                        simple_name: '江夏',
                        hidden: 0,
                    },
                    {
                        code: '420116',
                        name: '黄陂区',
                        simple_name: '黄陂',
                        hidden: 0,
                    },
                    {
                        code: '420117',
                        name: '新洲区',
                        simple_name: '新洲',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420200',
                name: '黄石市',
                simple_name: '黄石',
                hidden: 0,
                districts: [
                    {
                        code: '420202',
                        name: '黄石港区',
                        simple_name: '黄石港',
                        hidden: 0,
                    },
                    {
                        code: '420203',
                        name: '西塞山区',
                        simple_name: '西塞山',
                        hidden: 0,
                    },
                    {
                        code: '420204',
                        name: '下陆区',
                        simple_name: '下陆',
                        hidden: 0,
                    },
                    {
                        code: '420205',
                        name: '铁山区',
                        simple_name: '铁山',
                        hidden: 0,
                    },
                    {
                        code: '420222',
                        name: '阳新县',
                        simple_name: '阳新',
                        hidden: 0,
                    },
                    {
                        code: '420281',
                        name: '大冶市',
                        simple_name: '大冶',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420300',
                name: '十堰市',
                simple_name: '十堰',
                hidden: 0,
                districts: [
                    {
                        code: '420302',
                        name: '茅箭区',
                        simple_name: '茅箭',
                        hidden: 0,
                    },
                    {
                        code: '420303',
                        name: '张湾区',
                        simple_name: '张湾',
                        hidden: 0,
                    },
                    {
                        code: '420304',
                        name: '郧阳区',
                        simple_name: '郧阳',
                        hidden: 0,
                    },
                    {
                        code: '420322',
                        name: '郧西县',
                        simple_name: '郧西',
                        hidden: 0,
                    },
                    {
                        code: '420323',
                        name: '竹山县',
                        simple_name: '竹山',
                        hidden: 0,
                    },
                    {
                        code: '420324',
                        name: '竹溪县',
                        simple_name: '竹溪',
                        hidden: 0,
                    },
                    {
                        code: '420325',
                        name: '房县',
                        simple_name: '房县',
                        hidden: 0,
                    },
                    {
                        code: '420381',
                        name: '丹江口市',
                        simple_name: '丹江口',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420500',
                name: '宜昌市',
                simple_name: '宜昌',
                hidden: 0,
                districts: [
                    {
                        code: '420502',
                        name: '西陵区',
                        simple_name: '西陵',
                        hidden: 0,
                    },
                    {
                        code: '420503',
                        name: '伍家岗区',
                        simple_name: '伍家岗',
                        hidden: 0,
                    },
                    {
                        code: '420504',
                        name: '点军区',
                        simple_name: '点军',
                        hidden: 0,
                    },
                    {
                        code: '420505',
                        name: '猇亭区',
                        simple_name: '猇亭',
                        hidden: 0,
                    },
                    {
                        code: '420506',
                        name: '夷陵区',
                        simple_name: '夷陵',
                        hidden: 0,
                    },
                    {
                        code: '420525',
                        name: '远安县',
                        simple_name: '远安',
                        hidden: 0,
                    },
                    {
                        code: '420526',
                        name: '兴山县',
                        simple_name: '兴山',
                        hidden: 0,
                    },
                    {
                        code: '420527',
                        name: '秭归县',
                        simple_name: '秭归',
                        hidden: 0,
                    },
                    {
                        code: '420528',
                        name: '长阳土家族自治县',
                        simple_name: '长阳',
                        hidden: 0,
                    },
                    {
                        code: '420529',
                        name: '五峰土家族自治县',
                        simple_name: '五峰',
                        hidden: 0,
                    },
                    {
                        code: '420581',
                        name: '宜都市',
                        simple_name: '宜都',
                        hidden: 0,
                    },
                    {
                        code: '420582',
                        name: '当阳市',
                        simple_name: '当阳',
                        hidden: 0,
                    },
                    {
                        code: '420583',
                        name: '枝江市',
                        simple_name: '枝江',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420600',
                name: '襄阳市',
                simple_name: '襄阳',
                hidden: 0,
                districts: [
                    {
                        code: '420602',
                        name: '襄城区',
                        simple_name: '襄城',
                        hidden: 0,
                    },
                    {
                        code: '420606',
                        name: '樊城区',
                        simple_name: '樊城',
                        hidden: 0,
                    },
                    {
                        code: '420607',
                        name: '襄州区',
                        simple_name: '襄州',
                        hidden: 0,
                    },
                    {
                        code: '420624',
                        name: '南漳县',
                        simple_name: '南漳',
                        hidden: 0,
                    },
                    {
                        code: '420625',
                        name: '谷城县',
                        simple_name: '谷城',
                        hidden: 0,
                    },
                    {
                        code: '420626',
                        name: '保康县',
                        simple_name: '保康',
                        hidden: 0,
                    },
                    {
                        code: '420682',
                        name: '老河口市',
                        simple_name: '老河口',
                        hidden: 0,
                    },
                    {
                        code: '420683',
                        name: '枣阳市',
                        simple_name: '枣阳',
                        hidden: 0,
                    },
                    {
                        code: '420684',
                        name: '宜城市',
                        simple_name: '宜城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420700',
                name: '鄂州市',
                simple_name: '鄂州',
                hidden: 0,
                districts: [
                    {
                        code: '420702',
                        name: '梁子湖区',
                        simple_name: '梁子湖',
                        hidden: 0,
                    },
                    {
                        code: '420703',
                        name: '华容区',
                        simple_name: '华容',
                        hidden: 0,
                    },
                    {
                        code: '420704',
                        name: '鄂城区',
                        simple_name: '鄂城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420800',
                name: '荆门市',
                simple_name: '荆门',
                hidden: 0,
                districts: [
                    {
                        code: '420802',
                        name: '东宝区',
                        simple_name: '东宝',
                        hidden: 0,
                    },
                    {
                        code: '420804',
                        name: '掇刀区',
                        simple_name: '掇刀',
                        hidden: 0,
                    },
                    {
                        code: '420821',
                        name: '京山县',
                        simple_name: '京山',
                        hidden: 0,
                    },
                    {
                        code: '420822',
                        name: '沙洋县',
                        simple_name: '沙洋',
                        hidden: 0,
                    },
                    {
                        code: '420881',
                        name: '钟祥市',
                        simple_name: '钟祥',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '420900',
                name: '孝感市',
                simple_name: '孝感',
                hidden: 0,
                districts: [
                    {
                        code: '420902',
                        name: '孝南区',
                        simple_name: '孝南',
                        hidden: 0,
                    },
                    {
                        code: '420921',
                        name: '孝昌县',
                        simple_name: '孝昌',
                        hidden: 0,
                    },
                    {
                        code: '420922',
                        name: '大悟县',
                        simple_name: '大悟',
                        hidden: 0,
                    },
                    {
                        code: '420923',
                        name: '云梦县',
                        simple_name: '云梦',
                        hidden: 0,
                    },
                    {
                        code: '420981',
                        name: '应城市',
                        simple_name: '应城',
                        hidden: 0,
                    },
                    {
                        code: '420982',
                        name: '安陆市',
                        simple_name: '安陆',
                        hidden: 0,
                    },
                    {
                        code: '420984',
                        name: '汉川市',
                        simple_name: '汉川',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '421000',
                name: '荆州市',
                simple_name: '荆州',
                hidden: 0,
                districts: [
                    {
                        code: '421002',
                        name: '沙市区',
                        simple_name: '沙市',
                        hidden: 0,
                    },
                    {
                        code: '421003',
                        name: '荆州区',
                        simple_name: '荆州',
                        hidden: 0,
                    },
                    {
                        code: '421022',
                        name: '公安县',
                        simple_name: '公安',
                        hidden: 0,
                    },
                    {
                        code: '421023',
                        name: '监利县',
                        simple_name: '监利',
                        hidden: 0,
                    },
                    {
                        code: '421024',
                        name: '江陵县',
                        simple_name: '江陵',
                        hidden: 0,
                    },
                    {
                        code: '421081',
                        name: '石首市',
                        simple_name: '石首',
                        hidden: 0,
                    },
                    {
                        code: '421083',
                        name: '洪湖市',
                        simple_name: '洪湖',
                        hidden: 0,
                    },
                    {
                        code: '421087',
                        name: '松滋市',
                        simple_name: '松滋',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '421100',
                name: '黄冈市',
                simple_name: '黄冈',
                hidden: 0,
                districts: [
                    {
                        code: '421102',
                        name: '黄州区',
                        simple_name: '黄州',
                        hidden: 0,
                    },
                    {
                        code: '421121',
                        name: '团风县',
                        simple_name: '团风',
                        hidden: 0,
                    },
                    {
                        code: '421122',
                        name: '红安县',
                        simple_name: '红安',
                        hidden: 0,
                    },
                    {
                        code: '421123',
                        name: '罗田县',
                        simple_name: '罗田',
                        hidden: 0,
                    },
                    {
                        code: '421124',
                        name: '英山县',
                        simple_name: '英山',
                        hidden: 0,
                    },
                    {
                        code: '421125',
                        name: '浠水县',
                        simple_name: '浠水',
                        hidden: 0,
                    },
                    {
                        code: '421126',
                        name: '蕲春县',
                        simple_name: '蕲春',
                        hidden: 0,
                    },
                    {
                        code: '421127',
                        name: '黄梅县',
                        simple_name: '黄梅',
                        hidden: 0,
                    },
                    {
                        code: '421181',
                        name: '麻城市',
                        simple_name: '麻城',
                        hidden: 0,
                    },
                    {
                        code: '421182',
                        name: '武穴市',
                        simple_name: '武穴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '421200',
                name: '咸宁市',
                simple_name: '咸宁',
                hidden: 0,
                districts: [
                    {
                        code: '421202',
                        name: '咸安区',
                        simple_name: '咸安',
                        hidden: 0,
                    },
                    {
                        code: '421221',
                        name: '嘉鱼县',
                        simple_name: '嘉鱼',
                        hidden: 0,
                    },
                    {
                        code: '421222',
                        name: '通城县',
                        simple_name: '通城',
                        hidden: 0,
                    },
                    {
                        code: '421223',
                        name: '崇阳县',
                        simple_name: '崇阳',
                        hidden: 0,
                    },
                    {
                        code: '421224',
                        name: '通山县',
                        simple_name: '通山',
                        hidden: 0,
                    },
                    {
                        code: '421281',
                        name: '赤壁市',
                        simple_name: '赤壁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '421300',
                name: '随州市',
                simple_name: '随州',
                hidden: 0,
                districts: [
                    {
                        code: '421303',
                        name: '曾都区',
                        simple_name: '曾都',
                        hidden: 0,
                    },
                    {
                        code: '421321',
                        name: '随县',
                        simple_name: '随县',
                        hidden: 0,
                    },
                    {
                        code: '421381',
                        name: '广水市',
                        simple_name: '广水',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '422800',
                name: '恩施土家族苗族自治州',
                simple_name: '恩施',
                hidden: 0,
                districts: [
                    {
                        code: '422801',
                        name: '恩施市',
                        simple_name: '恩施',
                        hidden: 0,
                    },
                    {
                        code: '422802',
                        name: '利川市',
                        simple_name: '利川',
                        hidden: 0,
                    },
                    {
                        code: '422822',
                        name: '建始县',
                        simple_name: '建始',
                        hidden: 0,
                    },
                    {
                        code: '422823',
                        name: '巴东县',
                        simple_name: '巴东',
                        hidden: 0,
                    },
                    {
                        code: '422825',
                        name: '宣恩县',
                        simple_name: '宣恩',
                        hidden: 0,
                    },
                    {
                        code: '422826',
                        name: '咸丰县',
                        simple_name: '咸丰',
                        hidden: 0,
                    },
                    {
                        code: '422827',
                        name: '来凤县',
                        simple_name: '来凤',
                        hidden: 0,
                    },
                    {
                        code: '422828',
                        name: '鹤峰县',
                        simple_name: '鹤峰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '429000',
                name: '直辖县级',
                simple_name: ' ',
                hidden: 0,
                districts: [
                    {
                        code: '429004',
                        name: '仙桃市',
                        simple_name: '仙桃',
                        hidden: 0,
                    },
                    {
                        code: '429005',
                        name: '潜江市',
                        simple_name: '潜江',
                        hidden: 0,
                    },
                    {
                        code: '429006',
                        name: '天门市',
                        simple_name: '天门',
                        hidden: 0,
                    },
                    {
                        code: '429021',
                        name: '神农架林区',
                        simple_name: '神农架',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '430000',
        name: '湖南省',
        simple_name: '湖南',
        hidden: 0,
        cities: [
            {
                code: '430100',
                name: '长沙市',
                simple_name: '长沙',
                hidden: 0,
                districts: [
                    {
                        code: '430102',
                        name: '芙蓉区',
                        simple_name: '芙蓉',
                        hidden: 0,
                    },
                    {
                        code: '430103',
                        name: '天心区',
                        simple_name: '天心',
                        hidden: 0,
                    },
                    {
                        code: '430104',
                        name: '岳麓区',
                        simple_name: '岳麓',
                        hidden: 0,
                    },
                    {
                        code: '430105',
                        name: '开福区',
                        simple_name: '开福',
                        hidden: 0,
                    },
                    {
                        code: '430111',
                        name: '雨花区',
                        simple_name: '雨花',
                        hidden: 0,
                    },
                    {
                        code: '430112',
                        name: '望城区',
                        simple_name: '望城',
                        hidden: 0,
                    },
                    {
                        code: '430121',
                        name: '长沙县',
                        simple_name: '长沙',
                        hidden: 0,
                    },
                    {
                        code: '430124',
                        name: '宁乡县',
                        simple_name: '宁乡',
                        hidden: 0,
                    },
                    {
                        code: '430181',
                        name: '浏阳市',
                        simple_name: '浏阳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430200',
                name: '株洲市',
                simple_name: '株洲',
                hidden: 0,
                districts: [
                    {
                        code: '430202',
                        name: '荷塘区',
                        simple_name: '荷塘',
                        hidden: 0,
                    },
                    {
                        code: '430203',
                        name: '芦淞区',
                        simple_name: '芦淞',
                        hidden: 0,
                    },
                    {
                        code: '430204',
                        name: '石峰区',
                        simple_name: '石峰',
                        hidden: 0,
                    },
                    {
                        code: '430211',
                        name: '天元区',
                        simple_name: '天元',
                        hidden: 0,
                    },
                    {
                        code: '430221',
                        name: '株洲县',
                        simple_name: '株洲',
                        hidden: 0,
                    },
                    {
                        code: '430223',
                        name: '攸县',
                        simple_name: '攸县',
                        hidden: 0,
                    },
                    {
                        code: '430224',
                        name: '茶陵县',
                        simple_name: '茶陵',
                        hidden: 0,
                    },
                    {
                        code: '430225',
                        name: '炎陵县',
                        simple_name: '炎陵',
                        hidden: 0,
                    },
                    {
                        code: '430281',
                        name: '醴陵市',
                        simple_name: '醴陵',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430300',
                name: '湘潭市',
                simple_name: '湘潭',
                hidden: 0,
                districts: [
                    {
                        code: '430302',
                        name: '雨湖区',
                        simple_name: '雨湖',
                        hidden: 0,
                    },
                    {
                        code: '430304',
                        name: '岳塘区',
                        simple_name: '岳塘',
                        hidden: 0,
                    },
                    {
                        code: '430321',
                        name: '湘潭县',
                        simple_name: '湘潭',
                        hidden: 0,
                    },
                    {
                        code: '430381',
                        name: '湘乡市',
                        simple_name: '湘乡',
                        hidden: 0,
                    },
                    {
                        code: '430382',
                        name: '韶山市',
                        simple_name: '韶山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430400',
                name: '衡阳市',
                simple_name: '衡阳',
                hidden: 0,
                districts: [
                    {
                        code: '430405',
                        name: '珠晖区',
                        simple_name: '珠晖',
                        hidden: 0,
                    },
                    {
                        code: '430406',
                        name: '雁峰区',
                        simple_name: '雁峰',
                        hidden: 0,
                    },
                    {
                        code: '430407',
                        name: '石鼓区',
                        simple_name: '石鼓',
                        hidden: 0,
                    },
                    {
                        code: '430408',
                        name: '蒸湘区',
                        simple_name: '蒸湘',
                        hidden: 0,
                    },
                    {
                        code: '430412',
                        name: '南岳区',
                        simple_name: '南岳',
                        hidden: 0,
                    },
                    {
                        code: '430421',
                        name: '衡阳县',
                        simple_name: '衡阳',
                        hidden: 0,
                    },
                    {
                        code: '430422',
                        name: '衡南县',
                        simple_name: '衡南',
                        hidden: 0,
                    },
                    {
                        code: '430423',
                        name: '衡山县',
                        simple_name: '衡山',
                        hidden: 0,
                    },
                    {
                        code: '430424',
                        name: '衡东县',
                        simple_name: '衡东',
                        hidden: 0,
                    },
                    {
                        code: '430426',
                        name: '祁东县',
                        simple_name: '祁东',
                        hidden: 0,
                    },
                    {
                        code: '430481',
                        name: '耒阳市',
                        simple_name: '耒阳',
                        hidden: 0,
                    },
                    {
                        code: '430482',
                        name: '常宁市',
                        simple_name: '常宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430500',
                name: '邵阳市',
                simple_name: '邵阳',
                hidden: 0,
                districts: [
                    {
                        code: '430502',
                        name: '双清区',
                        simple_name: '双清',
                        hidden: 0,
                    },
                    {
                        code: '430503',
                        name: '大祥区',
                        simple_name: '大祥',
                        hidden: 0,
                    },
                    {
                        code: '430511',
                        name: '北塔区',
                        simple_name: '北塔',
                        hidden: 0,
                    },
                    {
                        code: '430521',
                        name: '邵东县',
                        simple_name: '邵东',
                        hidden: 0,
                    },
                    {
                        code: '430522',
                        name: '新邵县',
                        simple_name: '新邵',
                        hidden: 0,
                    },
                    {
                        code: '430523',
                        name: '邵阳县',
                        simple_name: '邵阳',
                        hidden: 0,
                    },
                    {
                        code: '430524',
                        name: '隆回县',
                        simple_name: '隆回',
                        hidden: 0,
                    },
                    {
                        code: '430525',
                        name: '洞口县',
                        simple_name: '洞口',
                        hidden: 0,
                    },
                    {
                        code: '430527',
                        name: '绥宁县',
                        simple_name: '绥宁',
                        hidden: 0,
                    },
                    {
                        code: '430528',
                        name: '新宁县',
                        simple_name: '新宁',
                        hidden: 0,
                    },
                    {
                        code: '430529',
                        name: '城步苗族自治县',
                        simple_name: '城步',
                        hidden: 0,
                    },
                    {
                        code: '430581',
                        name: '武冈市',
                        simple_name: '武冈',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430600',
                name: '岳阳市',
                simple_name: '岳阳',
                hidden: 0,
                districts: [
                    {
                        code: '430602',
                        name: '岳阳楼区',
                        simple_name: '岳阳楼',
                        hidden: 0,
                    },
                    {
                        code: '430603',
                        name: '云溪区',
                        simple_name: '云溪',
                        hidden: 0,
                    },
                    {
                        code: '430611',
                        name: '君山区',
                        simple_name: '君山',
                        hidden: 0,
                    },
                    {
                        code: '430621',
                        name: '岳阳县',
                        simple_name: '岳阳',
                        hidden: 0,
                    },
                    {
                        code: '430623',
                        name: '华容县',
                        simple_name: '华容',
                        hidden: 0,
                    },
                    {
                        code: '430624',
                        name: '湘阴县',
                        simple_name: '湘阴',
                        hidden: 0,
                    },
                    {
                        code: '430626',
                        name: '平江县',
                        simple_name: '平江',
                        hidden: 0,
                    },
                    {
                        code: '430681',
                        name: '汨罗市',
                        simple_name: '汨罗',
                        hidden: 0,
                    },
                    {
                        code: '430682',
                        name: '临湘市',
                        simple_name: '临湘',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430700',
                name: '常德市',
                simple_name: '常德',
                hidden: 0,
                districts: [
                    {
                        code: '430702',
                        name: '武陵区',
                        simple_name: '武陵',
                        hidden: 0,
                    },
                    {
                        code: '430703',
                        name: '鼎城区',
                        simple_name: '鼎城',
                        hidden: 0,
                    },
                    {
                        code: '430721',
                        name: '安乡县',
                        simple_name: '安乡',
                        hidden: 0,
                    },
                    {
                        code: '430722',
                        name: '汉寿县',
                        simple_name: '汉寿',
                        hidden: 0,
                    },
                    {
                        code: '430723',
                        name: '澧县',
                        simple_name: '澧县',
                        hidden: 0,
                    },
                    {
                        code: '430724',
                        name: '临澧县',
                        simple_name: '临澧',
                        hidden: 0,
                    },
                    {
                        code: '430725',
                        name: '桃源县',
                        simple_name: '桃源',
                        hidden: 0,
                    },
                    {
                        code: '430726',
                        name: '石门县',
                        simple_name: '石门',
                        hidden: 0,
                    },
                    {
                        code: '430781',
                        name: '津市市',
                        simple_name: '津市',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430800',
                name: '张家界市',
                simple_name: '张家界',
                hidden: 0,
                districts: [
                    {
                        code: '430802',
                        name: '永定区',
                        simple_name: '永定',
                        hidden: 0,
                    },
                    {
                        code: '430811',
                        name: '武陵源区',
                        simple_name: '武陵源',
                        hidden: 0,
                    },
                    {
                        code: '430821',
                        name: '慈利县',
                        simple_name: '慈利',
                        hidden: 0,
                    },
                    {
                        code: '430822',
                        name: '桑植县',
                        simple_name: '桑植',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '430900',
                name: '益阳市',
                simple_name: '益阳',
                hidden: 0,
                districts: [
                    {
                        code: '430902',
                        name: '资阳区',
                        simple_name: '资阳',
                        hidden: 0,
                    },
                    {
                        code: '430903',
                        name: '赫山区',
                        simple_name: '赫山',
                        hidden: 0,
                    },
                    {
                        code: '430921',
                        name: '南县',
                        simple_name: '南县',
                        hidden: 0,
                    },
                    {
                        code: '430922',
                        name: '桃江县',
                        simple_name: '桃江',
                        hidden: 0,
                    },
                    {
                        code: '430923',
                        name: '安化县',
                        simple_name: '安化',
                        hidden: 0,
                    },
                    {
                        code: '430981',
                        name: '沅江市',
                        simple_name: '沅江',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '431000',
                name: '郴州市',
                simple_name: '郴州',
                hidden: 0,
                districts: [
                    {
                        code: '431002',
                        name: '北湖区',
                        simple_name: '北湖',
                        hidden: 0,
                    },
                    {
                        code: '431003',
                        name: '苏仙区',
                        simple_name: '苏仙',
                        hidden: 0,
                    },
                    {
                        code: '431021',
                        name: '桂阳县',
                        simple_name: '桂阳',
                        hidden: 0,
                    },
                    {
                        code: '431022',
                        name: '宜章县',
                        simple_name: '宜章',
                        hidden: 0,
                    },
                    {
                        code: '431023',
                        name: '永兴县',
                        simple_name: '永兴',
                        hidden: 0,
                    },
                    {
                        code: '431024',
                        name: '嘉禾县',
                        simple_name: '嘉禾',
                        hidden: 0,
                    },
                    {
                        code: '431025',
                        name: '临武县',
                        simple_name: '临武',
                        hidden: 0,
                    },
                    {
                        code: '431026',
                        name: '汝城县',
                        simple_name: '汝城',
                        hidden: 0,
                    },
                    {
                        code: '431027',
                        name: '桂东县',
                        simple_name: '桂东',
                        hidden: 0,
                    },
                    {
                        code: '431028',
                        name: '安仁县',
                        simple_name: '安仁',
                        hidden: 0,
                    },
                    {
                        code: '431081',
                        name: '资兴市',
                        simple_name: '资兴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '431100',
                name: '永州市',
                simple_name: '永州',
                hidden: 0,
                districts: [
                    {
                        code: '431102',
                        name: '零陵区',
                        simple_name: '零陵',
                        hidden: 0,
                    },
                    {
                        code: '431103',
                        name: '冷水滩区',
                        simple_name: '冷水滩',
                        hidden: 0,
                    },
                    {
                        code: '431121',
                        name: '祁阳县',
                        simple_name: '祁阳',
                        hidden: 0,
                    },
                    {
                        code: '431122',
                        name: '东安县',
                        simple_name: '东安',
                        hidden: 0,
                    },
                    {
                        code: '431123',
                        name: '双牌县',
                        simple_name: '双牌',
                        hidden: 0,
                    },
                    {
                        code: '431124',
                        name: '道县',
                        simple_name: '道县',
                        hidden: 0,
                    },
                    {
                        code: '431125',
                        name: '江永县',
                        simple_name: '江永',
                        hidden: 0,
                    },
                    {
                        code: '431126',
                        name: '宁远县',
                        simple_name: '宁远',
                        hidden: 0,
                    },
                    {
                        code: '431127',
                        name: '蓝山县',
                        simple_name: '蓝山',
                        hidden: 0,
                    },
                    {
                        code: '431128',
                        name: '新田县',
                        simple_name: '新田',
                        hidden: 0,
                    },
                    {
                        code: '431129',
                        name: '江华瑶族自治县',
                        simple_name: '江华',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '431200',
                name: '怀化市',
                simple_name: '怀化',
                hidden: 0,
                districts: [
                    {
                        code: '431202',
                        name: '鹤城区',
                        simple_name: '鹤城',
                        hidden: 0,
                    },
                    {
                        code: '431221',
                        name: '中方县',
                        simple_name: '中方',
                        hidden: 0,
                    },
                    {
                        code: '431222',
                        name: '沅陵县',
                        simple_name: '沅陵',
                        hidden: 0,
                    },
                    {
                        code: '431223',
                        name: '辰溪县',
                        simple_name: '辰溪',
                        hidden: 0,
                    },
                    {
                        code: '431224',
                        name: '溆浦县',
                        simple_name: '溆浦',
                        hidden: 0,
                    },
                    {
                        code: '431225',
                        name: '会同县',
                        simple_name: '会同',
                        hidden: 0,
                    },
                    {
                        code: '431226',
                        name: '麻阳苗族自治县',
                        simple_name: '麻阳',
                        hidden: 0,
                    },
                    {
                        code: '431227',
                        name: '新晃侗族自治县',
                        simple_name: '新晃',
                        hidden: 0,
                    },
                    {
                        code: '431228',
                        name: '芷江侗族自治县',
                        simple_name: '芷江',
                        hidden: 0,
                    },
                    {
                        code: '431229',
                        name: '靖州苗族侗族自治县',
                        simple_name: '靖州',
                        hidden: 0,
                    },
                    {
                        code: '431230',
                        name: '通道侗族自治县',
                        simple_name: '通道',
                        hidden: 0,
                    },
                    {
                        code: '431281',
                        name: '洪江市',
                        simple_name: '洪江',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '431300',
                name: '娄底市',
                simple_name: '娄底',
                hidden: 0,
                districts: [
                    {
                        code: '431302',
                        name: '娄星区',
                        simple_name: '娄星',
                        hidden: 0,
                    },
                    {
                        code: '431321',
                        name: '双峰县',
                        simple_name: '双峰',
                        hidden: 0,
                    },
                    {
                        code: '431322',
                        name: '新化县',
                        simple_name: '新化',
                        hidden: 0,
                    },
                    {
                        code: '431381',
                        name: '冷水江市',
                        simple_name: '冷水江',
                        hidden: 0,
                    },
                    {
                        code: '431382',
                        name: '涟源市',
                        simple_name: '涟源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '433100',
                name: '湘西土家族苗族自治州',
                simple_name: '湘西',
                hidden: 0,
                districts: [
                    {
                        code: '433101',
                        name: '吉首市',
                        simple_name: '吉首',
                        hidden: 0,
                    },
                    {
                        code: '433122',
                        name: '泸溪县',
                        simple_name: '泸溪',
                        hidden: 0,
                    },
                    {
                        code: '433123',
                        name: '凤凰县',
                        simple_name: '凤凰',
                        hidden: 0,
                    },
                    {
                        code: '433124',
                        name: '花垣县',
                        simple_name: '花垣',
                        hidden: 0,
                    },
                    {
                        code: '433125',
                        name: '保靖县',
                        simple_name: '保靖',
                        hidden: 0,
                    },
                    {
                        code: '433126',
                        name: '古丈县',
                        simple_name: '古丈',
                        hidden: 0,
                    },
                    {
                        code: '433127',
                        name: '永顺县',
                        simple_name: '永顺',
                        hidden: 0,
                    },
                    {
                        code: '433130',
                        name: '龙山县',
                        simple_name: '龙山',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '440000',
        name: '广东省',
        simple_name: '广东',
        hidden: 0,
        cities: [
            {
                code: '440100',
                name: '广州市',
                simple_name: '广州',
                hidden: 0,
                districts: [
                    {
                        code: '440103',
                        name: '荔湾区',
                        simple_name: '荔湾',
                        hidden: 0,
                    },
                    {
                        code: '440104',
                        name: '越秀区',
                        simple_name: '越秀',
                        hidden: 0,
                    },
                    {
                        code: '440105',
                        name: '海珠区',
                        simple_name: '海珠',
                        hidden: 0,
                    },
                    {
                        code: '440106',
                        name: '天河区',
                        simple_name: '天河',
                        hidden: 0,
                    },
                    {
                        code: '440111',
                        name: '白云区',
                        simple_name: '白云',
                        hidden: 0,
                    },
                    {
                        code: '440112',
                        name: '黄埔区',
                        simple_name: '黄埔',
                        hidden: 0,
                    },
                    {
                        code: '440113',
                        name: '番禺区',
                        simple_name: '番禺',
                        hidden: 0,
                    },
                    {
                        code: '440114',
                        name: '花都区',
                        simple_name: '花都',
                        hidden: 0,
                    },
                    {
                        code: '440115',
                        name: '南沙区',
                        simple_name: '南沙',
                        hidden: 0,
                    },
                    {
                        code: '440117',
                        name: '从化区',
                        simple_name: '从化',
                        hidden: 0,
                    },
                    {
                        code: '440118',
                        name: '增城区',
                        simple_name: '增城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440200',
                name: '韶关市',
                simple_name: '韶关',
                hidden: 0,
                districts: [
                    {
                        code: '440203',
                        name: '武江区',
                        simple_name: '武江',
                        hidden: 0,
                    },
                    {
                        code: '440204',
                        name: '浈江区',
                        simple_name: '浈江',
                        hidden: 0,
                    },
                    {
                        code: '440205',
                        name: '曲江区',
                        simple_name: '曲江',
                        hidden: 0,
                    },
                    {
                        code: '440222',
                        name: '始兴县',
                        simple_name: '始兴',
                        hidden: 0,
                    },
                    {
                        code: '440224',
                        name: '仁化县',
                        simple_name: '仁化',
                        hidden: 0,
                    },
                    {
                        code: '440229',
                        name: '翁源县',
                        simple_name: '翁源',
                        hidden: 0,
                    },
                    {
                        code: '440232',
                        name: '乳源瑶族自治县',
                        simple_name: '乳源',
                        hidden: 0,
                    },
                    {
                        code: '440233',
                        name: '新丰县',
                        simple_name: '新丰',
                        hidden: 0,
                    },
                    {
                        code: '440281',
                        name: '乐昌市',
                        simple_name: '乐昌',
                        hidden: 0,
                    },
                    {
                        code: '440282',
                        name: '南雄市',
                        simple_name: '南雄',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440300',
                name: '深圳市',
                simple_name: '深圳',
                hidden: 0,
                districts: [
                    {
                        code: '440303',
                        name: '罗湖区',
                        simple_name: '罗湖',
                        hidden: 0,
                    },
                    {
                        code: '440304',
                        name: '福田区',
                        simple_name: '福田',
                        hidden: 0,
                    },
                    {
                        code: '440305',
                        name: '南山区',
                        simple_name: '南山',
                        hidden: 0,
                    },
                    {
                        code: '440306',
                        name: '宝安区',
                        simple_name: '宝安',
                        hidden: 0,
                    },
                    {
                        code: '440307',
                        name: '龙岗区',
                        simple_name: '龙岗',
                        hidden: 0,
                    },
                    {
                        code: '440308',
                        name: '盐田区',
                        simple_name: '盐田',
                        hidden: 0,
                    },
                    {
                        code: '440309',
                        name: '光明新区',
                        simple_name: '光明新区',
                        hidden: 0,
                    },
                    {
                        code: '440310',
                        name: '坪山新区',
                        simple_name: '坪山新区',
                        hidden: 0,
                    },
                    {
                        code: '440311',
                        name: '大鹏新区',
                        simple_name: '大鹏新区',
                        hidden: 0,
                    },
                    {
                        code: '440312',
                        name: '龙华新区',
                        simple_name: '龙华新区',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440400',
                name: '珠海市',
                simple_name: '珠海',
                hidden: 0,
                districts: [
                    {
                        code: '440402',
                        name: '香洲区',
                        simple_name: '香洲',
                        hidden: 0,
                    },
                    {
                        code: '440403',
                        name: '斗门区',
                        simple_name: '斗门',
                        hidden: 0,
                    },
                    {
                        code: '440404',
                        name: '金湾区',
                        simple_name: '金湾',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440500',
                name: '汕头市',
                simple_name: '汕头',
                hidden: 0,
                districts: [
                    {
                        code: '440507',
                        name: '龙湖区',
                        simple_name: '龙湖',
                        hidden: 0,
                    },
                    {
                        code: '440511',
                        name: '金平区',
                        simple_name: '金平',
                        hidden: 0,
                    },
                    {
                        code: '440512',
                        name: '濠江区',
                        simple_name: '濠江',
                        hidden: 0,
                    },
                    {
                        code: '440513',
                        name: '潮阳区',
                        simple_name: '潮阳',
                        hidden: 0,
                    },
                    {
                        code: '440514',
                        name: '潮南区',
                        simple_name: '潮南',
                        hidden: 0,
                    },
                    {
                        code: '440515',
                        name: '澄海区',
                        simple_name: '澄海',
                        hidden: 0,
                    },
                    {
                        code: '440523',
                        name: '南澳县',
                        simple_name: '南澳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440600',
                name: '佛山市',
                simple_name: '佛山',
                hidden: 0,
                districts: [
                    {
                        code: '440604',
                        name: '禅城区',
                        simple_name: '禅城',
                        hidden: 0,
                    },
                    {
                        code: '440605',
                        name: '南海区',
                        simple_name: '南海',
                        hidden: 0,
                    },
                    {
                        code: '440606',
                        name: '顺德区',
                        simple_name: '顺德',
                        hidden: 0,
                    },
                    {
                        code: '440607',
                        name: '三水区',
                        simple_name: '三水',
                        hidden: 0,
                    },
                    {
                        code: '440608',
                        name: '高明区',
                        simple_name: '高明',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440700',
                name: '江门市',
                simple_name: '江门',
                hidden: 0,
                districts: [
                    {
                        code: '440703',
                        name: '蓬江区',
                        simple_name: '蓬江',
                        hidden: 0,
                    },
                    {
                        code: '440704',
                        name: '江海区',
                        simple_name: '江海',
                        hidden: 0,
                    },
                    {
                        code: '440705',
                        name: '新会区',
                        simple_name: '新会',
                        hidden: 0,
                    },
                    {
                        code: '440781',
                        name: '台山市',
                        simple_name: '台山',
                        hidden: 0,
                    },
                    {
                        code: '440783',
                        name: '开平市',
                        simple_name: '开平',
                        hidden: 0,
                    },
                    {
                        code: '440784',
                        name: '鹤山市',
                        simple_name: '鹤山',
                        hidden: 0,
                    },
                    {
                        code: '440785',
                        name: '恩平市',
                        simple_name: '恩平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440800',
                name: '湛江市',
                simple_name: '湛江',
                hidden: 0,
                districts: [
                    {
                        code: '440802',
                        name: '赤坎区',
                        simple_name: '赤坎',
                        hidden: 0,
                    },
                    {
                        code: '440803',
                        name: '霞山区',
                        simple_name: '霞山',
                        hidden: 0,
                    },
                    {
                        code: '440804',
                        name: '坡头区',
                        simple_name: '坡头',
                        hidden: 0,
                    },
                    {
                        code: '440811',
                        name: '麻章区',
                        simple_name: '麻章',
                        hidden: 0,
                    },
                    {
                        code: '440823',
                        name: '遂溪县',
                        simple_name: '遂溪',
                        hidden: 0,
                    },
                    {
                        code: '440825',
                        name: '徐闻县',
                        simple_name: '徐闻',
                        hidden: 0,
                    },
                    {
                        code: '440881',
                        name: '廉江市',
                        simple_name: '廉江',
                        hidden: 0,
                    },
                    {
                        code: '440882',
                        name: '雷州市',
                        simple_name: '雷州',
                        hidden: 0,
                    },
                    {
                        code: '440883',
                        name: '吴川市',
                        simple_name: '吴川',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '440900',
                name: '茂名市',
                simple_name: '茂名',
                hidden: 0,
                districts: [
                    {
                        code: '440902',
                        name: '茂南区',
                        simple_name: '茂南',
                        hidden: 0,
                    },
                    {
                        code: '440904',
                        name: '电白区',
                        simple_name: '电白',
                        hidden: 0,
                    },
                    {
                        code: '440981',
                        name: '高州市',
                        simple_name: '高州',
                        hidden: 0,
                    },
                    {
                        code: '440982',
                        name: '化州市',
                        simple_name: '化州',
                        hidden: 0,
                    },
                    {
                        code: '440983',
                        name: '信宜市',
                        simple_name: '信宜',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441200',
                name: '肇庆市',
                simple_name: '肇庆',
                hidden: 0,
                districts: [
                    {
                        code: '441202',
                        name: '端州区',
                        simple_name: '端州',
                        hidden: 0,
                    },
                    {
                        code: '441203',
                        name: '鼎湖区',
                        simple_name: '鼎湖',
                        hidden: 0,
                    },
                    {
                        code: '441223',
                        name: '广宁县',
                        simple_name: '广宁',
                        hidden: 0,
                    },
                    {
                        code: '441224',
                        name: '怀集县',
                        simple_name: '怀集',
                        hidden: 0,
                    },
                    {
                        code: '441225',
                        name: '封开县',
                        simple_name: '封开',
                        hidden: 0,
                    },
                    {
                        code: '441226',
                        name: '德庆县',
                        simple_name: '德庆',
                        hidden: 0,
                    },
                    {
                        code: '441283',
                        name: '高要市',
                        simple_name: '高要',
                        hidden: 0,
                    },
                    {
                        code: '441284',
                        name: '四会市',
                        simple_name: '四会',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441300',
                name: '惠州市',
                simple_name: '惠州',
                hidden: 0,
                districts: [
                    {
                        code: '441302',
                        name: '惠城区',
                        simple_name: '惠城',
                        hidden: 0,
                    },
                    {
                        code: '441303',
                        name: '惠阳区',
                        simple_name: '惠阳',
                        hidden: 0,
                    },
                    {
                        code: '441322',
                        name: '博罗县',
                        simple_name: '博罗',
                        hidden: 0,
                    },
                    {
                        code: '441323',
                        name: '惠东县',
                        simple_name: '惠东',
                        hidden: 0,
                    },
                    {
                        code: '441324',
                        name: '龙门县',
                        simple_name: '龙门',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441400',
                name: '梅州市',
                simple_name: '梅州',
                hidden: 0,
                districts: [
                    {
                        code: '441402',
                        name: '梅江区',
                        simple_name: '梅江',
                        hidden: 0,
                    },
                    {
                        code: '441403',
                        name: '梅县区',
                        simple_name: '梅县',
                        hidden: 0,
                    },
                    {
                        code: '441422',
                        name: '大埔县',
                        simple_name: '大埔',
                        hidden: 0,
                    },
                    {
                        code: '441423',
                        name: '丰顺县',
                        simple_name: '丰顺',
                        hidden: 0,
                    },
                    {
                        code: '441424',
                        name: '五华县',
                        simple_name: '五华',
                        hidden: 0,
                    },
                    {
                        code: '441426',
                        name: '平远县',
                        simple_name: '平远',
                        hidden: 0,
                    },
                    {
                        code: '441427',
                        name: '蕉岭县',
                        simple_name: '蕉岭',
                        hidden: 0,
                    },
                    {
                        code: '441481',
                        name: '兴宁市',
                        simple_name: '兴宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441500',
                name: '汕尾市',
                simple_name: '汕尾',
                hidden: 0,
                districts: [
                    {
                        code: '441502',
                        name: '城区',
                        simple_name: '城区',
                        hidden: 0,
                    },
                    {
                        code: '441521',
                        name: '海丰县',
                        simple_name: '海丰',
                        hidden: 0,
                    },
                    {
                        code: '441523',
                        name: '陆河县',
                        simple_name: '陆河',
                        hidden: 0,
                    },
                    {
                        code: '441581',
                        name: '陆丰市',
                        simple_name: '陆丰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441600',
                name: '河源市',
                simple_name: '河源',
                hidden: 0,
                districts: [
                    {
                        code: '441602',
                        name: '源城区',
                        simple_name: '源城',
                        hidden: 0,
                    },
                    {
                        code: '441621',
                        name: '紫金县',
                        simple_name: '紫金',
                        hidden: 0,
                    },
                    {
                        code: '441622',
                        name: '龙川县',
                        simple_name: '龙川',
                        hidden: 0,
                    },
                    {
                        code: '441623',
                        name: '连平县',
                        simple_name: '连平',
                        hidden: 0,
                    },
                    {
                        code: '441624',
                        name: '和平县',
                        simple_name: '和平',
                        hidden: 0,
                    },
                    {
                        code: '441625',
                        name: '东源县',
                        simple_name: '东源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441700',
                name: '阳江市',
                simple_name: '阳江',
                hidden: 0,
                districts: [
                    {
                        code: '441702',
                        name: '江城区',
                        simple_name: '江城',
                        hidden: 0,
                    },
                    {
                        code: '441704',
                        name: '阳东区',
                        simple_name: '阳东',
                        hidden: 0,
                    },
                    {
                        code: '441721',
                        name: '阳西县',
                        simple_name: '阳西',
                        hidden: 0,
                    },
                    {
                        code: '441781',
                        name: '阳春市',
                        simple_name: '阳春',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441800',
                name: '清远市',
                simple_name: '清远',
                hidden: 0,
                districts: [
                    {
                        code: '441802',
                        name: '清城区',
                        simple_name: '清城',
                        hidden: 0,
                    },
                    {
                        code: '441803',
                        name: '清新区',
                        simple_name: '清新',
                        hidden: 0,
                    },
                    {
                        code: '441821',
                        name: '佛冈县',
                        simple_name: '佛冈',
                        hidden: 0,
                    },
                    {
                        code: '441823',
                        name: '阳山县',
                        simple_name: '阳山',
                        hidden: 0,
                    },
                    {
                        code: '441825',
                        name: '连山壮族瑶族自治县',
                        simple_name: '连山',
                        hidden: 0,
                    },
                    {
                        code: '441826',
                        name: '连南瑶族自治县',
                        simple_name: '连南',
                        hidden: 0,
                    },
                    {
                        code: '441881',
                        name: '英德市',
                        simple_name: '英德',
                        hidden: 0,
                    },
                    {
                        code: '441882',
                        name: '连州市',
                        simple_name: '连州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '441900',
                name: '东莞市',
                simple_name: '东莞',
                hidden: 0,
                districts: [
                    {
                        code: '441901',
                        name: '莞城区',
                        simple_name: '莞城',
                        hidden: 0,
                    },
                    {
                        code: '441902',
                        name: '南城区',
                        simple_name: '南城',
                        hidden: 0,
                    },
                    {
                        code: '441904',
                        name: '万江区',
                        simple_name: '万江',
                        hidden: 0,
                    },
                    {
                        code: '441905',
                        name: '石碣镇',
                        simple_name: '石碣',
                        hidden: 0,
                    },
                    {
                        code: '441906',
                        name: '石龙镇',
                        simple_name: '石龙',
                        hidden: 0,
                    },
                    {
                        code: '441907',
                        name: '茶山镇',
                        simple_name: '茶山',
                        hidden: 0,
                    },
                    {
                        code: '441908',
                        name: '石排镇',
                        simple_name: '石排',
                        hidden: 0,
                    },
                    {
                        code: '441909',
                        name: '企石镇',
                        simple_name: '企石',
                        hidden: 0,
                    },
                    {
                        code: '441910',
                        name: '横沥镇',
                        simple_name: '横沥',
                        hidden: 0,
                    },
                    {
                        code: '441911',
                        name: '桥头镇',
                        simple_name: '桥头',
                        hidden: 0,
                    },
                    {
                        code: '441912',
                        name: '谢岗镇',
                        simple_name: '谢岗',
                        hidden: 0,
                    },
                    {
                        code: '441913',
                        name: '东坑镇',
                        simple_name: '东坑',
                        hidden: 0,
                    },
                    {
                        code: '441914',
                        name: '常平镇',
                        simple_name: '常平',
                        hidden: 0,
                    },
                    {
                        code: '441915',
                        name: '寮步镇',
                        simple_name: '寮步',
                        hidden: 0,
                    },
                    {
                        code: '441916',
                        name: '大朗镇',
                        simple_name: '大朗',
                        hidden: 0,
                    },
                    {
                        code: '441917',
                        name: '麻涌镇',
                        simple_name: '麻涌',
                        hidden: 0,
                    },
                    {
                        code: '441918',
                        name: '中堂镇',
                        simple_name: '中堂',
                        hidden: 0,
                    },
                    {
                        code: '441919',
                        name: '高埗镇',
                        simple_name: '高埗',
                        hidden: 0,
                    },
                    {
                        code: '441920',
                        name: '樟木头镇',
                        simple_name: '樟木头',
                        hidden: 0,
                    },
                    {
                        code: '441921',
                        name: '大岭山镇',
                        simple_name: '大岭山',
                        hidden: 0,
                    },
                    {
                        code: '441922',
                        name: '望牛墩镇',
                        simple_name: '望牛墩',
                        hidden: 0,
                    },
                    {
                        code: '441923',
                        name: '黄江镇',
                        simple_name: '黄江',
                        hidden: 0,
                    },
                    {
                        code: '441924',
                        name: '洪梅镇',
                        simple_name: '洪梅',
                        hidden: 0,
                    },
                    {
                        code: '441925',
                        name: '清溪镇',
                        simple_name: '清溪',
                        hidden: 0,
                    },
                    {
                        code: '441926',
                        name: '沙田镇',
                        simple_name: '沙田',
                        hidden: 0,
                    },
                    {
                        code: '441927',
                        name: '道滘镇',
                        simple_name: '道滘',
                        hidden: 0,
                    },
                    {
                        code: '441928',
                        name: '塘厦镇',
                        simple_name: '塘厦',
                        hidden: 0,
                    },
                    {
                        code: '441929',
                        name: '虎门镇',
                        simple_name: '虎门',
                        hidden: 0,
                    },
                    {
                        code: '441930',
                        name: '厚街镇',
                        simple_name: '厚街',
                        hidden: 0,
                    },
                    {
                        code: '441931',
                        name: '凤岗镇',
                        simple_name: '凤岗',
                        hidden: 0,
                    },
                    {
                        code: '441932',
                        name: '长安镇',
                        simple_name: '长安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '442000',
                name: '中山市',
                simple_name: '中山',
                hidden: 0,
                districts: [
                    {
                        code: '442001',
                        name: '石岐区',
                        simple_name: '石岐',
                        hidden: 0,
                    },
                    {
                        code: '442004',
                        name: '南区',
                        simple_name: '南区',
                        hidden: 0,
                    },
                    {
                        code: '442005',
                        name: '五桂山区',
                        simple_name: '五桂山',
                        hidden: 0,
                    },
                    {
                        code: '442006',
                        name: '火炬开发区',
                        simple_name: '火炬',
                        hidden: 0,
                    },
                    {
                        code: '442007',
                        name: '黄圃镇',
                        simple_name: '黄圃',
                        hidden: 0,
                    },
                    {
                        code: '442008',
                        name: '南头镇',
                        simple_name: '南头',
                        hidden: 0,
                    },
                    {
                        code: '442009',
                        name: '东凤镇',
                        simple_name: '东凤',
                        hidden: 0,
                    },
                    {
                        code: '442010',
                        name: '阜沙镇',
                        simple_name: '阜沙',
                        hidden: 0,
                    },
                    {
                        code: '442011',
                        name: '小榄镇',
                        simple_name: '小榄',
                        hidden: 0,
                    },
                    {
                        code: '442012',
                        name: '东升镇',
                        simple_name: '东升',
                        hidden: 0,
                    },
                    {
                        code: '442013',
                        name: '古镇镇',
                        simple_name: '古镇',
                        hidden: 0,
                    },
                    {
                        code: '442014',
                        name: '横栏镇',
                        simple_name: '横栏',
                        hidden: 0,
                    },
                    {
                        code: '442015',
                        name: '三角镇',
                        simple_name: '三角',
                        hidden: 0,
                    },
                    {
                        code: '442016',
                        name: '民众镇',
                        simple_name: '民众',
                        hidden: 0,
                    },
                    {
                        code: '442017',
                        name: '南朗镇',
                        simple_name: '南朗',
                        hidden: 0,
                    },
                    {
                        code: '442018',
                        name: '港口镇',
                        simple_name: '港口',
                        hidden: 0,
                    },
                    {
                        code: '442019',
                        name: '大涌镇',
                        simple_name: '大涌',
                        hidden: 0,
                    },
                    {
                        code: '442020',
                        name: '沙溪镇',
                        simple_name: '沙溪',
                        hidden: 0,
                    },
                    {
                        code: '442021',
                        name: '三乡镇',
                        simple_name: '三乡',
                        hidden: 0,
                    },
                    {
                        code: '442022',
                        name: '板芙镇',
                        simple_name: '板芙',
                        hidden: 0,
                    },
                    {
                        code: '442023',
                        name: '神湾镇',
                        simple_name: '神湾',
                        hidden: 0,
                    },
                    {
                        code: '442024',
                        name: '坦洲镇',
                        simple_name: '坦洲',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '445100',
                name: '潮州市',
                simple_name: '潮州',
                hidden: 0,
                districts: [
                    {
                        code: '445102',
                        name: '湘桥区',
                        simple_name: '湘桥',
                        hidden: 0,
                    },
                    {
                        code: '445103',
                        name: '潮安区',
                        simple_name: '潮安',
                        hidden: 0,
                    },
                    {
                        code: '445122',
                        name: '饶平县',
                        simple_name: '饶平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '445200',
                name: '揭阳市',
                simple_name: '揭阳',
                hidden: 0,
                districts: [
                    {
                        code: '445202',
                        name: '榕城区',
                        simple_name: '榕城',
                        hidden: 0,
                    },
                    {
                        code: '445203',
                        name: '揭东区',
                        simple_name: '揭东',
                        hidden: 0,
                    },
                    {
                        code: '445222',
                        name: '揭西县',
                        simple_name: '揭西',
                        hidden: 0,
                    },
                    {
                        code: '445224',
                        name: '惠来县',
                        simple_name: '惠来',
                        hidden: 0,
                    },
                    {
                        code: '445281',
                        name: '普宁市',
                        simple_name: '普宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '445300',
                name: '云浮市',
                simple_name: '云浮',
                hidden: 0,
                districts: [
                    {
                        code: '445302',
                        name: '云城区',
                        simple_name: '云城',
                        hidden: 0,
                    },
                    {
                        code: '445303',
                        name: '云安区',
                        simple_name: '云安',
                        hidden: 0,
                    },
                    {
                        code: '445321',
                        name: '新兴县',
                        simple_name: '新兴',
                        hidden: 0,
                    },
                    {
                        code: '445322',
                        name: '郁南县',
                        simple_name: '郁南',
                        hidden: 0,
                    },
                    {
                        code: '445381',
                        name: '罗定市',
                        simple_name: '罗定',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '450000',
        name: '广西壮族自治区',
        simple_name: '广西',
        hidden: 0,
        cities: [
            {
                code: '450100',
                name: '南宁市',
                simple_name: '南宁',
                hidden: 0,
                districts: [
                    {
                        code: '450102',
                        name: '兴宁区',
                        simple_name: '兴宁',
                        hidden: 0,
                    },
                    {
                        code: '450103',
                        name: '青秀区',
                        simple_name: '青秀',
                        hidden: 0,
                    },
                    {
                        code: '450105',
                        name: '江南区',
                        simple_name: '江南',
                        hidden: 0,
                    },
                    {
                        code: '450107',
                        name: '西乡塘区',
                        simple_name: '西乡塘',
                        hidden: 0,
                    },
                    {
                        code: '450108',
                        name: '良庆区',
                        simple_name: '良庆',
                        hidden: 0,
                    },
                    {
                        code: '450109',
                        name: '邕宁区',
                        simple_name: '邕宁',
                        hidden: 0,
                    },
                    {
                        code: '450122',
                        name: '武鸣县',
                        simple_name: '武鸣',
                        hidden: 0,
                    },
                    {
                        code: '450123',
                        name: '隆安县',
                        simple_name: '隆安',
                        hidden: 0,
                    },
                    {
                        code: '450124',
                        name: '马山县',
                        simple_name: '马山',
                        hidden: 0,
                    },
                    {
                        code: '450125',
                        name: '上林县',
                        simple_name: '上林',
                        hidden: 0,
                    },
                    {
                        code: '450126',
                        name: '宾阳县',
                        simple_name: '宾阳',
                        hidden: 0,
                    },
                    {
                        code: '450127',
                        name: '横县',
                        simple_name: '横县',
                        hidden: 0,
                    },
                    {
                        code: '450128',
                        name: '埌东新区',
                        simple_name: '埌东',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450200',
                name: '柳州市',
                simple_name: '柳州',
                hidden: 0,
                districts: [
                    {
                        code: '450202',
                        name: '城中区',
                        simple_name: '城中',
                        hidden: 0,
                    },
                    {
                        code: '450203',
                        name: '鱼峰区',
                        simple_name: '鱼峰',
                        hidden: 0,
                    },
                    {
                        code: '450204',
                        name: '柳南区',
                        simple_name: '柳南',
                        hidden: 0,
                    },
                    {
                        code: '450205',
                        name: '柳北区',
                        simple_name: '柳北',
                        hidden: 0,
                    },
                    {
                        code: '450221',
                        name: '柳江县',
                        simple_name: '柳江',
                        hidden: 0,
                    },
                    {
                        code: '450222',
                        name: '柳城县',
                        simple_name: '柳城',
                        hidden: 0,
                    },
                    {
                        code: '450223',
                        name: '鹿寨县',
                        simple_name: '鹿寨',
                        hidden: 0,
                    },
                    {
                        code: '450224',
                        name: '融安县',
                        simple_name: '融安',
                        hidden: 0,
                    },
                    {
                        code: '450225',
                        name: '融水苗族自治县',
                        simple_name: '融水',
                        hidden: 0,
                    },
                    {
                        code: '450226',
                        name: '三江侗族自治县',
                        simple_name: '三江',
                        hidden: 0,
                    },
                    {
                        code: '450227',
                        name: '柳东新区',
                        simple_name: '柳东',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450300',
                name: '桂林市',
                simple_name: '桂林',
                hidden: 0,
                districts: [
                    {
                        code: '450302',
                        name: '秀峰区',
                        simple_name: '秀峰',
                        hidden: 0,
                    },
                    {
                        code: '450303',
                        name: '叠彩区',
                        simple_name: '叠彩',
                        hidden: 0,
                    },
                    {
                        code: '450304',
                        name: '象山区',
                        simple_name: '象山',
                        hidden: 0,
                    },
                    {
                        code: '450305',
                        name: '七星区',
                        simple_name: '七星',
                        hidden: 0,
                    },
                    {
                        code: '450311',
                        name: '雁山区',
                        simple_name: '雁山',
                        hidden: 0,
                    },
                    {
                        code: '450312',
                        name: '临桂区',
                        simple_name: '临桂',
                        hidden: 0,
                    },
                    {
                        code: '450321',
                        name: '阳朔县',
                        simple_name: '阳朔',
                        hidden: 0,
                    },
                    {
                        code: '450323',
                        name: '灵川县',
                        simple_name: '灵川',
                        hidden: 0,
                    },
                    {
                        code: '450324',
                        name: '全州县',
                        simple_name: '全州',
                        hidden: 0,
                    },
                    {
                        code: '450325',
                        name: '兴安县',
                        simple_name: '兴安',
                        hidden: 0,
                    },
                    {
                        code: '450326',
                        name: '永福县',
                        simple_name: '永福',
                        hidden: 0,
                    },
                    {
                        code: '450327',
                        name: '灌阳县',
                        simple_name: '灌阳',
                        hidden: 0,
                    },
                    {
                        code: '450328',
                        name: '龙胜各族自治县',
                        simple_name: '龙胜',
                        hidden: 0,
                    },
                    {
                        code: '450329',
                        name: '资源县',
                        simple_name: '资源',
                        hidden: 0,
                    },
                    {
                        code: '450330',
                        name: '平乐县',
                        simple_name: '平乐',
                        hidden: 0,
                    },
                    {
                        code: '450331',
                        name: '荔浦县',
                        simple_name: '荔浦',
                        hidden: 0,
                    },
                    {
                        code: '450332',
                        name: '恭城瑶族自治县',
                        simple_name: '恭城',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450400',
                name: '梧州市',
                simple_name: '梧州',
                hidden: 0,
                districts: [
                    {
                        code: '450403',
                        name: '万秀区',
                        simple_name: '万秀',
                        hidden: 0,
                    },
                    {
                        code: '450405',
                        name: '长洲区',
                        simple_name: '长洲',
                        hidden: 0,
                    },
                    {
                        code: '450406',
                        name: '龙圩区',
                        simple_name: '龙圩',
                        hidden: 0,
                    },
                    {
                        code: '450421',
                        name: '苍梧县',
                        simple_name: '苍梧',
                        hidden: 0,
                    },
                    {
                        code: '450422',
                        name: '藤县',
                        simple_name: '藤县',
                        hidden: 0,
                    },
                    {
                        code: '450423',
                        name: '蒙山县',
                        simple_name: '蒙山',
                        hidden: 0,
                    },
                    {
                        code: '450481',
                        name: '岑溪市',
                        simple_name: '岑溪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450500',
                name: '北海市',
                simple_name: '北海',
                hidden: 0,
                districts: [
                    {
                        code: '450502',
                        name: '海城区',
                        simple_name: '海城',
                        hidden: 0,
                    },
                    {
                        code: '450503',
                        name: '银海区',
                        simple_name: '银海',
                        hidden: 0,
                    },
                    {
                        code: '450512',
                        name: '铁山港区',
                        simple_name: '铁山港',
                        hidden: 0,
                    },
                    {
                        code: '450521',
                        name: '合浦县',
                        simple_name: '合浦',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450600',
                name: '防城港市',
                simple_name: '防城港',
                hidden: 0,
                districts: [
                    {
                        code: '450602',
                        name: '港口区',
                        simple_name: '港口',
                        hidden: 0,
                    },
                    {
                        code: '450603',
                        name: '防城区',
                        simple_name: '防城',
                        hidden: 0,
                    },
                    {
                        code: '450621',
                        name: '上思县',
                        simple_name: '上思',
                        hidden: 0,
                    },
                    {
                        code: '450681',
                        name: '东兴市',
                        simple_name: '东兴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450700',
                name: '钦州市',
                simple_name: '钦州',
                hidden: 0,
                districts: [
                    {
                        code: '450702',
                        name: '钦南区',
                        simple_name: '钦南',
                        hidden: 0,
                    },
                    {
                        code: '450703',
                        name: '钦北区',
                        simple_name: '钦北',
                        hidden: 0,
                    },
                    {
                        code: '450721',
                        name: '灵山县',
                        simple_name: '灵山',
                        hidden: 0,
                    },
                    {
                        code: '450722',
                        name: '浦北县',
                        simple_name: '浦北',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450800',
                name: '贵港市',
                simple_name: '贵港',
                hidden: 0,
                districts: [
                    {
                        code: '450802',
                        name: '港北区',
                        simple_name: '港北',
                        hidden: 0,
                    },
                    {
                        code: '450803',
                        name: '港南区',
                        simple_name: '港南',
                        hidden: 0,
                    },
                    {
                        code: '450804',
                        name: '覃塘区',
                        simple_name: '覃塘',
                        hidden: 0,
                    },
                    {
                        code: '450821',
                        name: '平南县',
                        simple_name: '平南',
                        hidden: 0,
                    },
                    {
                        code: '450881',
                        name: '桂平市',
                        simple_name: '桂平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '450900',
                name: '玉林市',
                simple_name: '玉林',
                hidden: 0,
                districts: [
                    {
                        code: '450902',
                        name: '玉州区',
                        simple_name: '玉州',
                        hidden: 0,
                    },
                    {
                        code: '450903',
                        name: '福绵区',
                        simple_name: '福绵',
                        hidden: 0,
                    },
                    {
                        code: '450904',
                        name: '玉东新区',
                        simple_name: '玉东',
                        hidden: 0,
                    },
                    {
                        code: '450921',
                        name: '容县',
                        simple_name: '容县',
                        hidden: 0,
                    },
                    {
                        code: '450922',
                        name: '陆川县',
                        simple_name: '陆川',
                        hidden: 0,
                    },
                    {
                        code: '450923',
                        name: '博白县',
                        simple_name: '博白',
                        hidden: 0,
                    },
                    {
                        code: '450924',
                        name: '兴业县',
                        simple_name: '兴业',
                        hidden: 0,
                    },
                    {
                        code: '450981',
                        name: '北流市',
                        simple_name: '北流',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '451000',
                name: '百色市',
                simple_name: '百色',
                hidden: 0,
                districts: [
                    {
                        code: '451002',
                        name: '右江区',
                        simple_name: '右江',
                        hidden: 0,
                    },
                    {
                        code: '451021',
                        name: '田阳县',
                        simple_name: '田阳',
                        hidden: 0,
                    },
                    {
                        code: '451022',
                        name: '田东县',
                        simple_name: '田东',
                        hidden: 0,
                    },
                    {
                        code: '451023',
                        name: '平果县',
                        simple_name: '平果',
                        hidden: 0,
                    },
                    {
                        code: '451024',
                        name: '德保县',
                        simple_name: '德保',
                        hidden: 0,
                    },
                    {
                        code: '451025',
                        name: '靖西县',
                        simple_name: '靖西',
                        hidden: 0,
                    },
                    {
                        code: '451026',
                        name: '那坡县',
                        simple_name: '那坡',
                        hidden: 0,
                    },
                    {
                        code: '451027',
                        name: '凌云县',
                        simple_name: '凌云',
                        hidden: 0,
                    },
                    {
                        code: '451028',
                        name: '乐业县',
                        simple_name: '乐业',
                        hidden: 0,
                    },
                    {
                        code: '451029',
                        name: '田林县',
                        simple_name: '田林',
                        hidden: 0,
                    },
                    {
                        code: '451030',
                        name: '西林县',
                        simple_name: '西林',
                        hidden: 0,
                    },
                    {
                        code: '451031',
                        name: '隆林各族自治县',
                        simple_name: '隆林',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '451100',
                name: '贺州市',
                simple_name: '贺州',
                hidden: 0,
                districts: [
                    {
                        code: '451102',
                        name: '八步区',
                        simple_name: '八步',
                        hidden: 0,
                    },
                    {
                        code: '451121',
                        name: '昭平县',
                        simple_name: '昭平',
                        hidden: 0,
                    },
                    {
                        code: '451122',
                        name: '钟山县',
                        simple_name: '钟山',
                        hidden: 0,
                    },
                    {
                        code: '451123',
                        name: '富川瑶族自治县',
                        simple_name: '富川',
                        hidden: 0,
                    },
                    {
                        code: '451124',
                        name: '平桂管理区',
                        simple_name: '平桂',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '451200',
                name: '河池市',
                simple_name: '河池',
                hidden: 0,
                districts: [
                    {
                        code: '451202',
                        name: '金城江区',
                        simple_name: '金城江',
                        hidden: 0,
                    },
                    {
                        code: '451221',
                        name: '南丹县',
                        simple_name: '南丹',
                        hidden: 0,
                    },
                    {
                        code: '451222',
                        name: '天峨县',
                        simple_name: '天峨',
                        hidden: 0,
                    },
                    {
                        code: '451223',
                        name: '凤山县',
                        simple_name: '凤山',
                        hidden: 0,
                    },
                    {
                        code: '451224',
                        name: '东兰县',
                        simple_name: '东兰',
                        hidden: 0,
                    },
                    {
                        code: '451225',
                        name: '罗城仫佬族自治县',
                        simple_name: '罗城',
                        hidden: 0,
                    },
                    {
                        code: '451226',
                        name: '环江毛南族自治县',
                        simple_name: '环江',
                        hidden: 0,
                    },
                    {
                        code: '451227',
                        name: '巴马瑶族自治县',
                        simple_name: '巴马',
                        hidden: 0,
                    },
                    {
                        code: '451228',
                        name: '都安瑶族自治县',
                        simple_name: '都安',
                        hidden: 0,
                    },
                    {
                        code: '451229',
                        name: '大化瑶族自治县',
                        simple_name: '大化',
                        hidden: 0,
                    },
                    {
                        code: '451281',
                        name: '宜州市',
                        simple_name: '宜州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '451300',
                name: '来宾市',
                simple_name: '来宾',
                hidden: 0,
                districts: [
                    {
                        code: '451302',
                        name: '兴宾区',
                        simple_name: '兴宾',
                        hidden: 0,
                    },
                    {
                        code: '451321',
                        name: '忻城县',
                        simple_name: '忻城',
                        hidden: 0,
                    },
                    {
                        code: '451322',
                        name: '象州县',
                        simple_name: '象州',
                        hidden: 0,
                    },
                    {
                        code: '451323',
                        name: '武宣县',
                        simple_name: '武宣',
                        hidden: 0,
                    },
                    {
                        code: '451324',
                        name: '金秀瑶族自治县',
                        simple_name: '金秀',
                        hidden: 0,
                    },
                    {
                        code: '451381',
                        name: '合山市',
                        simple_name: '合山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '451400',
                name: '崇左市',
                simple_name: '崇左',
                hidden: 0,
                districts: [
                    {
                        code: '451402',
                        name: '江州区',
                        simple_name: '江州',
                        hidden: 0,
                    },
                    {
                        code: '451421',
                        name: '扶绥县',
                        simple_name: '扶绥',
                        hidden: 0,
                    },
                    {
                        code: '451422',
                        name: '宁明县',
                        simple_name: '宁明',
                        hidden: 0,
                    },
                    {
                        code: '451423',
                        name: '龙州县',
                        simple_name: '龙州',
                        hidden: 0,
                    },
                    {
                        code: '451424',
                        name: '大新县',
                        simple_name: '大新',
                        hidden: 0,
                    },
                    {
                        code: '451425',
                        name: '天等县',
                        simple_name: '天等',
                        hidden: 0,
                    },
                    {
                        code: '451481',
                        name: '凭祥市',
                        simple_name: '凭祥',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '460000',
        name: '海南省',
        simple_name: '海南',
        hidden: 0,
        cities: [
            {
                code: '460100',
                name: '海口市',
                simple_name: '海口',
                hidden: 0,
                districts: [
                    {
                        code: '460105',
                        name: '秀英区',
                        simple_name: '秀英',
                        hidden: 0,
                    },
                    {
                        code: '460106',
                        name: '龙华区',
                        simple_name: '龙华',
                        hidden: 0,
                    },
                    {
                        code: '460107',
                        name: '琼山区',
                        simple_name: '琼山',
                        hidden: 0,
                    },
                    {
                        code: '460108',
                        name: '美兰区',
                        simple_name: '美兰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '460200',
                name: '三亚市',
                simple_name: '三亚',
                hidden: 0,
                districts: [
                    {
                        code: '460202',
                        name: '海棠区',
                        simple_name: '海棠',
                        hidden: 0,
                    },
                    {
                        code: '460203',
                        name: '吉阳区',
                        simple_name: '吉阳',
                        hidden: 0,
                    },
                    {
                        code: '460204',
                        name: '天涯区',
                        simple_name: '天涯',
                        hidden: 0,
                    },
                    {
                        code: '460205',
                        name: '崖州区',
                        simple_name: '崖州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '460300',
                name: '三沙市',
                simple_name: '三沙',
                hidden: 0,
                districts: [
                    {
                        code: '460321',
                        name: '西沙群岛',
                        simple_name: '西沙',
                        hidden: 0,
                    },
                    {
                        code: '460322',
                        name: '南沙群岛',
                        simple_name: '南沙',
                        hidden: 0,
                    },
                    {
                        code: '460323',
                        name: '中沙群岛',
                        simple_name: '中沙',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '469000',
                name: '直辖县级',
                simple_name: ' ',
                hidden: 0,
                districts: [
                    {
                        code: '469001',
                        name: '五指山市',
                        simple_name: '五指山',
                        hidden: 0,
                    },
                    {
                        code: '469002',
                        name: '琼海市',
                        simple_name: '琼海',
                        hidden: 0,
                    },
                    {
                        code: '469003',
                        name: '儋州市',
                        simple_name: '儋州',
                        hidden: 0,
                    },
                    {
                        code: '469005',
                        name: '文昌市',
                        simple_name: '文昌',
                        hidden: 0,
                    },
                    {
                        code: '469006',
                        name: '万宁市',
                        simple_name: '万宁',
                        hidden: 0,
                    },
                    {
                        code: '469007',
                        name: '东方市',
                        simple_name: '东方',
                        hidden: 0,
                    },
                    {
                        code: '469021',
                        name: '定安县',
                        simple_name: '定安',
                        hidden: 0,
                    },
                    {
                        code: '469022',
                        name: '屯昌县',
                        simple_name: '屯昌',
                        hidden: 0,
                    },
                    {
                        code: '469023',
                        name: '澄迈县',
                        simple_name: '澄迈',
                        hidden: 0,
                    },
                    {
                        code: '469024',
                        name: '临高县',
                        simple_name: '临高',
                        hidden: 0,
                    },
                    {
                        code: '469025',
                        name: '白沙黎族自治县',
                        simple_name: '白沙',
                        hidden: 0,
                    },
                    {
                        code: '469026',
                        name: '昌江黎族自治县',
                        simple_name: '昌江',
                        hidden: 0,
                    },
                    {
                        code: '469027',
                        name: '乐东黎族自治县',
                        simple_name: '乐东',
                        hidden: 0,
                    },
                    {
                        code: '469028',
                        name: '陵水黎族自治县',
                        simple_name: '陵水',
                        hidden: 0,
                    },
                    {
                        code: '469029',
                        name: '保亭黎族苗族自治县',
                        simple_name: '保亭',
                        hidden: 0,
                    },
                    {
                        code: '469030',
                        name: '琼中黎族苗族自治县',
                        simple_name: '琼中',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '500000',
        name: '重庆',
        simple_name: '重庆',
        hidden: 0,
        cities: [
            {
                code: '500100',
                name: '重庆市',
                simple_name: '重庆',
                hidden: 0,
                districts: [
                    {
                        code: '500101',
                        name: '万州区',
                        simple_name: '万州',
                        hidden: 0,
                    },
                    {
                        code: '500102',
                        name: '涪陵区',
                        simple_name: '涪陵',
                        hidden: 0,
                    },
                    {
                        code: '500103',
                        name: '渝中区',
                        simple_name: '渝中',
                        hidden: 0,
                    },
                    {
                        code: '500104',
                        name: '大渡口区',
                        simple_name: '大渡口',
                        hidden: 0,
                    },
                    {
                        code: '500105',
                        name: '江北区',
                        simple_name: '江北',
                        hidden: 0,
                    },
                    {
                        code: '500106',
                        name: '沙坪坝区',
                        simple_name: '沙坪坝',
                        hidden: 0,
                    },
                    {
                        code: '500107',
                        name: '九龙坡区',
                        simple_name: '九龙坡',
                        hidden: 0,
                    },
                    {
                        code: '500108',
                        name: '南岸区',
                        simple_name: '南岸',
                        hidden: 0,
                    },
                    {
                        code: '500109',
                        name: '北碚区',
                        simple_name: '北碚',
                        hidden: 0,
                    },
                    {
                        code: '500110',
                        name: '綦江区',
                        simple_name: '綦江',
                        hidden: 0,
                    },
                    {
                        code: '500111',
                        name: '大足区',
                        simple_name: '大足',
                        hidden: 0,
                    },
                    {
                        code: '500112',
                        name: '渝北区',
                        simple_name: '渝北',
                        hidden: 0,
                    },
                    {
                        code: '500113',
                        name: '巴南区',
                        simple_name: '巴南',
                        hidden: 0,
                    },
                    {
                        code: '500114',
                        name: '黔江区',
                        simple_name: '黔江',
                        hidden: 0,
                    },
                    {
                        code: '500115',
                        name: '长寿区',
                        simple_name: '长寿',
                        hidden: 0,
                    },
                    {
                        code: '500116',
                        name: '江津区',
                        simple_name: '江津',
                        hidden: 0,
                    },
                    {
                        code: '500117',
                        name: '合川区',
                        simple_name: '合川',
                        hidden: 0,
                    },
                    {
                        code: '500118',
                        name: '永川区',
                        simple_name: '永川',
                        hidden: 0,
                    },
                    {
                        code: '500119',
                        name: '南川区',
                        simple_name: '南川',
                        hidden: 0,
                    },
                    {
                        code: '500120',
                        name: '璧山区',
                        simple_name: '璧山',
                        hidden: 0,
                    },
                    {
                        code: '500151',
                        name: '铜梁区',
                        simple_name: '铜梁',
                        hidden: 0,
                    },
                    {
                        code: '500223',
                        name: '潼南县',
                        simple_name: '潼南',
                        hidden: 0,
                    },
                    {
                        code: '500226',
                        name: '荣昌县',
                        simple_name: '荣昌',
                        hidden: 0,
                    },
                    {
                        code: '500228',
                        name: '梁平县',
                        simple_name: '梁平',
                        hidden: 0,
                    },
                    {
                        code: '500229',
                        name: '城口县',
                        simple_name: '城口',
                        hidden: 0,
                    },
                    {
                        code: '500230',
                        name: '丰都县',
                        simple_name: '丰都',
                        hidden: 0,
                    },
                    {
                        code: '500231',
                        name: '垫江县',
                        simple_name: '垫江',
                        hidden: 0,
                    },
                    {
                        code: '500232',
                        name: '武隆县',
                        simple_name: '武隆',
                        hidden: 0,
                    },
                    {
                        code: '500233',
                        name: '忠县',
                        simple_name: '忠县',
                        hidden: 0,
                    },
                    {
                        code: '500234',
                        name: '开县',
                        simple_name: '开县',
                        hidden: 0,
                    },
                    {
                        code: '500235',
                        name: '云阳县',
                        simple_name: '云阳',
                        hidden: 0,
                    },
                    {
                        code: '500236',
                        name: '奉节县',
                        simple_name: '奉节',
                        hidden: 0,
                    },
                    {
                        code: '500237',
                        name: '巫山县',
                        simple_name: '巫山',
                        hidden: 0,
                    },
                    {
                        code: '500238',
                        name: '巫溪县',
                        simple_name: '巫溪',
                        hidden: 0,
                    },
                    {
                        code: '500240',
                        name: '石柱土家族自治县',
                        simple_name: '石柱',
                        hidden: 0,
                    },
                    {
                        code: '500241',
                        name: '秀山土家族苗族自治县',
                        simple_name: '秀山',
                        hidden: 0,
                    },
                    {
                        code: '500242',
                        name: '酉阳土家族苗族自治县',
                        simple_name: '酉阳',
                        hidden: 0,
                    },
                    {
                        code: '500243',
                        name: '彭水苗族土家族自治县',
                        simple_name: '彭水',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '500300',
                name: '两江新区',
                simple_name: '两江新区',
                hidden: 0,
                districts: [
                    {
                        code: '500301',
                        name: '北部新区',
                        simple_name: '北部新区',
                        hidden: 0,
                    },
                    {
                        code: '500302',
                        name: '保税港区',
                        simple_name: '保税港区',
                        hidden: 0,
                    },
                    {
                        code: '500303',
                        name: '工业园区',
                        simple_name: '工业园区',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '510000',
        name: '四川省',
        simple_name: '四川',
        hidden: 0,
        cities: [
            {
                code: '510100',
                name: '成都市',
                simple_name: '成都',
                hidden: 0,
                districts: [
                    {
                        code: '510104',
                        name: '锦江区',
                        simple_name: '锦江',
                        hidden: 0,
                    },
                    {
                        code: '510105',
                        name: '青羊区',
                        simple_name: '青羊',
                        hidden: 0,
                    },
                    {
                        code: '510106',
                        name: '金牛区',
                        simple_name: '金牛',
                        hidden: 0,
                    },
                    {
                        code: '510107',
                        name: '武侯区',
                        simple_name: '武侯',
                        hidden: 0,
                    },
                    {
                        code: '510108',
                        name: '成华区',
                        simple_name: '成华',
                        hidden: 0,
                    },
                    {
                        code: '510112',
                        name: '龙泉驿区',
                        simple_name: '龙泉驿',
                        hidden: 0,
                    },
                    {
                        code: '510113',
                        name: '青白江区',
                        simple_name: '青白江',
                        hidden: 0,
                    },
                    {
                        code: '510114',
                        name: '新都区',
                        simple_name: '新都',
                        hidden: 0,
                    },
                    {
                        code: '510115',
                        name: '温江区',
                        simple_name: '温江',
                        hidden: 0,
                    },
                    {
                        code: '510121',
                        name: '金堂县',
                        simple_name: '金堂',
                        hidden: 0,
                    },
                    {
                        code: '510122',
                        name: '双流县',
                        simple_name: '双流',
                        hidden: 0,
                    },
                    {
                        code: '510124',
                        name: '郫县',
                        simple_name: '郫县',
                        hidden: 0,
                    },
                    {
                        code: '510129',
                        name: '大邑县',
                        simple_name: '大邑',
                        hidden: 0,
                    },
                    {
                        code: '510131',
                        name: '蒲江县',
                        simple_name: '蒲江',
                        hidden: 0,
                    },
                    {
                        code: '510132',
                        name: '新津县',
                        simple_name: '新津',
                        hidden: 0,
                    },
                    {
                        code: '510181',
                        name: '都江堰市',
                        simple_name: '都江堰',
                        hidden: 0,
                    },
                    {
                        code: '510182',
                        name: '彭州市',
                        simple_name: '彭州',
                        hidden: 0,
                    },
                    {
                        code: '510183',
                        name: '邛崃市',
                        simple_name: '邛崃',
                        hidden: 0,
                    },
                    {
                        code: '510184',
                        name: '崇州市',
                        simple_name: '崇州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510300',
                name: '自贡市',
                simple_name: '自贡',
                hidden: 0,
                districts: [
                    {
                        code: '510302',
                        name: '自流井区',
                        simple_name: '自流井',
                        hidden: 0,
                    },
                    {
                        code: '510303',
                        name: '贡井区',
                        simple_name: '贡井',
                        hidden: 0,
                    },
                    {
                        code: '510304',
                        name: '大安区',
                        simple_name: '大安',
                        hidden: 0,
                    },
                    {
                        code: '510311',
                        name: '沿滩区',
                        simple_name: '沿滩',
                        hidden: 0,
                    },
                    {
                        code: '510321',
                        name: '荣县',
                        simple_name: '荣县',
                        hidden: 0,
                    },
                    {
                        code: '510322',
                        name: '富顺县',
                        simple_name: '富顺',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510400',
                name: '攀枝花市',
                simple_name: '攀枝花',
                hidden: 0,
                districts: [
                    {
                        code: '510402',
                        name: '东区',
                        simple_name: '东区',
                        hidden: 0,
                    },
                    {
                        code: '510403',
                        name: '西区',
                        simple_name: '西区',
                        hidden: 0,
                    },
                    {
                        code: '510411',
                        name: '仁和区',
                        simple_name: '仁和',
                        hidden: 0,
                    },
                    {
                        code: '510421',
                        name: '米易县',
                        simple_name: '米易',
                        hidden: 0,
                    },
                    {
                        code: '510422',
                        name: '盐边县',
                        simple_name: '盐边',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510500',
                name: '泸州市',
                simple_name: '泸州',
                hidden: 0,
                districts: [
                    {
                        code: '510502',
                        name: '江阳区',
                        simple_name: '江阳',
                        hidden: 0,
                    },
                    {
                        code: '510503',
                        name: '纳溪区',
                        simple_name: '纳溪',
                        hidden: 0,
                    },
                    {
                        code: '510504',
                        name: '龙马潭区',
                        simple_name: '龙马潭',
                        hidden: 0,
                    },
                    {
                        code: '510521',
                        name: '泸县',
                        simple_name: '泸县',
                        hidden: 0,
                    },
                    {
                        code: '510522',
                        name: '合江县',
                        simple_name: '合江',
                        hidden: 0,
                    },
                    {
                        code: '510524',
                        name: '叙永县',
                        simple_name: '叙永',
                        hidden: 0,
                    },
                    {
                        code: '510525',
                        name: '古蔺县',
                        simple_name: '古蔺',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510600',
                name: '德阳市',
                simple_name: '德阳',
                hidden: 0,
                districts: [
                    {
                        code: '510603',
                        name: '旌阳区',
                        simple_name: '旌阳',
                        hidden: 0,
                    },
                    {
                        code: '510623',
                        name: '中江县',
                        simple_name: '中江',
                        hidden: 0,
                    },
                    {
                        code: '510626',
                        name: '罗江县',
                        simple_name: '罗江',
                        hidden: 0,
                    },
                    {
                        code: '510681',
                        name: '广汉市',
                        simple_name: '广汉',
                        hidden: 0,
                    },
                    {
                        code: '510682',
                        name: '什邡市',
                        simple_name: '什邡',
                        hidden: 0,
                    },
                    {
                        code: '510683',
                        name: '绵竹市',
                        simple_name: '绵竹',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510700',
                name: '绵阳市',
                simple_name: '绵阳',
                hidden: 0,
                districts: [
                    {
                        code: '510703',
                        name: '涪城区',
                        simple_name: '涪城',
                        hidden: 0,
                    },
                    {
                        code: '510704',
                        name: '游仙区',
                        simple_name: '游仙',
                        hidden: 0,
                    },
                    {
                        code: '510722',
                        name: '三台县',
                        simple_name: '三台',
                        hidden: 0,
                    },
                    {
                        code: '510723',
                        name: '盐亭县',
                        simple_name: '盐亭',
                        hidden: 0,
                    },
                    {
                        code: '510724',
                        name: '安县',
                        simple_name: '安县',
                        hidden: 0,
                    },
                    {
                        code: '510725',
                        name: '梓潼县',
                        simple_name: '梓潼',
                        hidden: 0,
                    },
                    {
                        code: '510726',
                        name: '北川羌族自治县',
                        simple_name: '北川',
                        hidden: 0,
                    },
                    {
                        code: '510727',
                        name: '平武县',
                        simple_name: '平武',
                        hidden: 0,
                    },
                    {
                        code: '510781',
                        name: '江油市',
                        simple_name: '江油',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510800',
                name: '广元市',
                simple_name: '广元',
                hidden: 0,
                districts: [
                    {
                        code: '510802',
                        name: '利州区',
                        simple_name: '利州',
                        hidden: 0,
                    },
                    {
                        code: '510811',
                        name: '昭化区',
                        simple_name: '昭化',
                        hidden: 0,
                    },
                    {
                        code: '510812',
                        name: '朝天区',
                        simple_name: '朝天',
                        hidden: 0,
                    },
                    {
                        code: '510821',
                        name: '旺苍县',
                        simple_name: '旺苍',
                        hidden: 0,
                    },
                    {
                        code: '510822',
                        name: '青川县',
                        simple_name: '青川',
                        hidden: 0,
                    },
                    {
                        code: '510823',
                        name: '剑阁县',
                        simple_name: '剑阁',
                        hidden: 0,
                    },
                    {
                        code: '510824',
                        name: '苍溪县',
                        simple_name: '苍溪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '510900',
                name: '遂宁市',
                simple_name: '遂宁',
                hidden: 0,
                districts: [
                    {
                        code: '510903',
                        name: '船山区',
                        simple_name: '船山',
                        hidden: 0,
                    },
                    {
                        code: '510904',
                        name: '安居区',
                        simple_name: '安居',
                        hidden: 0,
                    },
                    {
                        code: '510921',
                        name: '蓬溪县',
                        simple_name: '蓬溪',
                        hidden: 0,
                    },
                    {
                        code: '510922',
                        name: '射洪县',
                        simple_name: '射洪',
                        hidden: 0,
                    },
                    {
                        code: '510923',
                        name: '大英县',
                        simple_name: '大英',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511000',
                name: '内江市',
                simple_name: '内江',
                hidden: 0,
                districts: [
                    {
                        code: '511002',
                        name: '市中区',
                        simple_name: '市中区',
                        hidden: 0,
                    },
                    {
                        code: '511011',
                        name: '东兴区',
                        simple_name: '东兴',
                        hidden: 0,
                    },
                    {
                        code: '511024',
                        name: '威远县',
                        simple_name: '威远',
                        hidden: 0,
                    },
                    {
                        code: '511025',
                        name: '资中县',
                        simple_name: '资中',
                        hidden: 0,
                    },
                    {
                        code: '511028',
                        name: '隆昌县',
                        simple_name: '隆昌',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511100',
                name: '乐山市',
                simple_name: '乐山',
                hidden: 0,
                districts: [
                    {
                        code: '511102',
                        name: '市中区',
                        simple_name: '市中区',
                        hidden: 0,
                    },
                    {
                        code: '511111',
                        name: '沙湾区',
                        simple_name: '沙湾',
                        hidden: 0,
                    },
                    {
                        code: '511112',
                        name: '五通桥区',
                        simple_name: '五通桥',
                        hidden: 0,
                    },
                    {
                        code: '511113',
                        name: '金口河区',
                        simple_name: '金口河',
                        hidden: 0,
                    },
                    {
                        code: '511123',
                        name: '犍为县',
                        simple_name: '犍为',
                        hidden: 0,
                    },
                    {
                        code: '511124',
                        name: '井研县',
                        simple_name: '井研',
                        hidden: 0,
                    },
                    {
                        code: '511126',
                        name: '夹江县',
                        simple_name: '夹江',
                        hidden: 0,
                    },
                    {
                        code: '511129',
                        name: '沐川县',
                        simple_name: '沐川',
                        hidden: 0,
                    },
                    {
                        code: '511132',
                        name: '峨边彝族自治县',
                        simple_name: '峨边',
                        hidden: 0,
                    },
                    {
                        code: '511133',
                        name: '马边彝族自治县',
                        simple_name: '马边',
                        hidden: 0,
                    },
                    {
                        code: '511181',
                        name: '峨眉山市',
                        simple_name: '峨眉山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511300',
                name: '南充市',
                simple_name: '南充',
                hidden: 0,
                districts: [
                    {
                        code: '511302',
                        name: '顺庆区',
                        simple_name: '顺庆',
                        hidden: 0,
                    },
                    {
                        code: '511303',
                        name: '高坪区',
                        simple_name: '高坪',
                        hidden: 0,
                    },
                    {
                        code: '511304',
                        name: '嘉陵区',
                        simple_name: '嘉陵',
                        hidden: 0,
                    },
                    {
                        code: '511321',
                        name: '南部县',
                        simple_name: '南部',
                        hidden: 0,
                    },
                    {
                        code: '511322',
                        name: '营山县',
                        simple_name: '营山',
                        hidden: 0,
                    },
                    {
                        code: '511323',
                        name: '蓬安县',
                        simple_name: '蓬安',
                        hidden: 0,
                    },
                    {
                        code: '511324',
                        name: '仪陇县',
                        simple_name: '仪陇',
                        hidden: 0,
                    },
                    {
                        code: '511325',
                        name: '西充县',
                        simple_name: '西充',
                        hidden: 0,
                    },
                    {
                        code: '511381',
                        name: '阆中市',
                        simple_name: '阆中',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511400',
                name: '眉山市',
                simple_name: '眉山',
                hidden: 0,
                districts: [
                    {
                        code: '511402',
                        name: '东坡区',
                        simple_name: '东坡',
                        hidden: 0,
                    },
                    {
                        code: '511403',
                        name: '彭山区',
                        simple_name: '彭山',
                        hidden: 0,
                    },
                    {
                        code: '511421',
                        name: '仁寿县',
                        simple_name: '仁寿',
                        hidden: 0,
                    },
                    {
                        code: '511423',
                        name: '洪雅县',
                        simple_name: '洪雅',
                        hidden: 0,
                    },
                    {
                        code: '511424',
                        name: '丹棱县',
                        simple_name: '丹棱',
                        hidden: 0,
                    },
                    {
                        code: '511425',
                        name: '青神县',
                        simple_name: '青神',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511500',
                name: '宜宾市',
                simple_name: '宜宾',
                hidden: 0,
                districts: [
                    {
                        code: '511502',
                        name: '翠屏区',
                        simple_name: '翠屏',
                        hidden: 0,
                    },
                    {
                        code: '511503',
                        name: '南溪区',
                        simple_name: '南溪',
                        hidden: 0,
                    },
                    {
                        code: '511521',
                        name: '宜宾县',
                        simple_name: '宜宾',
                        hidden: 0,
                    },
                    {
                        code: '511523',
                        name: '江安县',
                        simple_name: '江安',
                        hidden: 0,
                    },
                    {
                        code: '511524',
                        name: '长宁县',
                        simple_name: '长宁',
                        hidden: 0,
                    },
                    {
                        code: '511525',
                        name: '高县',
                        simple_name: '高县',
                        hidden: 0,
                    },
                    {
                        code: '511526',
                        name: '珙县',
                        simple_name: '珙县',
                        hidden: 0,
                    },
                    {
                        code: '511527',
                        name: '筠连县',
                        simple_name: '筠连',
                        hidden: 0,
                    },
                    {
                        code: '511528',
                        name: '兴文县',
                        simple_name: '兴文',
                        hidden: 0,
                    },
                    {
                        code: '511529',
                        name: '屏山县',
                        simple_name: '屏山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511600',
                name: '广安市',
                simple_name: '广安',
                hidden: 0,
                districts: [
                    {
                        code: '511602',
                        name: '广安区',
                        simple_name: '广安',
                        hidden: 0,
                    },
                    {
                        code: '511603',
                        name: '前锋区',
                        simple_name: '前锋',
                        hidden: 0,
                    },
                    {
                        code: '511621',
                        name: '岳池县',
                        simple_name: '岳池',
                        hidden: 0,
                    },
                    {
                        code: '511622',
                        name: '武胜县',
                        simple_name: '武胜',
                        hidden: 0,
                    },
                    {
                        code: '511623',
                        name: '邻水县',
                        simple_name: '邻水',
                        hidden: 0,
                    },
                    {
                        code: '511681',
                        name: '华蓥市',
                        simple_name: '华蓥',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511700',
                name: '达州市',
                simple_name: '达州',
                hidden: 0,
                districts: [
                    {
                        code: '511702',
                        name: '通川区',
                        simple_name: '通川',
                        hidden: 0,
                    },
                    {
                        code: '511703',
                        name: '达川区',
                        simple_name: '达川',
                        hidden: 0,
                    },
                    {
                        code: '511722',
                        name: '宣汉县',
                        simple_name: '宣汉',
                        hidden: 0,
                    },
                    {
                        code: '511723',
                        name: '开江县',
                        simple_name: '开江',
                        hidden: 0,
                    },
                    {
                        code: '511724',
                        name: '大竹县',
                        simple_name: '大竹',
                        hidden: 0,
                    },
                    {
                        code: '511725',
                        name: '渠县',
                        simple_name: '渠县',
                        hidden: 0,
                    },
                    {
                        code: '511781',
                        name: '万源市',
                        simple_name: '万源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511800',
                name: '雅安市',
                simple_name: '雅安',
                hidden: 0,
                districts: [
                    {
                        code: '511802',
                        name: '雨城区',
                        simple_name: '雨城',
                        hidden: 0,
                    },
                    {
                        code: '511803',
                        name: '名山区',
                        simple_name: '名山',
                        hidden: 0,
                    },
                    {
                        code: '511822',
                        name: '荥经县',
                        simple_name: '荥经',
                        hidden: 0,
                    },
                    {
                        code: '511823',
                        name: '汉源县',
                        simple_name: '汉源',
                        hidden: 0,
                    },
                    {
                        code: '511824',
                        name: '石棉县',
                        simple_name: '石棉',
                        hidden: 0,
                    },
                    {
                        code: '511825',
                        name: '天全县',
                        simple_name: '天全',
                        hidden: 0,
                    },
                    {
                        code: '511826',
                        name: '芦山县',
                        simple_name: '芦山',
                        hidden: 0,
                    },
                    {
                        code: '511827',
                        name: '宝兴县',
                        simple_name: '宝兴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '511900',
                name: '巴中市',
                simple_name: '巴中',
                hidden: 0,
                districts: [
                    {
                        code: '511902',
                        name: '巴州区',
                        simple_name: '巴州',
                        hidden: 0,
                    },
                    {
                        code: '511903',
                        name: '恩阳区',
                        simple_name: '恩阳',
                        hidden: 0,
                    },
                    {
                        code: '511921',
                        name: '通江县',
                        simple_name: '通江',
                        hidden: 0,
                    },
                    {
                        code: '511922',
                        name: '南江县',
                        simple_name: '南江',
                        hidden: 0,
                    },
                    {
                        code: '511923',
                        name: '平昌县',
                        simple_name: '平昌',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '512000',
                name: '资阳市',
                simple_name: '资阳',
                hidden: 0,
                districts: [
                    {
                        code: '512002',
                        name: '雁江区',
                        simple_name: '雁江',
                        hidden: 0,
                    },
                    {
                        code: '512021',
                        name: '安岳县',
                        simple_name: '安岳',
                        hidden: 0,
                    },
                    {
                        code: '512022',
                        name: '乐至县',
                        simple_name: '乐至',
                        hidden: 0,
                    },
                    {
                        code: '512081',
                        name: '简阳市',
                        simple_name: '简阳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '513200',
                name: '阿坝藏族羌族自治州',
                simple_name: '阿坝',
                hidden: 0,
                districts: [
                    {
                        code: '513221',
                        name: '汶川县',
                        simple_name: '汶川',
                        hidden: 0,
                    },
                    {
                        code: '513222',
                        name: '理县',
                        simple_name: '理县',
                        hidden: 0,
                    },
                    {
                        code: '513223',
                        name: '茂县',
                        simple_name: '茂县',
                        hidden: 0,
                    },
                    {
                        code: '513224',
                        name: '松潘县',
                        simple_name: '松潘',
                        hidden: 0,
                    },
                    {
                        code: '513225',
                        name: '九寨沟县',
                        simple_name: '九寨沟',
                        hidden: 0,
                    },
                    {
                        code: '513226',
                        name: '金川县',
                        simple_name: '金川',
                        hidden: 0,
                    },
                    {
                        code: '513227',
                        name: '小金县',
                        simple_name: '小金',
                        hidden: 0,
                    },
                    {
                        code: '513228',
                        name: '黑水县',
                        simple_name: '黑水',
                        hidden: 0,
                    },
                    {
                        code: '513229',
                        name: '马尔康县',
                        simple_name: '马尔康',
                        hidden: 0,
                    },
                    {
                        code: '513230',
                        name: '壤塘县',
                        simple_name: '壤塘',
                        hidden: 0,
                    },
                    {
                        code: '513231',
                        name: '阿坝县',
                        simple_name: '阿坝',
                        hidden: 0,
                    },
                    {
                        code: '513232',
                        name: '若尔盖县',
                        simple_name: '若尔盖',
                        hidden: 0,
                    },
                    {
                        code: '513233',
                        name: '红原县',
                        simple_name: '红原',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '513300',
                name: '甘孜藏族自治州',
                simple_name: '甘孜',
                hidden: 0,
                districts: [
                    {
                        code: '513321',
                        name: '康定县',
                        simple_name: '康定',
                        hidden: 0,
                    },
                    {
                        code: '513322',
                        name: '泸定县',
                        simple_name: '泸定',
                        hidden: 0,
                    },
                    {
                        code: '513323',
                        name: '丹巴县',
                        simple_name: '丹巴',
                        hidden: 0,
                    },
                    {
                        code: '513324',
                        name: '九龙县',
                        simple_name: '九龙',
                        hidden: 0,
                    },
                    {
                        code: '513325',
                        name: '雅江县',
                        simple_name: '雅江',
                        hidden: 0,
                    },
                    {
                        code: '513326',
                        name: '道孚县',
                        simple_name: '道孚',
                        hidden: 0,
                    },
                    {
                        code: '513327',
                        name: '炉霍县',
                        simple_name: '炉霍',
                        hidden: 0,
                    },
                    {
                        code: '513328',
                        name: '甘孜县',
                        simple_name: '甘孜',
                        hidden: 0,
                    },
                    {
                        code: '513329',
                        name: '新龙县',
                        simple_name: '新龙',
                        hidden: 0,
                    },
                    {
                        code: '513330',
                        name: '德格县',
                        simple_name: '德格',
                        hidden: 0,
                    },
                    {
                        code: '513331',
                        name: '白玉县',
                        simple_name: '白玉',
                        hidden: 0,
                    },
                    {
                        code: '513332',
                        name: '石渠县',
                        simple_name: '石渠',
                        hidden: 0,
                    },
                    {
                        code: '513333',
                        name: '色达县',
                        simple_name: '色达',
                        hidden: 0,
                    },
                    {
                        code: '513334',
                        name: '理塘县',
                        simple_name: '理塘',
                        hidden: 0,
                    },
                    {
                        code: '513335',
                        name: '巴塘县',
                        simple_name: '巴塘',
                        hidden: 0,
                    },
                    {
                        code: '513336',
                        name: '乡城县',
                        simple_name: '乡城',
                        hidden: 0,
                    },
                    {
                        code: '513337',
                        name: '稻城县',
                        simple_name: '稻城',
                        hidden: 0,
                    },
                    {
                        code: '513338',
                        name: '得荣县',
                        simple_name: '得荣',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '513400',
                name: '凉山彝族自治州',
                simple_name: '凉山',
                hidden: 0,
                districts: [
                    {
                        code: '513401',
                        name: '西昌市',
                        simple_name: '西昌',
                        hidden: 0,
                    },
                    {
                        code: '513422',
                        name: '木里藏族自治县',
                        simple_name: '木里',
                        hidden: 0,
                    },
                    {
                        code: '513423',
                        name: '盐源县',
                        simple_name: '盐源',
                        hidden: 0,
                    },
                    {
                        code: '513424',
                        name: '德昌县',
                        simple_name: '德昌',
                        hidden: 0,
                    },
                    {
                        code: '513425',
                        name: '会理县',
                        simple_name: '会理',
                        hidden: 0,
                    },
                    {
                        code: '513426',
                        name: '会东县',
                        simple_name: '会东',
                        hidden: 0,
                    },
                    {
                        code: '513427',
                        name: '宁南县',
                        simple_name: '宁南',
                        hidden: 0,
                    },
                    {
                        code: '513428',
                        name: '普格县',
                        simple_name: '普格',
                        hidden: 0,
                    },
                    {
                        code: '513429',
                        name: '布拖县',
                        simple_name: '布拖',
                        hidden: 0,
                    },
                    {
                        code: '513430',
                        name: '金阳县',
                        simple_name: '金阳',
                        hidden: 0,
                    },
                    {
                        code: '513431',
                        name: '昭觉县',
                        simple_name: '昭觉',
                        hidden: 0,
                    },
                    {
                        code: '513432',
                        name: '喜德县',
                        simple_name: '喜德',
                        hidden: 0,
                    },
                    {
                        code: '513433',
                        name: '冕宁县',
                        simple_name: '冕宁',
                        hidden: 0,
                    },
                    {
                        code: '513434',
                        name: '越西县',
                        simple_name: '越西',
                        hidden: 0,
                    },
                    {
                        code: '513435',
                        name: '甘洛县',
                        simple_name: '甘洛',
                        hidden: 0,
                    },
                    {
                        code: '513436',
                        name: '美姑县',
                        simple_name: '美姑',
                        hidden: 0,
                    },
                    {
                        code: '513437',
                        name: '雷波县',
                        simple_name: '雷波',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '520000',
        name: '贵州省',
        simple_name: '贵州',
        hidden: 0,
        cities: [
            {
                code: '520100',
                name: '贵阳市',
                simple_name: '贵阳',
                hidden: 0,
                districts: [
                    {
                        code: '520102',
                        name: '南明区',
                        simple_name: '南明',
                        hidden: 0,
                    },
                    {
                        code: '520103',
                        name: '云岩区',
                        simple_name: '云岩',
                        hidden: 0,
                    },
                    {
                        code: '520111',
                        name: '花溪区',
                        simple_name: '花溪',
                        hidden: 0,
                    },
                    {
                        code: '520112',
                        name: '乌当区',
                        simple_name: '乌当',
                        hidden: 0,
                    },
                    {
                        code: '520113',
                        name: '白云区',
                        simple_name: '白云',
                        hidden: 0,
                    },
                    {
                        code: '520115',
                        name: '观山湖区',
                        simple_name: '观山湖',
                        hidden: 0,
                    },
                    {
                        code: '520121',
                        name: '开阳县',
                        simple_name: '开阳',
                        hidden: 0,
                    },
                    {
                        code: '520122',
                        name: '息烽县',
                        simple_name: '息烽',
                        hidden: 0,
                    },
                    {
                        code: '520123',
                        name: '修文县',
                        simple_name: '修文',
                        hidden: 0,
                    },
                    {
                        code: '520181',
                        name: '清镇市',
                        simple_name: '清镇',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '520200',
                name: '六盘水市',
                simple_name: '六盘水',
                hidden: 0,
                districts: [
                    {
                        code: '520201',
                        name: '钟山区',
                        simple_name: '钟山',
                        hidden: 0,
                    },
                    {
                        code: '520203',
                        name: '六枝特区',
                        simple_name: '六枝',
                        hidden: 0,
                    },
                    {
                        code: '520221',
                        name: '水城县',
                        simple_name: '水城',
                        hidden: 0,
                    },
                    {
                        code: '520222',
                        name: '盘县',
                        simple_name: '盘县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '520300',
                name: '遵义市',
                simple_name: '遵义',
                hidden: 0,
                districts: [
                    {
                        code: '520302',
                        name: '红花岗区',
                        simple_name: '红花岗',
                        hidden: 0,
                    },
                    {
                        code: '520303',
                        name: '汇川区',
                        simple_name: '汇川',
                        hidden: 0,
                    },
                    {
                        code: '520321',
                        name: '遵义县',
                        simple_name: '遵义',
                        hidden: 0,
                    },
                    {
                        code: '520322',
                        name: '桐梓县',
                        simple_name: '桐梓',
                        hidden: 0,
                    },
                    {
                        code: '520323',
                        name: '绥阳县',
                        simple_name: '绥阳',
                        hidden: 0,
                    },
                    {
                        code: '520324',
                        name: '正安县',
                        simple_name: '正安',
                        hidden: 0,
                    },
                    {
                        code: '520325',
                        name: '道真仡佬族苗族自治县',
                        simple_name: '道真',
                        hidden: 0,
                    },
                    {
                        code: '520326',
                        name: '务川仡佬族苗族自治县',
                        simple_name: '务川',
                        hidden: 0,
                    },
                    {
                        code: '520327',
                        name: '凤冈县',
                        simple_name: '凤冈',
                        hidden: 0,
                    },
                    {
                        code: '520328',
                        name: '湄潭县',
                        simple_name: '湄潭',
                        hidden: 0,
                    },
                    {
                        code: '520329',
                        name: '余庆县',
                        simple_name: '余庆',
                        hidden: 0,
                    },
                    {
                        code: '520330',
                        name: '习水县',
                        simple_name: '习水',
                        hidden: 0,
                    },
                    {
                        code: '520381',
                        name: '赤水市',
                        simple_name: '赤水',
                        hidden: 0,
                    },
                    {
                        code: '520382',
                        name: '仁怀市',
                        simple_name: '仁怀',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '520400',
                name: '安顺市',
                simple_name: '安顺',
                hidden: 0,
                districts: [
                    {
                        code: '520402',
                        name: '西秀区',
                        simple_name: '西秀',
                        hidden: 0,
                    },
                    {
                        code: '520421',
                        name: '平坝区',
                        simple_name: '平坝',
                        hidden: 0,
                    },
                    {
                        code: '520422',
                        name: '普定县',
                        simple_name: '普定',
                        hidden: 0,
                    },
                    {
                        code: '520423',
                        name: '镇宁布依族苗族自治县',
                        simple_name: '镇宁',
                        hidden: 0,
                    },
                    {
                        code: '520424',
                        name: '关岭布依族苗族自治县',
                        simple_name: '关岭',
                        hidden: 0,
                    },
                    {
                        code: '520425',
                        name: '紫云苗族布依族自治县',
                        simple_name: '紫云',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '520500',
                name: '毕节市',
                simple_name: '毕节',
                hidden: 0,
                districts: [
                    {
                        code: '520502',
                        name: '七星关区',
                        simple_name: '七星关',
                        hidden: 0,
                    },
                    {
                        code: '520521',
                        name: '大方县',
                        simple_name: '大方',
                        hidden: 0,
                    },
                    {
                        code: '520522',
                        name: '黔西县',
                        simple_name: '黔西',
                        hidden: 0,
                    },
                    {
                        code: '520523',
                        name: '金沙县',
                        simple_name: '金沙',
                        hidden: 0,
                    },
                    {
                        code: '520524',
                        name: '织金县',
                        simple_name: '织金',
                        hidden: 0,
                    },
                    {
                        code: '520525',
                        name: '纳雍县',
                        simple_name: '纳雍',
                        hidden: 0,
                    },
                    {
                        code: '520526',
                        name: '威宁彝族回族苗族自治县',
                        simple_name: '威宁',
                        hidden: 0,
                    },
                    {
                        code: '520527',
                        name: '赫章县',
                        simple_name: '赫章',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '520600',
                name: '铜仁市',
                simple_name: '铜仁',
                hidden: 0,
                districts: [
                    {
                        code: '520602',
                        name: '碧江区',
                        simple_name: '碧江',
                        hidden: 0,
                    },
                    {
                        code: '520603',
                        name: '万山区',
                        simple_name: '万山',
                        hidden: 0,
                    },
                    {
                        code: '520621',
                        name: '江口县',
                        simple_name: '江口',
                        hidden: 0,
                    },
                    {
                        code: '520622',
                        name: '玉屏侗族自治县',
                        simple_name: '玉屏',
                        hidden: 0,
                    },
                    {
                        code: '520623',
                        name: '石阡县',
                        simple_name: '石阡',
                        hidden: 0,
                    },
                    {
                        code: '520624',
                        name: '思南县',
                        simple_name: '思南',
                        hidden: 0,
                    },
                    {
                        code: '520625',
                        name: '印江土家族苗族自治县',
                        simple_name: '印江',
                        hidden: 0,
                    },
                    {
                        code: '520626',
                        name: '德江县',
                        simple_name: '德江',
                        hidden: 0,
                    },
                    {
                        code: '520627',
                        name: '沿河土家族自治县',
                        simple_name: '沿河',
                        hidden: 0,
                    },
                    {
                        code: '520628',
                        name: '松桃苗族自治县',
                        simple_name: '松桃',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '522300',
                name: '黔西南布依族苗族自治州',
                simple_name: '黔西南',
                hidden: 0,
                districts: [
                    {
                        code: '522301',
                        name: '兴义市 ',
                        simple_name: '兴义',
                        hidden: 0,
                    },
                    {
                        code: '522322',
                        name: '兴仁县',
                        simple_name: '兴仁',
                        hidden: 0,
                    },
                    {
                        code: '522323',
                        name: '普安县',
                        simple_name: '普安',
                        hidden: 0,
                    },
                    {
                        code: '522324',
                        name: '晴隆县',
                        simple_name: '晴隆',
                        hidden: 0,
                    },
                    {
                        code: '522325',
                        name: '贞丰县',
                        simple_name: '贞丰',
                        hidden: 0,
                    },
                    {
                        code: '522326',
                        name: '望谟县',
                        simple_name: '望谟',
                        hidden: 0,
                    },
                    {
                        code: '522327',
                        name: '册亨县',
                        simple_name: '册亨',
                        hidden: 0,
                    },
                    {
                        code: '522328',
                        name: '安龙县',
                        simple_name: '安龙',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '522600',
                name: '黔东南苗族侗族自治州',
                simple_name: '黔东南',
                hidden: 0,
                districts: [
                    {
                        code: '522601',
                        name: '凯里市',
                        simple_name: '凯里',
                        hidden: 0,
                    },
                    {
                        code: '522622',
                        name: '黄平县',
                        simple_name: '黄平',
                        hidden: 0,
                    },
                    {
                        code: '522623',
                        name: '施秉县',
                        simple_name: '施秉',
                        hidden: 0,
                    },
                    {
                        code: '522624',
                        name: '三穗县',
                        simple_name: '三穗',
                        hidden: 0,
                    },
                    {
                        code: '522625',
                        name: '镇远县',
                        simple_name: '镇远',
                        hidden: 0,
                    },
                    {
                        code: '522626',
                        name: '岑巩县',
                        simple_name: '岑巩',
                        hidden: 0,
                    },
                    {
                        code: '522627',
                        name: '天柱县',
                        simple_name: '天柱',
                        hidden: 0,
                    },
                    {
                        code: '522628',
                        name: '锦屏县',
                        simple_name: '锦屏',
                        hidden: 0,
                    },
                    {
                        code: '522629',
                        name: '剑河县',
                        simple_name: '剑河',
                        hidden: 0,
                    },
                    {
                        code: '522630',
                        name: '台江县',
                        simple_name: '台江',
                        hidden: 0,
                    },
                    {
                        code: '522631',
                        name: '黎平县',
                        simple_name: '黎平',
                        hidden: 0,
                    },
                    {
                        code: '522632',
                        name: '榕江县',
                        simple_name: '榕江',
                        hidden: 0,
                    },
                    {
                        code: '522633',
                        name: '从江县',
                        simple_name: '从江',
                        hidden: 0,
                    },
                    {
                        code: '522634',
                        name: '雷山县',
                        simple_name: '雷山',
                        hidden: 0,
                    },
                    {
                        code: '522635',
                        name: '麻江县',
                        simple_name: '麻江',
                        hidden: 0,
                    },
                    {
                        code: '522636',
                        name: '丹寨县',
                        simple_name: '丹寨',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '522700',
                name: '黔南布依族苗族自治州',
                simple_name: '黔南',
                hidden: 0,
                districts: [
                    {
                        code: '522701',
                        name: '都匀市',
                        simple_name: '都匀',
                        hidden: 0,
                    },
                    {
                        code: '522702',
                        name: '福泉市',
                        simple_name: '福泉',
                        hidden: 0,
                    },
                    {
                        code: '522722',
                        name: '荔波县',
                        simple_name: '荔波',
                        hidden: 0,
                    },
                    {
                        code: '522723',
                        name: '贵定县',
                        simple_name: '贵定',
                        hidden: 0,
                    },
                    {
                        code: '522725',
                        name: '瓮安县',
                        simple_name: '瓮安',
                        hidden: 0,
                    },
                    {
                        code: '522726',
                        name: '独山县',
                        simple_name: '独山',
                        hidden: 0,
                    },
                    {
                        code: '522727',
                        name: '平塘县',
                        simple_name: '平塘',
                        hidden: 0,
                    },
                    {
                        code: '522728',
                        name: '罗甸县',
                        simple_name: '罗甸',
                        hidden: 0,
                    },
                    {
                        code: '522729',
                        name: '长顺县',
                        simple_name: '长顺',
                        hidden: 0,
                    },
                    {
                        code: '522730',
                        name: '龙里县',
                        simple_name: '龙里',
                        hidden: 0,
                    },
                    {
                        code: '522731',
                        name: '惠水县',
                        simple_name: '惠水',
                        hidden: 0,
                    },
                    {
                        code: '522732',
                        name: '三都水族自治县',
                        simple_name: '三都',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '530000',
        name: '云南省',
        simple_name: '云南',
        hidden: 0,
        cities: [
            {
                code: '530100',
                name: '昆明市',
                simple_name: '昆明',
                hidden: 0,
                districts: [
                    {
                        code: '530102',
                        name: '五华区',
                        simple_name: '五华',
                        hidden: 0,
                    },
                    {
                        code: '530103',
                        name: '盘龙区',
                        simple_name: '盘龙',
                        hidden: 0,
                    },
                    {
                        code: '530111',
                        name: '官渡区',
                        simple_name: '官渡',
                        hidden: 0,
                    },
                    {
                        code: '530112',
                        name: '西山区',
                        simple_name: '西山',
                        hidden: 0,
                    },
                    {
                        code: '530113',
                        name: '东川区',
                        simple_name: '东川',
                        hidden: 0,
                    },
                    {
                        code: '530114',
                        name: '呈贡区',
                        simple_name: '呈贡',
                        hidden: 0,
                    },
                    {
                        code: '530122',
                        name: '晋宁县',
                        simple_name: '晋宁',
                        hidden: 0,
                    },
                    {
                        code: '530124',
                        name: '富民县',
                        simple_name: '富民',
                        hidden: 0,
                    },
                    {
                        code: '530125',
                        name: '宜良县',
                        simple_name: '宜良',
                        hidden: 0,
                    },
                    {
                        code: '530126',
                        name: '石林彝族自治县',
                        simple_name: '石林',
                        hidden: 0,
                    },
                    {
                        code: '530127',
                        name: '嵩明县',
                        simple_name: '嵩明',
                        hidden: 0,
                    },
                    {
                        code: '530128',
                        name: '禄劝彝族苗族自治县',
                        simple_name: '禄劝',
                        hidden: 0,
                    },
                    {
                        code: '530129',
                        name: '寻甸回族彝族自治县 ',
                        simple_name: '寻甸',
                        hidden: 0,
                    },
                    {
                        code: '530181',
                        name: '安宁市',
                        simple_name: '安宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530300',
                name: '曲靖市',
                simple_name: '曲靖',
                hidden: 0,
                districts: [
                    {
                        code: '530302',
                        name: '麒麟区',
                        simple_name: '麒麟',
                        hidden: 0,
                    },
                    {
                        code: '530321',
                        name: '马龙县',
                        simple_name: '马龙',
                        hidden: 0,
                    },
                    {
                        code: '530322',
                        name: '陆良县',
                        simple_name: '陆良',
                        hidden: 0,
                    },
                    {
                        code: '530323',
                        name: '师宗县',
                        simple_name: '师宗',
                        hidden: 0,
                    },
                    {
                        code: '530324',
                        name: '罗平县',
                        simple_name: '罗平',
                        hidden: 0,
                    },
                    {
                        code: '530325',
                        name: '富源县',
                        simple_name: '富源',
                        hidden: 0,
                    },
                    {
                        code: '530326',
                        name: '会泽县',
                        simple_name: '会泽',
                        hidden: 0,
                    },
                    {
                        code: '530328',
                        name: '沾益县',
                        simple_name: '沾益',
                        hidden: 0,
                    },
                    {
                        code: '530381',
                        name: '宣威市',
                        simple_name: '宣威',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530400',
                name: '玉溪市',
                simple_name: '玉溪',
                hidden: 0,
                districts: [
                    {
                        code: '530402',
                        name: '红塔区',
                        simple_name: '红塔',
                        hidden: 0,
                    },
                    {
                        code: '530421',
                        name: '江川县',
                        simple_name: '江川',
                        hidden: 0,
                    },
                    {
                        code: '530422',
                        name: '澄江县',
                        simple_name: '澄江',
                        hidden: 0,
                    },
                    {
                        code: '530423',
                        name: '通海县',
                        simple_name: '通海',
                        hidden: 0,
                    },
                    {
                        code: '530424',
                        name: '华宁县',
                        simple_name: '华宁',
                        hidden: 0,
                    },
                    {
                        code: '530425',
                        name: '易门县',
                        simple_name: '易门',
                        hidden: 0,
                    },
                    {
                        code: '530426',
                        name: '峨山彝族自治县',
                        simple_name: '峨山',
                        hidden: 0,
                    },
                    {
                        code: '530427',
                        name: '新平彝族傣族自治县',
                        simple_name: '新平',
                        hidden: 0,
                    },
                    {
                        code: '530428',
                        name: '元江哈尼族彝族傣族自治县',
                        simple_name: '元江',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530500',
                name: '保山市',
                simple_name: '保山',
                hidden: 0,
                districts: [
                    {
                        code: '530502',
                        name: '隆阳区',
                        simple_name: '隆阳',
                        hidden: 0,
                    },
                    {
                        code: '530521',
                        name: '施甸县',
                        simple_name: '施甸',
                        hidden: 0,
                    },
                    {
                        code: '530522',
                        name: '腾冲县',
                        simple_name: '腾冲',
                        hidden: 0,
                    },
                    {
                        code: '530523',
                        name: '龙陵县',
                        simple_name: '龙陵',
                        hidden: 0,
                    },
                    {
                        code: '530524',
                        name: '昌宁县',
                        simple_name: '昌宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530600',
                name: '昭通市',
                simple_name: '昭通',
                hidden: 0,
                districts: [
                    {
                        code: '530602',
                        name: '昭阳区',
                        simple_name: '昭阳',
                        hidden: 0,
                    },
                    {
                        code: '530621',
                        name: '鲁甸县',
                        simple_name: '鲁甸',
                        hidden: 0,
                    },
                    {
                        code: '530622',
                        name: '巧家县',
                        simple_name: '巧家',
                        hidden: 0,
                    },
                    {
                        code: '530623',
                        name: '盐津县',
                        simple_name: '盐津',
                        hidden: 0,
                    },
                    {
                        code: '530624',
                        name: '大关县',
                        simple_name: '大关',
                        hidden: 0,
                    },
                    {
                        code: '530625',
                        name: '永善县',
                        simple_name: '永善',
                        hidden: 0,
                    },
                    {
                        code: '530626',
                        name: '绥江县',
                        simple_name: '绥江',
                        hidden: 0,
                    },
                    {
                        code: '530627',
                        name: '镇雄县',
                        simple_name: '镇雄',
                        hidden: 0,
                    },
                    {
                        code: '530628',
                        name: '彝良县',
                        simple_name: '彝良',
                        hidden: 0,
                    },
                    {
                        code: '530629',
                        name: '威信县',
                        simple_name: '威信',
                        hidden: 0,
                    },
                    {
                        code: '530630',
                        name: '水富县',
                        simple_name: '水富',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530700',
                name: '丽江市',
                simple_name: '丽江',
                hidden: 0,
                districts: [
                    {
                        code: '530702',
                        name: '古城区',
                        simple_name: '古城',
                        hidden: 0,
                    },
                    {
                        code: '530721',
                        name: '玉龙纳西族自治县',
                        simple_name: '玉龙',
                        hidden: 0,
                    },
                    {
                        code: '530722',
                        name: '永胜县',
                        simple_name: '永胜',
                        hidden: 0,
                    },
                    {
                        code: '530723',
                        name: '华坪县',
                        simple_name: '华坪',
                        hidden: 0,
                    },
                    {
                        code: '530724',
                        name: '宁蒗彝族自治县',
                        simple_name: '宁蒗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530800',
                name: '普洱市',
                simple_name: '普洱',
                hidden: 0,
                districts: [
                    {
                        code: '530802',
                        name: '思茅区',
                        simple_name: '思茅',
                        hidden: 0,
                    },
                    {
                        code: '530821',
                        name: '宁洱哈尼族彝族自治县',
                        simple_name: '宁洱',
                        hidden: 0,
                    },
                    {
                        code: '530822',
                        name: '墨江哈尼族自治县',
                        simple_name: '墨江',
                        hidden: 0,
                    },
                    {
                        code: '530823',
                        name: '景东彝族自治县',
                        simple_name: '景东',
                        hidden: 0,
                    },
                    {
                        code: '530824',
                        name: '景谷傣族彝族自治县',
                        simple_name: '景谷',
                        hidden: 0,
                    },
                    {
                        code: '530825',
                        name: '镇沅彝族哈尼族拉祜族自治县',
                        simple_name: '镇沅',
                        hidden: 0,
                    },
                    {
                        code: '530826',
                        name: '江城哈尼族彝族自治县',
                        simple_name: '江城',
                        hidden: 0,
                    },
                    {
                        code: '530827',
                        name: '孟连傣族拉祜族佤族自治县',
                        simple_name: '孟连',
                        hidden: 0,
                    },
                    {
                        code: '530828',
                        name: '澜沧拉祜族自治县',
                        simple_name: '澜沧',
                        hidden: 0,
                    },
                    {
                        code: '530829',
                        name: '西盟佤族自治县',
                        simple_name: '西盟',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '530900',
                name: '临沧市',
                simple_name: '临沧',
                hidden: 0,
                districts: [
                    {
                        code: '530902',
                        name: '临翔区',
                        simple_name: '临翔',
                        hidden: 0,
                    },
                    {
                        code: '530921',
                        name: '凤庆县',
                        simple_name: '凤庆',
                        hidden: 0,
                    },
                    {
                        code: '530922',
                        name: '云县',
                        simple_name: '云县',
                        hidden: 0,
                    },
                    {
                        code: '530923',
                        name: '永德县',
                        simple_name: '永德',
                        hidden: 0,
                    },
                    {
                        code: '530924',
                        name: '镇康县',
                        simple_name: '镇康',
                        hidden: 0,
                    },
                    {
                        code: '530925',
                        name: '双江拉祜族佤族布朗族傣族自治县',
                        simple_name: '双江',
                        hidden: 0,
                    },
                    {
                        code: '530926',
                        name: '耿马傣族佤族自治县',
                        simple_name: '耿马',
                        hidden: 0,
                    },
                    {
                        code: '530927',
                        name: '沧源佤族自治县',
                        simple_name: '沧源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '532300',
                name: '楚雄彝族自治州',
                simple_name: '楚雄',
                hidden: 0,
                districts: [
                    {
                        code: '532301',
                        name: '楚雄市',
                        simple_name: '楚雄',
                        hidden: 0,
                    },
                    {
                        code: '532322',
                        name: '双柏县',
                        simple_name: '双柏',
                        hidden: 0,
                    },
                    {
                        code: '532323',
                        name: '牟定县',
                        simple_name: '牟定',
                        hidden: 0,
                    },
                    {
                        code: '532324',
                        name: '南华县',
                        simple_name: '南华',
                        hidden: 0,
                    },
                    {
                        code: '532325',
                        name: '姚安县',
                        simple_name: '姚安',
                        hidden: 0,
                    },
                    {
                        code: '532326',
                        name: '大姚县',
                        simple_name: '大姚',
                        hidden: 0,
                    },
                    {
                        code: '532327',
                        name: '永仁县',
                        simple_name: '永仁',
                        hidden: 0,
                    },
                    {
                        code: '532328',
                        name: '元谋县',
                        simple_name: '元谋',
                        hidden: 0,
                    },
                    {
                        code: '532329',
                        name: '武定县',
                        simple_name: '武定',
                        hidden: 0,
                    },
                    {
                        code: '532331',
                        name: '禄丰县',
                        simple_name: '禄丰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '532500',
                name: '红河哈尼族彝族自治州',
                simple_name: '红河',
                hidden: 0,
                districts: [
                    {
                        code: '532501',
                        name: '个旧市',
                        simple_name: '个旧',
                        hidden: 0,
                    },
                    {
                        code: '532502',
                        name: '开远市',
                        simple_name: '开远',
                        hidden: 0,
                    },
                    {
                        code: '532503',
                        name: '蒙自市',
                        simple_name: '蒙自',
                        hidden: 0,
                    },
                    {
                        code: '532504',
                        name: '弥勒市',
                        simple_name: '弥勒',
                        hidden: 0,
                    },
                    {
                        code: '532523',
                        name: '屏边苗族自治县',
                        simple_name: '屏边',
                        hidden: 0,
                    },
                    {
                        code: '532524',
                        name: '建水县',
                        simple_name: '建水',
                        hidden: 0,
                    },
                    {
                        code: '532525',
                        name: '石屏县',
                        simple_name: '石屏',
                        hidden: 0,
                    },
                    {
                        code: '532527',
                        name: '泸西县',
                        simple_name: '泸西',
                        hidden: 0,
                    },
                    {
                        code: '532528',
                        name: '元阳县',
                        simple_name: '元阳',
                        hidden: 0,
                    },
                    {
                        code: '532529',
                        name: '红河县',
                        simple_name: '红河县',
                        hidden: 0,
                    },
                    {
                        code: '532530',
                        name: '金平苗族瑶族傣族自治县',
                        simple_name: '金平',
                        hidden: 0,
                    },
                    {
                        code: '532531',
                        name: '绿春县',
                        simple_name: '绿春',
                        hidden: 0,
                    },
                    {
                        code: '532532',
                        name: '河口瑶族自治县',
                        simple_name: '河口',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '532600',
                name: '文山壮族苗族自治州',
                simple_name: '文山',
                hidden: 0,
                districts: [
                    {
                        code: '532601',
                        name: '文山市',
                        simple_name: '文山',
                        hidden: 0,
                    },
                    {
                        code: '532622',
                        name: '砚山县',
                        simple_name: '砚山',
                        hidden: 0,
                    },
                    {
                        code: '532623',
                        name: '西畴县',
                        simple_name: '西畴',
                        hidden: 0,
                    },
                    {
                        code: '532624',
                        name: '麻栗坡县',
                        simple_name: '麻栗坡',
                        hidden: 0,
                    },
                    {
                        code: '532625',
                        name: '马关县',
                        simple_name: '马关',
                        hidden: 0,
                    },
                    {
                        code: '532626',
                        name: '丘北县',
                        simple_name: '丘北',
                        hidden: 0,
                    },
                    {
                        code: '532627',
                        name: '广南县',
                        simple_name: '广南',
                        hidden: 0,
                    },
                    {
                        code: '532628',
                        name: '富宁县',
                        simple_name: '富宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '532800',
                name: '西双版纳傣族自治州',
                simple_name: '西双版纳',
                hidden: 0,
                districts: [
                    {
                        code: '532801',
                        name: '景洪市',
                        simple_name: '景洪',
                        hidden: 0,
                    },
                    {
                        code: '532822',
                        name: '勐海县',
                        simple_name: '勐海',
                        hidden: 0,
                    },
                    {
                        code: '532823',
                        name: '勐腊县',
                        simple_name: '勐腊',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '532900',
                name: '大理白族自治州',
                simple_name: '大理',
                hidden: 0,
                districts: [
                    {
                        code: '532901',
                        name: '大理市',
                        simple_name: '大理',
                        hidden: 0,
                    },
                    {
                        code: '532922',
                        name: '漾濞彝族自治县',
                        simple_name: '漾濞',
                        hidden: 0,
                    },
                    {
                        code: '532923',
                        name: '祥云县',
                        simple_name: '祥云',
                        hidden: 0,
                    },
                    {
                        code: '532924',
                        name: '宾川县',
                        simple_name: '宾川',
                        hidden: 0,
                    },
                    {
                        code: '532925',
                        name: '弥渡县',
                        simple_name: '弥渡',
                        hidden: 0,
                    },
                    {
                        code: '532926',
                        name: '南涧彝族自治县',
                        simple_name: '南涧',
                        hidden: 0,
                    },
                    {
                        code: '532927',
                        name: '巍山彝族回族自治县',
                        simple_name: '巍山',
                        hidden: 0,
                    },
                    {
                        code: '532928',
                        name: '永平县',
                        simple_name: '永平',
                        hidden: 0,
                    },
                    {
                        code: '532929',
                        name: '云龙县',
                        simple_name: '云龙',
                        hidden: 0,
                    },
                    {
                        code: '532930',
                        name: '洱源县',
                        simple_name: '洱源',
                        hidden: 0,
                    },
                    {
                        code: '532931',
                        name: '剑川县',
                        simple_name: '剑川',
                        hidden: 0,
                    },
                    {
                        code: '532932',
                        name: '鹤庆县',
                        simple_name: '鹤庆',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '533100',
                name: '德宏傣族景颇族自治州',
                simple_name: '德宏',
                hidden: 0,
                districts: [
                    {
                        code: '533102',
                        name: '瑞丽市',
                        simple_name: '瑞丽',
                        hidden: 0,
                    },
                    {
                        code: '533103',
                        name: '芒市',
                        simple_name: '芒市',
                        hidden: 0,
                    },
                    {
                        code: '533122',
                        name: '梁河县',
                        simple_name: '梁河',
                        hidden: 0,
                    },
                    {
                        code: '533123',
                        name: '盈江县',
                        simple_name: '盈江',
                        hidden: 0,
                    },
                    {
                        code: '533124',
                        name: '陇川县',
                        simple_name: '陇川',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '533300',
                name: '怒江傈僳族自治州',
                simple_name: '怒江',
                hidden: 0,
                districts: [
                    {
                        code: '533321',
                        name: '泸水县',
                        simple_name: '泸水',
                        hidden: 0,
                    },
                    {
                        code: '533323',
                        name: '福贡县',
                        simple_name: '福贡',
                        hidden: 0,
                    },
                    {
                        code: '533324',
                        name: '贡山独龙族怒族自治县',
                        simple_name: '贡山',
                        hidden: 0,
                    },
                    {
                        code: '533325',
                        name: '兰坪白族普米族自治县',
                        simple_name: '兰坪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '533400',
                name: '迪庆藏族自治州',
                simple_name: '迪庆',
                hidden: 0,
                districts: [
                    {
                        code: '533421',
                        name: '香格里拉市',
                        simple_name: '香格里拉',
                        hidden: 0,
                    },
                    {
                        code: '533422',
                        name: '德钦县',
                        simple_name: '德钦',
                        hidden: 0,
                    },
                    {
                        code: '533423',
                        name: '维西傈僳族自治县',
                        simple_name: '维西',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '540000',
        name: '西藏自治区',
        simple_name: '西藏',
        hidden: 0,
        cities: [
            {
                code: '540100',
                name: '拉萨市',
                simple_name: '拉萨',
                hidden: 0,
                districts: [
                    {
                        code: '540102',
                        name: '城关区',
                        simple_name: '城关',
                        hidden: 0,
                    },
                    {
                        code: '540121',
                        name: '林周县',
                        simple_name: '林周',
                        hidden: 0,
                    },
                    {
                        code: '540122',
                        name: '当雄县',
                        simple_name: '当雄',
                        hidden: 0,
                    },
                    {
                        code: '540123',
                        name: '尼木县',
                        simple_name: '尼木',
                        hidden: 0,
                    },
                    {
                        code: '540124',
                        name: '曲水县',
                        simple_name: '曲水',
                        hidden: 0,
                    },
                    {
                        code: '540125',
                        name: '堆龙德庆县',
                        simple_name: '堆龙德庆',
                        hidden: 0,
                    },
                    {
                        code: '540126',
                        name: '达孜县',
                        simple_name: '达孜',
                        hidden: 0,
                    },
                    {
                        code: '540127',
                        name: '墨竹工卡县',
                        simple_name: '墨竹工卡',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '540200',
                name: '日喀则市',
                simple_name: '日喀则',
                hidden: 0,
                districts: [
                    {
                        code: '540202',
                        name: '桑珠孜区',
                        simple_name: '桑珠孜',
                        hidden: 0,
                    },
                    {
                        code: '540221',
                        name: '南木林县',
                        simple_name: '南木林',
                        hidden: 0,
                    },
                    {
                        code: '540222',
                        name: '江孜县',
                        simple_name: '江孜',
                        hidden: 0,
                    },
                    {
                        code: '540223',
                        name: '定日县',
                        simple_name: '定日',
                        hidden: 0,
                    },
                    {
                        code: '540224',
                        name: '萨迦县',
                        simple_name: '萨迦',
                        hidden: 0,
                    },
                    {
                        code: '540225',
                        name: '拉孜县',
                        simple_name: '拉孜',
                        hidden: 0,
                    },
                    {
                        code: '540226',
                        name: '昂仁县',
                        simple_name: '昂仁',
                        hidden: 0,
                    },
                    {
                        code: '540227',
                        name: '谢通门县',
                        simple_name: '谢通门',
                        hidden: 0,
                    },
                    {
                        code: '540228',
                        name: '白朗县',
                        simple_name: '白朗',
                        hidden: 0,
                    },
                    {
                        code: '540229',
                        name: '仁布县',
                        simple_name: '仁布',
                        hidden: 0,
                    },
                    {
                        code: '540230',
                        name: '康马县',
                        simple_name: '康马',
                        hidden: 0,
                    },
                    {
                        code: '540231',
                        name: '定结县',
                        simple_name: '定结',
                        hidden: 0,
                    },
                    {
                        code: '540232',
                        name: '仲巴县',
                        simple_name: '仲巴',
                        hidden: 0,
                    },
                    {
                        code: '540233',
                        name: '亚东县',
                        simple_name: '亚东',
                        hidden: 0,
                    },
                    {
                        code: '540234',
                        name: '吉隆县',
                        simple_name: '吉隆',
                        hidden: 0,
                    },
                    {
                        code: '540235',
                        name: '聂拉木县',
                        simple_name: '聂拉木',
                        hidden: 0,
                    },
                    {
                        code: '540236',
                        name: '萨嘎县',
                        simple_name: '萨嘎',
                        hidden: 0,
                    },
                    {
                        code: '540237',
                        name: '岗巴县',
                        simple_name: '岗巴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '540300',
                name: '昌都市',
                simple_name: '昌都',
                hidden: 0,
                districts: [
                    {
                        code: '540302',
                        name: '卡若区',
                        simple_name: '昌都',
                        hidden: 0,
                    },
                    {
                        code: '540321',
                        name: '江达县',
                        simple_name: '江达',
                        hidden: 0,
                    },
                    {
                        code: '540322',
                        name: '贡觉县',
                        simple_name: '贡觉',
                        hidden: 0,
                    },
                    {
                        code: '540323',
                        name: '类乌齐县',
                        simple_name: '类乌齐',
                        hidden: 0,
                    },
                    {
                        code: '540324',
                        name: '丁青县',
                        simple_name: '丁青',
                        hidden: 0,
                    },
                    {
                        code: '540325',
                        name: '察雅县',
                        simple_name: '察雅',
                        hidden: 0,
                    },
                    {
                        code: '540326',
                        name: '八宿县',
                        simple_name: '八宿',
                        hidden: 0,
                    },
                    {
                        code: '540327',
                        name: '左贡县',
                        simple_name: '左贡',
                        hidden: 0,
                    },
                    {
                        code: '540328',
                        name: '芒康县',
                        simple_name: '芒康',
                        hidden: 0,
                    },
                    {
                        code: '540329',
                        name: '洛隆县',
                        simple_name: '洛隆',
                        hidden: 0,
                    },
                    {
                        code: '540330',
                        name: '边坝县',
                        simple_name: '边坝',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '542200',
                name: '山南地区',
                simple_name: '山南',
                hidden: 0,
                districts: [
                    {
                        code: '542221',
                        name: '乃东县',
                        simple_name: '乃东',
                        hidden: 0,
                    },
                    {
                        code: '542222',
                        name: '扎囊县',
                        simple_name: '扎囊',
                        hidden: 0,
                    },
                    {
                        code: '542223',
                        name: '贡嘎县',
                        simple_name: '贡嘎',
                        hidden: 0,
                    },
                    {
                        code: '542224',
                        name: '桑日县',
                        simple_name: '桑日',
                        hidden: 0,
                    },
                    {
                        code: '542225',
                        name: '琼结县',
                        simple_name: '琼结',
                        hidden: 0,
                    },
                    {
                        code: '542226',
                        name: '曲松县',
                        simple_name: '曲松',
                        hidden: 0,
                    },
                    {
                        code: '542227',
                        name: '措美县',
                        simple_name: '措美',
                        hidden: 0,
                    },
                    {
                        code: '542228',
                        name: '洛扎县',
                        simple_name: '洛扎',
                        hidden: 0,
                    },
                    {
                        code: '542229',
                        name: '加查县',
                        simple_name: '加查',
                        hidden: 0,
                    },
                    {
                        code: '542231',
                        name: '隆子县',
                        simple_name: '隆子',
                        hidden: 0,
                    },
                    {
                        code: '542232',
                        name: '错那县',
                        simple_name: '错那',
                        hidden: 0,
                    },
                    {
                        code: '542233',
                        name: '浪卡子县',
                        simple_name: '浪卡子',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '542400',
                name: '那曲地区',
                simple_name: '那曲',
                hidden: 0,
                districts: [
                    {
                        code: '542421',
                        name: '那曲县',
                        simple_name: '那曲',
                        hidden: 0,
                    },
                    {
                        code: '542422',
                        name: '嘉黎县',
                        simple_name: '嘉黎',
                        hidden: 0,
                    },
                    {
                        code: '542423',
                        name: '比如县',
                        simple_name: '比如',
                        hidden: 0,
                    },
                    {
                        code: '542424',
                        name: '聂荣县',
                        simple_name: '聂荣',
                        hidden: 0,
                    },
                    {
                        code: '542425',
                        name: '安多县',
                        simple_name: '安多',
                        hidden: 0,
                    },
                    {
                        code: '542426',
                        name: '申扎县',
                        simple_name: '申扎',
                        hidden: 0,
                    },
                    {
                        code: '542427',
                        name: '索县',
                        simple_name: '索县',
                        hidden: 0,
                    },
                    {
                        code: '542428',
                        name: '班戈县',
                        simple_name: '班戈',
                        hidden: 0,
                    },
                    {
                        code: '542429',
                        name: '巴青县',
                        simple_name: '巴青',
                        hidden: 0,
                    },
                    {
                        code: '542430',
                        name: '尼玛县',
                        simple_name: '尼玛',
                        hidden: 0,
                    },
                    {
                        code: '542431',
                        name: '双湖县',
                        simple_name: '双湖',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '542500',
                name: '阿里地区',
                simple_name: '阿里',
                hidden: 0,
                districts: [
                    {
                        code: '542521',
                        name: '普兰县',
                        simple_name: '普兰',
                        hidden: 0,
                    },
                    {
                        code: '542522',
                        name: '札达县',
                        simple_name: '札达',
                        hidden: 0,
                    },
                    {
                        code: '542523',
                        name: '噶尔县',
                        simple_name: '噶尔',
                        hidden: 0,
                    },
                    {
                        code: '542524',
                        name: '日土县',
                        simple_name: '日土',
                        hidden: 0,
                    },
                    {
                        code: '542525',
                        name: '革吉县',
                        simple_name: '革吉',
                        hidden: 0,
                    },
                    {
                        code: '542526',
                        name: '改则县',
                        simple_name: '改则',
                        hidden: 0,
                    },
                    {
                        code: '542527',
                        name: '措勤县',
                        simple_name: '措勤',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '542600',
                name: '林芝地区',
                simple_name: '林芝',
                hidden: 0,
                districts: [
                    {
                        code: '542621',
                        name: '林芝县',
                        simple_name: '林芝',
                        hidden: 0,
                    },
                    {
                        code: '542622',
                        name: '工布江达县',
                        simple_name: '工布江达',
                        hidden: 0,
                    },
                    {
                        code: '542623',
                        name: '米林县',
                        simple_name: '米林',
                        hidden: 0,
                    },
                    {
                        code: '542624',
                        name: '墨脱县',
                        simple_name: '墨脱',
                        hidden: 0,
                    },
                    {
                        code: '542625',
                        name: '波密县',
                        simple_name: '波密',
                        hidden: 0,
                    },
                    {
                        code: '542626',
                        name: '察隅县',
                        simple_name: '察隅',
                        hidden: 0,
                    },
                    {
                        code: '542627',
                        name: '朗县',
                        simple_name: '朗县',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '610000',
        name: '陕西省',
        simple_name: '陕西',
        hidden: 0,
        cities: [
            {
                code: '610100',
                name: '西安市',
                simple_name: '西安',
                hidden: 0,
                districts: [
                    {
                        code: '610102',
                        name: '新城区',
                        simple_name: '新城',
                        hidden: 0,
                    },
                    {
                        code: '610103',
                        name: '碑林区',
                        simple_name: '碑林',
                        hidden: 0,
                    },
                    {
                        code: '610104',
                        name: '莲湖区',
                        simple_name: '莲湖',
                        hidden: 0,
                    },
                    {
                        code: '610111',
                        name: '灞桥区',
                        simple_name: '灞桥',
                        hidden: 0,
                    },
                    {
                        code: '610112',
                        name: '未央区',
                        simple_name: '未央',
                        hidden: 0,
                    },
                    {
                        code: '610113',
                        name: '雁塔区',
                        simple_name: '雁塔',
                        hidden: 0,
                    },
                    {
                        code: '610114',
                        name: '阎良区',
                        simple_name: '阎良',
                        hidden: 0,
                    },
                    {
                        code: '610115',
                        name: '临潼区',
                        simple_name: '临潼',
                        hidden: 0,
                    },
                    {
                        code: '610116',
                        name: '长安区',
                        simple_name: '长安',
                        hidden: 0,
                    },
                    {
                        code: '610122',
                        name: '蓝田县',
                        simple_name: '蓝田',
                        hidden: 0,
                    },
                    {
                        code: '610124',
                        name: '周至县',
                        simple_name: '周至',
                        hidden: 0,
                    },
                    {
                        code: '610125',
                        name: '户县',
                        simple_name: '户县',
                        hidden: 0,
                    },
                    {
                        code: '610126',
                        name: '高陵区',
                        simple_name: '高陵',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610200',
                name: '铜川市',
                simple_name: '铜川',
                hidden: 0,
                districts: [
                    {
                        code: '610202',
                        name: '王益区',
                        simple_name: '王益',
                        hidden: 0,
                    },
                    {
                        code: '610203',
                        name: '印台区',
                        simple_name: '印台',
                        hidden: 0,
                    },
                    {
                        code: '610204',
                        name: '耀州区',
                        simple_name: '耀州',
                        hidden: 0,
                    },
                    {
                        code: '610222',
                        name: '宜君县',
                        simple_name: '宜君',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610300',
                name: '宝鸡市',
                simple_name: '宝鸡',
                hidden: 0,
                districts: [
                    {
                        code: '610302',
                        name: '渭滨区',
                        simple_name: '渭滨',
                        hidden: 0,
                    },
                    {
                        code: '610303',
                        name: '金台区',
                        simple_name: '金台',
                        hidden: 0,
                    },
                    {
                        code: '610304',
                        name: '陈仓区',
                        simple_name: '陈仓',
                        hidden: 0,
                    },
                    {
                        code: '610322',
                        name: '凤翔县',
                        simple_name: '凤翔',
                        hidden: 0,
                    },
                    {
                        code: '610323',
                        name: '岐山县',
                        simple_name: '岐山',
                        hidden: 0,
                    },
                    {
                        code: '610324',
                        name: '扶风县',
                        simple_name: '扶风',
                        hidden: 0,
                    },
                    {
                        code: '610326',
                        name: '眉县',
                        simple_name: '眉县',
                        hidden: 0,
                    },
                    {
                        code: '610327',
                        name: '陇县',
                        simple_name: '陇县',
                        hidden: 0,
                    },
                    {
                        code: '610328',
                        name: '千阳县',
                        simple_name: '千阳',
                        hidden: 0,
                    },
                    {
                        code: '610329',
                        name: '麟游县',
                        simple_name: '麟游',
                        hidden: 0,
                    },
                    {
                        code: '610330',
                        name: '凤县',
                        simple_name: '凤县',
                        hidden: 0,
                    },
                    {
                        code: '610331',
                        name: '太白县',
                        simple_name: '太白',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610400',
                name: '咸阳市',
                simple_name: '咸阳',
                hidden: 0,
                districts: [
                    {
                        code: '610402',
                        name: '秦都区',
                        simple_name: '秦都',
                        hidden: 0,
                    },
                    {
                        code: '610403',
                        name: '杨陵区',
                        simple_name: '杨陵',
                        hidden: 0,
                    },
                    {
                        code: '610404',
                        name: '渭城区',
                        simple_name: '渭城',
                        hidden: 0,
                    },
                    {
                        code: '610422',
                        name: '三原县',
                        simple_name: '三原',
                        hidden: 0,
                    },
                    {
                        code: '610423',
                        name: '泾阳县',
                        simple_name: '泾阳',
                        hidden: 0,
                    },
                    {
                        code: '610424',
                        name: '乾县',
                        simple_name: '乾县',
                        hidden: 0,
                    },
                    {
                        code: '610425',
                        name: '礼泉县',
                        simple_name: '礼泉',
                        hidden: 0,
                    },
                    {
                        code: '610426',
                        name: '永寿县',
                        simple_name: '永寿',
                        hidden: 0,
                    },
                    {
                        code: '610427',
                        name: '彬县',
                        simple_name: '彬县',
                        hidden: 0,
                    },
                    {
                        code: '610428',
                        name: '长武县',
                        simple_name: '长武',
                        hidden: 0,
                    },
                    {
                        code: '610429',
                        name: '旬邑县',
                        simple_name: '旬邑',
                        hidden: 0,
                    },
                    {
                        code: '610430',
                        name: '淳化县',
                        simple_name: '淳化',
                        hidden: 0,
                    },
                    {
                        code: '610431',
                        name: '武功县',
                        simple_name: '武功',
                        hidden: 0,
                    },
                    {
                        code: '610481',
                        name: '兴平市',
                        simple_name: '兴平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610500',
                name: '渭南市',
                simple_name: '渭南',
                hidden: 0,
                districts: [
                    {
                        code: '610502',
                        name: '临渭区',
                        simple_name: '临渭',
                        hidden: 0,
                    },
                    {
                        code: '610521',
                        name: '华县',
                        simple_name: '华县',
                        hidden: 0,
                    },
                    {
                        code: '610522',
                        name: '潼关县',
                        simple_name: '潼关',
                        hidden: 0,
                    },
                    {
                        code: '610523',
                        name: '大荔县',
                        simple_name: '大荔',
                        hidden: 0,
                    },
                    {
                        code: '610524',
                        name: '合阳县',
                        simple_name: '合阳',
                        hidden: 0,
                    },
                    {
                        code: '610525',
                        name: '澄城县',
                        simple_name: '澄城',
                        hidden: 0,
                    },
                    {
                        code: '610526',
                        name: '蒲城县',
                        simple_name: '蒲城',
                        hidden: 0,
                    },
                    {
                        code: '610527',
                        name: '白水县',
                        simple_name: '白水',
                        hidden: 0,
                    },
                    {
                        code: '610528',
                        name: '富平县',
                        simple_name: '富平',
                        hidden: 0,
                    },
                    {
                        code: '610581',
                        name: '韩城市',
                        simple_name: '韩城',
                        hidden: 0,
                    },
                    {
                        code: '610582',
                        name: '华阴市',
                        simple_name: '华阴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610600',
                name: '延安市',
                simple_name: '延安',
                hidden: 0,
                districts: [
                    {
                        code: '610602',
                        name: '宝塔区',
                        simple_name: '宝塔',
                        hidden: 0,
                    },
                    {
                        code: '610621',
                        name: '延长县',
                        simple_name: '延长',
                        hidden: 0,
                    },
                    {
                        code: '610622',
                        name: '延川县',
                        simple_name: '延川',
                        hidden: 0,
                    },
                    {
                        code: '610623',
                        name: '子长县',
                        simple_name: '子长',
                        hidden: 0,
                    },
                    {
                        code: '610624',
                        name: '安塞县',
                        simple_name: '安塞',
                        hidden: 0,
                    },
                    {
                        code: '610625',
                        name: '志丹县',
                        simple_name: '志丹',
                        hidden: 0,
                    },
                    {
                        code: '610626',
                        name: '吴起县',
                        simple_name: '吴起',
                        hidden: 0,
                    },
                    {
                        code: '610627',
                        name: '甘泉县',
                        simple_name: '甘泉',
                        hidden: 0,
                    },
                    {
                        code: '610628',
                        name: '富县',
                        simple_name: '富县',
                        hidden: 0,
                    },
                    {
                        code: '610629',
                        name: '洛川县',
                        simple_name: '洛川',
                        hidden: 0,
                    },
                    {
                        code: '610630',
                        name: '宜川县',
                        simple_name: '宜川',
                        hidden: 0,
                    },
                    {
                        code: '610631',
                        name: '黄龙县',
                        simple_name: '黄龙',
                        hidden: 0,
                    },
                    {
                        code: '610632',
                        name: '黄陵县',
                        simple_name: '黄陵',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610700',
                name: '汉中市',
                simple_name: '汉中',
                hidden: 0,
                districts: [
                    {
                        code: '610702',
                        name: '汉台区',
                        simple_name: '汉台',
                        hidden: 0,
                    },
                    {
                        code: '610721',
                        name: '南郑县',
                        simple_name: '南郑',
                        hidden: 0,
                    },
                    {
                        code: '610722',
                        name: '城固县',
                        simple_name: '城固',
                        hidden: 0,
                    },
                    {
                        code: '610723',
                        name: '洋县',
                        simple_name: '洋县',
                        hidden: 0,
                    },
                    {
                        code: '610724',
                        name: '西乡县',
                        simple_name: '西乡',
                        hidden: 0,
                    },
                    {
                        code: '610725',
                        name: '勉县',
                        simple_name: '勉县',
                        hidden: 0,
                    },
                    {
                        code: '610726',
                        name: '宁强县',
                        simple_name: '宁强',
                        hidden: 0,
                    },
                    {
                        code: '610727',
                        name: '略阳县',
                        simple_name: '略阳',
                        hidden: 0,
                    },
                    {
                        code: '610728',
                        name: '镇巴县',
                        simple_name: '镇巴',
                        hidden: 0,
                    },
                    {
                        code: '610729',
                        name: '留坝县',
                        simple_name: '留坝',
                        hidden: 0,
                    },
                    {
                        code: '610730',
                        name: '佛坪县',
                        simple_name: '佛坪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610800',
                name: '榆林市',
                simple_name: '榆林',
                hidden: 0,
                districts: [
                    {
                        code: '610802',
                        name: '榆阳区',
                        simple_name: '榆阳',
                        hidden: 0,
                    },
                    {
                        code: '610821',
                        name: '神木县',
                        simple_name: '神木',
                        hidden: 0,
                    },
                    {
                        code: '610822',
                        name: '府谷县',
                        simple_name: '府谷',
                        hidden: 0,
                    },
                    {
                        code: '610823',
                        name: '横山县',
                        simple_name: '横山',
                        hidden: 0,
                    },
                    {
                        code: '610824',
                        name: '靖边县',
                        simple_name: '靖边',
                        hidden: 0,
                    },
                    {
                        code: '610825',
                        name: '定边县',
                        simple_name: '定边',
                        hidden: 0,
                    },
                    {
                        code: '610826',
                        name: '绥德县',
                        simple_name: '绥德',
                        hidden: 0,
                    },
                    {
                        code: '610827',
                        name: '米脂县',
                        simple_name: '米脂',
                        hidden: 0,
                    },
                    {
                        code: '610828',
                        name: '佳县',
                        simple_name: '佳县',
                        hidden: 0,
                    },
                    {
                        code: '610829',
                        name: '吴堡县',
                        simple_name: '吴堡',
                        hidden: 0,
                    },
                    {
                        code: '610830',
                        name: '清涧县',
                        simple_name: '清涧',
                        hidden: 0,
                    },
                    {
                        code: '610831',
                        name: '子洲县',
                        simple_name: '子洲',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '610900',
                name: '安康市',
                simple_name: '安康',
                hidden: 0,
                districts: [
                    {
                        code: '610902',
                        name: '汉滨区',
                        simple_name: '汉滨',
                        hidden: 0,
                    },
                    {
                        code: '610921',
                        name: '汉阴县',
                        simple_name: '汉阴',
                        hidden: 0,
                    },
                    {
                        code: '610922',
                        name: '石泉县',
                        simple_name: '石泉',
                        hidden: 0,
                    },
                    {
                        code: '610923',
                        name: '宁陕县',
                        simple_name: '宁陕',
                        hidden: 0,
                    },
                    {
                        code: '610924',
                        name: '紫阳县',
                        simple_name: '紫阳',
                        hidden: 0,
                    },
                    {
                        code: '610925',
                        name: '岚皋县',
                        simple_name: '岚皋',
                        hidden: 0,
                    },
                    {
                        code: '610926',
                        name: '平利县',
                        simple_name: '平利',
                        hidden: 0,
                    },
                    {
                        code: '610927',
                        name: '镇坪县',
                        simple_name: '镇坪',
                        hidden: 0,
                    },
                    {
                        code: '610928',
                        name: '旬阳县',
                        simple_name: '旬阳',
                        hidden: 0,
                    },
                    {
                        code: '610929',
                        name: '白河县',
                        simple_name: '白河',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '611000',
                name: '商洛市',
                simple_name: '商洛',
                hidden: 0,
                districts: [
                    {
                        code: '611002',
                        name: '商州区',
                        simple_name: '商州',
                        hidden: 0,
                    },
                    {
                        code: '611021',
                        name: '洛南县',
                        simple_name: '洛南',
                        hidden: 0,
                    },
                    {
                        code: '611022',
                        name: '丹凤县',
                        simple_name: '丹凤',
                        hidden: 0,
                    },
                    {
                        code: '611023',
                        name: '商南县',
                        simple_name: '商南',
                        hidden: 0,
                    },
                    {
                        code: '611024',
                        name: '山阳县',
                        simple_name: '山阳',
                        hidden: 0,
                    },
                    {
                        code: '611025',
                        name: '镇安县',
                        simple_name: '镇安',
                        hidden: 0,
                    },
                    {
                        code: '611026',
                        name: '柞水县',
                        simple_name: '柞水',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '611100',
                name: '西咸新区',
                simple_name: '西咸',
                hidden: 0,
                districts: [
                    {
                        code: '611101',
                        name: '空港新城',
                        simple_name: '空港',
                        hidden: 0,
                    },
                    {
                        code: '611102',
                        name: '沣东新城',
                        simple_name: '沣东',
                        hidden: 0,
                    },
                    {
                        code: '611103',
                        name: '秦汉新城',
                        simple_name: '秦汉',
                        hidden: 0,
                    },
                    {
                        code: '611104',
                        name: '沣西新城',
                        simple_name: '沣西',
                        hidden: 0,
                    },
                    {
                        code: '611105',
                        name: '泾河新城',
                        simple_name: '泾河',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '620000',
        name: '甘肃省',
        simple_name: '甘肃',
        hidden: 0,
        cities: [
            {
                code: '620100',
                name: '兰州市',
                simple_name: '兰州',
                hidden: 0,
                districts: [
                    {
                        code: '620102',
                        name: '城关区',
                        simple_name: '城关',
                        hidden: 0,
                    },
                    {
                        code: '620103',
                        name: '七里河区',
                        simple_name: '七里河',
                        hidden: 0,
                    },
                    {
                        code: '620104',
                        name: '西固区',
                        simple_name: '西固',
                        hidden: 0,
                    },
                    {
                        code: '620105',
                        name: '安宁区',
                        simple_name: '安宁',
                        hidden: 0,
                    },
                    {
                        code: '620111',
                        name: '红古区',
                        simple_name: '红古',
                        hidden: 0,
                    },
                    {
                        code: '620121',
                        name: '永登县',
                        simple_name: '永登',
                        hidden: 0,
                    },
                    {
                        code: '620122',
                        name: '皋兰县',
                        simple_name: '皋兰',
                        hidden: 0,
                    },
                    {
                        code: '620123',
                        name: '榆中县',
                        simple_name: '榆中',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620200',
                name: '嘉峪关市',
                simple_name: '嘉峪关',
                hidden: 0,
                districts: [
                    {
                        code: '620201',
                        name: '雄关区',
                        simple_name: '雄关',
                        hidden: 0,
                    },
                    {
                        code: '620202',
                        name: '长城区',
                        simple_name: '长城',
                        hidden: 0,
                    },
                    {
                        code: '620203',
                        name: '镜铁区',
                        simple_name: '镜铁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620300',
                name: '金昌市',
                simple_name: '金昌',
                hidden: 0,
                districts: [
                    {
                        code: '620302',
                        name: '金川区',
                        simple_name: '金川',
                        hidden: 0,
                    },
                    {
                        code: '620321',
                        name: '永昌县',
                        simple_name: '永昌',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620400',
                name: '白银市',
                simple_name: '白银',
                hidden: 0,
                districts: [
                    {
                        code: '620402',
                        name: '白银区',
                        simple_name: '白银',
                        hidden: 0,
                    },
                    {
                        code: '620403',
                        name: '平川区',
                        simple_name: '平川',
                        hidden: 0,
                    },
                    {
                        code: '620421',
                        name: '靖远县',
                        simple_name: '靖远',
                        hidden: 0,
                    },
                    {
                        code: '620422',
                        name: '会宁县',
                        simple_name: '会宁',
                        hidden: 0,
                    },
                    {
                        code: '620423',
                        name: '景泰县',
                        simple_name: '景泰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620500',
                name: '天水市',
                simple_name: '天水',
                hidden: 0,
                districts: [
                    {
                        code: '620502',
                        name: '秦州区',
                        simple_name: '秦州',
                        hidden: 0,
                    },
                    {
                        code: '620503',
                        name: '麦积区',
                        simple_name: '麦积',
                        hidden: 0,
                    },
                    {
                        code: '620521',
                        name: '清水县',
                        simple_name: '清水',
                        hidden: 0,
                    },
                    {
                        code: '620522',
                        name: '秦安县',
                        simple_name: '秦安',
                        hidden: 0,
                    },
                    {
                        code: '620523',
                        name: '甘谷县',
                        simple_name: '甘谷',
                        hidden: 0,
                    },
                    {
                        code: '620524',
                        name: '武山县',
                        simple_name: '武山',
                        hidden: 0,
                    },
                    {
                        code: '620525',
                        name: '张家川回族自治县',
                        simple_name: '张家川',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620600',
                name: '武威市',
                simple_name: '武威',
                hidden: 0,
                districts: [
                    {
                        code: '620602',
                        name: '凉州区',
                        simple_name: '凉州',
                        hidden: 0,
                    },
                    {
                        code: '620621',
                        name: '民勤县',
                        simple_name: '民勤',
                        hidden: 0,
                    },
                    {
                        code: '620622',
                        name: '古浪县',
                        simple_name: '古浪',
                        hidden: 0,
                    },
                    {
                        code: '620623',
                        name: '天祝藏族自治县',
                        simple_name: '天祝',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620700',
                name: '张掖市',
                simple_name: '张掖',
                hidden: 0,
                districts: [
                    {
                        code: '620702',
                        name: '甘州区',
                        simple_name: '甘州',
                        hidden: 0,
                    },
                    {
                        code: '620721',
                        name: '肃南裕固族自治县',
                        simple_name: '肃南',
                        hidden: 0,
                    },
                    {
                        code: '620722',
                        name: '民乐县',
                        simple_name: '民乐',
                        hidden: 0,
                    },
                    {
                        code: '620723',
                        name: '临泽县',
                        simple_name: '临泽',
                        hidden: 0,
                    },
                    {
                        code: '620724',
                        name: '高台县',
                        simple_name: '高台',
                        hidden: 0,
                    },
                    {
                        code: '620725',
                        name: '山丹县',
                        simple_name: '山丹',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620800',
                name: '平凉市',
                simple_name: '平凉',
                hidden: 0,
                districts: [
                    {
                        code: '620802',
                        name: '崆峒区',
                        simple_name: '崆峒',
                        hidden: 0,
                    },
                    {
                        code: '620821',
                        name: '泾川县',
                        simple_name: '泾川',
                        hidden: 0,
                    },
                    {
                        code: '620822',
                        name: '灵台县',
                        simple_name: '灵台',
                        hidden: 0,
                    },
                    {
                        code: '620823',
                        name: '崇信县',
                        simple_name: '崇信',
                        hidden: 0,
                    },
                    {
                        code: '620824',
                        name: '华亭县',
                        simple_name: '华亭',
                        hidden: 0,
                    },
                    {
                        code: '620825',
                        name: '庄浪县',
                        simple_name: '庄浪',
                        hidden: 0,
                    },
                    {
                        code: '620826',
                        name: '静宁县',
                        simple_name: '静宁',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '620900',
                name: '酒泉市',
                simple_name: '酒泉',
                hidden: 0,
                districts: [
                    {
                        code: '620902',
                        name: '肃州区',
                        simple_name: '肃州',
                        hidden: 0,
                    },
                    {
                        code: '620921',
                        name: '金塔县',
                        simple_name: '金塔',
                        hidden: 0,
                    },
                    {
                        code: '620922',
                        name: '瓜州县',
                        simple_name: '瓜州',
                        hidden: 0,
                    },
                    {
                        code: '620923',
                        name: '肃北蒙古族自治县',
                        simple_name: '肃北',
                        hidden: 0,
                    },
                    {
                        code: '620924',
                        name: '阿克塞哈萨克族自治县',
                        simple_name: '阿克塞',
                        hidden: 0,
                    },
                    {
                        code: '620981',
                        name: '玉门市',
                        simple_name: '玉门',
                        hidden: 0,
                    },
                    {
                        code: '620982',
                        name: '敦煌市',
                        simple_name: '敦煌',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '621000',
                name: '庆阳市',
                simple_name: '庆阳',
                hidden: 0,
                districts: [
                    {
                        code: '621002',
                        name: '西峰区',
                        simple_name: '西峰',
                        hidden: 0,
                    },
                    {
                        code: '621021',
                        name: '庆城县',
                        simple_name: '庆城',
                        hidden: 0,
                    },
                    {
                        code: '621022',
                        name: '环县',
                        simple_name: '环县',
                        hidden: 0,
                    },
                    {
                        code: '621023',
                        name: '华池县',
                        simple_name: '华池',
                        hidden: 0,
                    },
                    {
                        code: '621024',
                        name: '合水县',
                        simple_name: '合水',
                        hidden: 0,
                    },
                    {
                        code: '621025',
                        name: '正宁县',
                        simple_name: '正宁',
                        hidden: 0,
                    },
                    {
                        code: '621026',
                        name: '宁县',
                        simple_name: '宁县',
                        hidden: 0,
                    },
                    {
                        code: '621027',
                        name: '镇原县',
                        simple_name: '镇原',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '621100',
                name: '定西市',
                simple_name: '定西',
                hidden: 0,
                districts: [
                    {
                        code: '621102',
                        name: '安定区',
                        simple_name: '安定',
                        hidden: 0,
                    },
                    {
                        code: '621121',
                        name: '通渭县',
                        simple_name: '通渭',
                        hidden: 0,
                    },
                    {
                        code: '621122',
                        name: '陇西县',
                        simple_name: '陇西',
                        hidden: 0,
                    },
                    {
                        code: '621123',
                        name: '渭源县',
                        simple_name: '渭源',
                        hidden: 0,
                    },
                    {
                        code: '621124',
                        name: '临洮县',
                        simple_name: '临洮',
                        hidden: 0,
                    },
                    {
                        code: '621125',
                        name: '漳县',
                        simple_name: '漳县',
                        hidden: 0,
                    },
                    {
                        code: '621126',
                        name: '岷县',
                        simple_name: '岷县',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '621200',
                name: '陇南市',
                simple_name: '陇南',
                hidden: 0,
                districts: [
                    {
                        code: '621202',
                        name: '武都区',
                        simple_name: '武都',
                        hidden: 0,
                    },
                    {
                        code: '621221',
                        name: '成县',
                        simple_name: '成县',
                        hidden: 0,
                    },
                    {
                        code: '621222',
                        name: '文县',
                        simple_name: '文县',
                        hidden: 0,
                    },
                    {
                        code: '621223',
                        name: '宕昌县',
                        simple_name: '宕昌',
                        hidden: 0,
                    },
                    {
                        code: '621224',
                        name: '康县',
                        simple_name: '康县',
                        hidden: 0,
                    },
                    {
                        code: '621225',
                        name: '西和县',
                        simple_name: '西和',
                        hidden: 0,
                    },
                    {
                        code: '621226',
                        name: '礼县',
                        simple_name: '礼县',
                        hidden: 0,
                    },
                    {
                        code: '621227',
                        name: '徽县',
                        simple_name: '徽县',
                        hidden: 0,
                    },
                    {
                        code: '621228',
                        name: '两当县',
                        simple_name: '两当',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '622900',
                name: '临夏回族自治州',
                simple_name: '临夏',
                hidden: 0,
                districts: [
                    {
                        code: '622901',
                        name: '临夏市',
                        simple_name: '临夏',
                        hidden: 0,
                    },
                    {
                        code: '622921',
                        name: '临夏县',
                        simple_name: '临夏',
                        hidden: 0,
                    },
                    {
                        code: '622922',
                        name: '康乐县',
                        simple_name: '康乐',
                        hidden: 0,
                    },
                    {
                        code: '622923',
                        name: '永靖县',
                        simple_name: '永靖',
                        hidden: 0,
                    },
                    {
                        code: '622924',
                        name: '广河县',
                        simple_name: '广河',
                        hidden: 0,
                    },
                    {
                        code: '622925',
                        name: '和政县',
                        simple_name: '和政',
                        hidden: 0,
                    },
                    {
                        code: '622926',
                        name: '东乡族自治县',
                        simple_name: '东乡族',
                        hidden: 0,
                    },
                    {
                        code: '622927',
                        name: '积石山保安族东乡族撒拉族自治县',
                        simple_name: '积石山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '623000',
                name: '甘南藏族自治州',
                simple_name: '甘南',
                hidden: 0,
                districts: [
                    {
                        code: '623001',
                        name: '合作市',
                        simple_name: '合作',
                        hidden: 0,
                    },
                    {
                        code: '623021',
                        name: '临潭县',
                        simple_name: '临潭',
                        hidden: 0,
                    },
                    {
                        code: '623022',
                        name: '卓尼县',
                        simple_name: '卓尼',
                        hidden: 0,
                    },
                    {
                        code: '623023',
                        name: '舟曲县',
                        simple_name: '舟曲',
                        hidden: 0,
                    },
                    {
                        code: '623024',
                        name: '迭部县',
                        simple_name: '迭部',
                        hidden: 0,
                    },
                    {
                        code: '623025',
                        name: '玛曲县',
                        simple_name: '玛曲',
                        hidden: 0,
                    },
                    {
                        code: '623026',
                        name: '碌曲县',
                        simple_name: '碌曲',
                        hidden: 0,
                    },
                    {
                        code: '623027',
                        name: '夏河县',
                        simple_name: '夏河',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '630000',
        name: '青海省',
        simple_name: '青海',
        hidden: 0,
        cities: [
            {
                code: '630100',
                name: '西宁市',
                simple_name: '西宁',
                hidden: 0,
                districts: [
                    {
                        code: '630102',
                        name: '城东区',
                        simple_name: '城东',
                        hidden: 0,
                    },
                    {
                        code: '630103',
                        name: '城中区',
                        simple_name: '城中',
                        hidden: 0,
                    },
                    {
                        code: '630104',
                        name: '城西区',
                        simple_name: '城西',
                        hidden: 0,
                    },
                    {
                        code: '630105',
                        name: '城北区',
                        simple_name: '城北',
                        hidden: 0,
                    },
                    {
                        code: '630121',
                        name: '大通回族土族自治县',
                        simple_name: '大通',
                        hidden: 0,
                    },
                    {
                        code: '630122',
                        name: '湟中县',
                        simple_name: '湟中',
                        hidden: 0,
                    },
                    {
                        code: '630123',
                        name: '湟源县',
                        simple_name: '湟源',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '630200',
                name: '海东市',
                simple_name: '海东',
                hidden: 0,
                districts: [
                    {
                        code: '630202',
                        name: '乐都区',
                        simple_name: '乐都',
                        hidden: 0,
                    },
                    {
                        code: '630221',
                        name: '平安县',
                        simple_name: '平安',
                        hidden: 0,
                    },
                    {
                        code: '630222',
                        name: '民和回族土族自治县',
                        simple_name: '民和',
                        hidden: 0,
                    },
                    {
                        code: '630223',
                        name: '互助土族自治县',
                        simple_name: '互助',
                        hidden: 0,
                    },
                    {
                        code: '630224',
                        name: '化隆回族自治县',
                        simple_name: '化隆',
                        hidden: 0,
                    },
                    {
                        code: '630225',
                        name: '循化撒拉族自治县',
                        simple_name: '循化',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '632200',
                name: '海北藏族自治州',
                simple_name: '海北',
                hidden: 0,
                districts: [
                    {
                        code: '632221',
                        name: '门源回族自治县',
                        simple_name: '门源',
                        hidden: 0,
                    },
                    {
                        code: '632222',
                        name: '祁连县',
                        simple_name: '祁连',
                        hidden: 0,
                    },
                    {
                        code: '632223',
                        name: '海晏县',
                        simple_name: '海晏',
                        hidden: 0,
                    },
                    {
                        code: '632224',
                        name: '刚察县',
                        simple_name: '刚察',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '632300',
                name: '黄南藏族自治州',
                simple_name: '黄南',
                hidden: 0,
                districts: [
                    {
                        code: '632321',
                        name: '同仁县',
                        simple_name: '同仁',
                        hidden: 0,
                    },
                    {
                        code: '632322',
                        name: '尖扎县',
                        simple_name: '尖扎',
                        hidden: 0,
                    },
                    {
                        code: '632323',
                        name: '泽库县',
                        simple_name: '泽库',
                        hidden: 0,
                    },
                    {
                        code: '632324',
                        name: '河南蒙古族自治县',
                        simple_name: '河南',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '632500',
                name: '海南藏族自治州',
                simple_name: '海南',
                hidden: 0,
                districts: [
                    {
                        code: '632521',
                        name: '共和县',
                        simple_name: '共和',
                        hidden: 0,
                    },
                    {
                        code: '632522',
                        name: '同德县',
                        simple_name: '同德',
                        hidden: 0,
                    },
                    {
                        code: '632523',
                        name: '贵德县',
                        simple_name: '贵德',
                        hidden: 0,
                    },
                    {
                        code: '632524',
                        name: '兴海县',
                        simple_name: '兴海',
                        hidden: 0,
                    },
                    {
                        code: '632525',
                        name: '贵南县',
                        simple_name: '贵南',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '632600',
                name: '果洛藏族自治州',
                simple_name: '果洛',
                hidden: 0,
                districts: [
                    {
                        code: '632621',
                        name: '玛沁县',
                        simple_name: '玛沁',
                        hidden: 0,
                    },
                    {
                        code: '632622',
                        name: '班玛县',
                        simple_name: '班玛',
                        hidden: 0,
                    },
                    {
                        code: '632623',
                        name: '甘德县',
                        simple_name: '甘德',
                        hidden: 0,
                    },
                    {
                        code: '632624',
                        name: '达日县',
                        simple_name: '达日',
                        hidden: 0,
                    },
                    {
                        code: '632625',
                        name: '久治县',
                        simple_name: '久治',
                        hidden: 0,
                    },
                    {
                        code: '632626',
                        name: '玛多县',
                        simple_name: '玛多',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '632700',
                name: '玉树藏族自治州',
                simple_name: '玉树',
                hidden: 0,
                districts: [
                    {
                        code: '632701',
                        name: '玉树市',
                        simple_name: '玉树',
                        hidden: 0,
                    },
                    {
                        code: '632722',
                        name: '杂多县',
                        simple_name: '杂多',
                        hidden: 0,
                    },
                    {
                        code: '632723',
                        name: '称多县',
                        simple_name: '称多',
                        hidden: 0,
                    },
                    {
                        code: '632724',
                        name: '治多县',
                        simple_name: '治多',
                        hidden: 0,
                    },
                    {
                        code: '632725',
                        name: '囊谦县',
                        simple_name: '囊谦',
                        hidden: 0,
                    },
                    {
                        code: '632726',
                        name: '曲麻莱县',
                        simple_name: '曲麻莱',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '632800',
                name: '海西蒙古族藏族自治州',
                simple_name: '海西',
                hidden: 0,
                districts: [
                    {
                        code: '632801',
                        name: '格尔木市',
                        simple_name: '格尔木',
                        hidden: 0,
                    },
                    {
                        code: '632802',
                        name: '德令哈市',
                        simple_name: '德令哈',
                        hidden: 0,
                    },
                    {
                        code: '632821',
                        name: '乌兰县',
                        simple_name: '乌兰',
                        hidden: 0,
                    },
                    {
                        code: '632822',
                        name: '都兰县',
                        simple_name: '都兰',
                        hidden: 0,
                    },
                    {
                        code: '632823',
                        name: '天峻县',
                        simple_name: '天峻',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '640000',
        name: '宁夏回族自治区',
        simple_name: '宁夏',
        hidden: 0,
        cities: [
            {
                code: '640100',
                name: '银川市',
                simple_name: '银川',
                hidden: 0,
                districts: [
                    {
                        code: '640104',
                        name: '兴庆区',
                        simple_name: '兴庆',
                        hidden: 0,
                    },
                    {
                        code: '640105',
                        name: '西夏区',
                        simple_name: '西夏',
                        hidden: 0,
                    },
                    {
                        code: '640106',
                        name: '金凤区',
                        simple_name: '金凤',
                        hidden: 0,
                    },
                    {
                        code: '640121',
                        name: '永宁县',
                        simple_name: '永宁',
                        hidden: 0,
                    },
                    {
                        code: '640122',
                        name: '贺兰县',
                        simple_name: '贺兰',
                        hidden: 0,
                    },
                    {
                        code: '640181',
                        name: '灵武市',
                        simple_name: '灵武',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '640200',
                name: '石嘴山市',
                simple_name: '石嘴山',
                hidden: 0,
                districts: [
                    {
                        code: '640202',
                        name: '大武口区',
                        simple_name: '大武口',
                        hidden: 0,
                    },
                    {
                        code: '640205',
                        name: '惠农区',
                        simple_name: '惠农',
                        hidden: 0,
                    },
                    {
                        code: '640221',
                        name: '平罗县',
                        simple_name: '平罗',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '640300',
                name: '吴忠市',
                simple_name: '吴忠',
                hidden: 0,
                districts: [
                    {
                        code: '640302',
                        name: '利通区',
                        simple_name: '利通',
                        hidden: 0,
                    },
                    {
                        code: '640303',
                        name: '红寺堡区',
                        simple_name: '红寺堡',
                        hidden: 0,
                    },
                    {
                        code: '640323',
                        name: '盐池县',
                        simple_name: '盐池',
                        hidden: 0,
                    },
                    {
                        code: '640324',
                        name: '同心县',
                        simple_name: '同心',
                        hidden: 0,
                    },
                    {
                        code: '640381',
                        name: '青铜峡市',
                        simple_name: '青铜峡',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '640400',
                name: '固原市',
                simple_name: '固原',
                hidden: 0,
                districts: [
                    {
                        code: '640402',
                        name: '原州区',
                        simple_name: '原州',
                        hidden: 0,
                    },
                    {
                        code: '640422',
                        name: '西吉县',
                        simple_name: '西吉',
                        hidden: 0,
                    },
                    {
                        code: '640423',
                        name: '隆德县',
                        simple_name: '隆德',
                        hidden: 0,
                    },
                    {
                        code: '640424',
                        name: '泾源县',
                        simple_name: '泾源',
                        hidden: 0,
                    },
                    {
                        code: '640425',
                        name: '彭阳县',
                        simple_name: '彭阳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '640500',
                name: '中卫市',
                simple_name: '中卫',
                hidden: 0,
                districts: [
                    {
                        code: '640502',
                        name: '沙坡头区',
                        simple_name: '沙坡头',
                        hidden: 0,
                    },
                    {
                        code: '640521',
                        name: '中宁县',
                        simple_name: '中宁',
                        hidden: 0,
                    },
                    {
                        code: '640522',
                        name: '海原县',
                        simple_name: '海原',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '650000',
        name: '新疆维吾尔自治区',
        simple_name: '新疆',
        hidden: 0,
        cities: [
            {
                code: '650100',
                name: '乌鲁木齐市',
                simple_name: '乌鲁木齐',
                hidden: 0,
                districts: [
                    {
                        code: '650102',
                        name: '天山区',
                        simple_name: '天山',
                        hidden: 0,
                    },
                    {
                        code: '650103',
                        name: '沙依巴克区',
                        simple_name: '沙依巴克',
                        hidden: 0,
                    },
                    {
                        code: '650104',
                        name: '新市区',
                        simple_name: '新市',
                        hidden: 0,
                    },
                    {
                        code: '650105',
                        name: '水磨沟区',
                        simple_name: '水磨沟',
                        hidden: 0,
                    },
                    {
                        code: '650106',
                        name: '头屯河区',
                        simple_name: '头屯河',
                        hidden: 0,
                    },
                    {
                        code: '650107',
                        name: '达坂城区',
                        simple_name: '达坂城',
                        hidden: 0,
                    },
                    {
                        code: '650109',
                        name: '米东区',
                        simple_name: '米东',
                        hidden: 0,
                    },
                    {
                        code: '650121',
                        name: '乌鲁木齐县',
                        simple_name: '乌鲁木齐',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '650200',
                name: '克拉玛依市',
                simple_name: '克拉玛依',
                hidden: 0,
                districts: [
                    {
                        code: '650202',
                        name: '独山子区',
                        simple_name: '独山子',
                        hidden: 0,
                    },
                    {
                        code: '650203',
                        name: '克拉玛依区',
                        simple_name: '克拉玛依',
                        hidden: 0,
                    },
                    {
                        code: '650204',
                        name: '白碱滩区',
                        simple_name: '白碱滩',
                        hidden: 0,
                    },
                    {
                        code: '650205',
                        name: '乌尔禾区',
                        simple_name: '乌尔禾',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '652100',
                name: '吐鲁番地区',
                simple_name: '吐鲁番',
                hidden: 0,
                districts: [
                    {
                        code: '652101',
                        name: '吐鲁番市',
                        simple_name: '吐鲁番',
                        hidden: 0,
                    },
                    {
                        code: '652122',
                        name: '鄯善县',
                        simple_name: '鄯善',
                        hidden: 0,
                    },
                    {
                        code: '652123',
                        name: '托克逊县',
                        simple_name: '托克逊',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '652200',
                name: '哈密地区',
                simple_name: '哈密',
                hidden: 0,
                districts: [
                    {
                        code: '652201',
                        name: '哈密市',
                        simple_name: '哈密',
                        hidden: 0,
                    },
                    {
                        code: '652222',
                        name: '巴里坤哈萨克自治县',
                        simple_name: '巴里坤',
                        hidden: 0,
                    },
                    {
                        code: '652223',
                        name: '伊吾县',
                        simple_name: '伊吾',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '652300',
                name: '昌吉回族自治州',
                simple_name: '昌吉',
                hidden: 0,
                districts: [
                    {
                        code: '652301',
                        name: '昌吉市',
                        simple_name: '昌吉',
                        hidden: 0,
                    },
                    {
                        code: '652302',
                        name: '阜康市',
                        simple_name: '阜康',
                        hidden: 0,
                    },
                    {
                        code: '652323',
                        name: '呼图壁县',
                        simple_name: '呼图壁',
                        hidden: 0,
                    },
                    {
                        code: '652324',
                        name: '玛纳斯县',
                        simple_name: '玛纳斯',
                        hidden: 0,
                    },
                    {
                        code: '652325',
                        name: '奇台县',
                        simple_name: '奇台',
                        hidden: 0,
                    },
                    {
                        code: '652327',
                        name: '吉木萨尔县',
                        simple_name: '吉木萨尔',
                        hidden: 0,
                    },
                    {
                        code: '652328',
                        name: '木垒哈萨克自治县',
                        simple_name: '木垒',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '652700',
                name: '博尔塔拉蒙古自治州',
                simple_name: '博尔塔拉',
                hidden: 0,
                districts: [
                    {
                        code: '652701',
                        name: '博乐市',
                        simple_name: '博乐',
                        hidden: 0,
                    },
                    {
                        code: '652702',
                        name: '阿拉山口市',
                        simple_name: '阿拉山口',
                        hidden: 0,
                    },
                    {
                        code: '652722',
                        name: '精河县',
                        simple_name: '精河',
                        hidden: 0,
                    },
                    {
                        code: '652723',
                        name: '温泉县',
                        simple_name: '温泉',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '652800',
                name: '巴音郭楞蒙古自治州',
                simple_name: '巴音郭楞',
                hidden: 0,
                districts: [
                    {
                        code: '652801',
                        name: '库尔勒市',
                        simple_name: '库尔勒',
                        hidden: 0,
                    },
                    {
                        code: '652822',
                        name: '轮台县',
                        simple_name: '轮台',
                        hidden: 0,
                    },
                    {
                        code: '652823',
                        name: '尉犁县',
                        simple_name: '尉犁',
                        hidden: 0,
                    },
                    {
                        code: '652824',
                        name: '若羌县',
                        simple_name: '若羌',
                        hidden: 0,
                    },
                    {
                        code: '652825',
                        name: '且末县',
                        simple_name: '且末',
                        hidden: 0,
                    },
                    {
                        code: '652826',
                        name: '焉耆回族自治县',
                        simple_name: '焉耆',
                        hidden: 0,
                    },
                    {
                        code: '652827',
                        name: '和静县',
                        simple_name: '和静',
                        hidden: 0,
                    },
                    {
                        code: '652828',
                        name: '和硕县',
                        simple_name: '和硕',
                        hidden: 0,
                    },
                    {
                        code: '652829',
                        name: '博湖县',
                        simple_name: '博湖',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '652900',
                name: '阿克苏地区',
                simple_name: '阿克苏',
                hidden: 0,
                districts: [
                    {
                        code: '652901',
                        name: '阿克苏市',
                        simple_name: '阿克苏',
                        hidden: 0,
                    },
                    {
                        code: '652922',
                        name: '温宿县',
                        simple_name: '温宿',
                        hidden: 0,
                    },
                    {
                        code: '652923',
                        name: '库车县',
                        simple_name: '库车',
                        hidden: 0,
                    },
                    {
                        code: '652924',
                        name: '沙雅县',
                        simple_name: '沙雅',
                        hidden: 0,
                    },
                    {
                        code: '652925',
                        name: '新和县',
                        simple_name: '新和',
                        hidden: 0,
                    },
                    {
                        code: '652926',
                        name: '拜城县',
                        simple_name: '拜城',
                        hidden: 0,
                    },
                    {
                        code: '652927',
                        name: '乌什县',
                        simple_name: '乌什',
                        hidden: 0,
                    },
                    {
                        code: '652928',
                        name: '阿瓦提县',
                        simple_name: '阿瓦提',
                        hidden: 0,
                    },
                    {
                        code: '652929',
                        name: '柯坪县',
                        simple_name: '柯坪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '653000',
                name: '克孜勒苏柯尔克孜自治州',
                simple_name: '克孜勒苏',
                hidden: 0,
                districts: [
                    {
                        code: '653001',
                        name: '阿图什市',
                        simple_name: '阿图什',
                        hidden: 0,
                    },
                    {
                        code: '653022',
                        name: '阿克陶县',
                        simple_name: '阿克陶',
                        hidden: 0,
                    },
                    {
                        code: '653023',
                        name: '阿合奇县',
                        simple_name: '阿合奇',
                        hidden: 0,
                    },
                    {
                        code: '653024',
                        name: '乌恰县',
                        simple_name: '乌恰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '653100',
                name: '喀什地区',
                simple_name: '喀什',
                hidden: 0,
                districts: [
                    {
                        code: '653101',
                        name: '喀什市',
                        simple_name: '喀什',
                        hidden: 0,
                    },
                    {
                        code: '653121',
                        name: '疏附县',
                        simple_name: '疏附',
                        hidden: 0,
                    },
                    {
                        code: '653122',
                        name: '疏勒县',
                        simple_name: '疏勒',
                        hidden: 0,
                    },
                    {
                        code: '653123',
                        name: '英吉沙县',
                        simple_name: '英吉沙',
                        hidden: 0,
                    },
                    {
                        code: '653124',
                        name: '泽普县',
                        simple_name: '泽普',
                        hidden: 0,
                    },
                    {
                        code: '653125',
                        name: '莎车县',
                        simple_name: '莎车',
                        hidden: 0,
                    },
                    {
                        code: '653126',
                        name: '叶城县',
                        simple_name: '叶城',
                        hidden: 0,
                    },
                    {
                        code: '653127',
                        name: '麦盖提县',
                        simple_name: '麦盖提',
                        hidden: 0,
                    },
                    {
                        code: '653128',
                        name: '岳普湖县',
                        simple_name: '岳普湖',
                        hidden: 0,
                    },
                    {
                        code: '653129',
                        name: '伽师县',
                        simple_name: '伽师',
                        hidden: 0,
                    },
                    {
                        code: '653130',
                        name: '巴楚县',
                        simple_name: '巴楚',
                        hidden: 0,
                    },
                    {
                        code: '653131',
                        name: '塔什库尔干塔吉克自治县',
                        simple_name: '塔什库尔干塔吉克',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '653200',
                name: '和田地区',
                simple_name: '和田',
                hidden: 0,
                districts: [
                    {
                        code: '653201',
                        name: '和田市',
                        simple_name: '和田市',
                        hidden: 0,
                    },
                    {
                        code: '653221',
                        name: '和田县',
                        simple_name: '和田县',
                        hidden: 0,
                    },
                    {
                        code: '653222',
                        name: '墨玉县',
                        simple_name: '墨玉',
                        hidden: 0,
                    },
                    {
                        code: '653223',
                        name: '皮山县',
                        simple_name: '皮山',
                        hidden: 0,
                    },
                    {
                        code: '653224',
                        name: '洛浦县',
                        simple_name: '洛浦',
                        hidden: 0,
                    },
                    {
                        code: '653225',
                        name: '策勒县',
                        simple_name: '策勒',
                        hidden: 0,
                    },
                    {
                        code: '653226',
                        name: '于田县',
                        simple_name: '于田',
                        hidden: 0,
                    },
                    {
                        code: '653227',
                        name: '民丰县',
                        simple_name: '民丰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '654000',
                name: '伊犁哈萨克自治州',
                simple_name: '伊犁',
                hidden: 0,
                districts: [
                    {
                        code: '654002',
                        name: '伊宁市',
                        simple_name: '伊宁',
                        hidden: 0,
                    },
                    {
                        code: '654003',
                        name: '奎屯市',
                        simple_name: '奎屯',
                        hidden: 0,
                    },
                    {
                        code: '654004',
                        name: '霍尔果斯市',
                        simple_name: '霍尔果斯',
                        hidden: 0,
                    },
                    {
                        code: '654021',
                        name: '伊宁县',
                        simple_name: '伊宁',
                        hidden: 0,
                    },
                    {
                        code: '654022',
                        name: '察布查尔锡伯自治县',
                        simple_name: '察布查尔锡伯',
                        hidden: 0,
                    },
                    {
                        code: '654023',
                        name: '霍城县',
                        simple_name: '霍城',
                        hidden: 0,
                    },
                    {
                        code: '654024',
                        name: '巩留县',
                        simple_name: '巩留',
                        hidden: 0,
                    },
                    {
                        code: '654025',
                        name: '新源县',
                        simple_name: '新源',
                        hidden: 0,
                    },
                    {
                        code: '654026',
                        name: '昭苏县',
                        simple_name: '昭苏',
                        hidden: 0,
                    },
                    {
                        code: '654027',
                        name: '特克斯县',
                        simple_name: '特克斯',
                        hidden: 0,
                    },
                    {
                        code: '654028',
                        name: '尼勒克县',
                        simple_name: '尼勒克',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '654200',
                name: '塔城地区',
                simple_name: '塔城',
                hidden: 0,
                districts: [
                    {
                        code: '654201',
                        name: '塔城市',
                        simple_name: '塔城',
                        hidden: 0,
                    },
                    {
                        code: '654202',
                        name: '乌苏市',
                        simple_name: '乌苏',
                        hidden: 0,
                    },
                    {
                        code: '654221',
                        name: '额敏县',
                        simple_name: '额敏',
                        hidden: 0,
                    },
                    {
                        code: '654223',
                        name: '沙湾县',
                        simple_name: '沙湾',
                        hidden: 0,
                    },
                    {
                        code: '654224',
                        name: '托里县',
                        simple_name: '托里',
                        hidden: 0,
                    },
                    {
                        code: '654225',
                        name: '裕民县',
                        simple_name: '裕民',
                        hidden: 0,
                    },
                    {
                        code: '654226',
                        name: '和布克赛尔蒙古自治县',
                        simple_name: '和布克赛尔',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '654300',
                name: '阿勒泰地区',
                simple_name: '阿勒泰',
                hidden: 0,
                districts: [
                    {
                        code: '654301',
                        name: '阿勒泰市',
                        simple_name: '阿勒泰',
                        hidden: 0,
                    },
                    {
                        code: '654321',
                        name: '布尔津县',
                        simple_name: '布尔津',
                        hidden: 0,
                    },
                    {
                        code: '654322',
                        name: '富蕴县',
                        simple_name: '富蕴',
                        hidden: 0,
                    },
                    {
                        code: '654323',
                        name: '福海县',
                        simple_name: '福海',
                        hidden: 0,
                    },
                    {
                        code: '654324',
                        name: '哈巴河县',
                        simple_name: '哈巴河',
                        hidden: 0,
                    },
                    {
                        code: '654325',
                        name: '青河县',
                        simple_name: '青河',
                        hidden: 0,
                    },
                    {
                        code: '654326',
                        name: '吉木乃县',
                        simple_name: '吉木乃',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '659000',
                name: '直辖县级',
                simple_name: ' ',
                hidden: 0,
                districts: [
                    {
                        code: '659001',
                        name: '石河子市',
                        simple_name: '石河子',
                        hidden: 0,
                    },
                    {
                        code: '659002',
                        name: '阿拉尔市',
                        simple_name: '阿拉尔',
                        hidden: 0,
                    },
                    {
                        code: '659003',
                        name: '图木舒克市',
                        simple_name: '图木舒克',
                        hidden: 0,
                    },
                    {
                        code: '659004',
                        name: '五家渠市',
                        simple_name: '五家渠',
                        hidden: 0,
                    },
                    {
                        code: '659005',
                        name: '北屯市',
                        simple_name: '北屯',
                        hidden: 0,
                    },
                    {
                        code: '659006',
                        name: '铁门关市',
                        simple_name: '铁门关',
                        hidden: 0,
                    },
                    {
                        code: '659007',
                        name: '双河市',
                        simple_name: '双河',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '710000',
        name: '台湾',
        simple_name: '台湾',
        hidden: 0,
        cities: [
            {
                code: '710100',
                name: '台北市',
                simple_name: '台北',
                hidden: 0,
                districts: [
                    {
                        code: '710101',
                        name: '松山区',
                        simple_name: '松山',
                        hidden: 0,
                    },
                    {
                        code: '710102',
                        name: '信义区',
                        simple_name: '信义',
                        hidden: 0,
                    },
                    {
                        code: '710103',
                        name: '大安区',
                        simple_name: '大安',
                        hidden: 0,
                    },
                    {
                        code: '710104',
                        name: '中山区',
                        simple_name: '中山',
                        hidden: 0,
                    },
                    {
                        code: '710105',
                        name: '中正区',
                        simple_name: '中正',
                        hidden: 0,
                    },
                    {
                        code: '710106',
                        name: '大同区',
                        simple_name: '大同',
                        hidden: 0,
                    },
                    {
                        code: '710107',
                        name: '万华区',
                        simple_name: '万华',
                        hidden: 0,
                    },
                    {
                        code: '710108',
                        name: '文山区',
                        simple_name: '文山',
                        hidden: 0,
                    },
                    {
                        code: '710109',
                        name: '南港区',
                        simple_name: '南港',
                        hidden: 0,
                    },
                    {
                        code: '710110',
                        name: '内湖区',
                        simple_name: '内湖',
                        hidden: 0,
                    },
                    {
                        code: '710111',
                        name: '士林区',
                        simple_name: '士林',
                        hidden: 0,
                    },
                    {
                        code: '710112',
                        name: '北投区',
                        simple_name: '北投',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710200',
                name: '高雄市',
                simple_name: '高雄',
                hidden: 0,
                districts: [
                    {
                        code: '710201',
                        name: '盐埕区',
                        simple_name: '盐埕',
                        hidden: 0,
                    },
                    {
                        code: '710202',
                        name: '鼓山区',
                        simple_name: '鼓山',
                        hidden: 0,
                    },
                    {
                        code: '710203',
                        name: '左营区',
                        simple_name: '左营',
                        hidden: 0,
                    },
                    {
                        code: '710204',
                        name: '楠梓区',
                        simple_name: '楠梓',
                        hidden: 0,
                    },
                    {
                        code: '710205',
                        name: '三民区',
                        simple_name: '三民',
                        hidden: 0,
                    },
                    {
                        code: '710206',
                        name: '新兴区',
                        simple_name: '新兴',
                        hidden: 0,
                    },
                    {
                        code: '710207',
                        name: '前金区',
                        simple_name: '前金',
                        hidden: 0,
                    },
                    {
                        code: '710208',
                        name: '苓雅区',
                        simple_name: '苓雅',
                        hidden: 0,
                    },
                    {
                        code: '710209',
                        name: '前镇区',
                        simple_name: '前镇',
                        hidden: 0,
                    },
                    {
                        code: '710210',
                        name: '旗津区',
                        simple_name: '旗津',
                        hidden: 0,
                    },
                    {
                        code: '710211',
                        name: '小港区',
                        simple_name: '小港',
                        hidden: 0,
                    },
                    {
                        code: '710212',
                        name: '凤山区',
                        simple_name: '凤山',
                        hidden: 0,
                    },
                    {
                        code: '710213',
                        name: '林园区',
                        simple_name: '林园',
                        hidden: 0,
                    },
                    {
                        code: '710214',
                        name: '大寮区',
                        simple_name: '大寮',
                        hidden: 0,
                    },
                    {
                        code: '710215',
                        name: '大树区',
                        simple_name: '大树',
                        hidden: 0,
                    },
                    {
                        code: '710216',
                        name: '大社区',
                        simple_name: '大社',
                        hidden: 0,
                    },
                    {
                        code: '710217',
                        name: '仁武区',
                        simple_name: '仁武',
                        hidden: 0,
                    },
                    {
                        code: '710218',
                        name: '鸟松区',
                        simple_name: '鸟松',
                        hidden: 0,
                    },
                    {
                        code: '710219',
                        name: '冈山区',
                        simple_name: '冈山',
                        hidden: 0,
                    },
                    {
                        code: '710220',
                        name: '桥头区',
                        simple_name: '桥头',
                        hidden: 0,
                    },
                    {
                        code: '710221',
                        name: '燕巢区',
                        simple_name: '燕巢',
                        hidden: 0,
                    },
                    {
                        code: '710222',
                        name: '田寮区',
                        simple_name: '田寮',
                        hidden: 0,
                    },
                    {
                        code: '710223',
                        name: '阿莲区',
                        simple_name: '阿莲',
                        hidden: 0,
                    },
                    {
                        code: '710224',
                        name: '路竹区',
                        simple_name: '路竹',
                        hidden: 0,
                    },
                    {
                        code: '710225',
                        name: '湖内区',
                        simple_name: '湖内',
                        hidden: 0,
                    },
                    {
                        code: '710226',
                        name: '茄萣区',
                        simple_name: '茄萣',
                        hidden: 0,
                    },
                    {
                        code: '710227',
                        name: '永安区',
                        simple_name: '永安',
                        hidden: 0,
                    },
                    {
                        code: '710228',
                        name: '弥陀区',
                        simple_name: '弥陀',
                        hidden: 0,
                    },
                    {
                        code: '710229',
                        name: '梓官区',
                        simple_name: '梓官',
                        hidden: 0,
                    },
                    {
                        code: '710230',
                        name: '旗山区',
                        simple_name: '旗山',
                        hidden: 0,
                    },
                    {
                        code: '710231',
                        name: '美浓区',
                        simple_name: '美浓',
                        hidden: 0,
                    },
                    {
                        code: '710232',
                        name: '六龟区',
                        simple_name: '六龟',
                        hidden: 0,
                    },
                    {
                        code: '710233',
                        name: '甲仙区',
                        simple_name: '甲仙',
                        hidden: 0,
                    },
                    {
                        code: '710234',
                        name: '杉林区',
                        simple_name: '杉林',
                        hidden: 0,
                    },
                    {
                        code: '710235',
                        name: '内门区',
                        simple_name: '内门',
                        hidden: 0,
                    },
                    {
                        code: '710236',
                        name: '茂林区',
                        simple_name: '茂林',
                        hidden: 0,
                    },
                    {
                        code: '710237',
                        name: '桃源区',
                        simple_name: '桃源',
                        hidden: 0,
                    },
                    {
                        code: '710238',
                        name: '那玛夏区',
                        simple_name: '那玛夏',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710300',
                name: '基隆市',
                simple_name: '基隆',
                hidden: 0,
                districts: [
                    {
                        code: '710301',
                        name: '中正区',
                        simple_name: '中正',
                        hidden: 0,
                    },
                    {
                        code: '710302',
                        name: '七堵区',
                        simple_name: '七堵',
                        hidden: 0,
                    },
                    {
                        code: '710303',
                        name: '暖暖区',
                        simple_name: '暖暖',
                        hidden: 0,
                    },
                    {
                        code: '710304',
                        name: '仁爱区',
                        simple_name: '仁爱',
                        hidden: 0,
                    },
                    {
                        code: '710305',
                        name: '中山区',
                        simple_name: '中山',
                        hidden: 0,
                    },
                    {
                        code: '710306',
                        name: '安乐区',
                        simple_name: '安乐',
                        hidden: 0,
                    },
                    {
                        code: '710307',
                        name: '信义区',
                        simple_name: '信义',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710400',
                name: '台中市',
                simple_name: '台中',
                hidden: 0,
                districts: [
                    {
                        code: '710401',
                        name: '中区',
                        simple_name: '中区',
                        hidden: 0,
                    },
                    {
                        code: '710402',
                        name: '东区',
                        simple_name: '东区',
                        hidden: 0,
                    },
                    {
                        code: '710403',
                        name: '南区',
                        simple_name: '南区',
                        hidden: 0,
                    },
                    {
                        code: '710404',
                        name: '西区',
                        simple_name: '西区',
                        hidden: 0,
                    },
                    {
                        code: '710405',
                        name: '北区',
                        simple_name: '北区',
                        hidden: 0,
                    },
                    {
                        code: '710406',
                        name: '西屯区',
                        simple_name: '西屯',
                        hidden: 0,
                    },
                    {
                        code: '710407',
                        name: '南屯区',
                        simple_name: '南屯',
                        hidden: 0,
                    },
                    {
                        code: '710408',
                        name: '北屯区',
                        simple_name: '北屯',
                        hidden: 0,
                    },
                    {
                        code: '710409',
                        name: '丰原区',
                        simple_name: '丰原',
                        hidden: 0,
                    },
                    {
                        code: '710410',
                        name: '东势区',
                        simple_name: '东势',
                        hidden: 0,
                    },
                    {
                        code: '710411',
                        name: '大甲区',
                        simple_name: '大甲',
                        hidden: 0,
                    },
                    {
                        code: '710412',
                        name: '清水区',
                        simple_name: '清水',
                        hidden: 0,
                    },
                    {
                        code: '710413',
                        name: '沙鹿区',
                        simple_name: '沙鹿',
                        hidden: 0,
                    },
                    {
                        code: '710414',
                        name: '梧栖区',
                        simple_name: '梧栖',
                        hidden: 0,
                    },
                    {
                        code: '710415',
                        name: '后里区',
                        simple_name: '后里',
                        hidden: 0,
                    },
                    {
                        code: '710416',
                        name: '神冈区',
                        simple_name: '神冈',
                        hidden: 0,
                    },
                    {
                        code: '710417',
                        name: '潭子区',
                        simple_name: '潭子',
                        hidden: 0,
                    },
                    {
                        code: '710418',
                        name: '大雅区',
                        simple_name: '大雅',
                        hidden: 0,
                    },
                    {
                        code: '710419',
                        name: '新社区',
                        simple_name: '新社',
                        hidden: 0,
                    },
                    {
                        code: '710420',
                        name: '石冈区',
                        simple_name: '石冈',
                        hidden: 0,
                    },
                    {
                        code: '710421',
                        name: '外埔区',
                        simple_name: '外埔',
                        hidden: 0,
                    },
                    {
                        code: '710422',
                        name: '大安区',
                        simple_name: '大安',
                        hidden: 0,
                    },
                    {
                        code: '710423',
                        name: '乌日区',
                        simple_name: '乌日',
                        hidden: 0,
                    },
                    {
                        code: '710424',
                        name: '大肚区',
                        simple_name: '大肚',
                        hidden: 0,
                    },
                    {
                        code: '710425',
                        name: '龙井区',
                        simple_name: '龙井',
                        hidden: 0,
                    },
                    {
                        code: '710426',
                        name: '雾峰区',
                        simple_name: '雾峰',
                        hidden: 0,
                    },
                    {
                        code: '710427',
                        name: '太平区',
                        simple_name: '太平',
                        hidden: 0,
                    },
                    {
                        code: '710428',
                        name: '大里区',
                        simple_name: '大里',
                        hidden: 0,
                    },
                    {
                        code: '710429',
                        name: '和平区',
                        simple_name: '和平',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710500',
                name: '台南市',
                simple_name: '台南',
                hidden: 0,
                districts: [
                    {
                        code: '710501',
                        name: '东区',
                        simple_name: '东区',
                        hidden: 0,
                    },
                    {
                        code: '710502',
                        name: '南区',
                        simple_name: '南区',
                        hidden: 0,
                    },
                    {
                        code: '710504',
                        name: '北区',
                        simple_name: '北区',
                        hidden: 0,
                    },
                    {
                        code: '710506',
                        name: '安南区',
                        simple_name: '安南',
                        hidden: 0,
                    },
                    {
                        code: '710507',
                        name: '安平区',
                        simple_name: '安平',
                        hidden: 0,
                    },
                    {
                        code: '710508',
                        name: '中西区',
                        simple_name: '中西',
                        hidden: 0,
                    },
                    {
                        code: '710509',
                        name: '新营区',
                        simple_name: '新营',
                        hidden: 0,
                    },
                    {
                        code: '710510',
                        name: '盐水区',
                        simple_name: '盐水',
                        hidden: 0,
                    },
                    {
                        code: '710511',
                        name: '白河区',
                        simple_name: '白河',
                        hidden: 0,
                    },
                    {
                        code: '710512',
                        name: '柳营区',
                        simple_name: '柳营',
                        hidden: 0,
                    },
                    {
                        code: '710513',
                        name: '后壁区',
                        simple_name: '后壁',
                        hidden: 0,
                    },
                    {
                        code: '710514',
                        name: '东山区',
                        simple_name: '东山',
                        hidden: 0,
                    },
                    {
                        code: '710515',
                        name: '麻豆区',
                        simple_name: '麻豆',
                        hidden: 0,
                    },
                    {
                        code: '710516',
                        name: '下营区',
                        simple_name: '下营',
                        hidden: 0,
                    },
                    {
                        code: '710517',
                        name: '六甲区',
                        simple_name: '六甲',
                        hidden: 0,
                    },
                    {
                        code: '710518',
                        name: '官田区',
                        simple_name: '官田',
                        hidden: 0,
                    },
                    {
                        code: '710519',
                        name: '大内区',
                        simple_name: '大内',
                        hidden: 0,
                    },
                    {
                        code: '710520',
                        name: '佳里区',
                        simple_name: '佳里',
                        hidden: 0,
                    },
                    {
                        code: '710521',
                        name: '学甲区',
                        simple_name: '学甲',
                        hidden: 0,
                    },
                    {
                        code: '710522',
                        name: '西港区',
                        simple_name: '西港',
                        hidden: 0,
                    },
                    {
                        code: '710523',
                        name: '七股区',
                        simple_name: '七股',
                        hidden: 0,
                    },
                    {
                        code: '710524',
                        name: '将军区',
                        simple_name: '将军',
                        hidden: 0,
                    },
                    {
                        code: '710525',
                        name: '北门区',
                        simple_name: '北门',
                        hidden: 0,
                    },
                    {
                        code: '710526',
                        name: '新化区',
                        simple_name: '新化',
                        hidden: 0,
                    },
                    {
                        code: '710527',
                        name: '善化区',
                        simple_name: '善化',
                        hidden: 0,
                    },
                    {
                        code: '710528',
                        name: '新市区',
                        simple_name: '新市',
                        hidden: 0,
                    },
                    {
                        code: '710529',
                        name: '安定区',
                        simple_name: '安定',
                        hidden: 0,
                    },
                    {
                        code: '710530',
                        name: '山上区',
                        simple_name: '山上',
                        hidden: 0,
                    },
                    {
                        code: '710531',
                        name: '玉井区',
                        simple_name: '玉井',
                        hidden: 0,
                    },
                    {
                        code: '710532',
                        name: '楠西区',
                        simple_name: '楠西',
                        hidden: 0,
                    },
                    {
                        code: '710533',
                        name: '南化区',
                        simple_name: '南化',
                        hidden: 0,
                    },
                    {
                        code: '710534',
                        name: '左镇区',
                        simple_name: '左镇',
                        hidden: 0,
                    },
                    {
                        code: '710535',
                        name: '仁德区',
                        simple_name: '仁德',
                        hidden: 0,
                    },
                    {
                        code: '710536',
                        name: '归仁区',
                        simple_name: '归仁',
                        hidden: 0,
                    },
                    {
                        code: '710537',
                        name: '关庙区',
                        simple_name: '关庙',
                        hidden: 0,
                    },
                    {
                        code: '710538',
                        name: '龙崎区',
                        simple_name: '龙崎',
                        hidden: 0,
                    },
                    {
                        code: '710539',
                        name: '永康区',
                        simple_name: '永康',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710600',
                name: '新竹市',
                simple_name: '新竹',
                hidden: 0,
                districts: [
                    {
                        code: '710601',
                        name: '东区',
                        simple_name: '东区',
                        hidden: 0,
                    },
                    {
                        code: '710602',
                        name: '北区',
                        simple_name: '北区',
                        hidden: 0,
                    },
                    {
                        code: '710603',
                        name: '香山区',
                        simple_name: '香山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710700',
                name: '嘉义市',
                simple_name: '嘉义',
                hidden: 0,
                districts: [
                    {
                        code: '710701',
                        name: '东区',
                        simple_name: '东区',
                        hidden: 0,
                    },
                    {
                        code: '710702',
                        name: '西区',
                        simple_name: '西区',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '710800',
                name: '新北市',
                simple_name: '新北',
                hidden: 0,
                districts: [
                    {
                        code: '710801',
                        name: '板桥区',
                        simple_name: '板桥',
                        hidden: 0,
                    },
                    {
                        code: '710802',
                        name: '三重区',
                        simple_name: '三重',
                        hidden: 0,
                    },
                    {
                        code: '710803',
                        name: '中和区',
                        simple_name: '中和',
                        hidden: 0,
                    },
                    {
                        code: '710804',
                        name: '永和区',
                        simple_name: '永和',
                        hidden: 0,
                    },
                    {
                        code: '710805',
                        name: '新庄区',
                        simple_name: '新庄',
                        hidden: 0,
                    },
                    {
                        code: '710806',
                        name: '新店区',
                        simple_name: '新店',
                        hidden: 0,
                    },
                    {
                        code: '710807',
                        name: '树林区',
                        simple_name: '树林',
                        hidden: 0,
                    },
                    {
                        code: '710808',
                        name: '莺歌区',
                        simple_name: '莺歌',
                        hidden: 0,
                    },
                    {
                        code: '710809',
                        name: '三峡区',
                        simple_name: '三峡',
                        hidden: 0,
                    },
                    {
                        code: '710810',
                        name: '淡水区',
                        simple_name: '淡水',
                        hidden: 0,
                    },
                    {
                        code: '710811',
                        name: '汐止区',
                        simple_name: '汐止',
                        hidden: 0,
                    },
                    {
                        code: '710812',
                        name: '瑞芳区',
                        simple_name: '瑞芳',
                        hidden: 0,
                    },
                    {
                        code: '710813',
                        name: '土城区',
                        simple_name: '土城',
                        hidden: 0,
                    },
                    {
                        code: '710814',
                        name: '芦洲区',
                        simple_name: '芦洲',
                        hidden: 0,
                    },
                    {
                        code: '710815',
                        name: '五股区',
                        simple_name: '五股',
                        hidden: 0,
                    },
                    {
                        code: '710816',
                        name: '泰山区',
                        simple_name: '泰山',
                        hidden: 0,
                    },
                    {
                        code: '710817',
                        name: '林口区',
                        simple_name: '林口',
                        hidden: 0,
                    },
                    {
                        code: '710818',
                        name: '深坑区',
                        simple_name: '深坑',
                        hidden: 0,
                    },
                    {
                        code: '710819',
                        name: '石碇区',
                        simple_name: '石碇',
                        hidden: 0,
                    },
                    {
                        code: '710820',
                        name: '坪林区',
                        simple_name: '坪林',
                        hidden: 0,
                    },
                    {
                        code: '710821',
                        name: '三芝区',
                        simple_name: '三芝',
                        hidden: 0,
                    },
                    {
                        code: '710822',
                        name: '石门区',
                        simple_name: '石门',
                        hidden: 0,
                    },
                    {
                        code: '710823',
                        name: '八里区',
                        simple_name: '八里',
                        hidden: 0,
                    },
                    {
                        code: '710824',
                        name: '平溪区',
                        simple_name: '平溪',
                        hidden: 0,
                    },
                    {
                        code: '710825',
                        name: '双溪区',
                        simple_name: '双溪',
                        hidden: 0,
                    },
                    {
                        code: '710826',
                        name: '贡寮区',
                        simple_name: '贡寮',
                        hidden: 0,
                    },
                    {
                        code: '710827',
                        name: '金山区',
                        simple_name: '金山',
                        hidden: 0,
                    },
                    {
                        code: '710828',
                        name: '万里区',
                        simple_name: '万里',
                        hidden: 0,
                    },
                    {
                        code: '710829',
                        name: '乌来区',
                        simple_name: '乌来',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712200',
                name: '宜兰县',
                simple_name: '宜兰',
                hidden: 0,
                districts: [
                    {
                        code: '712201',
                        name: '宜兰市',
                        simple_name: '宜兰',
                        hidden: 0,
                    },
                    {
                        code: '712221',
                        name: '罗东镇',
                        simple_name: '罗东',
                        hidden: 0,
                    },
                    {
                        code: '712222',
                        name: '苏澳镇',
                        simple_name: '苏澳',
                        hidden: 0,
                    },
                    {
                        code: '712223',
                        name: '头城镇',
                        simple_name: '头城',
                        hidden: 0,
                    },
                    {
                        code: '712224',
                        name: '礁溪乡',
                        simple_name: '礁溪',
                        hidden: 0,
                    },
                    {
                        code: '712225',
                        name: '壮围乡',
                        simple_name: '壮围',
                        hidden: 0,
                    },
                    {
                        code: '712226',
                        name: '员山乡',
                        simple_name: '员山',
                        hidden: 0,
                    },
                    {
                        code: '712227',
                        name: '冬山乡',
                        simple_name: '冬山',
                        hidden: 0,
                    },
                    {
                        code: '712228',
                        name: '五结乡',
                        simple_name: '五结',
                        hidden: 0,
                    },
                    {
                        code: '712229',
                        name: '三星乡',
                        simple_name: '三星',
                        hidden: 0,
                    },
                    {
                        code: '712230',
                        name: '大同乡',
                        simple_name: '大同',
                        hidden: 0,
                    },
                    {
                        code: '712231',
                        name: '南澳乡',
                        simple_name: '南澳',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712300',
                name: '桃园县',
                simple_name: '桃园',
                hidden: 0,
                districts: [
                    {
                        code: '712301',
                        name: '桃园市',
                        simple_name: '桃园',
                        hidden: 0,
                    },
                    {
                        code: '712302',
                        name: '中坜市',
                        simple_name: '中坜',
                        hidden: 0,
                    },
                    {
                        code: '712303',
                        name: '平镇市',
                        simple_name: '平镇',
                        hidden: 0,
                    },
                    {
                        code: '712304',
                        name: '八德市',
                        simple_name: '八德',
                        hidden: 0,
                    },
                    {
                        code: '712305',
                        name: '杨梅市',
                        simple_name: '杨梅',
                        hidden: 0,
                    },
                    {
                        code: '712306',
                        name: '芦竹市',
                        simple_name: '芦竹',
                        hidden: 0,
                    },
                    {
                        code: '712321',
                        name: '大溪镇',
                        simple_name: '大溪',
                        hidden: 0,
                    },
                    {
                        code: '712324',
                        name: '大园乡',
                        simple_name: '大园',
                        hidden: 0,
                    },
                    {
                        code: '712325',
                        name: '龟山乡',
                        simple_name: '龟山',
                        hidden: 0,
                    },
                    {
                        code: '712327',
                        name: '龙潭乡',
                        simple_name: '龙潭',
                        hidden: 0,
                    },
                    {
                        code: '712329',
                        name: '新屋乡',
                        simple_name: '新屋',
                        hidden: 0,
                    },
                    {
                        code: '712330',
                        name: '观音乡',
                        simple_name: '观音',
                        hidden: 0,
                    },
                    {
                        code: '712331',
                        name: '复兴乡',
                        simple_name: '复兴',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712400',
                name: '新竹县',
                simple_name: '新竹',
                hidden: 0,
                districts: [
                    {
                        code: '712401',
                        name: '竹北市',
                        simple_name: '竹北',
                        hidden: 0,
                    },
                    {
                        code: '712421',
                        name: '竹东镇',
                        simple_name: '竹东',
                        hidden: 0,
                    },
                    {
                        code: '712422',
                        name: '新埔镇',
                        simple_name: '新埔',
                        hidden: 0,
                    },
                    {
                        code: '712423',
                        name: '关西镇',
                        simple_name: '关西',
                        hidden: 0,
                    },
                    {
                        code: '712424',
                        name: '湖口乡',
                        simple_name: '湖口',
                        hidden: 0,
                    },
                    {
                        code: '712425',
                        name: '新丰乡',
                        simple_name: '新丰',
                        hidden: 0,
                    },
                    {
                        code: '712426',
                        name: '芎林乡',
                        simple_name: '芎林',
                        hidden: 0,
                    },
                    {
                        code: '712427',
                        name: '横山乡',
                        simple_name: '横山',
                        hidden: 0,
                    },
                    {
                        code: '712428',
                        name: '北埔乡',
                        simple_name: '北埔',
                        hidden: 0,
                    },
                    {
                        code: '712429',
                        name: '宝山乡',
                        simple_name: '宝山',
                        hidden: 0,
                    },
                    {
                        code: '712430',
                        name: '峨眉乡',
                        simple_name: '峨眉',
                        hidden: 0,
                    },
                    {
                        code: '712431',
                        name: '尖石乡',
                        simple_name: '尖石',
                        hidden: 0,
                    },
                    {
                        code: '712432',
                        name: '五峰乡',
                        simple_name: '五峰',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712500',
                name: '苗栗县',
                simple_name: '苗栗',
                hidden: 0,
                districts: [
                    {
                        code: '712501',
                        name: '苗栗市',
                        simple_name: '苗栗',
                        hidden: 0,
                    },
                    {
                        code: '712521',
                        name: '苑里镇',
                        simple_name: '苑里',
                        hidden: 0,
                    },
                    {
                        code: '712522',
                        name: '通霄镇',
                        simple_name: '通霄',
                        hidden: 0,
                    },
                    {
                        code: '712523',
                        name: '竹南镇',
                        simple_name: '竹南',
                        hidden: 0,
                    },
                    {
                        code: '712524',
                        name: '头份镇',
                        simple_name: '头份',
                        hidden: 0,
                    },
                    {
                        code: '712525',
                        name: '后龙镇',
                        simple_name: '后龙',
                        hidden: 0,
                    },
                    {
                        code: '712526',
                        name: '卓兰镇',
                        simple_name: '卓兰',
                        hidden: 0,
                    },
                    {
                        code: '712527',
                        name: '大湖乡',
                        simple_name: '大湖',
                        hidden: 0,
                    },
                    {
                        code: '712528',
                        name: '公馆乡',
                        simple_name: '公馆',
                        hidden: 0,
                    },
                    {
                        code: '712529',
                        name: '铜锣乡',
                        simple_name: '铜锣',
                        hidden: 0,
                    },
                    {
                        code: '712530',
                        name: '南庄乡',
                        simple_name: '南庄',
                        hidden: 0,
                    },
                    {
                        code: '712531',
                        name: '头屋乡',
                        simple_name: '头屋',
                        hidden: 0,
                    },
                    {
                        code: '712532',
                        name: '三义乡',
                        simple_name: '三义',
                        hidden: 0,
                    },
                    {
                        code: '712533',
                        name: '西湖乡',
                        simple_name: '西湖',
                        hidden: 0,
                    },
                    {
                        code: '712534',
                        name: '造桥乡',
                        simple_name: '造桥',
                        hidden: 0,
                    },
                    {
                        code: '712535',
                        name: '三湾乡',
                        simple_name: '三湾',
                        hidden: 0,
                    },
                    {
                        code: '712536',
                        name: '狮潭乡',
                        simple_name: '狮潭',
                        hidden: 0,
                    },
                    {
                        code: '712537',
                        name: '泰安乡',
                        simple_name: '泰安',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712700',
                name: '彰化县',
                simple_name: '彰化',
                hidden: 0,
                districts: [
                    {
                        code: '712701',
                        name: '彰化市',
                        simple_name: '彰化市',
                        hidden: 0,
                    },
                    {
                        code: '712721',
                        name: '鹿港镇',
                        simple_name: '鹿港',
                        hidden: 0,
                    },
                    {
                        code: '712722',
                        name: '和美镇',
                        simple_name: '和美',
                        hidden: 0,
                    },
                    {
                        code: '712723',
                        name: '线西乡',
                        simple_name: '线西',
                        hidden: 0,
                    },
                    {
                        code: '712724',
                        name: '伸港乡',
                        simple_name: '伸港',
                        hidden: 0,
                    },
                    {
                        code: '712725',
                        name: '福兴乡',
                        simple_name: '福兴',
                        hidden: 0,
                    },
                    {
                        code: '712726',
                        name: '秀水乡',
                        simple_name: '秀水',
                        hidden: 0,
                    },
                    {
                        code: '712727',
                        name: '花坛乡',
                        simple_name: '花坛',
                        hidden: 0,
                    },
                    {
                        code: '712728',
                        name: '芬园乡',
                        simple_name: '芬园',
                        hidden: 0,
                    },
                    {
                        code: '712729',
                        name: '员林镇',
                        simple_name: '员林',
                        hidden: 0,
                    },
                    {
                        code: '712730',
                        name: '溪湖镇',
                        simple_name: '溪湖',
                        hidden: 0,
                    },
                    {
                        code: '712731',
                        name: '田中镇',
                        simple_name: '田中',
                        hidden: 0,
                    },
                    {
                        code: '712732',
                        name: '大村乡',
                        simple_name: '大村',
                        hidden: 0,
                    },
                    {
                        code: '712733',
                        name: '埔盐乡',
                        simple_name: '埔盐',
                        hidden: 0,
                    },
                    {
                        code: '712734',
                        name: '埔心乡',
                        simple_name: '埔心',
                        hidden: 0,
                    },
                    {
                        code: '712735',
                        name: '永靖乡',
                        simple_name: '永靖',
                        hidden: 0,
                    },
                    {
                        code: '712736',
                        name: '社头乡',
                        simple_name: '社头',
                        hidden: 0,
                    },
                    {
                        code: '712737',
                        name: '二水乡',
                        simple_name: '二水',
                        hidden: 0,
                    },
                    {
                        code: '712738',
                        name: '北斗镇',
                        simple_name: '北斗',
                        hidden: 0,
                    },
                    {
                        code: '712739',
                        name: '二林镇',
                        simple_name: '二林',
                        hidden: 0,
                    },
                    {
                        code: '712740',
                        name: '田尾乡',
                        simple_name: '田尾',
                        hidden: 0,
                    },
                    {
                        code: '712741',
                        name: '埤头乡',
                        simple_name: '埤头',
                        hidden: 0,
                    },
                    {
                        code: '712742',
                        name: '芳苑乡',
                        simple_name: '芳苑',
                        hidden: 0,
                    },
                    {
                        code: '712743',
                        name: '大城乡',
                        simple_name: '大城',
                        hidden: 0,
                    },
                    {
                        code: '712744',
                        name: '竹塘乡',
                        simple_name: '竹塘',
                        hidden: 0,
                    },
                    {
                        code: '712745',
                        name: '溪州乡',
                        simple_name: '溪州',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712800',
                name: '南投县',
                simple_name: '南投',
                hidden: 0,
                districts: [
                    {
                        code: '712801',
                        name: '南投市',
                        simple_name: '南投市',
                        hidden: 0,
                    },
                    {
                        code: '712821',
                        name: '埔里镇',
                        simple_name: '埔里',
                        hidden: 0,
                    },
                    {
                        code: '712822',
                        name: '草屯镇',
                        simple_name: '草屯',
                        hidden: 0,
                    },
                    {
                        code: '712823',
                        name: '竹山镇',
                        simple_name: '竹山',
                        hidden: 0,
                    },
                    {
                        code: '712824',
                        name: '集集镇',
                        simple_name: '集集',
                        hidden: 0,
                    },
                    {
                        code: '712825',
                        name: '名间乡',
                        simple_name: '名间',
                        hidden: 0,
                    },
                    {
                        code: '712826',
                        name: '鹿谷乡',
                        simple_name: '鹿谷',
                        hidden: 0,
                    },
                    {
                        code: '712827',
                        name: '中寮乡',
                        simple_name: '中寮',
                        hidden: 0,
                    },
                    {
                        code: '712828',
                        name: '鱼池乡',
                        simple_name: '鱼池',
                        hidden: 0,
                    },
                    {
                        code: '712829',
                        name: '国姓乡',
                        simple_name: '国姓',
                        hidden: 0,
                    },
                    {
                        code: '712830',
                        name: '水里乡',
                        simple_name: '水里',
                        hidden: 0,
                    },
                    {
                        code: '712831',
                        name: '信义乡',
                        simple_name: '信义',
                        hidden: 0,
                    },
                    {
                        code: '712832',
                        name: '仁爱乡',
                        simple_name: '仁爱',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '712900',
                name: '云林县',
                simple_name: '云林',
                hidden: 0,
                districts: [
                    {
                        code: '712901',
                        name: '斗六市',
                        simple_name: '斗六',
                        hidden: 0,
                    },
                    {
                        code: '712921',
                        name: '斗南镇',
                        simple_name: '斗南',
                        hidden: 0,
                    },
                    {
                        code: '712922',
                        name: '虎尾镇',
                        simple_name: '虎尾',
                        hidden: 0,
                    },
                    {
                        code: '712923',
                        name: '西螺镇',
                        simple_name: '西螺',
                        hidden: 0,
                    },
                    {
                        code: '712924',
                        name: '土库镇',
                        simple_name: '土库',
                        hidden: 0,
                    },
                    {
                        code: '712925',
                        name: '北港镇',
                        simple_name: '北港',
                        hidden: 0,
                    },
                    {
                        code: '712926',
                        name: '古坑乡',
                        simple_name: '古坑',
                        hidden: 0,
                    },
                    {
                        code: '712927',
                        name: '大埤乡',
                        simple_name: '大埤',
                        hidden: 0,
                    },
                    {
                        code: '712928',
                        name: '莿桐乡',
                        simple_name: '莿桐',
                        hidden: 0,
                    },
                    {
                        code: '712929',
                        name: '林内乡',
                        simple_name: '林内',
                        hidden: 0,
                    },
                    {
                        code: '712930',
                        name: '二仑乡',
                        simple_name: '二仑',
                        hidden: 0,
                    },
                    {
                        code: '712931',
                        name: '仑背乡',
                        simple_name: '仑背',
                        hidden: 0,
                    },
                    {
                        code: '712932',
                        name: '麦寮乡',
                        simple_name: '麦寮',
                        hidden: 0,
                    },
                    {
                        code: '712933',
                        name: '东势乡',
                        simple_name: '东势',
                        hidden: 0,
                    },
                    {
                        code: '712934',
                        name: '褒忠乡',
                        simple_name: '褒忠',
                        hidden: 0,
                    },
                    {
                        code: '712935',
                        name: '台西乡',
                        simple_name: '台西',
                        hidden: 0,
                    },
                    {
                        code: '712936',
                        name: '元长乡',
                        simple_name: '元长',
                        hidden: 0,
                    },
                    {
                        code: '712937',
                        name: '四湖乡',
                        simple_name: '四湖',
                        hidden: 0,
                    },
                    {
                        code: '712938',
                        name: '口湖乡',
                        simple_name: '口湖',
                        hidden: 0,
                    },
                    {
                        code: '712939',
                        name: '水林乡',
                        simple_name: '水林',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713000',
                name: '嘉义县',
                simple_name: '嘉义',
                hidden: 0,
                districts: [
                    {
                        code: '713001',
                        name: '太保市',
                        simple_name: '太保',
                        hidden: 0,
                    },
                    {
                        code: '713002',
                        name: '朴子市',
                        simple_name: '朴子',
                        hidden: 0,
                    },
                    {
                        code: '713023',
                        name: '布袋镇',
                        simple_name: '布袋',
                        hidden: 0,
                    },
                    {
                        code: '713024',
                        name: '大林镇',
                        simple_name: '大林',
                        hidden: 0,
                    },
                    {
                        code: '713025',
                        name: '民雄乡',
                        simple_name: '民雄',
                        hidden: 0,
                    },
                    {
                        code: '713026',
                        name: '溪口乡',
                        simple_name: '溪口',
                        hidden: 0,
                    },
                    {
                        code: '713027',
                        name: '新港乡',
                        simple_name: '新港',
                        hidden: 0,
                    },
                    {
                        code: '713028',
                        name: '六脚乡',
                        simple_name: '六脚',
                        hidden: 0,
                    },
                    {
                        code: '713029',
                        name: '东石乡',
                        simple_name: '东石',
                        hidden: 0,
                    },
                    {
                        code: '713030',
                        name: '义竹乡',
                        simple_name: '义竹',
                        hidden: 0,
                    },
                    {
                        code: '713031',
                        name: '鹿草乡',
                        simple_name: '鹿草',
                        hidden: 0,
                    },
                    {
                        code: '713032',
                        name: '水上乡',
                        simple_name: '水上',
                        hidden: 0,
                    },
                    {
                        code: '713033',
                        name: '中埔乡',
                        simple_name: '中埔',
                        hidden: 0,
                    },
                    {
                        code: '713034',
                        name: '竹崎乡',
                        simple_name: '竹崎',
                        hidden: 0,
                    },
                    {
                        code: '713035',
                        name: '梅山乡',
                        simple_name: '梅山',
                        hidden: 0,
                    },
                    {
                        code: '713036',
                        name: '番路乡',
                        simple_name: '番路',
                        hidden: 0,
                    },
                    {
                        code: '713037',
                        name: '大埔乡',
                        simple_name: '大埔',
                        hidden: 0,
                    },
                    {
                        code: '713038',
                        name: '阿里山乡',
                        simple_name: '阿里山',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713300',
                name: '屏东县',
                simple_name: '屏东',
                hidden: 0,
                districts: [
                    {
                        code: '713301',
                        name: '屏东市',
                        simple_name: '屏东',
                        hidden: 0,
                    },
                    {
                        code: '713321',
                        name: '潮州镇',
                        simple_name: '潮州',
                        hidden: 0,
                    },
                    {
                        code: '713322',
                        name: '东港镇',
                        simple_name: '东港',
                        hidden: 0,
                    },
                    {
                        code: '713323',
                        name: '恒春镇',
                        simple_name: '恒春',
                        hidden: 0,
                    },
                    {
                        code: '713324',
                        name: '万丹乡',
                        simple_name: '万丹',
                        hidden: 0,
                    },
                    {
                        code: '713325',
                        name: '长治乡',
                        simple_name: '长治',
                        hidden: 0,
                    },
                    {
                        code: '713326',
                        name: '麟洛乡',
                        simple_name: '麟洛',
                        hidden: 0,
                    },
                    {
                        code: '713327',
                        name: '九如乡',
                        simple_name: '九如',
                        hidden: 0,
                    },
                    {
                        code: '713328',
                        name: '里港乡',
                        simple_name: '里港',
                        hidden: 0,
                    },
                    {
                        code: '713329',
                        name: '盐埔乡',
                        simple_name: '盐埔',
                        hidden: 0,
                    },
                    {
                        code: '713330',
                        name: '高树乡',
                        simple_name: '高树',
                        hidden: 0,
                    },
                    {
                        code: '713331',
                        name: '万峦乡',
                        simple_name: '万峦',
                        hidden: 0,
                    },
                    {
                        code: '713332',
                        name: '内埔乡',
                        simple_name: '内埔',
                        hidden: 0,
                    },
                    {
                        code: '713333',
                        name: '竹田乡',
                        simple_name: '竹田',
                        hidden: 0,
                    },
                    {
                        code: '713334',
                        name: '新埤乡',
                        simple_name: '新埤',
                        hidden: 0,
                    },
                    {
                        code: '713335',
                        name: '枋寮乡',
                        simple_name: '枋寮',
                        hidden: 0,
                    },
                    {
                        code: '713336',
                        name: '新园乡',
                        simple_name: '新园',
                        hidden: 0,
                    },
                    {
                        code: '713337',
                        name: '崁顶乡',
                        simple_name: '崁顶',
                        hidden: 0,
                    },
                    {
                        code: '713338',
                        name: '林边乡',
                        simple_name: '林边',
                        hidden: 0,
                    },
                    {
                        code: '713339',
                        name: '南州乡',
                        simple_name: '南州',
                        hidden: 0,
                    },
                    {
                        code: '713340',
                        name: '佳冬乡',
                        simple_name: '佳冬',
                        hidden: 0,
                    },
                    {
                        code: '713341',
                        name: '琉球乡',
                        simple_name: '琉球',
                        hidden: 0,
                    },
                    {
                        code: '713342',
                        name: '车城乡',
                        simple_name: '车城',
                        hidden: 0,
                    },
                    {
                        code: '713343',
                        name: '满州乡',
                        simple_name: '满州',
                        hidden: 0,
                    },
                    {
                        code: '713344',
                        name: '枋山乡',
                        simple_name: '枋山',
                        hidden: 0,
                    },
                    {
                        code: '713345',
                        name: '三地门乡',
                        simple_name: '三地门',
                        hidden: 0,
                    },
                    {
                        code: '713346',
                        name: '雾台乡',
                        simple_name: '雾台',
                        hidden: 0,
                    },
                    {
                        code: '713347',
                        name: '玛家乡',
                        simple_name: '玛家',
                        hidden: 0,
                    },
                    {
                        code: '713348',
                        name: '泰武乡',
                        simple_name: '泰武',
                        hidden: 0,
                    },
                    {
                        code: '713349',
                        name: '来义乡',
                        simple_name: '来义',
                        hidden: 0,
                    },
                    {
                        code: '713350',
                        name: '春日乡',
                        simple_name: '春日',
                        hidden: 0,
                    },
                    {
                        code: '713351',
                        name: '狮子乡',
                        simple_name: '狮子',
                        hidden: 0,
                    },
                    {
                        code: '713352',
                        name: '牡丹乡',
                        simple_name: '牡丹',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713400',
                name: '台东县',
                simple_name: '台东',
                hidden: 0,
                districts: [
                    {
                        code: '713401',
                        name: '台东市',
                        simple_name: '台东',
                        hidden: 0,
                    },
                    {
                        code: '713421',
                        name: '成功镇',
                        simple_name: '成功',
                        hidden: 0,
                    },
                    {
                        code: '713422',
                        name: '关山镇',
                        simple_name: '关山',
                        hidden: 0,
                    },
                    {
                        code: '713423',
                        name: '卑南乡',
                        simple_name: '卑南',
                        hidden: 0,
                    },
                    {
                        code: '713424',
                        name: '鹿野乡',
                        simple_name: '鹿野',
                        hidden: 0,
                    },
                    {
                        code: '713425',
                        name: '池上乡',
                        simple_name: '池上',
                        hidden: 0,
                    },
                    {
                        code: '713426',
                        name: '东河乡',
                        simple_name: '东河',
                        hidden: 0,
                    },
                    {
                        code: '713427',
                        name: '长滨乡',
                        simple_name: '长滨',
                        hidden: 0,
                    },
                    {
                        code: '713428',
                        name: '太麻里乡',
                        simple_name: '太麻里',
                        hidden: 0,
                    },
                    {
                        code: '713429',
                        name: '大武乡',
                        simple_name: '大武',
                        hidden: 0,
                    },
                    {
                        code: '713430',
                        name: '绿岛乡',
                        simple_name: '绿岛',
                        hidden: 0,
                    },
                    {
                        code: '713431',
                        name: '海端乡',
                        simple_name: '海端',
                        hidden: 0,
                    },
                    {
                        code: '713432',
                        name: '延平乡',
                        simple_name: '延平',
                        hidden: 0,
                    },
                    {
                        code: '713433',
                        name: '金峰乡',
                        simple_name: '金峰',
                        hidden: 0,
                    },
                    {
                        code: '713434',
                        name: '达仁乡',
                        simple_name: '达仁',
                        hidden: 0,
                    },
                    {
                        code: '713435',
                        name: '兰屿乡',
                        simple_name: '兰屿',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713500',
                name: '花莲县',
                simple_name: '花莲',
                hidden: 0,
                districts: [
                    {
                        code: '713501',
                        name: '花莲市',
                        simple_name: '花莲',
                        hidden: 0,
                    },
                    {
                        code: '713521',
                        name: '凤林镇',
                        simple_name: '凤林',
                        hidden: 0,
                    },
                    {
                        code: '713522',
                        name: '玉里镇',
                        simple_name: '玉里',
                        hidden: 0,
                    },
                    {
                        code: '713523',
                        name: '新城乡',
                        simple_name: '新城',
                        hidden: 0,
                    },
                    {
                        code: '713524',
                        name: '吉安乡',
                        simple_name: '吉安',
                        hidden: 0,
                    },
                    {
                        code: '713525',
                        name: '寿丰乡',
                        simple_name: '寿丰',
                        hidden: 0,
                    },
                    {
                        code: '713526',
                        name: '光复乡',
                        simple_name: '光复',
                        hidden: 0,
                    },
                    {
                        code: '713527',
                        name: '丰滨乡',
                        simple_name: '丰滨',
                        hidden: 0,
                    },
                    {
                        code: '713528',
                        name: '瑞穗乡',
                        simple_name: '瑞穗',
                        hidden: 0,
                    },
                    {
                        code: '713529',
                        name: '富里乡',
                        simple_name: '富里',
                        hidden: 0,
                    },
                    {
                        code: '713530',
                        name: '秀林乡',
                        simple_name: '秀林',
                        hidden: 0,
                    },
                    {
                        code: '713531',
                        name: '万荣乡',
                        simple_name: '万荣',
                        hidden: 0,
                    },
                    {
                        code: '713532',
                        name: '卓溪乡',
                        simple_name: '卓溪',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713600',
                name: '澎湖县',
                simple_name: '澎湖',
                hidden: 0,
                districts: [
                    {
                        code: '713601',
                        name: '马公市',
                        simple_name: '马公',
                        hidden: 0,
                    },
                    {
                        code: '713621',
                        name: '湖西乡',
                        simple_name: '湖西',
                        hidden: 0,
                    },
                    {
                        code: '713622',
                        name: '白沙乡',
                        simple_name: '白沙',
                        hidden: 0,
                    },
                    {
                        code: '713623',
                        name: '西屿乡',
                        simple_name: '西屿',
                        hidden: 0,
                    },
                    {
                        code: '713624',
                        name: '望安乡',
                        simple_name: '望安',
                        hidden: 0,
                    },
                    {
                        code: '713625',
                        name: '七美乡',
                        simple_name: '七美',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713700',
                name: '金门县',
                simple_name: '金门',
                hidden: 0,
                districts: [
                    {
                        code: '713701',
                        name: '金城镇',
                        simple_name: '金城',
                        hidden: 0,
                    },
                    {
                        code: '713702',
                        name: '金湖镇',
                        simple_name: '金湖',
                        hidden: 0,
                    },
                    {
                        code: '713703',
                        name: '金沙镇',
                        simple_name: '金沙',
                        hidden: 0,
                    },
                    {
                        code: '713704',
                        name: '金宁乡',
                        simple_name: '金宁',
                        hidden: 0,
                    },
                    {
                        code: '713705',
                        name: '烈屿乡',
                        simple_name: '烈屿',
                        hidden: 0,
                    },
                    {
                        code: '713706',
                        name: '乌丘乡',
                        simple_name: '乌丘',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '713800',
                name: '连江县',
                simple_name: '连江',
                hidden: 0,
                districts: [
                    {
                        code: '713801',
                        name: '南竿乡',
                        simple_name: '南竿',
                        hidden: 0,
                    },
                    {
                        code: '713802',
                        name: '北竿乡',
                        simple_name: '北竿',
                        hidden: 0,
                    },
                    {
                        code: '713803',
                        name: '莒光乡',
                        simple_name: '莒光',
                        hidden: 0,
                    },
                    {
                        code: '713804',
                        name: '东引乡',
                        simple_name: '东引',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '810000',
        name: '香港特别行政区',
        simple_name: '香港',
        hidden: 0,
        cities: [
            {
                code: '810100',
                name: '香港岛',
                simple_name: '香港岛',
                hidden: 0,
                districts: [
                    {
                        code: '810101',
                        name: '中西区',
                        simple_name: '中西区',
                        hidden: 0,
                    },
                    {
                        code: '810102',
                        name: '湾仔区',
                        simple_name: '湾仔区',
                        hidden: 0,
                    },
                    {
                        code: '810103',
                        name: '东区',
                        simple_name: '东区',
                        hidden: 0,
                    },
                    {
                        code: '810104',
                        name: '南区',
                        simple_name: '南区',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '810200',
                name: '九龙',
                simple_name: '九龙',
                hidden: 0,
                districts: [
                    {
                        code: '810201',
                        name: '油尖旺区',
                        simple_name: '油尖旺',
                        hidden: 0,
                    },
                    {
                        code: '810202',
                        name: '深水埗区',
                        simple_name: '深水埗',
                        hidden: 0,
                    },
                    {
                        code: '810203',
                        name: '九龙城区',
                        simple_name: '九龙城',
                        hidden: 0,
                    },
                    {
                        code: '810204',
                        name: '黄大仙区',
                        simple_name: '黄大仙',
                        hidden: 0,
                    },
                    {
                        code: '810205',
                        name: '观塘区',
                        simple_name: '观塘',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '810300',
                name: '新界',
                simple_name: '新界',
                hidden: 0,
                districts: [
                    {
                        code: '810301',
                        name: '荃湾区',
                        simple_name: '荃湾',
                        hidden: 0,
                    },
                    {
                        code: '810302',
                        name: '屯门区',
                        simple_name: '屯门',
                        hidden: 0,
                    },
                    {
                        code: '810303',
                        name: '元朗区',
                        simple_name: '元朗',
                        hidden: 0,
                    },
                    {
                        code: '810304',
                        name: '北区',
                        simple_name: '北区',
                        hidden: 0,
                    },
                    {
                        code: '810305',
                        name: '大埔区',
                        simple_name: '大埔',
                        hidden: 0,
                    },
                    {
                        code: '810306',
                        name: '西贡区',
                        simple_name: '西贡',
                        hidden: 0,
                    },
                    {
                        code: '810307',
                        name: '沙田区',
                        simple_name: '沙田',
                        hidden: 0,
                    },
                    {
                        code: '810308',
                        name: '葵青区',
                        simple_name: '葵青',
                        hidden: 0,
                    },
                    {
                        code: '810309',
                        name: '离岛区',
                        simple_name: '离岛',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '820000',
        name: '澳门特别行政区',
        simple_name: '澳门',
        hidden: 0,
        cities: [
            {
                code: '820100',
                name: '澳门半岛',
                simple_name: '澳门半岛',
                hidden: 0,
                districts: [
                    {
                        code: '820101',
                        name: '花地玛堂区',
                        simple_name: '花地玛堂区',
                        hidden: 0,
                    },
                    {
                        code: '820102',
                        name: '圣安多尼堂区',
                        simple_name: '圣安多尼堂区',
                        hidden: 0,
                    },
                    {
                        code: '820103',
                        name: '大堂区',
                        simple_name: '大堂',
                        hidden: 0,
                    },
                    {
                        code: '820104',
                        name: '望德堂区',
                        simple_name: '望德堂区',
                        hidden: 0,
                    },
                    {
                        code: '820105',
                        name: '风顺堂区',
                        simple_name: '风顺堂区',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '820200',
                name: '氹仔岛',
                simple_name: '氹仔岛',
                hidden: 0,
                districts: [
                    {
                        code: '820201',
                        name: '嘉模堂区',
                        simple_name: '嘉模堂区',
                        hidden: 0,
                    },
                ],
            },
            {
                code: '820300',
                name: '路环岛',
                simple_name: '路环岛',
                hidden: 0,
                districts: [
                    {
                        code: '820301',
                        name: '圣方济各堂区',
                        simple_name: '圣方济各堂区',
                        hidden: 0,
                    },
                ],
            },
        ],
    },
    {
        code: '900000',
        name: '钓鱼岛',
        simple_name: '钓鱼岛',
        hidden: 0,
        cities: [],
    },
];

export default area;
